import { executeTursoQuery, executeTursoBatch } from '../lib/turso';
import { UserProfile, NoticeItem, FinancialTransaction, GelanggangDetail, CourseSection, LessonItem, GelanggangFeePackage, Role, Gelanggang, BengkungLevel, TransactionType, InvoiceItem, GrantProposal, AssociationAsset, AssetRentalLog, TrainerAllowanceClaim, MerchandiseOrder, MerchandiseItem, DonationCampaign, DonationRecord, SyllabusGradingRecord, UjianBengkungRegistration, AvailabilityEntry, RoleItem, PermissionItem, AlertNotificationSettings, PersatuanPaymentSettings, SellerPaymentSettings, UjianGradingAssessment, GradingItemScore, PaidUjianCandidate } from '../types';
import { DriveFileItem, INITIAL_MANAGEMENT_DRIVE_FILES } from '../lib/gdrive';
import { isUserAbove18, toTitleCase, sanitizeIc, sanitizePhone } from '../utils/formatters';
import { isEligibleForMonthlyFee } from '../utils/pricing';
import { DEFAULT_EVENT_TEMPLATES, normalizeEventTemplates } from '../utils/alertTemplate';
import { cleanBengkungTitle, toDbBengkungCode, BengkungRankInfo, ASMM_BENGKUNG_RANKS, getCustomBengkungRanks, getNextBengkungRank, getPreviousRankLessonIds, isPreviousBengkungRank, resolveBengkungBadge } from '../data/bengkungRanks';
import { UjianBertulisAttempt } from '../data/ujianBertulisQuestions';

// DEFAULT AVATAR PLACEHOLDER FOR MEMBERS WITHOUT UPLOADED PHOTO
export const DEFAULT_AVATAR_URL = '/default-avatar.svg';

export const isDefaultPhoto = (url?: string): boolean => {
  if (!url) return true;
  const trimmed = url.trim();
  return (
    trimmed === '' ||
    trimmed === '/badges/default.jpeg' ||
    trimmed === DEFAULT_AVATAR_URL ||
    trimmed === '/default-avatar.png' ||
    trimmed === '/default-avatar.svg' ||
    trimmed === '/logo-pssasmm.png'
  );
};

// REAL OFFICIAL ASMM SEED MEMBERS
export const SEED_MEMBERS: UserProfile[] = [
  {
    id: 'ASMM-001',
    name: 'Mohd Hafife Bin Abd Halim',
    icNo: '850612025431',
    email: 'hafife@asmm.org.my',
    phone: '0194589201',
    address: 'No. 1, Jalan Warisan, Taman Warisan, 09600 Lunas, Kedah',
    role: 'Pengerusi',
    gelanggang: 'ASMM',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/hafife.jpeg',
    joinedDate: '2018-03-15',
    status: 'Aktif',
  },
  {
    id: 'ASMM-002',
    name: 'Zulkifli Bin Saad',
    icNo: '790415025121',
    email: 'zulkifli@asmm.org.my',
    phone: '0195829104',
    address: 'No. 12, Lorong Melati, Taman Melati, 09000 Kulim, Kedah',
    role: 'Timbalan Pengerusi',
    gelanggang: 'ASMM',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/zulkifli.jpeg',
    joinedDate: '2018-03-15',
    status: 'Aktif',
  },
  {
    id: 'ASMM-003',
    name: 'Mohd Fauzi Bin Abd Aziz',
    icNo: '800114025309',
    email: 'fauzi@asmm.org.my',
    phone: '0124475157',
    address: 'No. 45, Kampung Padang Meha, 09400 Padang Serai, Kedah',
    role: 'Setiausaha',
    gelanggang: 'Wadi AnNour',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/fauzi.jpeg',
    joinedDate: '2019-06-20',
    status: 'Aktif',
  },
  {
    id: 'ASMM-004',
    name: 'Mohammad Syah Firafizal Bin Abubakar',
    icNo: '871109025401',
    email: 'syah@asmm.org.my',
    phone: '0195810293',
    address: 'No. 8, Jalan Bersatu, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'merah3',
    bengkungBadge: '/badges/merah3-pembantu-jurulatih-sulung.png',
    photoUrl: '/badges/syah-firafizal.jpeg',
    joinedDate: '2020-02-10',
    status: 'Aktif',
  },
  {
    id: 'ASMM-005',
    name: 'Mohd Aizat Bin Yusoff',
    icNo: '900514025201',
    email: 'aizat@asmm.org.my',
    phone: '0174820194',
    address: 'No. 23, Taman Mahsuri, 09600 Lunas, Kedah',
    role: 'Bendahari',
    gelanggang: 'ASMM',
    bengkung: 'kuning0',
    bengkungBadge: '/badges/kuning0-penolong-jurulatih.png',
    photoUrl: '/badges/aizat.jpeg',
    joinedDate: '2024-01-15',
    status: 'Aktif',
  },
  {
    id: 'ASMM-006',
    name: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    icNo: '950218026115',
    email: 'zaki@asmm.org.my',
    phone: '0135819201',
    address: 'No. 7, Jalan Anggerik 2, 09000 Kulim, Kedah',
    role: 'Ketua Biro Media & Penerangan',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/zaki.jpeg',
    joinedDate: '2022-05-18',
    status: 'Aktif',
  },
  {
    id: 'ASMM-007',
    name: 'Mohamad Shakir Fahmi Bin Mohamad Zaki',
    icNo: '990812085921',
    email: 'shakir@gmail.com',
    phone: '01128194012',
    address: 'No. 54, Taman Paya Besar, 09600 Lunas, Kedah',
    role: 'Ketua Biro Sosial & Kebajikan',
    gelanggang: 'Paya Besar',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/shakir.jpeg',
    joinedDate: '2023-09-01',
    status: 'Aktif',
  },
  {
    id: 'ASMM-008',
    name: 'Shahrul Aswad Bin Shamsuri',
    icNo: '910405026105',
    email: 'aswad@asmm.org.my',
    phone: '0134829104',
    address: 'No. 15, Taman Desa Aman, 09400 Padang Serai, Kedah',
    role: 'Ketua Biro Keusahawanan & Sukan',
    gelanggang: 'ASMM',
    bengkung: 'merah2',
    bengkungBadge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    photoUrl: '/badges/aswad.jpeg',
    joinedDate: '2021-04-12',
    status: 'Aktif',
  },
  {
    id: 'ASMM-009',
    name: 'Hasbullah Bin Shaik Ahmad Amirruddin',
    icNo: '881102075129',
    email: 'hasbullah@asmm.org.my',
    phone: '0194820193',
    address: 'No. 32, Jalan Meranti 3, 09000 Kulim, Kedah',
    role: 'Ketua Biro Latihan & Dakwah',
    gelanggang: 'ASMM',
    bengkung: 'kuning5',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/hasbullah.jpeg',
    joinedDate: '2020-01-10',
    status: 'Aktif',
  },
  {
    id: 'ASMM-010',
    name: 'Mohd Shukor Bin Sahidin',
    icNo: '020719026192',
    email: 'shukor@asmm.org.my',
    phone: '0194810293',
    address: 'No. 19, Kampung Sungai Seluang, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'ASMM',
    bengkung: 'merah2',
    bengkungBadge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    photoUrl: '/badges/shukor.jpeg',
    joinedDate: '2024-03-01',
    status: 'Aktif',
  },
  {
    id: 'ASMM-011',
    name: 'Mohammad Hafiz Bin Halim',
    icNo: '030819025819',
    email: 'meisterhafiz@gmail.com',
    phone: '0194920194',
    address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
    role: 'Pen. Setiausaha',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih1',
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: '/badges/hafiz.jpeg',
    joinedDate: '2024-04-10',
    status: 'Aktif',
  },
  {
    id: 'ASMM-012',
    name: 'Muhdfarhan 2012',
    icNo: '120101025119',
    email: 'muhdfarhan2012@gmail.com',
    phone: '0194820194',
    address: 'No. 55, Jalan Pusaka 2, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih0' as any,
    bengkungBadge: '/badges/putih0.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2024-05-12',
    status: 'Aktif',
  },
  {
    id: 'ASMM-014',
    name: 'Aisya Humaira binti Mohammad Hafiz',
    icNo: '161205021110',
    email: '161205021110@asmm.org.my',
    phone: '0194920194',
    address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih1' as any,
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2024-09-01',
    status: 'Aktif',
    parentId: 'ASMM-011',
    relationship: 'Anak',
    kinName: 'Mohammad Hafiz Bin Halim',
    kinPhone: '0194920194',
  },
  {
    id: 'ASMM-015',
    name: 'Zainab Binti Ismail',
    icNo: '800812025114',
    email: 'zainab@gmail.com',
    phone: '0194820194',
    address: 'No. 12, Jalan Sejahtera 3, Taman Sejahtera, 09600 Lunas, Kedah',
    role: 'Waris',
    gelanggang: 'Pusaka Warisan',
    bengkung: '' as any,
    bengkungBadge: '',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2026-08-15',
    status: 'Aktif',
  },
  {
    id: 'ASMM-016',
    name: 'Ahmad Malik bin Mohammad Hafiz',
    icNo: '181120025619',
    email: '181120025619@asmm.org.my',
    phone: '0194920194',
    address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih1' as any,
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2024-09-01',
    status: 'Aktif',
    parentId: 'ASMM-011',
    relationship: 'Anak',
    kinName: 'Mohammad Hafiz Bin Halim',
    kinPhone: '0194920194',
  },
  {
    id: 'ASMM-017',
    name: 'Muhammad Adam Bin Rosli',
    icNo: '140512025619',
    email: 'adam@asmm.org.my',
    phone: '0194820194',
    address: 'No. 12, Jalan Sejahtera 3, Taman Sejahtera, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih1' as any,
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2026-08-16',
    status: 'Aktif',
    parentId: 'ASMM-015',
    relationship: 'Anak',
    kinName: 'Zainab Binti Ismail',
    kinPhone: '0194820194',
  },
  {
    id: 'ASMM-018',
    name: 'Yasmin Dahlia Binti Roslan',
    icNo: '120508026114',
    email: 'yasmin@asmm.org.my',
    phone: '0174829104',
    address: 'No. 28, Kampung Padang Meha, 09400 Padang Serai, Kedah',
    role: 'Ahli',
    gelanggang: 'Wadi AnNour',
    bengkung: 'putih1' as any,
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2026-09-01',
    status: 'Aktif',
  },
  {
    id: 'ASMM-101',
    name: 'Najwa Binti Abdul Azis',
    icNo: '880930495678',
    email: 'najwa.abdulazis@gmail.com',
    phone: '0172018658',
    address: 'No 36, Lorong Cendawan 5/4, Taman Bayam, 09600 Lunas, Kedah',
    role: 'Waris',
    roles: ['Waris'],
    gelanggang: 'Pusaka Warisan',
    bengkung: '' as any,
    bengkungBadge: '',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2026-10-04',
    status: 'Aktif',
    isOldMember: false,
    onboardingStatus: 'pending_payment'
  },
  {
    id: 'ASMM-102',
    name: 'Akira Muhammad bin Muhammad Firdaus',
    icNo: '170323021159',
    email: '170323021159@asmm.org.my',
    phone: '0172018658',
    address: 'No 36, Lorong Cendawan 5/4, Taman Bayam, 09600 Lunas, Kedah',
    role: 'Ahli',
    roles: ['Ahli'],
    gelanggang: 'Pusaka Warisan',
    bengkung: 'putih1' as any,
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: DEFAULT_AVATAR_URL,
    joinedDate: '2026-10-04',
    status: 'Aktif',
    parentId: 'ASMM-101',
    relationship: 'Anak',
    kinName: 'Najwa Binti Abdul Azis',
    kinPhone: '0172018658',
    isOldMember: false,
    onboardingStatus: 'pending_payment'
  },
  {
    id: 'ASMM-109',
    name: 'Mohd Syahir Bin Mohd Yusof',
    icNo: '82101207533',
    email: 'syahir82@gmail.com',
    phone: '0194223193',
    address: '338 JALAN SENANGIN, TAMAN SENANGIN,09000 KULIM ,KEDAH',
    role: 'Penolong Bendahari',
    roles: ['Penolong Bendahari', 'Ahli Seumur Hidup'],
    gelanggang: 'ASMM',
    bengkung: 'kuning3' as any,
    bengkungBadge: '/badges/kuning3-jurulatih-muda.png',
    photoUrl: '/badges/syahir.jpg',
    joinedDate: '1998-04-03',
    status: 'Aktif',
    isOldMember: true,
  },
  {
    id: 'ASMM-110',
    name: 'Mohd Nizam bin Salleh',
    icNo: '880312025117',
    email: 'nizam@asmm.org.my',
    phone: '0194820192',
    address: 'No. 14, Jalan Angsana, 09600 Lunas, Kedah',
    role: 'AJK',
    roles: ['AJK'],
    gelanggang: 'ASMM',
    bengkung: 'putih0' as any,
    bengkungBadge: '/badges/putih0.png',
    photoUrl: '/badges/nizam.jpg',
    joinedDate: '2024-05-01',
    status: 'Aktif',
    isOldMember: false,
  },
  {
    id: 'ASMM-132',
    name: 'Nazihah binti Mohd Noor',
    icNo: '920418025614',
    email: 'nazihah@asmm.org.my',
    phone: '0194820193',
    address: 'No. 30, Taman Kancil, 09600 Lunas, Kedah',
    role: 'Juru Audit Dalaman',
    roles: ['Juru Audit Dalaman'],
    gelanggang: 'ASMM',
    bengkung: 'putih0' as any,
    bengkungBadge: '/badges/putih0.png',
    photoUrl: '/badges/nizam.jpg',
    joinedDate: '2024-05-01',
    status: 'Aktif',
    isOldMember: false,
  }
];

// REAL OFFICIAL ASMM SEED NOTICES
export const SEED_NOTICES: NoticeItem[] = [
  {
    id: 'notice-02',
    title: 'Pengumpulan Yuran Bulanan Gelanggang Ogos 2026',
    content: 'Peringatan yuran bulanan RM20.00 untuk tabung pengurusan gelanggang. Bayaran boleh dibuat secara dalam talian melalui ToyyibPay FPX.',
    type: 'pengumuman',
    authorName: 'Mohd Aizat Bin Yusoff',
    authorRole: 'Bendahari',
    targetGelanggang: 'Semua Gelanggang',
    createdAt: '2026-08-01',
    ctaButtonText: 'Bayar Yuran',
    ctaButtonType: 'payment',
  },
  {
    id: 'notice-03',
    title: 'Undian Pemilihan Rekabentuk T-Shirt Latihan 2026',
    content: 'AJK ASMM memohon maklum balas semua pesilat bagi menentukan corak & warna T-Shirt Latihan baharu persatuan.',
    type: 'poll',
    authorName: 'Mohd Hafife Bin Abd Halim',
    authorRole: 'Pengerusi',
    targetGelanggang: 'Semua Gelanggang',
    createdAt: '2026-08-04',
    pollOptions: [
      { id: 'opt-1', text: 'Hitam Emas (Lambang Merah Muda)', count: 12 },
      { id: 'opt-2', text: 'Merah Harimau (Lambang Merah Muda)', count: 5 },
      { id: 'opt-3', text: 'Kuning Diraja + Emblem Hitam (Edisi Khusus)', count: 3 }
    ],
    pollVotes: [
      { userId: 'usr-pengerusi-01', userName: 'Mohd Hafife Bin Abd Halim', optionId: 'opt-1', updatedAt: '2026-08-04 12:00' },
      { userId: 'usr-kg-paya-01', userName: 'Mohamad Shakir Fahmi Bin Mohamad Zaki', optionId: 'opt-1', updatedAt: '2026-08-05 14:00' }
    ]
  }
];

// REAL OFFICIAL ASMM FINANCIAL TRANSACTIONS
export const SEED_TRANSACTIONS: FinancialTransaction[] = [
  {
    id: 'tx-101',
    date: '2026-08-05',
    category: 'Yuran Bulanan',
    description: 'Bayaran Yuran Bulanan Ogos 2026 - Mohamad Shakir Fahmi',
    amount: 20.00,
    type: 'Income',
    payerOrPayee: 'Mohamad Shakir Fahmi',
    gelanggang: 'Paya Besar',
    recordedBy: 'Mohd Aizat Bin Yusoff',
    status: 'Disahkan',
    toyibBillCode: 'ASMM-FPX-882910'
  },
  {
    id: 'tx-102',
    date: '2026-08-04',
    category: 'Sewa Gelanggang',
    description: 'Bayaran Sewa Latihan Dewan Riadah Wadi AnNour (Ogos)',
    amount: 150.00,
    type: 'Expense',
    payerOrPayee: 'Pengurusan Pusat Riadah Wadi AnNour',
    gelanggang: 'Wadi AnNour',
    recordedBy: 'Mohd Aizat Bin Yusoff',
    status: 'Disahkan',
    receiptUrl: 'gdrive-management-file-102'
  },
  {
    id: 'tx-103',
    date: '2026-08-02',
    category: 'Yuran Bengkung',
    description: 'Yuran Ujian Bengkung Putih Ke Hitam - 5 Pesilat Muda',
    amount: 250.00,
    type: 'Income',
    payerOrPayee: 'Kumpulan Pesilat Muda Pusaka Warisan',
    gelanggang: 'Pusaka Warisan',
    recordedBy: 'Mohd Fauzi Bin Abd Aziz',
    status: 'Disahkan',
    toyibBillCode: 'ASMM-FPX-901238'
  },
  {
    id: 'tx-104',
    date: '2026-07-28',
    category: 'Pembelian Alatan',
    description: 'Pembelian 10 Unit Target Kick Pad & Tanjak Pertunjukan',
    amount: 480.00,
    type: 'Expense',
    payerOrPayee: 'Pembekal Alatan Silat Kulim',
    gelanggang: 'Semua Gelanggang',
    recordedBy: 'Mohd Aizat Bin Yusoff',
    status: 'Disahkan',
    receiptUrl: 'gdrive-management-file-104'
  }
];

export const SEED_GELANGGANG: GelanggangDetail[] = [
  {
    id: 'gel-pusaka',
    name: 'Pusaka Warisan',
    location: 'Padang Awam Taman Sejahtera, Lunas, Kedah',
    address: 'Padang Awam Taman Sejahtera, 09600 Lunas, Kedah',
    gpsLocation: '',
    sessionTime: 'Jumaat & Sabtu (8.00 AM)',
    leaderName: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    leaderPhone: '013-5819201',
    status: 'Aktif'
  },
  {
    id: 'gel-wadi',
    name: 'Wadi AnNour',
    location: 'Pusat Riadah Wadi AnNour, Kulim, Kedah',
    address: 'Pusat Riadah Wadi AnNour, Kampung Simpang Tiga Keladi, 09000 Kulim, Kedah',
    gpsLocation: '',
    sessionTime: 'Jumaat & Sabtu (8.30 PM)',
    leaderName: 'Mohd Fauzi Bin Abd Aziz',
    leaderPhone: '0124475157',
    status: 'Aktif'
  },
  {
    id: 'gel-paya',
    name: 'Paya Besar',
    location: 'Sekolah Paya Besar, Kulim, Kedah',
    address: 'SK Paya Besar, Lunas, 09000 Kulim, Kedah',
    gpsLocation: '',
    sessionTime: 'Rabu & Sabtu (9.00 PM)',
    leaderName: 'Mohamad Shakir Fahmi Bin Mohamad Zaki',
    leaderPhone: '011-28194012',
    status: 'Aktif'
  }
];

export const SEED_SYLLABUS: CourseSection[] = [
  // ══════════════════════════════════════════════════════════════════════════════
  // KURSUS TUNAS PENDEKAR (KANAK-KANAK: 7 - 12 TAHUN)
  // ══════════════════════════════════════════════════════════════════════════════
  // 1. Bengkung Tunas Pendekar
  {
    id: 'sec-hitam', bengkungRank: 'hitam', sortOrder: 0,
    category: 'KURSUS TUNAS PENDEKAR (7 - 12 TAHUN)',
    requiredBengkungName: 'Bengkung Tunas Pendekar',
    title: 'Bengkung Tunas Pendekar',
    badge: '/badges/hitam0-tunas-pendekar.png',
    lessons: [
      { id: 'les-h01', sortOrder: 0, title: 'Adab Buka Gelanggang (Syahadah & Doa)', type: 'reading', duration: '10:00', completed: false, description: 'Adab memasuki gelanggang dan bacaan wajib sebelum latihan (syahadah 9 kali, selawat & surah 3 khul).' },
      { id: 'les-h02', sortOrder: 1, title: 'Hormat Perguruan', type: 'reading', duration: '05:00', completed: false, description: 'Adab menghormati Guru Utama dan barisan jurulatih perguruan ASMM.' },
      { id: 'les-h03', sortOrder: 2, title: 'Senaman Separuh Tiang', type: 'video', duration: '15:00', completed: false, description: 'Tumbuk Hadapan & Bawah, Siku Layang & Atas, Tangkisan Luar & Dalam (tangkisan tapak).' },
      { id: 'les-h04', sortOrder: 3, title: 'Senaman Satu Tiang', type: 'video', duration: '15:00', completed: false, description: 'Serangan Lutut, Tanjai, Sepak Cakuk, Sepak Layang, Tangkisan Siku & Sepakan.' },
      { id: 'les-h05', sortOrder: 4, title: 'Jurus Asas 1 – 5', type: 'video', duration: '18:00', completed: false, description: 'Rangkaian Jurus Asas 1 hingga 5.' },
      { id: 'les-h06', sortOrder: 5, title: 'Elak Luar & Dalam berserta Serang Balas', type: 'video', duration: '14:00', completed: false, description: 'Teknik elak luar dan dalam berserta serang balas pantas.' },
      { id: 'les-h07', sortOrder: 6, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '16:00', completed: false, description: 'Koleksi teknik beladiri praktikal pelepasan pegangan peringkat Tunas Pendekar.' },
    ]
  },
  // 2. Bengkung Tunas Pendekar Muda
  {
    id: 'sec-hitam1', bengkungRank: 'hitam1', sortOrder: 1,
    category: 'KURSUS TUNAS PENDEKAR (7 - 12 TAHUN)',
    requiredBengkungName: 'Bengkung Tunas Pendekar Muda',
    title: 'Bengkung Tunas Pendekar Muda',
    badge: '/badges/hitam1-tunas-pendekar-muda.png',
    lessons: [
      { id: 'les-h10', sortOrder: 0, title: 'Jurus Asas 6 – 10', type: 'video', duration: '18:00', completed: false, description: 'Rangkaian Jurus Asas 6 hingga 10.' },
      { id: 'les-h11', sortOrder: 1, title: 'Buah Pukulan 1 (Pecahan 1.1 – 1.3)', type: 'video', duration: '16:00', completed: false, description: 'Aplikasi Buah Pukulan 1 bahagian 1.1 hingga 1.3.' },
      { id: 'les-h12', sortOrder: 2, title: 'Teknik Gulingan (Depan, Belakang & Sisi)', type: 'video', duration: '14:00', completed: false, description: 'Teknik gulingan pelbagai arah untuk elakan selamat.' },
      { id: 'les-h13', sortOrder: 3, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Buah-buah poket lanjutan peringkat Tunas Pendekar Muda.' },
      { id: 'les-h14', sortOrder: 4, title: 'Jurus Masal 1 – 3', type: 'video', duration: '20:00', completed: false, description: 'Jurus Masal 1, 2 dan 3 untuk latihan persembahan beramai-ramai.' },
    ]
  },
  // 3. Bengkung Tunas Pendekar Kanan
  {
    id: 'sec-hitam2', bengkungRank: 'hitam2', sortOrder: 2,
    category: 'KURSUS TUNAS PENDEKAR (7 - 12 TAHUN)',
    requiredBengkungName: 'Bengkung Tunas Pendekar Kanan',
    title: 'Bengkung Tunas Pendekar Kanan',
    badge: '/badges/hitam3-tunas-pendekar-kanan.png',
    lessons: [
      { id: 'les-h15', sortOrder: 0, title: 'Buah Pukulan 1 (Pecahan 1.4 – 1.6)', type: 'video', duration: '16:00', completed: false, description: 'Aplikasi Buah Pukulan 1 bahagian 1.4 hingga 1.6.' },
      { id: 'les-h16', sortOrder: 1, title: 'Seni Tempur Tangan Kosong', type: 'video', duration: '22:00', completed: false, description: 'Seni Tempur tangan kosong — serangan dan pertahanan tanpa senjata.' },
      { id: 'les-h17', sortOrder: 2, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Buah-buah poket peringkat Tunas Pendekar Kanan.' },
      { id: 'les-h18', sortOrder: 3, title: 'Jurus Masal 4 – 6', type: 'video', duration: '20:00', completed: false, description: 'Jurus Masal 4, 5 dan 6.' },
    ]
  },
  // 4. Bengkung Tunas Pendekar Sulung
  {
    id: 'sec-hitam3', bengkungRank: 'hitam3', sortOrder: 3,
    category: 'KURSUS TUNAS PENDEKAR (7 - 12 TAHUN)',
    requiredBengkungName: 'Bengkung Tunas Pendekar Sulung',
    title: 'Bengkung Tunas Pendekar Sulung',
    badge: '/badges/hitam2-tunas-pendekar-sulung.png',
    lessons: [
      { id: 'les-h19', sortOrder: 0, title: 'Buah Pukulan 1 (Pecahan 1.7 – 1.9)', type: 'video', duration: '16:00', completed: false, description: 'Aplikasi Buah Pukulan 1 bahagian 1.7 hingga 1.9.' },
      { id: 'les-h20', sortOrder: 1, title: 'Seni Tari Silat', type: 'video', duration: '20:00', completed: false, description: 'Pembelajaran Seni Tari Silat ASMM — bunga silat dan langkah persembahan.' },
      { id: 'les-h21', sortOrder: 2, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Buah-buah poket peringkat Tunas Pendekar Sulung.' },
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════════
  // PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)
  // ══════════════════════════════════════════════════════════════════════════════
  // 5. Bengkung Putih Kosong
  {
    id: 'sec-putih', bengkungRank: 'putih', sortOrder: 4,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pesilat Asas',
    requiredBengkungName: 'Bengkung Putih Kosong',
    title: 'Bengkung Putih Kosong',
    badge: '/badges/putih0.png',
    lessons: [
      { id: 'les-p01', sortOrder: 0, title: 'Adab Buka Gelanggang (Syahadah & Doa)', type: 'reading', duration: '10:00', completed: false, description: 'Adab buka gelanggang (syahadah 9 kali, selawat & surah 3 khul).' },
      { id: 'les-p02', sortOrder: 1, title: 'Hormat Perguruan', type: 'reading', duration: '05:00', completed: false, description: 'Adab menghormati guru dan rakan seperjuangan.' },
      { id: 'les-p03', sortOrder: 2, title: 'Senaman Separuh Tiang', type: 'video', duration: '15:00', completed: false, description: 'Tumbuk Hadapan & Bawah, Siku Layang & Atas, Tangkisan Luar & Dalam (tangkisan tapak).' },
      { id: 'les-p04', sortOrder: 3, title: 'Senaman Satu Tiang', type: 'video', duration: '15:00', completed: false, description: 'Serangan Lutut, Tanjai, Sepak Cakuk, Sepak Layang, Tangkisan Siku & Sepakan.' },
      { id: 'les-p05', sortOrder: 4, title: 'Elak Luar & Dalam berserta Serang Balas', type: 'video', duration: '15:00', completed: false, description: 'Teknik elak luar & dalam beserta tangkisan dan serang balas.' },
      { id: 'les-p06', sortOrder: 5, title: 'Tangkisan Serangan Kaki berserta Serang Balas', type: 'video', duration: '13:00', completed: false, description: 'Tangkisan serangan kaki diikuti serang balas.' },
      { id: 'les-p07', sortOrder: 6, title: 'Buah Pukulan 1 (Pecahan 1.1 – 1.5)', type: 'video', duration: '18:00', completed: false, description: 'Aplikasi Buah Pukulan 1, pecahan 1.1 hingga 1.5.' },
      { id: 'les-p08', sortOrder: 7, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Koleksi teknik beladiri praktikal peringkat Putih Kosong.' },
    ]
  },
  // 6. Bengkung Putih 1
  {
    id: 'sec-putih1', bengkungRank: 'putih1', sortOrder: 5,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pesilat Muda',
    requiredBengkungName: 'Bengkung Putih 1',
    title: 'Bengkung Putih 1',
    badge: '/badges/putih1-pesilat-muda.png',
    lessons: [
      { id: 'les-p11', sortOrder: 0, title: 'Jurus Asas 1 – 10', type: 'video', duration: '22:00', completed: false, description: 'Rangkaian Jurus Asas 1 hingga 10.' },
      { id: 'les-p12', sortOrder: 1, title: 'Buah Pukulan 1 (Pecahan 1.6 – 1.10)', type: 'video', duration: '18:00', completed: false, description: 'Aplikasi Buah Pukulan 1, pecahan 1.6 hingga 1.10.' },
      { id: 'les-p13', sortOrder: 2, title: 'Buah Cindai 1 – 5', type: 'video', duration: '18:00', completed: false, description: 'Teknik Buah Cindai 1 hingga 5.' },
      { id: 'les-p14', sortOrder: 3, title: 'Teknik Jatuhan (Depan, Belakang & Sisi)', type: 'video', duration: '14:00', completed: false, description: 'Teknik jatuhan pelbagai arah: depan, belakang dan sisi/tepi.' },
      { id: 'les-p15', sortOrder: 4, title: 'Teknik Gulingan (Depan, Belakang & Sisi)', type: 'video', duration: '14:00', completed: false, description: 'Teknik gulingan pelbagai arah: depan, belakang dan sisi/tepi.' },
      { id: 'les-p16', sortOrder: 5, title: 'Tangkisan Serangan Siku berserta Serang Balas', type: 'video', duration: '13:00', completed: false, description: 'Tangkisan serangan siku diikuti serang balas.' },
      { id: 'les-p17', sortOrder: 6, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Buah-buah poket peringkat Pesilat Muda.' },
      { id: 'les-p18', sortOrder: 7, title: 'Jurus Masal 1 – 5', type: 'video', duration: '22:00', completed: false, description: 'Jurus Masal 1 hingga 5 untuk persembahan berkumpulan.' },
    ]
  },
  // 7. Bengkung Putih 2
  {
    id: 'sec-putih2', bengkungRank: 'putih2', sortOrder: 6,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pesilat Kanan',
    requiredBengkungName: 'Bengkung Putih 2',
    title: 'Bengkung Putih 2',
    badge: '/badges/putih2-pesilat-kanan.png',
    lessons: [
      { id: 'les-p19', sortOrder: 0, title: 'Jurus Asas 11 – 20', type: 'video', duration: '22:00', completed: false, description: 'Rangkaian Jurus Asas 11 hingga 20.' },
      { id: 'les-p20', sortOrder: 1, title: 'Tari Jabat 14', type: 'video', duration: '20:00', completed: false, description: 'Pembelajaran Tari Jabat 14 — seni tari tradisional ASMM.' },
      { id: 'les-p21', sortOrder: 2, title: 'Buah Pukulan 2 (Pecahan 2.1 – 2.10)', type: 'video', duration: '22:00', completed: false, description: 'Aplikasi Buah Pukulan 2 bahagian 2.1 hingga 2.10.' },
      { id: 'les-p22', sortOrder: 3, title: 'Buah Cindai 6 – 10', type: 'video', duration: '18:00', completed: false, description: 'Teknik Buah Cindai 6 hingga 10.' },
      { id: 'les-p23', sortOrder: 4, title: 'Buah Pisau (Tangkisan & Serang Balas)', type: 'video', duration: '18:00', completed: false, description: 'Teknik tangkisan serangan pisau dan serang balas.' },
      { id: 'les-p24', sortOrder: 5, title: 'Asas Seni Tari Silat', type: 'video', duration: '16:00', completed: false, description: 'Asas pembelajaran seni tari silat ASMM.' },
      { id: 'les-p25', sortOrder: 6, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '15:00', completed: false, description: 'Buah-buah poket peringkat Pesilat Kanan.' },
      { id: 'les-p26', sortOrder: 7, title: 'Jurus Masal 6 – 10', type: 'video', duration: '22:00', completed: false, description: 'Jurus Masal 6 hingga 10.' },
    ]
  },
  // 8. Bengkung Putih 3
  {
    id: 'sec-putih3', bengkungRank: 'putih3', sortOrder: 7,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pesilat Sulung',
    requiredBengkungName: 'Bengkung Putih 3',
    title: 'Bengkung Putih 3',
    badge: '/badges/putih3-pesilat-sulung.png',
    lessons: [
      { id: 'les-p27', sortOrder: 0, title: 'Ulangkaji Pelajaran Bengkung Putih 1 & 2', type: 'reading', duration: '15:00', completed: false, description: 'Ulangkaji menyeluruh sukatan pelajaran dari Bengkung Putih 1 hingga Putih 2.' },
      { id: 'les-p28', sortOrder: 1, title: 'Ujian Tempur Tangan Kosong (5 Lawan 1)', type: 'video', duration: '20:00', completed: false, description: 'Diuji aplikasi buah tangan kosong dengan cara 5 lawan 1.' },
      { id: 'les-p29', sortOrder: 2, title: 'Kursus Asas Pembantu Jurulatih', type: 'reading', duration: '10:00', completed: false, description: 'Menghadiri kursus asas pembantu jurulatih yang ditetapkan persatuan.' },
      { id: 'les-p30', sortOrder: 3, title: 'Manual Pelajaran Bengkung Putih (PDF)', type: 'pdf', duration: 'Fail PDF', completed: false, pdfFileId: 'gdrive-doc-03', description: 'Dokumen rasmi sukatan pelajaran Bengkung Putih terbitan Perguruan ASMM.' },
    ]
  },

  // 9. Bengkung Merah Kosong
  {
    id: 'sec-merah', bengkungRank: 'merah', sortOrder: 8,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pembantu Jurulatih',
    requiredBengkungName: 'Bengkung Merah Kosong',
    title: 'Bengkung Merah Kosong',
    badge: '/badges/merah0-pembantu-jurulatih.png',
    lessons: [
      { id: 'les-m01', sortOrder: 0, title: 'Aplikasi Jurus Asas 1 – 20', type: 'video', duration: '25:00', completed: false, description: 'Aplikasi penuh Jurus Asas 1 hingga 20 dalam konteks tempur.' },
      { id: 'les-m02', sortOrder: 1, title: 'Buah Pukulan 3 (Pecahan 3.1 – 3.10)', type: 'video', duration: '22:00', completed: false, description: 'Aplikasi Buah Pukulan 3, pecahan 3.1 hingga 3.10.' },
      { id: 'les-m03', sortOrder: 2, title: 'Seni Permainan Kayu (Sembat)', type: 'video', duration: '20:00', completed: false, description: 'Teknik seni permainan kayu / sembat.' },
      { id: 'les-m04', sortOrder: 3, title: 'Seni Permainan Cindai', type: 'video', duration: '18:00', completed: false, description: 'Teknik seni permainan cindai.' },
      { id: 'les-m05', sortOrder: 4, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '16:00', completed: false, description: 'Buah-buah poket peringkat Pembantu Jurulatih.' },
    ]
  },
  // 10. Bengkung Merah 1
  {
    id: 'sec-merah1', bengkungRank: 'merah1', sortOrder: 9,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pembantu Jurulatih Muda',
    requiredBengkungName: 'Bengkung Merah 1',
    title: 'Bengkung Merah 1',
    badge: '/badges/merah1-pembantu-jurulatih-muda.png',
    lessons: [
      { id: 'les-m06', sortOrder: 0, title: 'Jurus Asas Lanjutan 1', type: 'video', duration: '22:00', completed: false, description: 'Jurus Asas Lanjutan siri pertama.' },
      { id: 'les-m07', sortOrder: 1, title: 'Buah Pukulan 4 (Pecahan 4.1 – 4.10)', type: 'video', duration: '22:00', completed: false, description: 'Aplikasi Buah Pukulan 4, pecahan 4.1 hingga 4.10.' },
      { id: 'les-m08', sortOrder: 2, title: 'Seni Permainan Parang Panjang', type: 'video', duration: '20:00', completed: false, description: 'Teknik seni permainan parang panjang.' },
      { id: 'les-m09', sortOrder: 3, title: 'Seni Permainan Belati (Pisau)', type: 'video', duration: '18:00', completed: false, description: 'Teknik seni permainan belati (pisau).' },
      { id: 'les-m10', sortOrder: 4, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '16:00', completed: false, description: 'Buah-buah poket peringkat Pembantu Jurulatih Muda.' },
    ]
  },
  // 11. Bengkung Merah 2
  {
    id: 'sec-merah2', bengkungRank: 'merah2', sortOrder: 10,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pembantu Jurulatih Kanan',
    requiredBengkungName: 'Bengkung Merah 2',
    title: 'Bengkung Merah 2',
    badge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    lessons: [
      { id: 'les-m11', sortOrder: 0, title: 'Jurus Asas Lanjutan 2', type: 'video', duration: '22:00', completed: false, description: 'Jurus Asas Lanjutan siri kedua.' },
      { id: 'les-m12', sortOrder: 1, title: 'Buah Pukulan 5 (Pecahan 5.1 – 5.10)', type: 'video', duration: '22:00', completed: false, description: 'Aplikasi Buah Pukulan 5, pecahan 5.1 hingga 5.10.' },
      { id: 'les-m13', sortOrder: 2, title: 'Seni Permainan Keris', type: 'video', duration: '20:00', completed: false, description: 'Teknik seni permainan keris — warisan senjata tradisional Melayu.' },
      { id: 'les-m14', sortOrder: 3, title: 'Buah-buah Poket Beladiri', type: 'video', duration: '16:00', completed: false, description: 'Buah-buah poket peringkat Pembantu Jurulatih Kanan.' },
    ]
  },
  // 12. Bengkung Merah 3
  {
    id: 'sec-merah3', bengkungRank: 'merah3', sortOrder: 11,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Pembantu Jurulatih Sulung',
    requiredBengkungName: 'Bengkung Merah 3',
    title: 'Bengkung Merah 3',
    badge: '/badges/merah3-pembantu-jurulatih-sulung.png',
    lessons: [
      { id: 'les-m15', sortOrder: 0, title: 'Ulangkaji Bengkung Putih 1 hingga Merah 2', type: 'reading', duration: '20:00', completed: false, description: 'Ujian ulangkaji menyeluruh dari Bengkung Putih 1 hingga Bengkung Merah 2.' },
      { id: 'les-m16', sortOrder: 1, title: 'Ujian Aplikasi Senjata (5 Lawan 1)', type: 'video', duration: '20:00', completed: false, description: 'Diuji aplikasi buah senjata dengan cara 5 lawan 1.' },
      { id: 'les-m17', sortOrder: 2, title: 'Kursus Asas Kejurulatihan', type: 'reading', duration: '10:00', completed: false, description: 'Mengikuti kursus asas kejurulatihan yang ditetapkan persatuan.' },
    ]
  },
  // 13. Bengkung Kuning Kosong
  {
    id: 'sec-kuning', bengkungRank: 'kuning', sortOrder: 12,
    category: 'PERINGKAT REMAJA & DEWASA (13 TAHUN KE ATAS)',
    rankSubtitle: 'Jurulatih',
    requiredBengkungName: 'Bengkung Kuning Kosong',
    title: 'Bengkung Kuning Kosong',
    badge: '/badges/kuning0-penolong-jurulatih.png',
    lessons: [
      { id: 'les-k01', sortOrder: 0, title: 'Tapak 7 (Tapak Seni Raja)', type: 'video', duration: '25:00', completed: false, description: 'Tapak 7 (Tapak Seni Raja) — tapak pergerakan kepahlawanan tertinggi ASMM.' },
      { id: 'les-k02', sortOrder: 1, title: 'Tapak 4 (Tapak Pendekar)', type: 'video', duration: '22:00', completed: false, description: 'Tapak 4 (Tapak Pendekar).' },
      { id: 'les-k03', sortOrder: 2, title: 'Teknik Kuncian & Nama-nama Kuncian', type: 'video', duration: '22:00', completed: false, description: 'Mempelajari teknik-teknik kuncian dan nama-nama kuncian rasmi perguruan.' },
      { id: 'les-k04', sortOrder: 3, title: 'Seni Permainan Kerambit', type: 'video', duration: '20:00', completed: false, description: 'Seni permainan senjata kerambit Awang Sulung.' },
      { id: 'les-k05', sortOrder: 4, title: 'Asas Perubatan Tradisional', type: 'reading', duration: '15:00', completed: false, description: 'Asas perubatan tradisional Melayu dalam konteks silat.' },
      { id: 'les-k10', sortOrder: 5, title: 'Dokumen Sandang Kebesaran PSSASMM (PDF)', type: 'pdf', duration: 'Fail PDF', completed: false, pdfFileId: 'gdrive-doc-04', description: 'Manual rasmi Istiadat Pemakaian Selempang Sandang Kebesaran & Amanah ASMM.' },
      { id: 'les-k11', sortOrder: 6, title: 'Perlembagaan PSSASMM 2007 (PDF)', type: 'pdf', duration: 'Fail PDF', completed: false, pdfFileId: 'gdrive-doc-06', description: 'Dokumen rasmi perlembagaan dan hak-hak ahli perguruan.' },
    ]
  },

  // ══════════════════════════════════════════════════════════════════════════════
  // PANGKAT JURULATIH (18 TAHUN KE ATAS)
  // ══════════════════════════════════════════════════════════════════════════════
  // 14. Pangkat Jurulatih (Kuning 1 – 7)
  {
    id: 'sec-kuning1', bengkungRank: 'kuning1', sortOrder: 13,
    category: 'PANGKAT JURULATIH (18 TAHUN KE ATAS)',
    rankSubtitle: 'Gelaran "Cikgu"',
    requiredBengkungName: 'Bengkung Kuning 1',
    title: 'Pangkat Jurulatih (Kuning 1 – 7)',
    badge: '/badges/kuning1-junior-instructor-jurulatih-muda.png',
    lessons: [
      { id: 'les-k06', sortOrder: 0, title: 'Buah Pukulan Awang Sulung (Kaedah Pendekar)', type: 'video', duration: '30:00', completed: false, description: 'Teknik rahsia Buah Pukulan Awang Sulung - Kaedah Pendekar.' },
      { id: 'les-k07', sortOrder: 1, title: 'Seni Permainan 7 Haiwan Hutan', type: 'video', duration: '28:00', completed: false, description: 'Seni permainan berasaskan 7 haiwan hutan warisan ASMM.' },
      { id: 'les-k08', sortOrder: 2, title: 'Perubatan Tradisional Melayu', type: 'reading', duration: '20:00', completed: false, description: 'Ilmu perubatan tradisional Melayu yang diwarisi dalam perguruan ASMM.' },
      { id: 'les-k09', sortOrder: 3, title: 'Rahsia-rahsia Pendekar ASMM', type: 'video', duration: '30:00', completed: false, description: 'Mempelajari rahsia-rahsia ilmu kependekaran warisan Awang Sulung Merah Muda.' },
      { id: 'les-k13', sortOrder: 4, title: 'Hierarki Bengkung Kuning 1 – 7 (Jurulatih)', type: 'reading', duration: '15:00', completed: false, description: 'Kenaikan pangkat Jurulatih berdasarkan pengalaman mengajar ditentukan melalui mesyuarat Majlis Pendekar.' },
      { id: 'les-k12', sortOrder: 5, title: 'Prosedur Penilaian Ujian Bengkung ROS', type: 'reading', duration: '15:00', completed: false, description: 'Panduan penilaian ujian kenaikan bengkung mengikut kriteria pertubuhan ROS.' },
    ]
  },
  // 15. Bengkung Biru Samudera
  {
    id: 'sec-biru', bengkungRank: 'biru', sortOrder: 14,
    category: 'PANGKAT JURULATIH (18 TAHUN KE ATAS)',
    rankSubtitle: 'Dewan Pendekar',
    requiredBengkungName: 'Bengkung Biru Samudera',
    title: 'Bengkung Biru Samudera',
    badge: '/badges/biru.png',
    lessons: [
      { id: 'les-b01', sortOrder: 0, title: 'Falsafah Lautan Membiru & Pengijazahan', type: 'reading', duration: '20:00', completed: false, description: 'Falsafah Lautan Membiru — lambang keluasan ilmu, perpaduan pesilat, dan adab kependekaran ASMM.' },
      { id: 'les-b02', sortOrder: 1, title: 'Salasilah Pawang Diraja Awang Sulung Merah Muda', type: 'reading', duration: '25:00', completed: false, description: 'Salasilah warisan Pawang Diraja dan sanad keilmuan silat Melayu Kedah Darul Aman.' },
      { id: 'les-b03', sortOrder: 2, title: 'Majlis Penetapan Syarat Dewan Guru Utama', type: 'reading', duration: '15:00', completed: false, description: 'Garis panduan mesyuarat Majlis Pendekar dalam kenaikan pangkat Jurulatih dan penarafan darjah perguruan.' },
    ]
  },
];

// REAL OFFICIAL ASMM GELANGGANG FEE PACKAGES
export const SEED_FEE_PACKAGES: GelanggangFeePackage[] = [
  // WADI ANNOUR (Kulim) - Packages: Memanah, Berkuda, Silat Sahaja, Kombo
  {
    id: 'pkg-wadi-01',
    gelanggang: 'Wadi AnNour',
    title: 'Silat Bulanan Sahaja',
    price: 40,
    category: 'Yuran Bulanan',
    description: 'Yuran latihan silat bulanan asas di Pusat Riadah Wadi AnNour',
    targetAudience: 'Semua Pesilat',
    status: 'Aktif'
  },
  {
    id: 'pkg-wadi-02',
    gelanggang: 'Wadi AnNour',
    title: 'Pakej Silat + Memanah',
    price: 75,
    category: 'Pakej Khas',
    description: 'Latihan silat gabungan dengan akses sesi memanah sunnah berjadual di Wadi AnNour',
    targetAudience: 'Ahli Sukan Sunnah',
    status: 'Aktif'
  },
  {
    id: 'pkg-wadi-03',
    gelanggang: 'Wadi AnNour',
    title: 'Pakej Silat + Berkuda',
    price: 120,
    category: 'Pakej Khas',
    description: 'Latihan silat beserta sesi tunggangan kuda asas bulanan',
    targetAudience: 'Ahli Penunggang Kuda',
    status: 'Aktif'
  },
  {
    id: 'pkg-wadi-04',
    gelanggang: 'Wadi AnNour',
    title: 'Pakej Kombo Lengkap (Silat + Memanah + Berkuda)',
    price: 150,
    category: 'Pakej Khas',
    description: 'Pakej VIP integrasi penuh silat, kelab memanah & akademi berkuda Wadi AnNour',
    targetAudience: 'Ahli Kombo VIP',
    status: 'Aktif'
  },

  // PUSAKA WARISAN (Lunas) - Packages: Dewasa, Kanak-Kanak
  {
    id: 'pkg-pusaka-01',
    gelanggang: 'Pusaka Warisan',
    title: 'Pakej Silat Dewasa',
    price: 50,
    category: 'Yuran Bulanan',
    description: 'Latihan silat bulanan pesilat dewasa & belia Gelanggang Pusaka Warisan (Lunas)',
    targetAudience: 'Dewasa (18 Tahun Ke Atas)',
    status: 'Aktif'
  },
  {
    id: 'pkg-pusaka-02',
    gelanggang: 'Pusaka Warisan',
    title: 'Pakej Silat Kanak-Kanak / Remaja',
    price: 30,
    category: 'Yuran Bulanan',
    description: 'Yuran latihan silat cilik & pelajar sekolah menengah/rendah',
    targetAudience: 'Kanak-Kanak & Remaja',
    status: 'Aktif'
  },

  // GELANGGANG PAYA BESAR (Kulim / Sg Besar) - Packages: Budak Sekolah, Am
  {
    id: 'pkg-paya-01',
    gelanggang: 'Paya Besar',
    title: 'Pakej Budak Sekolah (Paya Besar)',
    price: 25,
    category: 'Yuran Bulanan',
    description: 'Yuran khas latihan silat bulanan pelajar sekolah Gelanggang Paya Besar',
    targetAudience: 'Budak Sekolah',
    status: 'Aktif'
  },
  {
    id: 'pkg-paya-02',
    gelanggang: 'Paya Besar',
    title: 'Pakej Silat Am',
    price: 35,
    category: 'Yuran Bulanan',
    description: 'Yuran latihan am bulanan gelanggang Paya Besar',
    targetAudience: 'Ahli Umum',
    status: 'Aktif'
  },

  // GENERAL PACKAGES (Semua Gelanggang)
  {
    id: 'pkg-gen-01',
    gelanggang: 'Semua Gelanggang',
    title: 'Yuran Pendaftaran Ahli Baharu',
    price: 50,
    category: 'Yuran Pendaftaran',
    description: 'Pendaftaran rasmi, kad keahlian, lencana & fail pengiktirafan ROS',
    targetAudience: 'Ahli Baharu',
    status: 'Aktif'
  },
  {
    id: 'pkg-gen-02',
    gelanggang: 'Semua Gelanggang',
    title: 'Yuran Ujian Bengkung',
    price: 35,
    category: 'Yuran Bengkung',
    description: 'Pengujian kemahiran jurus, siri penilaian & sijil pengiktirafan bengkung',
    targetAudience: 'Calon Ujian Bengkung',
    status: 'Aktif'
  }
];

export const SEED_INVOICES: InvoiceItem[] = [
  {
    id: 'inv-2026-001',
    invoiceNo: 'INV-2026-001',
    memberId: 'ASMM-001',
    memberName: 'Mohd Hafife Bin Abd Halim',
    memberIcNo: '850612025431',
    memberPhone: '0194589201',
    gelanggang: 'Wadi AnNour',
    category: 'Yuran Bulanan',
    title: 'Yuran Bulanan Latihan Silat Ogos 2026',
    description: 'Yuran latihan bulanan pesilat berdaftar ASMM bagi bulan Ogos 2026',
    amount: 40.00,
    dueDate: '2026-08-15',
    createdAt: '2026-08-01',
    status: 'Belum Dibayar'
  },
  {
    id: 'inv-2026-002',
    invoiceNo: 'INV-2026-002',
    memberId: 'ASMM-002',
    memberName: 'Mohd Shukor Bin Sahidin',
    memberIcNo: '880315025911',
    memberPhone: '0124475157',
    gelanggang: 'Wadi AnNour',
    category: 'Yuran Bulanan',
    title: 'Yuran Bulanan Latihan Silat Ogos 2026',
    description: 'Yuran latihan bulanan pesilat berdaftar ASMM bagi bulan Ogos 2026',
    amount: 40.00,
    dueDate: '2026-08-15',
    createdAt: '2026-08-01',
    status: 'Lulus / Dibayar',
    toyibBillCode: 'ASMM-FPX-841920',
    paidAt: '2026-08-01'
  },
  {
    id: 'inv-2026-003',
    invoiceNo: 'INV-2026-003',
    memberId: 'ASMM-003',
    memberName: 'Mohd Fauzi Bin Abd Aziz',
    memberIcNo: '820921025119',
    memberPhone: '0124475157',
    gelanggang: 'Wadi AnNour',
    category: 'Yuran Bengkung',
    title: 'Yuran Ujian Kenaikan Bengkung Hitam 2026',
    description: 'Yuran pentaksiran & pendaftaran sijil ujian bengkung ASMM',
    amount: 50.00,
    dueDate: '2026-08-20',
    createdAt: '2026-08-03',
    status: 'Belum Dibayar'
  },
  {
    id: 'inv-202609-015',
    invoiceNo: 'INV-202609-015',
    memberId: 'ASMM-015',
    memberName: 'Puan Zainab Binti Omar (Waris Mohammad Adam)',
    memberIcNo: '870412025890',
    memberPhone: '0195543210',
    gelanggang: 'Pusaka Warisan',
    category: 'Yuran Bulanan',
    title: 'Yuran Bulanan Latihan Silat September 2026',
    description: 'Yuran latihan bulanan pesilat berdaftar ASMM bagi bulan September 2026',
    amount: 20.00,
    dueDate: '2026-09-25',
    createdAt: '2026-09-01',
    status: 'Lulus / Dibayar',
    toyibBillCode: '132735344Q',
    transactionRef: '132735344Q',
    paidAt: '6 Sep 2026, 10:05 PM',
    paymentMethod: 'DuitNow QR (Maybank Scan & Pay)',
    receiptFileName: 'Maybank_ScanPay_132735344Q.pdf',
    items: [
      { id: 'item-1', description: 'Yuran Bulanan Latihan Silat September 2026', quantity: 1, unitPrice: 20.00, amount: 20.00 }
    ]
  },
  {
    id: 'inv-202609-018',
    invoiceNo: 'INV-202609-018',
    memberId: 'ASMM-018',
    memberName: 'Yasmin Dahlia Binti Roslan',
    memberIcNo: '120508026114',
    memberPhone: '0174829104',
    gelanggang: 'Wadi AnNour',
    category: 'Yuran Bulanan',
    title: 'Yuran Bulanan Latihan Silat September 2026',
    description: 'Yuran silat sept 2026 yasmin dahlia',
    amount: 40.00,
    dueDate: '2026-09-25',
    createdAt: '2026-09-01',
    status: 'Lulus / Dibayar',
    toyibBillCode: '12372550',
    transactionRef: '12372550',
    paidAt: '08 Sep 2026 03:28:58 PM',
    paymentMethod: 'DuitNow QR (CIMB OCTO)',
    receiptFileName: 'CIMB_OCTO_DuitNow_12372550.pdf',
    items: [
      { id: 'item-1', description: 'Yuran Bulanan Latihan Silat September 2026', quantity: 1, unitPrice: 40.00, amount: 40.00 }
    ]
  },
  {
    id: 'inv-2026-005',
    invoiceNo: 'INV-2026-Y001',
    memberId: 'ASMM-002',
    memberName: 'Mohd Shukor Bin Sahidin',
    memberIcNo: '880315025911',
    memberPhone: '0124475157',
    gelanggang: 'Wadi AnNour',
    category: 'Yuran Bulanan',
    title: 'Yuran Tahunan Latihan Silat 2026/2027',
    description: 'Yuran latihan tahunan (12 bulan) pesilat berdaftar ASMM — Jimat 10% berbanding bayaran bulanan',
    amount: 432.00,
    dueDate: '2026-09-01',
    createdAt: '2026-08-05',
    status: 'Belum Dibayar',
    billingCycle: 'Tahunan',
    billingMonths: 12,
    originalMonthlyPrice: 40,
    discountPercent: 10
  }
];

export function cleanSyllabusSectionTitle(title: string): string {
  if (!title) return '';
  let clean = title.replace(/^Modul\s+\d+:\s*/i, '').trim();
  // Strip any trailing or nested (10 Bulan) or (X Bulan)
  clean = clean.replace(/\s*\(\s*\d+\s*bulan\s*\)/gi, '').trim();

  if (clean.startsWith('Bengkung Hitam —') || clean === 'Bengkung Hitam' || clean === 'Bengkung Tunas Pendekar') {
    return 'Bengkung Tunas Pendekar';
  }
  if (clean.startsWith('Bengkung Hitam 1') || clean.includes('Tunas Pendekar Muda')) {
    return 'Bengkung Tunas Pendekar Muda';
  }
  if (clean.startsWith('Bengkung Hitam 2') || clean.includes('Tunas Pendekar Kanan')) {
    return 'Bengkung Tunas Pendekar Kanan';
  }
  if (clean.startsWith('Bengkung Hitam 3') || clean.includes('Tunas Pendekar Sulung')) {
    return 'Bengkung Tunas Pendekar Sulung';
  }
  if (clean.startsWith('Bengkung Putih —') || clean === 'Bengkung Putih' || clean.includes('Putih Kosong')) {
    return 'Bengkung Putih Kosong';
  }
  if (clean.startsWith('Bengkung Putih 1')) {
    return 'Bengkung Putih 1';
  }
  if (clean.startsWith('Bengkung Putih 2')) {
    return 'Bengkung Putih 2';
  }
  if (clean.startsWith('Bengkung Putih 3')) {
    return 'Bengkung Putih 3';
  }
  if (clean.startsWith('Bengkung Merah —') || clean === 'Bengkung Merah' || clean.includes('Merah Kosong')) {
    return 'Bengkung Merah Kosong';
  }
  if (clean.startsWith('Bengkung Merah 1')) {
    return 'Bengkung Merah 1';
  }
  if (clean.startsWith('Bengkung Merah 2')) {
    return 'Bengkung Merah 2';
  }
  if (clean.startsWith('Bengkung Merah 3')) {
    return 'Bengkung Merah 3';
  }
  if (clean.startsWith('Bengkung Kuning —') || clean === 'Bengkung Kuning' || clean.includes('Kuning Kosong')) {
    return 'Bengkung Kuning Kosong';
  }
  if (clean.startsWith('Pangkat Jurulatih') || clean.includes('Pangkat-Pangkat Jurulatih')) {
    return 'Pangkat Jurulatih (Kuning 1 – 7)';
  }
  if (clean.includes('Biru Samudera')) {
    return 'Bengkung Biru Samudera';
  }
  return clean;
}

// Local Storage Storage Keys
const KEYS = {
  MEMBERS: 'asmm_db_members_v4',
  NOTICES: 'asmm_db_notices_v4',
  TRANSACTIONS: 'asmm_db_transactions_v4',
  FILES: 'asmm_db_files_v4',
  GELANGGANG: 'asmm_db_gelanggang_v5',
  SYLLABUS: 'asmm_db_syllabus_v7',
  FEE_PACKAGES: 'asmm_db_fee_packages_v4',
  INVOICES: 'asmm_db_invoices_v4',
  MERCHANDISE_ITEMS: 'asmm_db_merch_items_v1',
  MERCHANDISE_ORDERS: 'asmm_merchandise_orders_v1',
  GRANT_PROPOSALS: 'asmm_grant_proposals_v1',
  ASSOCIATION_ASSETS: 'asmm_association_assets_v1',
  ASSET_RENTAL_LOGS: 'asmm_asset_rental_logs_v1',
  TRAINER_ALLOWANCES: 'asmm_trainer_allowances_v1',
  DONATION_CAMPAIGNS: 'asmm_donation_campaigns_v1',
  DONATIONS: 'asmm_donations_v1',
  SYLLABUS_GRADING: 'asmm_syllabus_grading_v1',
  UJIAN_BENGKUNG_REGISTRATIONS: 'asmm_ujian_bengkung_registrations_v1',
  UJIAN_BENGKUNG_FEES: 'asmm_ujian_bengkung_fees_v1',
  BENGKUNG_RANKS: 'asmm_bengkung_ranks_custom_v1',
  DELETED_INVOICES: 'asmm_db_deleted_invoices_v1',
  DELETED_NOTICES: 'asmm_db_deleted_notices_v1',
  DELETED_MEMBERS: 'asmm_db_deleted_members_v1',
  DELETED_TRANSACTIONS: 'asmm_db_deleted_transactions_v1',
  AVAILABILITY: 'asmm_availability_v1',
  ROLES: 'asmm_roles_definitions_v1',
  PERMISSIONS: 'asmm_permissions_definitions_v1',
  ROLE_PERMS: 'asmm_role_permissions_map_v1',
  ALERT_SETTINGS: 'asmm_alert_settings_v1',
  PERSATUAN_PAYMENT_SETTINGS: 'asmm_persatuan_payment_settings_v1',
  SELLER_PAYMENT_SETTINGS: 'asmm_seller_payment_settings_v1',
  UJIAN_GRADING_ASSESSMENTS: 'asmm_ujian_grading_assessments_v1',
  UJIAN_BERTULIS_ATTEMPTS: 'asmm_ujian_bertulis_attempts_v1',
  UJIAN_BERTULIS_KEY_UNLOCKED: 'asmm_ujian_bertulis_key_unlocked_v1'
};

export const SEED_DONATION_CAMPAIGNS: DonationCampaign[] = [
  {
    id: 'tabung-pembangunan-gelanggang-lunas',
    title: 'Tabung Pembangunan Gelanggang Silat & Karpet Keselamatan Lunas',
    category: 'Pembangunan Gelanggang',
    targetAmount: 15000,
    currentAmount: 9450,
    donorCount: 48,
    coverImage: '/badges/pusaka-warisan-lunas.jpg',
    story: 'Gelanggang Pusaka Warisan di Lunas memerlukan dana wakaf bagi menggantikan 100 keping puzzle mat EVA ketumpatan tinggi (4.0cm) untuk keselamatan latihan jatuh pesilat kanak-kanak dan remaja. Di samping itu, dana ini turut menampung pemasangan lampu limpah solar LED untuk sesi latihan malam.',
    organizerName: 'Persatuan Seni Silat Awang Sulung Merah Muda Kedah',
    beneficiaryGelanggang: 'Pusaka Warisan',
    startDate: '2026-08-01',
    endDate: '2026-09-30',
    status: 'Aktif',
    isFeatured: true,
    impactMilestones: [
      { amount: 50, description: '1 Keping Puzzle Mat EVA Keselamatan Latihan' },
      { amount: 150, description: '1 Unit Lampu Limpah Solar LED Padang Latihan' },
      { amount: 300, description: '1 Set Target Pad & Pao Tendangan Silat' },
      { amount: 500, description: 'Penajaan Lengkap 1 Petak Latihan Jatuhan Silat' }
    ]
  },
  {
    id: 'tabung-kebajikan-pesilat-asnaf',
    title: 'Tabung Kebajikan Pesilat Muda & Anak Asnaf ASMM Kedah',
    category: 'Kebajikan & Asnaf',
    targetAmount: 8000,
    currentAmount: 5200,
    donorCount: 31,
    coverImage: '/badges/wadi-annour-kulim.jpg',
    story: 'Inisiatif bantuan yuran latihan bulanan, sepersalinan uniform silat hitam percuma, dan bantuan pengangkutan bagi anak-anak pesilat daripada keluarga asnaf dan anak yatim di sekitar daerah Kulim & Lunas agar tiada anak muda yang tercicir mempelajari seni warisan bangsa.',
    organizerName: 'Biro Sosial & Kebajikan ASMM',
    beneficiaryGelanggang: 'Wadi AnNour',
    startDate: '2026-08-05',
    endDate: '2026-10-31',
    status: 'Aktif',
    isFeatured: false,
    impactMilestones: [
      { amount: 35, description: 'Bantuan Yuran Latihan 1 Bulan Pesilat Asnaf' },
      { amount: 75, description: 'Sepasang Baju Silat Rasmi Lengkap Bengkung' },
      { amount: 150, description: 'Bantuan Sara Hidup & Latihan Silat 1 Penggal' }
    ]
  },
  {
    id: 'tabung-pemeliharaan-busana-senjata',
    title: 'Dana Pemeliharaan Busana Warisan, Tanjak & Senjata Silat Melayu',
    category: 'Peralatan & Busana',
    targetAmount: 10000,
    currentAmount: 6800,
    donorCount: 24,
    coverImage: '/asmm_tanjak.png',
    story: 'Pemeliharaan dan perolehan busana tradisional pesilat, tengkolok songket warisan, set gendang silat / serunai tradisional serta replika senjata seni silat berdaftar untuk kegunaan demonstrasi kebudayaan peringkat negeri dan kebangsaan.',
    organizerName: 'Biro Keusahawanan & Kebudayaan ASMM',
    beneficiaryGelanggang: 'Semua Gelanggang',
    startDate: '2026-07-15',
    endDate: '2026-11-30',
    status: 'Aktif',
    isFeatured: false,
    impactMilestones: [
      { amount: 50, description: '1 Unit Tanjak Warisan Songket Emas' },
      { amount: 120, description: '1 Pasang Busana Pertunjukan Silat Tradisional' },
      { amount: 400, description: '1 Unit Gendang Anak / Ibu Silat Tradisional' }
    ]
  },
  {
    id: 'tabung-kontinjen-kejuaraan-silat',
    title: 'Tabung Kontinjen Kejuaraan Silat Antarabangsa & Kebangsaan 2026',
    category: 'Kontinjen & Sukan',
    targetAmount: 6000,
    currentAmount: 4150,
    donorCount: 19,
    coverImage: '/badges/paya-besar-kulim.jpg',
    story: 'Menampung kos pengangkutan bas kontinjen, penginapan atlet silat cilik dan pesilat remaja ASMM, serta peralatan perlindungan pertandingan semasa menyertai temasya Kejuaraan Silat Antarabangsa 2026.',
    organizerName: 'Biro Latihan & Sukan ASMM',
    beneficiaryGelanggang: 'Paya Besar',
    startDate: '2026-08-10',
    endDate: '2026-09-15',
    status: 'Aktif',
    isFeatured: false,
    impactMilestones: [
      { amount: 60, description: 'Pek Makanan & Nutrisi Atlet Kejohanan' },
      { amount: 100, description: 'Yuran Pendaftaran Acara Tanding / Seni Silat' },
      { amount: 250, description: 'Penginapan & Pengangkutan 1 Atlet Silat' }
    ]
  }
];

export const SEED_DONATIONS: DonationRecord[] = [
  {
    id: 'don-001',
    campaignId: 'tabung-pembangunan-gelanggang-lunas',
    campaignTitle: 'Tabung Pembangunan Gelanggang Silat & Karpet Keselamatan Lunas',
    amount: 250,
    donorName: 'Hj. Kamaruddin Bin Ismail',
    isAnonymous: false,
    donorEmail: 'kamaruddin@gmail.com',
    donorPhone: '0194581122',
    message: 'Infaq wakaf gelanggang untuk keselamatan anak-anak muda kita belajar ilmu mempertahankan diri. Semoga ASMM terus diberkati.',
    infaqType: 'Wakaf Gelanggang',
    paymentMethod: 'ToyyibPay FPX',
    transactionRef: 'ASMM-FPX-901123',
    status: 'Berjaya',
    createdAt: '2026-08-20 14:32'
  },
  {
    id: 'don-002',
    campaignId: 'tabung-pembangunan-gelanggang-lunas',
    campaignTitle: 'Tabung Pembangunan Gelanggang Silat & Karpet Keselamatan Lunas',
    amount: 100,
    donorName: 'Hamba Allah',
    isAnonymous: true,
    donorEmail: 'hambaallah@gmail.com',
    donorPhone: '0124458921',
    message: 'Semoga persatuan terus melahirkan generasi pendekar yang berakhlak mulia dan berdisiplin tinggi.',
    infaqType: 'Sedekah Jariah',
    paymentMethod: 'ToyyibPay FPX',
    transactionRef: 'ASMM-FPX-901145',
    status: 'Berjaya',
    createdAt: '2026-08-21 09:15'
  },
  {
    id: 'don-003',
    campaignId: 'tabung-kebajikan-pesilat-asnaf',
    campaignTitle: 'Tabung Kebajikan Pesilat Muda & Anak Asnaf ASMM Kedah',
    amount: 150,
    donorName: 'Cikgu Noraini Binti Ahmad',
    isAnonymous: false,
    donorEmail: 'noraini@moe.gov.my',
    donorPhone: '0134882190',
    message: 'Sumbangan ikhlas untuk anak-anak asnaf. Teruskan usaha murni ini membimbing belia ke arah kebaikan.',
    infaqType: 'Kebajikan Pesilat',
    paymentMethod: 'DuitNow QR',
    transactionRef: 'QR-DN-884129',
    status: 'Berjaya',
    createdAt: '2026-08-22 11:05'
  },
  {
    id: 'don-004',
    campaignId: 'tabung-pembangunan-gelanggang-lunas',
    campaignTitle: 'Tabung Pembangunan Gelanggang Silat & Karpet Keselamatan Lunas',
    amount: 50,
    donorName: 'Hamba Allah',
    isAnonymous: true,
    donorEmail: 'infaq@yahoo.com',
    donorPhone: '0174829104',
    message: 'Wakaf sebahagian rezeki buat gelanggang silat.',
    infaqType: 'Wakaf Gelanggang',
    paymentMethod: 'ToyyibPay FPX',
    transactionRef: 'ASMM-FPX-901188',
    status: 'Berjaya',
    createdAt: '2026-08-23 16:40'
  },
  {
    id: 'don-005',
    campaignId: 'tabung-kontinjen-kejuaraan-silat',
    campaignTitle: 'Tabung Kontinjen Kejuaraan Silat Antarabangsa & Kebangsaan 2026',
    amount: 300,
    donorName: 'En. Razak & Keluarga',
    isAnonymous: false,
    donorEmail: 'razak.auto@gmail.com',
    donorPhone: '0195829104',
    message: 'Selamat berjuang pesilat muda ASMM! Bawa pulang kejayaan untuk negeri Kedah!',
    infaqType: 'Sumbangan Am',
    paymentMethod: 'ToyyibPay FPX',
    transactionRef: 'ASMM-FPX-901201',
    status: 'Berjaya',
    createdAt: '2026-08-24 08:20'
  }
];


export const SEED_MERCHANDISE_ITEMS: MerchandiseItem[] = [
  {
    id: 'merch-baju-silat',
    name: 'Baju Silat Awang Sulung Merah Muda',
    category: 'Pakaian',
    price: 120.0,
    description: 'Baju silat hitam rasmi persatuan diperbuat daripada kain kapas (cotton) tebal berkualiti tinggi yang tahan lasak untuk latihan dan pertunjukan. Lengkap dengan logo sulaman ASMM yang eksklusif mengikut ketetapan saiz pendaftaran rasmi.',
    photoUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1792429117/asmm/merchandise/merch-baju-silat.jpg',
    sizes: ['110cm', '120cm', '130cm', '140cm', '150cm', '160cm', '170cm', '180cm', '190cm', '200cm', '210cm'],
    stockStatus: 'Dalam Stok',
    specifications: {
      "Bahan": "Kapas Premium 100%",
      "Warna": "Hitam dengan Sulaman Merah/Kuning",
      "Sesuai Untuk": "Latihan Mingguan & Kejohanan Resmi",
      "Kandungan Pakej": "1 x Baju, 1 x Seluar (Bengkung dijual berasingan)"
    },
    variations: ['Hitam Sulaman Standard', 'Hitam Sulaman Khas Emas'],
    userId: 'ASMM-011',
    deliveryMethods: ['Ambil di Gelanggang']
  },
  {
    id: 'merch-tanjak',
    name: 'Tanjak Hitam Warisan ASMM',
    category: 'Kelengkapan',
    price: 50.0,
    description: 'Tanjak warisan tradisional Melayu ditenun kemas dengan songket benang emas asli. Jahitan stabil, kukuh, dan dilengkapi dengan tapak boleh laras mengikut saiz kepala.',
    photoUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1792429119/asmm/merchandise/merch-tanjak.jpg',
    stockStatus: 'Dalam Stok',
    specifications: {
      "Bahan": "Songket Asli Tenunan Tangan",
      "Warna": "Hitam corak Benang Emas",
      "Jenis Lipatan": "Lipatan Dendam Tak Sudah (Modifikasi ASMM)",
      "Laras Saiz": "Pengikat Velcro premium di bahagian belakang"
    },
    variations: ['Emas Standard', 'Perak Premium'],
    userId: 'ASMM-011',
    deliveryMethods: ['Ambil di Gelanggang']
  },
  {
    id: 'merch-keychain',
    name: 'Keychain Ukiran Kayu ASMM',
    category: 'Aksesori',
    price: 10.0,
    description: 'Keychain ukiran laser laser-cut daripada kayu oak asli mempamerkan simbol rasmi Awang Sulung Merah Muda. Sesuai dijadikan cenderahati atau hiasan beg.',
    photoUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1792429118/asmm/merchandise/merch-keychain.jpg',
    stockStatus: 'Dalam Stok',
    specifications: {
      "Bahan": "Kayu Oak Asli Bersalut Pelindung",
      "Saiz": "5cm x 5cm x 0.5cm",
      "Ukiran": "Laser Engraving Dua Sisi",
      "Rantai": "Keluli Tahan Karat (Stainless Steel)"
    },
    variations: ['Kayu Oak Klasik', 'Kayu Maple Terang'],
    userId: 'ASMM-011',
    deliveryMethods: ['Ambil di Gelanggang']
  },
  {
    id: 'merch-tshirt',
    name: 'T-Shirt Sukan Raglan ASMM',
    category: 'Pakaian',
    price: 35.0,
    description: 'T-Shirt raglan kasual mikro-fiber mesra peluh dengan kombinasi warna hitam-merah rasmi persatuan. Sesuai untuk latihan kecergasan luar dan riadah santai.',
    photoUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1792429119/asmm/merchandise/merch-tshirt.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    stockStatus: 'Stok Rendah',
    specifications: {
      "Bahan": "Mikro-fiber Quick-Dry",
      "Kadar Pengudaraan": "Sangat Baik (Mesra Peluh)",
      "Warna": "Raglan Hitam-Merah",
      "Cetak": "Silkscreen Logo ASMM belakang & dada kiri"
    },
    variations: ['Lengan Pendek', 'Lengan Panjang (Muslimah)'],
    userId: 'ASMM-011',
    deliveryMethods: ['Ambil di Gelanggang']
  },
  {
    id: 'merch-bengkung',
    name: 'Bengkung Silat Rasmi',
    category: 'Kelengkapan',
    price: 25.0,
    description: 'Bengkung kain satin berkilat rasmi mengikut peringkat cula bengkung silat (Putih, Hitam, Merah, Kuning). Dibuat mengikut ketetapan saiz standard persatuan.',
    photoUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1792429089/asmm/merchandise/merch-bengkung-rasmi.jpg',
    sizes: ['Putih (Pesilat Muda)', 'Hitam (Tunas Pendekar)', 'Merah (Pembantu Jurulatih)', 'Kuning (Penolong Jurulatih)'],
    stockStatus: 'Dalam Stok',
    specifications: {
      "Bahan": "Kain Satin Berkilat Premium",
      "Lebar": "8cm",
      "Panjang": "220cm",
      "Jahitan": "Ganda Tepi (Kemasan Kemas)"
    },
    variations: ['Cula Putih', 'Cula Hitam', 'Cula Merah', 'Cula Kuning'],
    userId: 'ASMM-011',
    deliveryMethods: ['Ambil di Gelanggang']
  }
];

// ============================================================
// TURSO OPTIMIZATION: Singleton init, throttle & dedup guards
// ============================================================
let _dbInitialized = false;

// Table-specific TTLs to protect Turso quota (in milliseconds)
const TABLE_REFRESH_TTL_MS: Record<string, number> = {
  donation_campaigns: 10 * 60 * 1000, // 10 minutes
  donations: 10 * 60 * 1000,          // 10 minutes
  gelanggang: 30 * 60 * 1000,         // 30 minutes
  syllabus: 60 * 60 * 1000,           // 60 minutes
  fee_packages: 30 * 60 * 1000,       // 30 minutes
  merchandise_items: 15 * 60 * 1000,  // 15 minutes
  members: 5 * 60 * 1000,             // 5 minutes
  notices: 5 * 60 * 1000,             // 5 minutes
  invoices: 5 * 60 * 1000,            // 5 minutes
  transactions: 5 * 60 * 1000,        // 5 minutes
  files: 30 * 60 * 1000               // 30 minutes
};

const _lastTursoFetch: Record<string, number> = {};
const _inflightRefresh: Record<string, Promise<any> | null> = {};
let _monthlyInvoicesChecked = false;

function shouldRefreshFromTurso(table: string): boolean {
  const last = _lastTursoFetch[table] || 0;
  const ttl = TABLE_REFRESH_TTL_MS[table] || (5 * 60 * 1000);
  return (Date.now() - last) > ttl;
}

function markTursoFetched(table: string): void {
  _lastTursoFetch[table] = Date.now();
}

/**
/**
 * Helper to generate SQL and arguments for upserting a member into Turso DB.
 */
export function getMemberSqlUpsert(m: UserProfile) {
  const cleanIcNo = sanitizeIc(m.icNo);
  const cleanPhone = sanitizePhone(m.phone);
  const cleanName = toTitleCase(m.name) || 'Pesilat ASMM';
  const cleanKinName = m.kinName ? toTitleCase(m.kinName) : null;
  const cleanKinPhone = m.kinPhone ? sanitizePhone(m.kinPhone) : null;
  const rolesList: Role[] = (m.roles && Array.isArray(m.roles) && m.roles.length > 0)
    ? Array.from(new Set(m.roles))
    : (m.role ? [m.role] : ['Ahli']);
  const primaryRole = m.role || rolesList[0] || 'Ahli';
  const rolesJson = JSON.stringify(rolesList);

  const isOldMemberNum = m.isOldMember ? 1 : 0;
  const onbStatus = m.onboardingStatus || (m.isOldMember ? 'completed' : 'pending_payment');

  return {
    sql: `REPLACE INTO members (id, name, icNo, email, phone, role, gelanggang, bengkung, photoUrl, status, parentId, password, sessionTime, joinedDate, relationship, firebaseUid, authProvider, address, occupation, kinName, kinPhone, bengkungBadge, approvedBy, approvedByName, approvedAt, rejectedBy, rejectedByName, rejectedAt, rejectionReason, roles, onboardingStatus, isOldMember, onboardingInvoiceId, uniformSize) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [
      m.id,
      cleanName,
      cleanIcNo,
      (m.email || '').toLowerCase().trim(),
      cleanPhone,
      primaryRole,
      m.gelanggang || 'Pusaka Warisan',
      m.bengkung || 'Putih 0 (Pesilat Asas)',
      m.photoUrl || DEFAULT_AVATAR_URL,
      m.status || 'Aktif',
      m.parentId || null,
      m.password || null,
      m.sessionTime || null,
      m.joinedDate || null,
      m.relationship || null,
      m.firebaseUid || null,
      m.authProvider || null,
      m.address || null,
      m.occupation || null,
      cleanKinName,
      cleanKinPhone,
      m.bengkungBadge || null,
      m.approvedBy || null,
      m.approvedByName || null,
      m.approvedAt || null,
      m.rejectedBy || null,
      m.rejectedByName || null,
      m.rejectedAt || null,
      m.rejectionReason || null,
      rolesJson,
      onbStatus,
      isOldMemberNum,
      m.onboardingInvoiceId || null,
      m.uniformSize || null
    ]
  };
}

/**
 * Merges two UserProfile objects by combining best attributes, preferring canonical seed records and populated fields.
 */
export function mergeTwoMemberProfiles(a: UserProfile, b: UserProfile): UserProfile {
  // Determine canonical ID
  // Priority: Seed member IDs (e.g. 'asmm-001' .. 'asmm-011') > custom ID > lower numeric ASMM-xxx
  let canonicalId = (a.id || '').trim().toUpperCase();
  const isASeed = a.id.toLowerCase().startsWith('asmm-0');
  const isBSeed = b.id.toLowerCase().startsWith('asmm-0');
  if (isBSeed && !isASeed) {
    canonicalId = (b.id || '').trim().toUpperCase();
  } else if (!isASeed && !isBSeed && b.id && (!a.id || b.id < a.id)) {
    canonicalId = (b.id || '').trim().toUpperCase();
  }

  // Name resolution: prefer valid incoming name from b, otherwise fallback to a
  const cleanName = (b.name && b.name.trim() && b.name !== 'Pesilat ASMM' && b.name !== 'Ahli ASMM')
    ? b.name.trim()
    : ((a.name && a.name !== 'Pesilat ASMM' && a.name !== 'Ahli ASMM') ? a.name.trim() : (b.name || a.name || 'Pesilat ASMM'));

  // IC & Phone resolution: prefer incoming values from b
  const cleanIcNo = (b.icNo && b.icNo.replace(/\D/g, '').length >= 6)
    ? b.icNo.replace(/[\s-]/g, '').trim()
    : (a.icNo ? a.icNo.replace(/[\s-]/g, '').trim() : '');

  const cleanEmail = (b.email !== undefined && b.email !== null)
    ? b.email.toLowerCase().trim()
    : (a.email ? a.email.toLowerCase().trim() : '');

  const cleanPhone = (b.phone && b.phone.replace(/\D/g, '').length >= 8)
    ? b.phone.replace(/[\s-]/g, '').trim()
    : (a.phone ? a.phone.replace(/[\s-]/g, '').trim() : '');

  // Role resolution (seeds/leadership roles win over generic 'Ahli', but if b has an explicit non-Ahli role it is preserved)
  const seedMatch = SEED_MEMBERS.find(s => s.id.toLowerCase() === canonicalId.toLowerCase());
  const role = (b.role && b.role !== 'Ahli' && b.role !== 'Waris')
    ? b.role
    : (seedMatch ? seedMatch.role : ((a.role && a.role !== 'Ahli' && a.role !== 'Waris') ? a.role : (b.role || a.role || 'Ahli')));

  // Multi-roles resolution
  const bRoles: Role[] = (b.roles && Array.isArray(b.roles) && b.roles.length > 0) ? b.roles : (b.role ? [b.role] : []);
  const aRoles: Role[] = (a.roles && Array.isArray(a.roles) && a.roles.length > 0) ? a.roles : (a.role ? [a.role] : []);
  const combinedRoles = Array.from(new Set([...bRoles, ...aRoles].filter(Boolean) as Role[]));
  const finalRoles: Role[] = combinedRoles.length > 0 ? combinedRoles : [role as Role];
  const finalPrimaryRole: Role = role && finalRoles.includes(role as Role) ? (role as Role) : (finalRoles[0] || 'Ahli');

  let rawGelanggang = (b.gelanggang && (b.gelanggang as string) !== 'Tiada')
    ? b.gelanggang
    : (a.gelanggang || b.gelanggang || 'Pusaka Warisan');
  const gelanggang = rawGelanggang === 'Semua Gelanggang' ? 'ASMM' : rawGelanggang;

  const bengkung = (b.bengkung && b.bengkung !== 'Putih' && b.bengkung !== 'putih0' && b.bengkung !== 'Putih 0 (Pesilat Asas)')
    ? b.bengkung
    : (a.bengkung || b.bengkung || 'Putih 0 (Pesilat Asas)');

  const bengkungBadge = (b.bengkungBadge && b.bengkungBadge !== '/badges/default.jpeg' && b.bengkungBadge !== '/badges/putih0.png')
    ? b.bengkungBadge
    : (a.bengkungBadge || b.bengkungBadge || '/badges/putih0.png');

  // Photo resolution: prefer actual photo from b over default placeholders
  const photoUrl = !isDefaultPhoto(b.photoUrl)
    ? b.photoUrl
    : (!isDefaultPhoto(a.photoUrl) ? a.photoUrl : DEFAULT_AVATAR_URL);

  const status = (b.status === 'Aktif' || a.status === 'Aktif') ? (b.status || a.status || 'Aktif') : (b.status || a.status || 'Aktif');

  const firebaseUid = b.firebaseUid || a.firebaseUid || undefined;
  const password = b.password || a.password || undefined;

  let authProvider: 'password' | 'google' | 'both' | undefined = undefined;
  if (firebaseUid && password) {
    authProvider = 'both';
  } else if (firebaseUid) {
    authProvider = 'google';
  } else if (password) {
    authProvider = 'password';
  } else {
    authProvider = b.authProvider || a.authProvider;
  }

  // Address, Occupation, Kin Details: Incoming b's value MUST overwrite if provided!
  const address = (b.address !== undefined && b.address !== null && b.address.trim() !== '')
    ? b.address.trim()
    : (a.address ? a.address.trim() : '');

  const occupation = (b.occupation !== undefined && b.occupation !== null && b.occupation.trim() !== '')
    ? b.occupation.trim()
    : (a.occupation ? a.occupation.trim() : '');

  const kinName = (b.kinName !== undefined && b.kinName !== null && b.kinName.trim() !== '')
    ? b.kinName.trim()
    : (a.kinName ? a.kinName.trim() : '');

  const kinPhone = (b.kinPhone !== undefined && b.kinPhone !== null && b.kinPhone.trim() !== '')
    ? b.kinPhone.trim()
    : (a.kinPhone ? a.kinPhone.trim() : '');

  return {
    id: canonicalId,
    name: cleanName,
    icNo: cleanIcNo,
    email: cleanEmail,
    phone: cleanPhone,
    role: finalPrimaryRole,
    roles: finalRoles,
    gelanggang,
    bengkung,
    bengkungBadge,
    photoUrl,
    status,
    parentId: (canonicalId === 'ASMM-014' || canonicalId === 'ASMM-016') ? 'ASMM-011' : (canonicalId === 'ASMM-017' ? 'ASMM-015' : (b.parentId || a.parentId)),
    relationship: b.relationship || a.relationship,
    password,
    sessionTime: b.sessionTime || a.sessionTime,
    joinedDate: b.joinedDate || a.joinedDate || new Date().toISOString().split('T')[0],
    firebaseUid,
    authProvider,
    address,
    occupation,
    kinName,
    kinPhone,
    approvedBy: b.approvedBy || a.approvedBy,
    approvedByName: b.approvedByName || a.approvedByName,
    approvedAt: b.approvedAt || a.approvedAt,
    rejectedBy: b.rejectedBy || a.rejectedBy,
    rejectedByName: b.rejectedByName || a.rejectedByName,
    rejectedAt: b.rejectedAt || a.rejectedAt,
    rejectionReason: b.rejectionReason || a.rejectionReason,
    isOldMember: b.isOldMember !== undefined ? b.isOldMember : a.isOldMember,
    onboardingStatus: b.onboardingStatus || a.onboardingStatus,
    onboardingInvoiceId: b.onboardingInvoiceId || a.onboardingInvoiceId,
    uniformSize: b.uniformSize || a.uniformSize
  };
}

/**
 * Permanently records one or more deleted entity IDs in aaPanel MySQL deleted_records table
 * and synchronizes with local storage blacklist across all client sessions.
 */
export async function recordDeletedEntities(ids: string[], entityType: string): Promise<void> {
  if (!ids || ids.length === 0) return;
  const cleanIds = Array.from(new Set(ids.map(id => (id || '').trim()).filter(Boolean)));
  if (cleanIds.length === 0) return;

  // 1. Update local storage blacklist immediately
  try {
    const key = `asmm_db_deleted_${entityType}s_v1`;
    const raw = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    const set = new Set<string>(raw ? JSON.parse(raw) : []);
    cleanIds.forEach(id => {
      set.add(id);
      set.add(id.toLowerCase());
      set.add(id.toUpperCase());
    });
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(Array.from(set)));
    }
  } catch { }

  // 2. Persist to MySQL deleted_records table (awaited for persistence across all browsers/devices)
  const statements = cleanIds.map(id => ({
    sql: `INSERT IGNORE INTO deleted_records (id, entity_type) VALUES (?, ?);`,
    args: [id, entityType]
  }));
  await executeTursoBatch(statements).catch(err => {
    console.warn(`Failed to persist deleted ${entityType} records in aaPanel:`, err);
  });
}

export async function recordDeletedEntity(id: string, entityType: string): Promise<void> {
  return recordDeletedEntities([id], entityType);
}

export async function fetchDeletedEntityIds(entityType: string): Promise<Set<string>> {
  const result = new Set<string>();

  // 1. Instant read from local storage
  try {
    const key = `asmm_db_deleted_${entityType}s_v1`;
    const raw = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    if (raw) {
      const parsed: string[] = JSON.parse(raw);
      parsed.forEach(id => {
        const clean = (id || '').trim();
        if (clean) {
          result.add(clean);
          result.add(clean.toLowerCase());
          result.add(clean.toUpperCase());
        }
      });
    }
  } catch { }

  // 2. Fetch remote source of truth from aaPanel MySQL
  try {
    const res = await executeTursoQuery(
      `SELECT id FROM deleted_records WHERE entity_type = ?;`,
      [entityType]
    );
    if (res && res.rows && Array.isArray(res.rows)) {
      res.rows.forEach((r: any) => {
        const id = String(r.id ?? r[0] ?? '').trim();
        if (id) {
          result.add(id);
          result.add(id.toLowerCase());
          result.add(id.toUpperCase());
        }
      });
      // Save merged blacklist to local storage
      const key = `asmm_db_deleted_${entityType}s_v1`;
      if (typeof window !== 'undefined') {
        localStorage.setItem(key, JSON.stringify(Array.from(result)));
      }
    }
  } catch (err) {
    console.warn(`Notice reading remote deleted_${entityType} records:`, err);
  }

  return result;
}

export function getDeletedMemberIds(): Set<string> {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DELETED_MEMBERS) : null;
    return new Set<string>(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set<string>();
  }
}

export function filterOutDeletedMembers(list: UserProfile[]): UserProfile[] {
  const deleted = getDeletedMemberIds();
  if (deleted.size === 0) return list;
  return list.filter(m => {
    if (!m || !m.id) return false;
    const clean = m.id.trim().toUpperCase();
    return !deleted.has(clean) && !deleted.has(clean.toLowerCase());
  });
}

/**
 * Sanitizes and merges member data across local and remote sources.
 * Intelligently merges duplicates sharing the same Email, IC, Firebase UID, or ID.
 */
export function sanitizeAndMergeMembers(rawMembers: UserProfile[]): {
  merged: UserProfile[];
  duplicatesToDelete: string[];
  canonicalHafiz: UserProfile | null;
  modified: boolean;
} {
  const deleted = getDeletedMemberIds();
  if (!rawMembers || !Array.isArray(rawMembers)) {
    return { merged: [], duplicatesToDelete: [], canonicalHafiz: null, modified: false };
  }

  const duplicatesToDelete: string[] = [];
  let modified = false;

  const mergedList: UserProfile[] = [];
  const emailToMergedIndex = new Map<string, number>();
  const icToMergedIndex = new Map<string, number>();
  const idToMergedIndex = new Map<string, number>();
  const uidToMergedIndex = new Map<string, number>();

  for (const raw of rawMembers) {
    if (!raw) continue;
    const cleanId = (raw.id || '').trim().toUpperCase();
    if (deleted.has(cleanId) || deleted.has(cleanId.toLowerCase())) {
      continue;
    }
    const cleanEmail = (raw.email || '').toLowerCase().trim();
    const cleanIc = (raw.icNo || '').replace(/\D/g, '');
    const cleanUid = (raw.firebaseUid || '').trim();

    // Prioritize ID and IC matching over Email so distinct individuals sharing family email are not merged/deleted!
    let existingIndex = -1;
    if (cleanId && idToMergedIndex.has(cleanId.toLowerCase())) {
      existingIndex = idToMergedIndex.get(cleanId.toLowerCase())!;
    } else if (cleanIc && cleanIc.length >= 10 && icToMergedIndex.has(cleanIc)) {
      existingIndex = icToMergedIndex.get(cleanIc)!;
    } else if (cleanUid && uidToMergedIndex.has(cleanUid)) {
      existingIndex = uidToMergedIndex.get(cleanUid)!;
    } else if (cleanEmail && emailToMergedIndex.has(cleanEmail)) {
      const candIdx = emailToMergedIndex.get(cleanEmail)!;
      const cand = mergedList[candIdx];
      const samePerson = (!cand.icNo || !cleanIc || cand.icNo === cleanIc) &&
        (!cand.name || !raw.name || cand.name.toLowerCase().trim() === raw.name.toLowerCase().trim());
      if (samePerson) {
        existingIndex = candIdx;
      }
    }

    if (existingIndex >= 0) {
      // Merge with existing record
      const existing = mergedList[existingIndex];
      const mergedProfile = {
        ...mergeTwoMemberProfiles(existing, raw),
        id: (existing.id || cleanId).trim().toUpperCase()
      };

      if (raw.id && raw.id !== mergedProfile.id) {
        duplicatesToDelete.push(raw.id);
      }
      mergedList[existingIndex] = mergedProfile;
      modified = true;

      // Update lookup indices
      if (mergedProfile.id) idToMergedIndex.set(mergedProfile.id.toLowerCase(), existingIndex);
      if (mergedProfile.email) emailToMergedIndex.set(mergedProfile.email.toLowerCase().trim(), existingIndex);
      if (mergedProfile.icNo) {
        const icD = mergedProfile.icNo.replace(/\D/g, '');
        if (icD.length >= 10) icToMergedIndex.set(icD, existingIndex);
      }
      if (mergedProfile.firebaseUid) uidToMergedIndex.set(mergedProfile.firebaseUid.trim(), existingIndex);
    } else {
      // New distinct member
      const memberToInsert: UserProfile = {
        ...raw,
        id: cleanId,
        email: cleanEmail,
        icNo: cleanIc ? raw.icNo.replace(/[\s-]/g, '').trim() : (raw.icNo || ''),
        phone: raw.phone ? raw.phone.replace(/[\s-]/g, '').trim() : ''
      };

      const newIdx = mergedList.length;
      mergedList.push(memberToInsert);

      if (memberToInsert.id) idToMergedIndex.set(memberToInsert.id.toLowerCase(), newIdx);
      if (memberToInsert.email) emailToMergedIndex.set(memberToInsert.email.toLowerCase().trim(), newIdx);
      if (memberToInsert.icNo) {
        const icD = memberToInsert.icNo.replace(/\D/g, '');
        if (icD.length >= 10) icToMergedIndex.set(icD, newIdx);
      }
      if (memberToInsert.firebaseUid) uidToMergedIndex.set(memberToInsert.firebaseUid.trim(), newIdx);
    }
  }

  // Ensure all members with 'Semua Gelanggang' are migrated to 'ASMM'
  for (const m of mergedList) {
    if (m.gelanggang === 'Semua Gelanggang') {
      m.gelanggang = 'ASMM';
      modified = true;
    }
  }

  // Ensure placeholder / logo photos are cleaned up to DEFAULT_AVATAR_URL (/default-avatar.svg)
  for (const m of mergedList) {
    if (isDefaultPhoto(m.photoUrl)) {
      if (m.photoUrl !== DEFAULT_AVATAR_URL) {
        m.photoUrl = DEFAULT_AVATAR_URL;
        modified = true;
      }
    }
  }

  // Ensure Zainab has sequential ASMM ID (ASMM-015) and is Waris only, not pesilat (no bengkung)
  for (const m of mergedList) {
    if (m.id.toLowerCase() === 'asmm-waris-zainab' || (m.role === 'Waris' && (m.name || '').toLowerCase().includes('zainab'))) {
      m.id = 'ASMM-015';
      m.role = 'Waris';
      m.bengkung = '' as any;
      m.bengkungBadge = '';
      if (!m.photoUrl || m.photoUrl === '/badges/default.jpeg') m.photoUrl = DEFAULT_AVATAR_URL;
      modified = true;
    }
  }

  // Update any child whose parent was asmm-waris-zainab to ASMM-015, and Adam to ASMM-017
  for (const m of mergedList) {
    if (m.parentId?.toLowerCase() === 'asmm-waris-zainab') {
      m.parentId = 'ASMM-015';
      modified = true;
    }
    // Reassign Adam from ASMM-016/ASMM-015 to ASMM-017 under Zainab (ASMM-015)
    if ((m.id.toUpperCase() === 'ASMM-015' || m.id.toUpperCase() === 'ASMM-016' || m.id.toUpperCase() === 'ASMM-017') && (m.name || '').toLowerCase().includes('adam')) {
      m.id = 'ASMM-017';
      m.parentId = 'ASMM-015';
      modified = true;
    }
    // Ensure Aisya Humaira (ASMM-014) is bound to Mohammad Hafiz Bin Halim (ASMM-011)
    if (m.id.toUpperCase() === 'ASMM-014' || (m.name || '').toLowerCase().includes('aisya humaira')) {
      m.id = 'ASMM-014';
      m.parentId = 'ASMM-011';
      m.relationship = 'Anak';
      m.kinName = 'Mohammad Hafiz Bin Halim';
      m.kinPhone = '0194920194';
      modified = true;
    }
    // Ensure Ahmad Malik (ASMM-016) is bound to Mohammad Hafiz Bin Halim (ASMM-011)
    if (m.id.toUpperCase() === 'ASMM-016' || (m.name || '').toLowerCase().includes('ahmad malik')) {
      m.id = 'ASMM-016';
      m.parentId = 'ASMM-011';
      m.relationship = 'Anak';
      m.kinName = 'Mohammad Hafiz Bin Halim';
      m.kinPhone = '0194920194';
      modified = true;
    }
    // Ensure Mohammad Hafiz (ASMM-011) has role 'Penolong Setiausaha'
    if (m.id.toUpperCase() === 'ASMM-011' || (m.name || '').toLowerCase().includes('mohammad hafiz')) {
      m.role = 'Penolong Setiausaha';
      modified = true;
    }
    // Ensure Mohamad Syah Firafizal (ASMM-004) has role 'AJK'
    if (m.id.toUpperCase() === 'ASMM-004' || (m.name || '').toLowerCase().includes('firafizal')) {
      m.role = 'AJK';
      modified = true;
    }
  }

  // Ensure Mohd Syahir (ASMM-109) has role Penolong Bendahari & official photo
  const syahirIdx = mergedList.findIndex(m => m.id.toUpperCase() === 'ASMM-109' || (m.name || '').toLowerCase().includes('syahir'));
  if (syahirIdx >= 0) {
    const s = mergedList[syahirIdx];
    s.id = 'ASMM-109';
    s.role = 'Penolong Bendahari';
    const rolesSet = new Set(s.roles || []);
    rolesSet.add('Penolong Bendahari');
    s.roles = Array.from(rolesSet);
    if (s.photoUrl !== '/badges/syahir.jpg') {
      s.photoUrl = '/badges/syahir.jpg';
    }
    modified = true;
  } else if (!deleted.has('ASMM-109')) {
    mergedList.push({
      id: 'ASMM-109',
      name: 'Mohd Syahir Bin Mohd Yusof',
      icNo: '82101207533',
      email: 'syahir82@gmail.com',
      phone: '0194223193',
      address: '338 JALAN SENANGIN, TAMAN SENANGIN,09000 KULIM ,KEDAH',
      role: 'Penolong Bendahari',
      roles: ['Penolong Bendahari', 'Ahli Seumur Hidup'],
      gelanggang: 'ASMM',
      bengkung: 'kuning3' as any,
      bengkungBadge: '/badges/kuning3-jurulatih-muda.png',
      photoUrl: '/badges/syahir.jpg',
      joinedDate: '1998-04-03',
      status: 'Aktif',
      isOldMember: true,
    });
    modified = true;
  }

  // Update Syahir's photo to official photo /badges/syahir.jpg
  for (const m of mergedList) {
    if ((m.name || '').toLowerCase().includes('syahir') || m.id.toUpperCase() === 'ASMM-109') {
      if (m.photoUrl !== '/badges/syahir.jpg') {
        m.photoUrl = '/badges/syahir.jpg';
        modified = true;
      }
    }
  }

  // Ensure Mohd Nizam (ASMM-110) exists in mergedList and has official photo
  const hasNizam = mergedList.some(m => (m.name || '').toLowerCase().includes('nizam bin salleh'));
  if (!hasNizam && !deleted.has('ASMM-110')) {
    mergedList.push({
      id: 'ASMM-110',
      name: 'Mohd Nizam bin Salleh',
      icNo: '880312025117',
      email: 'nizam@asmm.org.my',
      phone: '0194820192',
      address: 'No. 14, Jalan Angsana, 09600 Lunas, Kedah',
      role: 'AJK',
      roles: ['AJK'],
      gelanggang: 'ASMM',
      bengkung: 'putih0' as any,
      bengkungBadge: '/badges/putih0.png',
      photoUrl: '/badges/nizam.jpg',
      joinedDate: '2024-05-01',
      status: 'Aktif',
      isOldMember: false,
    });
    modified = true;
  }

  // Update Nizam's photo to official photo /badges/nizam.jpg
  for (const m of mergedList) {
    if ((m.name || '').toLowerCase().includes('nizam') || m.id.toUpperCase() === 'ASMM-110') {
      if (m.photoUrl !== '/badges/nizam.jpg') {
        m.photoUrl = '/badges/nizam.jpg';
        modified = true;
      }
    }
  }

  // Ensure Nazihah (ASMM-132) exists in mergedList with unique ID (Norman Bin Mansor is ASMM-111)
  const nazihahIdx = mergedList.findIndex(m => (m.name || '').toLowerCase().includes('nazihah'));
  if (nazihahIdx >= 0) {
    if (mergedList[nazihahIdx].id !== 'ASMM-132') {
      mergedList[nazihahIdx].id = 'ASMM-132';
      mergedList[nazihahIdx].role = 'Juru Audit Dalaman';
      modified = true;
    }
  } else if (!deleted.has('ASMM-132')) {
    mergedList.push({
      id: 'ASMM-132',
      name: 'Nazihah binti Mohd Noor',
      icNo: '920418025614',
      email: 'nazihah@asmm.org.my',
      phone: '0194820193',
      address: 'No. 30, Taman Kancil, 09600 Lunas, Kedah',
      role: 'Juru Audit Dalaman',
      roles: ['Juru Audit Dalaman'],
      gelanggang: 'ASMM',
      bengkung: 'putih0' as any,
      bengkungBadge: '/badges/putih0.png',
      photoUrl: DEFAULT_AVATAR_URL,
      joinedDate: '2024-05-01',
      status: 'Aktif',
      isOldMember: false,
    });
    modified = true;
  }

  // Ensure Ahmad Malik (ASMM-016) exists in mergedList under ASMM-011 if not already present
  const hasAhmadMalik = mergedList.some(m => m.id.toUpperCase() === 'ASMM-016' || (m.name || '').toLowerCase().includes('ahmad malik'));
  if (!hasAhmadMalik && !deleted.has('ASMM-016') && !deleted.has('asmm-016')) {
    mergedList.push({
      id: 'ASMM-016',
      name: 'Ahmad Malik bin Mohammad Hafiz',
      icNo: '181120025619',
      email: '181120025619@asmm.org.my',
      phone: '',
      address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
      role: 'Ahli',
      gelanggang: 'Pusaka Warisan',
      bengkung: 'putih1',
      bengkungBadge: '/badges/putih1-pesilat-muda.png',
      photoUrl: DEFAULT_AVATAR_URL,
      joinedDate: '2024-09-01',
      status: 'Aktif',
      parentId: 'ASMM-011',
      relationship: 'Anak',
      kinName: 'Mohammad Hafiz Bin Halim',
      kinPhone: '0194920194',
    });
    modified = true;
  }

  // Ensure Aisya Humaira (ASMM-014) exists in mergedList under ASMM-011 if not already present
  const hasAisya = mergedList.some(m => m.id.toUpperCase() === 'ASMM-014' || (m.name || '').toLowerCase().includes('aisya humaira'));
  if (!hasAisya && !deleted.has('ASMM-014') && !deleted.has('asmm-014')) {
    mergedList.push({
      id: 'ASMM-014',
      name: 'Aisya Humaira binti Mohammad Hafiz',
      icNo: '161205021110',
      email: '161205021110@asmm.org.my',
      phone: '',
      address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
      role: 'Ahli',
      gelanggang: 'Pusaka Warisan',
      bengkung: 'putih1',
      bengkungBadge: '/badges/putih1-pesilat-muda.png',
      photoUrl: DEFAULT_AVATAR_URL,
      joinedDate: '2024-09-01',
      status: 'Aktif',
      parentId: 'ASMM-011',
      relationship: 'Anak',
      kinName: 'Mohammad Hafiz Bin Halim',
      kinPhone: '0194920194',
    });
    modified = true;
  }

  // Ensure Waris non-pesilat (e.g. Zainab ASMM-015) has at least one registered child pesilat (Adam ASMM-017)
  const warisMembers = mergedList.filter(m => m.role === 'Waris');
  for (const w of warisMembers) {
    const hasChild = mergedList.some(m => m.parentId === w.id);
    if (!hasChild && !deleted.has('ASMM-017') && !deleted.has('asmm-017') && (w.id.toUpperCase() === 'ASMM-015' || (w.name || '').toLowerCase().includes('zainab'))) {
      mergedList.push({
        id: 'ASMM-017',
        name: 'Muhammad Adam Bin Rosli',
        icNo: '140512025619',
        email: 'adam@asmm.org.my',
        phone: '',
        address: w.address || 'No. 12, Jalan Sejahtera 3, Taman Sejahtera, 09600 Lunas, Kedah',
        role: 'Ahli',
        gelanggang: w.gelanggang || 'Pusaka Warisan',
        bengkung: 'putih1',
        bengkungBadge: '/badges/putih1-pesilat-muda.png',
        photoUrl: DEFAULT_AVATAR_URL,
        joinedDate: '2026-08-16',
        status: 'Aktif',
        parentId: w.id,
        relationship: 'Anak',
        kinName: w.name,
        kinPhone: w.phone || '0194820194',
      });
      modified = true;
    }

    if (!hasChild && !deleted.has('ASMM-102') && !deleted.has('asmm-102') && (w.id.toUpperCase() === 'ASMM-101' || (w.name || '').toLowerCase().includes('najwa'))) {
      mergedList.push({
        id: 'ASMM-102',
        name: 'Akira Muhammad bin Muhammad Firdaus',
        icNo: '170323021159',
        email: '170323021159@asmm.org.my',
        phone: w.phone || '0172018658',
        address: w.address || 'No 36, Lorong Cendawan 5/4, Taman Bayam, 09600 Lunas, Kedah',
        role: 'Ahli',
        roles: ['Ahli'],
        gelanggang: w.gelanggang || 'Pusaka Warisan',
        bengkung: 'putih1',
        bengkungBadge: '/badges/putih1-pesilat-muda.png',
        photoUrl: DEFAULT_AVATAR_URL,
        joinedDate: '2026-10-04',
        status: 'Aktif',
        parentId: w.id,
        relationship: 'Anak',
        kinName: w.name,
        kinPhone: w.phone || '0172018658',
        isOldMember: false,
        onboardingStatus: 'pending_payment'
      });
      modified = true;
    }
  }

  return {
    merged: mergedList,
    duplicatesToDelete,
    canonicalHafiz: null,
    modified
  };
}

/**
 * Synchronizes and merges a Google-authenticated user directly with Turso members database.
 * Prevents any duplicates by searching live by firebaseUid or matching email.
 */
export async function syncGoogleUserWithTursoDB(googleUser: {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
  phoneNumber?: string | null;
}): Promise<{ member: UserProfile; isExisting: boolean; wasMerged: boolean }> {
  const cleanEmail = (googleUser.email || '').toLowerCase().trim();
  const googleUid = googleUser.uid;

  // 1. Fetch fresh member list
  const members = await getMembersDB();

  // 2. Search for existing member by firebaseUid
  const matchedByUid = members.find(m => m.firebaseUid && m.firebaseUid === googleUid);
  if (matchedByUid) {
    const updated: UserProfile = {
      ...matchedByUid,
      email: cleanEmail || matchedByUid.email,
      photoUrl: isDefaultPhoto(matchedByUid.photoUrl) && googleUser.photoURL ? googleUser.photoURL : (isDefaultPhoto(matchedByUid.photoUrl) ? DEFAULT_AVATAR_URL : matchedByUid.photoUrl),
      authProvider: matchedByUid.password ? 'both' : 'google'
    };
    await saveMemberDB(updated);
    return { member: updated, isExisting: true, wasMerged: false };
  }

  // 3. Search for existing member by exact Email only
  const matchedByEmail = cleanEmail
    ? members.find(m => m.email && m.email.toLowerCase().trim() === cleanEmail)
    : null;

  if (matchedByEmail) {
    const merged: UserProfile = {
      ...matchedByEmail,
      firebaseUid: googleUid,
      email: cleanEmail || matchedByEmail.email,
      photoUrl: isDefaultPhoto(matchedByEmail.photoUrl) && googleUser.photoURL ? googleUser.photoURL : (isDefaultPhoto(matchedByEmail.photoUrl) ? DEFAULT_AVATAR_URL : matchedByEmail.photoUrl),
      authProvider: matchedByEmail.password ? 'both' : 'google'
    };
    await saveMemberDB(merged);
    return { member: merged, isExisting: true, wasMerged: true };
  }

  // 4. New member: Provision sequential ID and insert directly to Turso DB
  const nextId = await getNextMemberId();
  const newMember: UserProfile = {
    id: nextId,
    name: googleUser.displayName || 'Pesilat ASMM',
    icNo: '',
    email: cleanEmail || `${nextId.toLowerCase()}@asmm.org.my`,
    phone: googleUser.phoneNumber ? googleUser.phoneNumber.replace(/[\s-]/g, '') : '',
    role: 'Ahli',
    roles: ['Ahli'],
    gelanggang: 'Pusaka Warisan',
    bengkung: 'Putih 0 (Pesilat Asas)',
    bengkungBadge: '/badges/putih0.png',
    photoUrl: googleUser.photoURL || DEFAULT_AVATAR_URL,
    joinedDate: new Date().toISOString().split('T')[0],
    status: 'Menunggu Pengesahan',
    onboardingStatus: 'pending_payment',
    firebaseUid: googleUid,
    authProvider: 'google'
  };

  await saveMemberDB(newMember);
  return { member: newMember, isExisting: false, wasMerged: false };
}

// Initialize DB with seed data — runs ONCE per session
export function initializeDB(): void {
  if (typeof window === 'undefined') return;
  if (_dbInitialized) return;
  _dbInitialized = true;

  // One-time migration: purge dummy seed caches so only real live data from aaPanel MySQL is used (ahli retained!)
  if (!localStorage.getItem('asmm_live_data_migrated_v4')) {
    localStorage.removeItem(KEYS.MEMBERS);
    localStorage.removeItem(KEYS.NOTICES);
    localStorage.removeItem(KEYS.TRANSACTIONS);
    localStorage.removeItem(KEYS.INVOICES);
    localStorage.removeItem(KEYS.GELANGGANG);
    localStorage.removeItem(KEYS.SYLLABUS);
    localStorage.removeItem(KEYS.MERCHANDISE_ORDERS);
    localStorage.removeItem(KEYS.MERCHANDISE_ITEMS);
    localStorage.removeItem(KEYS.GRANT_PROPOSALS);
    localStorage.removeItem(KEYS.ASSOCIATION_ASSETS);
    localStorage.removeItem(KEYS.ASSET_RENTAL_LOGS);
    localStorage.removeItem(KEYS.TRAINER_ALLOWANCES);
    localStorage.removeItem(KEYS.SYLLABUS_GRADING);
    localStorage.removeItem(KEYS.FEE_PACKAGES);
    localStorage.removeItem(KEYS.DONATION_CAMPAIGNS);
    localStorage.removeItem(KEYS.DONATIONS);
    localStorage.removeItem(KEYS.AVAILABILITY);
    localStorage.removeItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS);
    localStorage.removeItem(KEYS.UJIAN_BENGKUNG_FEES);
    localStorage.removeItem(KEYS.ROLES);
    localStorage.removeItem(KEYS.PERMISSIONS);
    localStorage.removeItem(KEYS.ROLE_PERMS);
    localStorage.removeItem('gdrive_ahli_json_vault');
    localStorage.setItem('asmm_live_data_migrated_v4', 'true');
  }

  // One-time migration: add payment columns to gelanggang table if missing
  if (!localStorage.getItem('asmm_gelanggang_payment_cols_v1')) {
    const alterCols = [
      'ALTER TABLE gelanggang ADD COLUMN paymentPreference VARCHAR(20) DEFAULT NULL',
      'ALTER TABLE gelanggang ADD COLUMN qrBankName VARCHAR(150) DEFAULT NULL',
      'ALTER TABLE gelanggang ADD COLUMN qrAccountName VARCHAR(150) DEFAULT NULL',
      'ALTER TABLE gelanggang ADD COLUMN qrAccountNo VARCHAR(50) DEFAULT NULL',
      'ALTER TABLE gelanggang ADD COLUMN qrImageUrl TEXT DEFAULT NULL',
      'ALTER TABLE gelanggang ADD COLUMN qrNotes TEXT DEFAULT NULL',
    ];
    Promise.all(alterCols.map(sql => executeTursoQuery(sql).catch(() => { /* column may already exist */ })))
      .finally(() => { localStorage.setItem('asmm_gelanggang_payment_cols_v1', 'true'); });
  }

  // One-time migration: add roles column to members table if missing
  if (!localStorage.getItem('asmm_members_roles_col_v1')) {
    executeTursoQuery('ALTER TABLE members ADD COLUMN roles TEXT DEFAULT NULL;')
      .catch(() => { /* column already exists */ })
      .finally(() => { localStorage.setItem('asmm_members_roles_col_v1', 'true'); });
  }

  const storedMembersRaw = localStorage.getItem(KEYS.MEMBERS);
  if (storedMembersRaw) {
    try {
      const parsed = JSON.parse(storedMembersRaw);
      if (Array.isArray(parsed)) {
        const { merged, duplicatesToDelete, modified } = sanitizeAndMergeMembers(parsed);
        if (modified || duplicatesToDelete.length > 0) {
          localStorage.setItem(KEYS.MEMBERS, JSON.stringify(merged));
          cachedMembersInMemory = merged;
          if (duplicatesToDelete.length > 0) {
            executeTursoBatch(duplicatesToDelete.map(id => ({ sql: 'DELETE FROM members WHERE id = ?;', args: [id] }))).catch(() => { });
          }
        }
      }
    } catch { }
  }

  const storedNoticesRaw = localStorage.getItem(KEYS.NOTICES);
  if (storedNoticesRaw) {
    try {
      const parsed = JSON.parse(storedNoticesRaw);
      if (Array.isArray(parsed)) {
        const cleaned = filterOutDeletedNotices(parsed);
        if (cleaned.length !== parsed.length) {
          localStorage.setItem(KEYS.NOTICES, JSON.stringify(cleaned));
        }
      }
    } catch { }
  }

  const storedTransactionsRaw = localStorage.getItem(KEYS.TRANSACTIONS);
  if (storedTransactionsRaw) {
    try {
      const parsed = JSON.parse(storedTransactionsRaw);
      if (Array.isArray(parsed)) {
        const cleaned = filterOutDeletedTransactions(parsed);
        if (cleaned.length !== parsed.length) {
          localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(cleaned));
        }
      }
    } catch { }
  }

  const storedGelanggangRaw = localStorage.getItem(KEYS.GELANGGANG);
  if (storedGelanggangRaw) {
    try {
      const parsed: GelanggangDetail[] = JSON.parse(storedGelanggangRaw);
      if (Array.isArray(parsed)) {
        let changed = false;
        const updated = parsed.map(g => {
          if (g.name === 'Gelanggang Paya Besar') {
            changed = true;
            return { ...g, name: 'Paya Besar' as Gelanggang };
          }
          return g;
        });
        if (changed) {
          localStorage.setItem(KEYS.GELANGGANG, JSON.stringify(updated));
          cachedGelanggangInMemory = updated;
        }
      }
    } catch { }
  }

  const storedSyllabusRaw = localStorage.getItem(KEYS.SYLLABUS);
  if (storedSyllabusRaw) {
    try {
      const parsed: CourseSection[] = JSON.parse(storedSyllabusRaw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        let changed = false;
        const cleaned = parsed.map(s => {
          const seedMatch = SEED_SYLLABUS.find(sm => sm.id === s.id);
          const newTitle = cleanSyllabusSectionTitle(s.title);
          const newBadge = seedMatch?.badge || s.badge;
          const newCategory = s.category || seedMatch?.category;
          const newRankSubtitle = s.rankSubtitle || seedMatch?.rankSubtitle;
          if (newTitle !== s.title || newBadge !== s.badge || newCategory !== s.category || newRankSubtitle !== s.rankSubtitle) {
            changed = true;
            return {
              ...s,
              title: newTitle,
              badge: newBadge,
              category: newCategory,
              rankSubtitle: newRankSubtitle
            };
          }
          return s;
        });
        if (changed) {
          localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(cleaned));
          cachedSyllabusInMemory = cleaned;
        } else {
          cachedSyllabusInMemory = parsed;
        }
      } else {
        localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(SEED_SYLLABUS));
        cachedSyllabusInMemory = SEED_SYLLABUS;
      }
    } catch {
      localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(SEED_SYLLABUS));
      cachedSyllabusInMemory = SEED_SYLLABUS;
    }
  } else {
    localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(SEED_SYLLABUS));
    cachedSyllabusInMemory = SEED_SYLLABUS;
  }

  const storedCampaignsRaw = localStorage.getItem(KEYS.DONATION_CAMPAIGNS);
  if (storedCampaignsRaw) {
    try {
      const parsed: DonationCampaign[] = JSON.parse(storedCampaignsRaw);
      if (Array.isArray(parsed)) {
        const legacyMap: Record<string, string> = {
          'camp-001': 'tabung-pembangunan-gelanggang-lunas',
          'camp-002': 'tabung-kebajikan-pesilat-asnaf',
          'camp-003': 'tabung-pemeliharaan-busana-senjata',
          'camp-004': 'tabung-kontinjen-kejuaraan-silat'
        };
        let changed = false;
        const seen = new Set<string>();
        const migratedList: DonationCampaign[] = [];
        for (const c of parsed) {
          const mappedId = legacyMap[c.id] || c.id;
          if (mappedId !== c.id) changed = true;
          if (!seen.has(mappedId)) {
            seen.add(mappedId);
            migratedList.push({ ...c, id: mappedId });
          }
        }
        if (changed || migratedList.length !== parsed.length) {
          localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(migratedList));
          cachedDonationCampaignsInMemory = migratedList;
        }
      }
    } catch { }
  }

  const storedDonationsRaw = localStorage.getItem(KEYS.DONATIONS);
  if (storedDonationsRaw) {
    try {
      const parsed: DonationRecord[] = JSON.parse(storedDonationsRaw);
      if (Array.isArray(parsed)) {
        const legacyMap: Record<string, string> = {
          'camp-001': 'tabung-pembangunan-gelanggang-lunas',
          'camp-002': 'tabung-kebajikan-pesilat-asnaf',
          'camp-003': 'tabung-pemeliharaan-busana-senjata',
          'camp-004': 'tabung-kontinjen-kejuaraan-silat'
        };
        let changed = false;
        const migratedList = parsed.map(d => {
          if (legacyMap[d.campaignId]) {
            changed = true;
            return { ...d, campaignId: legacyMap[d.campaignId] };
          }
          return d;
        });
        if (changed) {
          localStorage.setItem(KEYS.DONATIONS, JSON.stringify(migratedList));
          cachedDonationsInMemory = migratedList;
        }
      }
    } catch { }
  }

  // Ensure DDL schema statements are executed only once per browser to save DB calls
  if (!localStorage.getItem('asmm_turso_schema_v3')) {
    executeTursoBatch([
      { sql: `CREATE TABLE IF NOT EXISTS invoices (id TEXT PRIMARY KEY, invoiceNo TEXT NOT NULL, memberId TEXT NOT NULL, memberName TEXT NOT NULL, memberIcNo TEXT, memberPhone TEXT, gelanggang TEXT NOT NULL, category TEXT NOT NULL, title TEXT NOT NULL, description TEXT, amount REAL NOT NULL, dueDate TEXT NOT NULL, createdAt TEXT NOT NULL, status TEXT NOT NULL, toyibBillCode TEXT, paidAt TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS members (id TEXT PRIMARY KEY, name TEXT NOT NULL, icNo TEXT NOT NULL, email TEXT, phone TEXT, role TEXT NOT NULL, gelanggang TEXT NOT NULL, bengkung TEXT NOT NULL, photoUrl TEXT, status TEXT NOT NULL);`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN parentId TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN password TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN sessionTime TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN joinedDate TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN relationship TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN firebaseUid TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN authProvider TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN address TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN occupation TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN kinName TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN kinPhone TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN bengkungBadge TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN approvedBy TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN approvedByName TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN approvedAt TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN rejectedBy TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN rejectedByName TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN rejectedAt TEXT;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN rejectionReason TEXT;`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS notices (id TEXT PRIMARY KEY, title TEXT NOT NULL, content TEXT NOT NULL, type TEXT NOT NULL, authorName TEXT, authorRole TEXT, targetGelanggang TEXT, createdAt TEXT, eventDate TEXT, eventTime TEXT, eventLocation TEXT, data TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS transactions (id TEXT PRIMARY KEY, date TEXT NOT NULL, category TEXT NOT NULL, description TEXT NOT NULL, amount REAL NOT NULL, type TEXT NOT NULL, payerOrPayee TEXT, gelanggang TEXT, receiptUrl TEXT, recordedBy TEXT, status TEXT, toyibBillCode TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS files (id TEXT PRIMARY KEY, name TEXT NOT NULL, mimeType TEXT, driveType TEXT, webContentLink TEXT, category TEXT, uploadedAt TEXT, size TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS gelanggang (id TEXT PRIMARY KEY, name TEXT NOT NULL, location TEXT, address TEXT, gpsLocation TEXT, sessionTime TEXT, leaderName TEXT, leaderPhone TEXT, status TEXT);`, args: [] },
      { sql: `ALTER TABLE gelanggang ADD COLUMN address TEXT;`, args: [] },
      { sql: `ALTER TABLE gelanggang ADD COLUMN gpsLocation TEXT;`, args: [] },
      { sql: `ALTER TABLE gelanggang ADD COLUMN classes TEXT;`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS merchandise_orders (id TEXT PRIMARY KEY, memberId TEXT NOT NULL, memberName TEXT NOT NULL, gelanggang TEXT NOT NULL, itemId TEXT NOT NULL, itemName TEXT NOT NULL, itemCategory TEXT NOT NULL, quantity INTEGER NOT NULL, size TEXT, totalAmount REAL NOT NULL, deliveryMethod TEXT NOT NULL, notes TEXT, status TEXT NOT NULL, invoiceId TEXT, createdAt TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS merchandise_items (id TEXT PRIMARY KEY, name TEXT NOT NULL, category TEXT NOT NULL, price REAL NOT NULL, description TEXT, photoUrl TEXT, sizes TEXT, stockStatus TEXT NOT NULL, specifications TEXT, variations TEXT, userId TEXT);`, args: [] },
      { sql: `ALTER TABLE merchandise_items ADD COLUMN userId TEXT;`, args: [] },
      { sql: `ALTER TABLE merchandise_items ADD COLUMN stockQuantity INT DEFAULT 0;`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS syllabus (id TEXT PRIMARY KEY, bengkungRank TEXT NOT NULL, requiredBengkungName TEXT NOT NULL, title TEXT NOT NULL, badge TEXT, lessons TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS fee_packages (id TEXT PRIMARY KEY, gelanggang TEXT NOT NULL, title TEXT NOT NULL, price REAL NOT NULL, category TEXT NOT NULL, description TEXT, targetAudience TEXT, status TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS grant_proposals (id TEXT PRIMARY KEY, title TEXT NOT NULL, agencyName TEXT NOT NULL, grantCategory TEXT NOT NULL, targetAmount REAL NOT NULL, approvedAmount REAL, status TEXT NOT NULL, submittedDate TEXT, contactPerson TEXT, objective TEXT, targetAudience TEXT, budgetBreakdown TEXT, erosFilingStatus TEXT, documentUrl TEXT, documentFileName TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS association_assets (id TEXT PRIMARY KEY, assetName TEXT NOT NULL, category TEXT NOT NULL, acquiredDate TEXT, fundedBy TEXT, quantity INTEGER NOT NULL, estimatedValue REAL NOT NULL, condition TEXT NOT NULL, dailyRentalRate REAL NOT NULL, assignedGelanggang TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS asset_rental_logs (id TEXT PRIMARY KEY, assetId TEXT NOT NULL, assetName TEXT NOT NULL, renterName TEXT NOT NULL, renterPhone TEXT, startDate TEXT NOT NULL, endDate TEXT NOT NULL, totalDays INTEGER NOT NULL, totalRentalFee REAL NOT NULL, status TEXT NOT NULL, paymentStatus TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS trainer_allowances (id TEXT PRIMARY KEY, grantId TEXT, programTitle TEXT NOT NULL, trainerName TEXT NOT NULL, trainerRole TEXT NOT NULL, sessionDate TEXT NOT NULL, hours REAL NOT NULL, allowanceRatePerHour REAL NOT NULL, totalAllowance REAL NOT NULL, status TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS donation_campaigns (id TEXT PRIMARY KEY, title TEXT NOT NULL, category TEXT NOT NULL, targetAmount REAL NOT NULL, currentAmount REAL NOT NULL, donorCount INTEGER NOT NULL, coverImage TEXT, story TEXT NOT NULL, organizerName TEXT, beneficiaryGelanggang TEXT NOT NULL, startDate TEXT NOT NULL, endDate TEXT, status TEXT NOT NULL, isFeatured INTEGER, impactMilestones TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS donations (id TEXT PRIMARY KEY, campaignId TEXT NOT NULL, campaignTitle TEXT NOT NULL, amount REAL NOT NULL, donorName TEXT NOT NULL, isAnonymous INTEGER NOT NULL, donorEmail TEXT NOT NULL, donorPhone TEXT NOT NULL, message TEXT, infaqType TEXT, paymentMethod TEXT NOT NULL, transactionRef TEXT NOT NULL, receiptUrl TEXT, status TEXT NOT NULL, createdAt TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS syllabus_progress (memberId TEXT PRIMARY KEY, completedLessons TEXT NOT NULL, updatedAt TEXT NOT NULL);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS bengkung_ranks (id TEXT PRIMARY KEY, code TEXT NOT NULL, dbCode TEXT NOT NULL, bengkungName TEXT NOT NULL, rankTitle TEXT NOT NULL, module TEXT NOT NULL, culaCount INTEGER NOT NULL DEFAULT 0, beltBgClass TEXT, culaBgClass TEXT, textColorClass TEXT, sortOrder INTEGER NOT NULL DEFAULT 0, updatedAt TEXT);`, args: [] }
    ])
      .then(() => { localStorage.setItem('asmm_turso_schema_v5_bengkung', '1'); })
      .catch(() => { });
  }

  if (!localStorage.getItem('asmm_turso_schema_v6_roles')) {
    executeTursoBatch([
      { sql: `CREATE TABLE IF NOT EXISTS roles (id TEXT PRIMARY KEY, name TEXT NOT NULL UNIQUE, category TEXT NOT NULL, description TEXT, isSystem INTEGER NOT NULL DEFAULT 0, sortOrder INTEGER NOT NULL DEFAULT 0, updatedAt TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS permissions (permKey TEXT PRIMARY KEY, name TEXT NOT NULL, module TEXT NOT NULL, description TEXT, isSystem INTEGER NOT NULL DEFAULT 0, sortOrder INTEGER NOT NULL DEFAULT 0, updatedAt TEXT);`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS role_permissions (id INTEGER PRIMARY KEY AUTOINCREMENT, roleName TEXT NOT NULL, permKey TEXT NOT NULL, createdAt TEXT);`, args: [] }
    ])
      .then(() => { localStorage.setItem('asmm_turso_schema_v6_roles', '1'); })
      .catch(() => { });
  }

  if (!localStorage.getItem('asmm_turso_schema_v7_complete')) {
    executeTursoBatch([
      { sql: `CREATE TABLE IF NOT EXISTS syllabus_grading (id VARCHAR(100) PRIMARY KEY, memberId VARCHAR(100) NOT NULL, rankLevel VARCHAR(100) NOT NULL, status VARCHAR(50) NOT NULL, assessedBy VARCHAR(150), assessorRole VARCHAR(100), assessedAt VARCHAR(100), gelanggang VARCHAR(100), notes TEXT, updatedAt VARCHAR(100));`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS ujian_bengkung_registrations (id VARCHAR(100) PRIMARY KEY, memberId VARCHAR(100) NOT NULL, memberName VARCHAR(150) NOT NULL, memberPhone VARCHAR(50), memberIcNo VARCHAR(50), gelanggang VARCHAR(100), currentBengkung VARCHAR(100), targetBengkung VARCHAR(100), status VARCHAR(50), registeredAt VARCHAR(100), scheduledEventId VARCHAR(100), scheduledEventTitle VARCHAR(255), scheduledEventDate VARCHAR(100), invoiceId VARCHAR(100), paidAt VARCHAR(100), notes TEXT, updatedAt VARCHAR(100));`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS ujian_bengkung_fees (id VARCHAR(100) PRIMARY KEY, hitam DOUBLE DEFAULT 30.0, putih DOUBLE DEFAULT 50.0, merah DOUBLE DEFAULT 70.0, kuning DOUBLE DEFAULT 100.0, biru DOUBLE DEFAULT 80.0, customLevels TEXT, updatedAt VARCHAR(100), updatedBy VARCHAR(150));`, args: [] },
      { sql: `CREATE TABLE IF NOT EXISTS availability (id VARCHAR(100) PRIMARY KEY, userId VARCHAR(100) NOT NULL, userName VARCHAR(150) NOT NULL, gelanggang VARCHAR(100) NOT NULL, date VARCHAR(50) NOT NULL, timeSlots TEXT NOT NULL, updatedAt VARCHAR(100) NOT NULL);`, args: [] }
    ])
      .then(() => { localStorage.setItem('asmm_turso_schema_v7_complete', '1'); })
      .catch(() => { });
  }

  if (!localStorage.getItem('asmm_turso_schema_v8_onboarding')) {
    executeTursoBatch([
      { sql: `ALTER TABLE members ADD COLUMN onboardingStatus VARCHAR(50) DEFAULT 'pending_payment';`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN isOldMember INT DEFAULT 0;`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN onboardingInvoiceId VARCHAR(100);`, args: [] },
      { sql: `ALTER TABLE members ADD COLUMN uniformSize VARCHAR(50);`, args: [] }
    ])
      .then(() => { localStorage.setItem('asmm_turso_schema_v8_onboarding', '1'); })
      .catch(() => { });
  }
}

// In-memory cache variables for all entities
let cachedMembersInMemory: UserProfile[] | null = null;
let cachedNoticesInMemory: NoticeItem[] | null = null;
let cachedTransactionsInMemory: FinancialTransaction[] | null = null;
let cachedGelanggangInMemory: GelanggangDetail[] | null = null;
let cachedInvoicesInMemory: InvoiceItem[] | null = null;
let cachedFilesInMemory: DriveFileItem[] | null = null;
let cachedSyllabusInMemory: CourseSection[] | null = null;
let cachedFeePackagesInMemory: GelanggangFeePackage[] | null = null;
let cachedGrantProposalsInMemory: GrantProposal[] | null = null;
let cachedAssociationAssetsInMemory: AssociationAsset[] | null = null;
let cachedAssetRentalLogsInMemory: AssetRentalLog[] | null = null;
let cachedTrainerAllowancesInMemory: TrainerAllowanceClaim[] | null = null;
let cachedDonationCampaignsInMemory: DonationCampaign[] | null = null;
let cachedDonationsInMemory: DonationRecord[] | null = null;
let cachedMerchandiseOrdersInMemory: MerchandiseOrder[] | null = null;
let cachedMerchandiseItemsInMemory: MerchandiseItem[] | null = null;
let cachedSyllabusGradingInMemory: SyllabusGradingRecord[] | null = null;
let cachedUjianBengkungRegsInMemory: UjianBengkungRegistration[] | null = null;
let cachedUjianBengkungFeesInMemory: UjianBengkungFeeConfig | null = null;
let cachedUjianGradingAssessmentsInMemory: UjianGradingAssessment[] | null = null;
let cachedUjianBertulisAttemptsInMemory: UjianBertulisAttempt[] | null = null;
let cachedAvailabilityInMemory: AvailabilityEntry[] | null = null;
let cachedRolesInMemory: RoleItem[] | null = null;
let cachedPermissionsInMemory: PermissionItem[] | null = null;
let cachedRolePermsMapInMemory: Record<string, string[]> | null = null;

// MEMBER DATABASE OPERATIONS

export async function syncAllMembersToTursoDB(membersList?: UserProfile[]): Promise<void> {
  const membersToSync = membersList || await getMembersDB();
  const statements = membersToSync.map(m => getMemberSqlUpsert(m));
  await executeTursoBatch(statements).catch((err) => { console.error('Turso syncAllMembersToTursoDB error:', err); });
}

/** Generate the next sequential ASMM-xxx member ID based on existing members. */
export async function getNextMemberId(): Promise<string> {
  const members = await getMembersDB();
  let maxNum = 0;
  for (const m of members) {
    const match = m.id.match(/^asmm-(\d+)$/i);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num > maxNum) maxNum = num;
    }
  }
  const nextNum = maxNum + 1;
  return `ASMM-${String(nextNum).padStart(3, '0')}`;
}

export async function getMembersDB(): Promise<UserProfile[]> {
  initializeDB();

  // Instant 0ms return from in-memory cache if already loaded in this session
  if (cachedMembersInMemory && cachedMembersInMemory.length > 0) {
    const clean = filterOutDeletedMembers(cachedMembersInMemory);
    // Throttled background refresh — only if TTL expired + no inflight request
    if (shouldRefreshFromTurso('members') && !_inflightRefresh['members']) {
      _inflightRefresh['members'] = refreshMembersCacheFromTurso()
        .finally(() => { _inflightRefresh['members'] = null; });
    }
    return clean;
  }

  // Fetch live from aaPanel MySQL DB directly
  return filterOutDeletedMembers(await refreshMembersCacheFromTurso());
}

async function refreshMembersCacheFromTurso(): Promise<UserProfile[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM members;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbMembers: UserProfile[] = tursoRes.rows.map((row: any) => {
        let parsedRoles: Role[] = [];
        const rawRoles = row.roles ?? row[29];
        if (rawRoles) {
          if (Array.isArray(rawRoles)) {
            parsedRoles = rawRoles;
          } else if (typeof rawRoles === 'string') {
            const trimmed = rawRoles.trim();
            if (trimmed.startsWith('[')) {
              try {
                parsedRoles = JSON.parse(trimmed);
              } catch {
                parsedRoles = [];
              }
            } else if (trimmed) {
              parsedRoles = trimmed.split(',').map((s: string) => s.trim() as Role).filter(Boolean);
            }
          }
        }
        const roleStr = String(row.role ?? row[5] ?? 'Ahli') as Role;
        if (parsedRoles.length === 0) {
          parsedRoles = [roleStr];
        } else if (!parsedRoles.includes(roleStr)) {
          parsedRoles = [roleStr, ...parsedRoles];
        }
        const primaryRole = parsedRoles[0] || roleStr || 'Ahli';

        const mId = String(row.id ?? row[0]);
        const isOldSeed = /^ASMM-0[0-1][0-9]$/i.test(mId);
        const rawIsOld = row.isOldMember ?? row[31];
        const isOld = (rawIsOld !== undefined && rawIsOld !== null && rawIsOld !== '') ? Boolean(Number(rawIsOld)) : isOldSeed;
        const rawOnbStatus = row.onboardingStatus ?? row[30];
        const onbStatus = (rawOnbStatus && String(rawOnbStatus).trim()) ? String(rawOnbStatus).trim() : (isOld ? 'completed' : 'pending_payment');

        return {
          id: mId,
          name: toTitleCase(String(row.name ?? row[1])),
          icNo: sanitizeIc(String(row.icNo ?? row[2] ?? '')),
          email: String(row.email ?? row[3] ?? ''),
          phone: sanitizePhone(String(row.phone ?? row[4] ?? '')),
          role: primaryRole,
          roles: parsedRoles,
          gelanggang: String(row.gelanggang ?? row[6]) as Gelanggang,
          bengkung: String(row.bengkung ?? row[7]) as BengkungLevel,
          photoUrl: (() => {
            const raw = String(row.photoUrl ?? row[8] ?? '');
            return isDefaultPhoto(raw) ? DEFAULT_AVATAR_URL : raw;
          })(),
          status: String(row.status ?? row[9] ?? 'Aktif') as any,
          parentId: row.parentId ? String(row.parentId) : (row[10] ? String(row[10]) : undefined),
          password: row.password ? String(row.password) : (row[11] ? String(row[11]) : undefined),
          sessionTime: row.sessionTime ? String(row.sessionTime) : (row[12] ? String(row[12]) : undefined),
          joinedDate: row.joinedDate ? String(row.joinedDate) : (row[13] ? String(row[13]) : new Date().toISOString().split('T')[0]),
          relationship: row.relationship ? String(row.relationship) : (row[14] ? String(row[14]) : undefined),
          firebaseUid: row.firebaseUid ? String(row.firebaseUid) : (row[15] ? String(row[15]) : undefined),
          authProvider: (row.authProvider ? String(row.authProvider) : (row[16] ? String(row[16]) : undefined)) as any,
          address: row.address ? String(row.address) : (row[17] ? String(row[17]) : undefined),
          occupation: row.occupation ? String(row.occupation) : (row[18] ? String(row[18]) : undefined),
          kinName: row.kinName ? toTitleCase(String(row.kinName)) : (row[19] ? toTitleCase(String(row[19])) : undefined),
          kinPhone: row.kinPhone ? sanitizePhone(String(row.kinPhone)) : (row[20] ? sanitizePhone(String(row[20])) : undefined),
          bengkungBadge: row.bengkungBadge ? String(row.bengkungBadge) : (row[21] ? String(row[21]) : '/badges/putih0.png'),
          approvedBy: row.approvedBy ? String(row.approvedBy) : (row[22] ? String(row[22]) : undefined),
          approvedByName: row.approvedByName ? String(row.approvedByName) : (row[23] ? String(row[23]) : undefined),
          approvedAt: row.approvedAt ? String(row.approvedAt) : (row[24] ? String(row[24]) : undefined),
          rejectedBy: row.rejectedBy ? String(row.rejectedBy) : (row[25] ? String(row[25]) : undefined),
          rejectedByName: row.rejectedByName ? String(row.rejectedByName) : (row[26] ? String(row[26]) : undefined),
          rejectedAt: row.rejectedAt ? String(row.rejectedAt) : (row[27] ? String(row[27]) : undefined),
          rejectionReason: row.rejectionReason ? String(row.rejectionReason) : (row[28] ? String(row[28]) : undefined),
          onboardingStatus: onbStatus as any,
          isOldMember: isOld,
          onboardingInvoiceId: row.onboardingInvoiceId ? String(row.onboardingInvoiceId) : (row[32] ? String(row[32]) : undefined),
          uniformSize: row.uniformSize ? String(row.uniformSize) : (row[33] ? String(row[33]) : undefined)
        };
      });

      // Auto-heal: persist sanitized names (Title Case) and IC/phone (digits only) back to DB
      try {
        const dirty: UserProfile[] = [];
        tursoRes.rows.forEach((row: any, i: number) => {
          const m = dbMembers[i];
          if (!m) return;
          const rawName = String(row.name ?? row[1] ?? '');
          const rawIc = String(row.icNo ?? row[2] ?? '');
          const rawPhone = String(row.phone ?? row[4] ?? '');
          const rawKinPhone = String(row.kinPhone ?? row[20] ?? '');
          const rawKinName = String(row.kinName ?? row[19] ?? '');
          if (
            rawName !== m.name ||
            rawIc !== m.icNo ||
            rawPhone !== m.phone ||
            (rawKinPhone && rawKinPhone !== (m.kinPhone || '')) ||
            (rawKinName && rawKinName !== (m.kinName || ''))
          ) {
            dirty.push(m);
          }
        });
        if (dirty.length > 0) {
          executeTursoBatch(dirty.map(m => getMemberSqlUpsert(m))).catch(() => { });
        }
      } catch { }

      const { merged, duplicatesToDelete } = sanitizeAndMergeMembers(dbMembers);

      if (duplicatesToDelete.length > 0) {
        executeTursoBatch(duplicatesToDelete.map(id => ({ sql: 'DELETE FROM members WHERE id = ?;', args: [id] }))).catch(() => { });
      }

      // Cache live database rows to localStorage & in-memory cache
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.MEMBERS, JSON.stringify(merged));
      }
      cachedMembersInMemory = merged;
      markTursoFetched('members');
      return merged;
    }
  } catch (e) {
    console.warn("aaPanel live member fetch notice (Local fallback active):", e);
  }

  // Fallback to localStorage ONLY on network/query failure
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.MEMBERS) : null;
  const parsed: UserProfile[] = raw ? JSON.parse(raw) : [];
  const { merged } = sanitizeAndMergeMembers(parsed);
  cachedMembersInMemory = merged;
  return merged;
}

export async function saveMemberDB(member: UserProfile): Promise<UserProfile[]> {
  const cleanMember: UserProfile = {
    ...member,
    name: toTitleCase(member.name),
    icNo: sanitizeIc(member.icNo),
    phone: sanitizePhone(member.phone),
    kinName: member.kinName ? toTitleCase(member.kinName) : member.kinName,
    kinPhone: member.kinPhone ? sanitizePhone(member.kinPhone) : member.kinPhone,
    gelanggang: member.gelanggang === 'Semua Gelanggang' ? 'ASMM' : member.gelanggang
  };
  const current = await getMembersDB();
  const index = current.findIndex(m => (m.id || '').trim().toLowerCase() === (cleanMember.id || '').trim().toLowerCase());
  let updated: UserProfile[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = cleanMember;
  } else {
    updated = [cleanMember, ...current];
  }

  const { merged, duplicatesToDelete } = sanitizeAndMergeMembers(updated);
  updated = merged;

  if (duplicatesToDelete.length > 0) {
    await executeTursoBatch(duplicatesToDelete.map(id => ({ sql: 'DELETE FROM members WHERE id = ?;', args: [id] }))).catch(() => { });
  }

  try {
    localStorage.setItem(KEYS.MEMBERS, JSON.stringify(updated));
  } catch (err: any) {
    if (err.name === 'QuotaExceededError' || err.code === 22 || err.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
      console.warn('LocalStorage quota exceeded! Healing members cache by removing large base64 photo URLs...');
      const healed = updated.map(m => {
        if (m.photoUrl && m.photoUrl.startsWith('data:') && m.photoUrl.length > 50000) {
          return { ...m, photoUrl: DEFAULT_AVATAR_URL };
        }
        return m;
      });
      try {
        localStorage.setItem(KEYS.MEMBERS, JSON.stringify(healed));
        updated = healed;
      } catch (innerErr) {
        console.error('Failed to set healed members cache:', innerErr);
      }
    } else {
      throw err;
    }
  }

  // Find the exact canonical version of this member in merged list
  const targetMemberToSync = updated.find(m => (m.id || '').trim().toLowerCase() === (cleanMember.id || '').trim().toLowerCase() || (cleanMember.email && m.email && m.email.toLowerCase().trim() === cleanMember.email.toLowerCase().trim())) || cleanMember;
  const upsert = getMemberSqlUpsert(targetMemberToSync);
  await executeTursoQuery(upsert.sql, upsert.args).catch((err) => { console.error('Turso saveMemberDB sync error:', err); });

  cachedMembersInMemory = updated;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'member', member: targetMemberToSync } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }
  return updated;
}

/**
 * Forces an immediate live AJAX query to the database, bypassing any cache or TTL,
 * updating local storage and memory cache with the fresh database records.
 */
export async function refreshMembersLiveDB(): Promise<UserProfile[]> {
  _lastTursoFetch['members'] = 0;
  _inflightRefresh['members'] = null;
  return await refreshMembersCacheFromTurso();
}

export interface DeleteMemberOptions {
  deleteFamily?: boolean;
  familyMemberIds?: string[];
}

export async function deleteMemberDB(id: string, options?: DeleteMemberOptions): Promise<UserProfile[]> {
  const targetIds = options?.deleteFamily && options?.familyMemberIds && options.familyMemberIds.length > 0
    ? Array.from(new Set([id, ...options.familyMemberIds]))
    : [id];

  const allCleanIds = targetIds.map(tid => tid.trim().toUpperCase());
  const allLowerIds = targetIds.map(tid => tid.trim().toLowerCase());

  // 1. Identify members to delete and extract their IC numbers, names, phones
  const rawMembers = typeof window !== 'undefined' ? localStorage.getItem(KEYS.MEMBERS) : null;
  const currentMembers: UserProfile[] = rawMembers ? JSON.parse(rawMembers) : (cachedMembersInMemory || []);
  const deletedMemberObjs = currentMembers.filter(m =>
    allLowerIds.includes((m.id || '').toLowerCase()) || allCleanIds.includes((m.id || '').toUpperCase())
  );
  const targetIcs = Array.from(new Set(deletedMemberObjs.map(m => (m.icNo || '').replace(/[\s-]/g, '')).filter(Boolean)));
  const targetNames = Array.from(new Set(deletedMemberObjs.map(m => (m.name || '').trim()).filter(Boolean)));

  // 2. Record permanently in deleted members tracking (MySQL + localStorage)
  const memberEntitiesToRecord = Array.from(new Set([...targetIds, ...allCleanIds, ...allLowerIds]));
  await recordDeletedEntities(memberEntitiesToRecord, 'member');

  // 3. Invoices cleanup - Purge all invoices associated with target members
  const rawInvoices = typeof window !== 'undefined' ? localStorage.getItem(KEYS.INVOICES) : null;
  const currentInvoices: InvoiceItem[] = rawInvoices ? JSON.parse(rawInvoices) : (cachedInvoicesInMemory || []);

  const invoicesToDelete = currentInvoices.filter(inv => {
    const mId = (inv.memberId || '').toLowerCase();
    const mIc = (inv.memberIcNo || '').replace(/[\s-]/g, '');
    return allLowerIds.includes(mId) || (mIc && targetIcs.includes(mIc));
  });
  const deletedInvoiceIds = invoicesToDelete.map(inv => inv.id);
  const deletedInvoiceNos = invoicesToDelete.map(inv => inv.invoiceNo).filter(Boolean);

  if (deletedInvoiceIds.length > 0 || deletedInvoiceNos.length > 0) {
    await recordDeletedEntities([...deletedInvoiceIds, ...deletedInvoiceNos], 'invoice');
  }

  const updatedInvoices = currentInvoices.filter(inv => !deletedInvoiceIds.includes(inv.id));
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.INVOICES, JSON.stringify(updatedInvoices));
  }
  cachedInvoicesInMemory = updatedInvoices;
  markTursoFetched('invoices');
  _inflightRefresh['invoices'] = null;

  // 4. Transactions cleanup - Purge Buku Tunai / Cashbook entries for these members/invoices
  const rawTx = typeof window !== 'undefined' ? localStorage.getItem(KEYS.TRANSACTIONS) : null;
  const currentTx: FinancialTransaction[] = rawTx ? JSON.parse(rawTx) : (cachedTransactionsInMemory || []);

  const txToDelete = currentTx.filter(t => {
    const p = (t.payerOrPayee || '').toLowerCase();
    const desc = (t.description || '').toLowerCase();
    const matchName = targetNames.some(name => name.length >= 3 && (p.includes(name.toLowerCase()) || desc.includes(name.toLowerCase())));
    const matchId = allLowerIds.some(tid => desc.includes(tid) || p.includes(tid));
    const matchInv = deletedInvoiceIds.some(invId => desc.includes(invId.toLowerCase())) ||
      deletedInvoiceNos.some(invNo => desc.includes(invNo.toLowerCase()));
    return matchName || matchId || matchInv;
  });
  const deletedTxIds = txToDelete.map(t => t.id);

  if (deletedTxIds.length > 0) {
    await recordDeletedEntities(deletedTxIds, 'transaction');
    const updatedTx = currentTx.filter(t => !deletedTxIds.includes(t.id));
    if (typeof window !== 'undefined') {
      localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(updatedTx));
    }
    cachedTransactionsInMemory = updatedTx;
    markTursoFetched('transactions');
    _inflightRefresh['transactions'] = null;
  }

  // 5. Clean up other localStorage stores (merchandise orders, ujian registrations, syllabus, availability, notice RSVPs)
  if (typeof window !== 'undefined') {
    try {
      const rawOrders = localStorage.getItem(KEYS.MERCHANDISE_ORDERS);
      if (rawOrders) {
        const orders = JSON.parse(rawOrders);
        localStorage.setItem(KEYS.MERCHANDISE_ORDERS, JSON.stringify(orders.filter((o: any) => !allLowerIds.includes((o.memberId || '').toLowerCase()))));
      }
    } catch { }

    try {
      const rawUjian = localStorage.getItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS);
      if (rawUjian) {
        const ujian = JSON.parse(rawUjian);
        localStorage.setItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS, JSON.stringify(ujian.filter((u: any) => !allLowerIds.includes((u.memberId || '').toLowerCase()))));
      }
    } catch { }

    try {
      const rawGrading = localStorage.getItem(KEYS.SYLLABUS_GRADING);
      if (rawGrading) {
        const grading = JSON.parse(rawGrading);
        localStorage.setItem(KEYS.SYLLABUS_GRADING, JSON.stringify(grading.filter((g: any) => !allLowerIds.includes((g.memberId || '').toLowerCase()))));
      }
    } catch { }

    try {
      const rawAvail = localStorage.getItem(KEYS.AVAILABILITY);
      if (rawAvail) {
        const avail = JSON.parse(rawAvail);
        localStorage.setItem(KEYS.AVAILABILITY, JSON.stringify(avail.filter((a: any) => !allLowerIds.includes((a.userId || '').toLowerCase()))));
      }
    } catch { }

    try {
      const rawNotices = localStorage.getItem(KEYS.NOTICES);
      if (rawNotices) {
        const notices: NoticeItem[] = JSON.parse(rawNotices);
        let noticesChanged = false;
        for (const notice of notices) {
          if (notice.rsvps && Array.isArray(notice.rsvps)) {
            const origLen = notice.rsvps.length;
            notice.rsvps = notice.rsvps.filter(r => !allLowerIds.includes((r.userId || '').toLowerCase()));
            if (notice.rsvps.length !== origLen) noticesChanged = true;
          }
          if (notice.pollVotes && Array.isArray(notice.pollVotes)) {
            const origLen = notice.pollVotes.length;
            notice.pollVotes = notice.pollVotes.filter(v => !allLowerIds.includes((v.userId || '').toLowerCase()));
            if (notice.pollVotes.length !== origLen) noticesChanged = true;
          }
        }
        if (noticesChanged) {
          localStorage.setItem(KEYS.NOTICES, JSON.stringify(notices));
        }
      }
    } catch { }
  }

  // 6. Immediate optimistic local cache & memory update
  let updated = currentMembers.filter(m =>
    !allLowerIds.includes((m.id || '').toLowerCase()) &&
    !allCleanIds.includes((m.id || '').toUpperCase())
  );

  // If not deleting family, detach any remaining members from the deleted parent
  if (!options?.deleteFamily) {
    updated = updated.map(m => {
      if (m.parentId && (allLowerIds.includes(m.parentId.toLowerCase()) || targetIcs.includes(m.parentId.replace(/[\s-]/g, '')))) {
        return { ...m, parentId: undefined };
      }
      return m;
    });
  }

  updated = filterOutDeletedMembers(updated);
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.MEMBERS, JSON.stringify(updated));
  }
  cachedMembersInMemory = updated;

  // Prevent immediate in-flight refresh from overwriting optimistic delete
  markTursoFetched('members');
  _inflightRefresh['members'] = null;

  // 7. Await AJAX delete & batch cascade to remote DB (aaPanel MySQL)
  const batchStatements: Array<{ sql: string; args: any[] }> = [];

  // Delete from members
  for (const tid of targetIds) {
    batchStatements.push({
      sql: `DELETE FROM members WHERE id = ? OR id = ? OR LOWER(id) = ?;`,
      args: [tid.trim().toUpperCase(), tid, tid.toLowerCase()]
    });
  }

  // Detach children in MySQL if not deleting family
  if (!options?.deleteFamily) {
    for (const tid of targetIds) {
      batchStatements.push({
        sql: `UPDATE members SET parentId = NULL WHERE parentId = ? OR LOWER(parentId) = ?;`,
        args: [tid, tid.toLowerCase()]
      });
    }
    for (const tic of targetIcs) {
      batchStatements.push({
        sql: `UPDATE members SET parentId = NULL WHERE parentId = ?;`,
        args: [tic]
      });
    }
  }

  // Delete from invoices
  for (const tid of targetIds) {
    batchStatements.push({
      sql: `DELETE FROM invoices WHERE memberId = ? OR LOWER(memberId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
  }
  for (const tic of targetIcs) {
    batchStatements.push({
      sql: `DELETE FROM invoices WHERE memberIcNo = ?;`,
      args: [tic]
    });
  }
  for (const invId of deletedInvoiceIds) {
    batchStatements.push({
      sql: `DELETE FROM invoices WHERE id = ?;`,
      args: [invId]
    });
  }

  // Delete from merchandise_orders
  for (const tid of targetIds) {
    batchStatements.push({
      sql: `DELETE FROM merchandise_orders WHERE memberId = ? OR LOWER(memberId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
  }

  // Delete from syllabus_progress, grading, ujian, availability
  for (const tid of targetIds) {
    batchStatements.push({
      sql: `DELETE FROM syllabus_progress WHERE memberId = ? OR LOWER(memberId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
    batchStatements.push({
      sql: `DELETE FROM syllabus_grading WHERE memberId = ? OR LOWER(memberId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
    batchStatements.push({
      sql: `DELETE FROM ujian_bengkung_registrations WHERE memberId = ? OR LOWER(memberId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
    batchStatements.push({
      sql: `DELETE FROM availability WHERE userId = ? OR LOWER(userId) = ?;`,
      args: [tid, tid.toLowerCase()]
    });
  }

  // Delete from transactions
  for (const txId of deletedTxIds) {
    batchStatements.push({
      sql: `DELETE FROM transactions WHERE id = ?;`,
      args: [txId]
    });
  }
  for (const tid of targetIds) {
    batchStatements.push({
      sql: `DELETE FROM transactions WHERE description LIKE ? OR payerOrPayee LIKE ?;`,
      args: [`%${tid}%`, `%${tid}%`]
    });
  }

  if (batchStatements.length > 0) {
    await executeTursoBatch(batchStatements).catch((err) => {
      console.error("AJAX deleteMemberDB batch error:", err);
    });
  }

  // 8. Notify all listeners with an instant database updated event
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return updated;
}

// NOTICE DATABASE OPERATIONS

function getDeletedNoticeIds(): Set<string> {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DELETED_NOTICES) : null;
    const set = new Set<string>(raw ? JSON.parse(raw) : []);
    set.add('notice-01');
    return set;
  } catch {
    return new Set<string>(['notice-01']);
  }
}

function filterOutDeletedNotices(list: NoticeItem[]): NoticeItem[] {
  const deleted = getDeletedNoticeIds();
  return list.filter(n => !deleted.has(n.id) && n.id !== 'notice-01' && !n.title.includes('Mesyuarat Agung Tahunan ASMM 2026'));
}

export async function getNoticesDB(): Promise<NoticeItem[]> {
  initializeDB();

  if (cachedNoticesInMemory && cachedNoticesInMemory.length > 0) {
    const clean = filterOutDeletedNotices(cachedNoticesInMemory);
    if (shouldRefreshFromTurso('notices') && !_inflightRefresh['notices']) {
      _inflightRefresh['notices'] = refreshNoticesCacheFromTurso()
        .finally(() => { _inflightRefresh['notices'] = null; });
    }
    return clean;
  }

  return filterOutDeletedNotices(await refreshNoticesCacheFromTurso());
}

async function refreshNoticesCacheFromTurso(): Promise<NoticeItem[]> {
  // 1. Attempt fetching actual rows directly from aaPanel database
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM notices;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbNotices: NoticeItem[] = tursoRes.rows.map((row: any) => {
        let parsedData: any = {};
        try {
          if (row.data) parsedData = typeof row.data === 'string' ? JSON.parse(row.data) : row.data;
        } catch { }

        const ctaBtnText = parsedData.ctaButtonText === 'Bayar Yuran ToyyibPay Now' ? 'Bayar Yuran' : parsedData.ctaButtonText;

        return {
          id: String(row.id ?? row[0]),
          title: String(row.title ?? row[1]),
          content: String(row.content ?? row[2]),
          type: String(row.type ?? row[3]) as NoticeItem['type'],
          authorName: String(row.authorName ?? row[4] ?? ''),
          authorRole: String(row.authorRole ?? row[5] ?? '') as Role,
          targetGelanggang: String(row.targetGelanggang ?? row[6] ?? 'Semua Gelanggang') as Gelanggang,
          createdAt: String(row.createdAt ?? row[7] ?? ''),
          eventDate: String(row.eventDate ?? row[8] ?? ''),
          eventEndDate: parsedData.eventEndDate || '',
          eventTime: String(row.eventTime ?? row[9] ?? ''),
          eventLocation: String(row.eventLocation ?? row[10] ?? ''),
          ctaButtonText: ctaBtnText,
          ctaButtonLink: parsedData.ctaButtonLink,
          ctaButtonType: parsedData.ctaButtonType,
          data: typeof row.data === 'string' ? row.data : (row.data ? JSON.stringify(row.data) : undefined),
          actionConfirm: parsedData.actionConfirm,
          actionDecline: parsedData.actionDecline,
          leadHours: parsedData.leadHours,
          rsvps: parsedData.rsvps || [],
          pollOptions: parsedData.pollOptions,
          pollVotes: parsedData.pollVotes,
          attachmentUrl: parsedData.attachmentUrl,
          attachmentName: parsedData.attachmentName,
          attachmentVault: parsedData.attachmentVault,
          hasFamilyAddon: parsedData.hasFamilyAddon,
          freeSeatsPerPax: parsedData.freeSeatsPerPax,
          freeMealsPerPax: parsedData.freeMealsPerPax,
          seatOriginalPrice: parsedData.seatOriginalPrice,
          seatPromoPrice: parsedData.seatPromoPrice,
          mealOriginalPrice: parsedData.mealOriginalPrice,
          mealPromoPrice: parsedData.mealPromoPrice,
          registrationDeadline: parsedData.registrationDeadline,
          promoDeadline: parsedData.promoDeadline,
          paymentMethod: parsedData.paymentMethod,
          qrBankName: parsedData.qrBankName,
          qrAccountName: parsedData.qrAccountName,
          qrAccountNo: parsedData.qrAccountNo,
          qrImageUrl: parsedData.qrImageUrl,
          qrNotes: parsedData.qrNotes
        };
      });

      const deletedIds = await fetchDeletedEntityIds('notice');
      const cleanNotices = dbNotices.filter(n => !deletedIds.has(n.id) && !deletedIds.has(n.id.toLowerCase()));

      // Cache live database rows to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.NOTICES, JSON.stringify(cleanNotices));
      }
      cachedNoticesInMemory = cleanNotices;
      markTursoFetched('notices');
      return cleanNotices;
    }
  } catch (e) {
    console.warn("aaPanel live notice fetch notice (Local fallback active):", e);
  }

  // 2. Fallback to localStorage ONLY on network/query failure
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.NOTICES) : null;
  const notices: NoticeItem[] = raw ? JSON.parse(raw) : [];
  const sanitized = filterOutDeletedNotices(notices.map(n => {
    if (n.ctaButtonText && n.ctaButtonText.includes('ToyyibPay')) {
      return { ...n, ctaButtonText: 'Bayar Yuran' };
    }
    return n;
  }));
  cachedNoticesInMemory = sanitized;
  return sanitized;
}

export async function saveNoticeDB(notice: NoticeItem): Promise<NoticeItem[]> {
  const cleanNotice = {
    ...notice,
    ctaButtonText: notice.ctaButtonText === 'Bayar Yuran ToyyibPay Now' ? 'Bayar Yuran' : notice.ctaButtonText
  };
  const current = await getNoticesDB();
  const index = current.findIndex(n => n.id === cleanNotice.id);
  let updated: NoticeItem[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = cleanNotice;
  } else {
    updated = [cleanNotice, ...current];
  }
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.NOTICES, JSON.stringify(updated));
  }
  cachedNoticesInMemory = updated;

  // Clear TTL locks so subsequent calls get immediate fresh data
  _lastTursoFetch['notices'] = 0;
  _inflightRefresh['notices'] = null;

  // Sync to aaPanel database asynchronously
  const extraData = JSON.stringify({
    ctaButtonText: cleanNotice.ctaButtonText,
    ctaButtonLink: cleanNotice.ctaButtonLink,
    ctaButtonType: cleanNotice.ctaButtonType,
    eventEndDate: cleanNotice.eventEndDate,
    rsvps: cleanNotice.rsvps,
    pollOptions: cleanNotice.pollOptions,
    pollVotes: cleanNotice.pollVotes,
    attachmentUrl: cleanNotice.attachmentUrl,
    attachmentName: cleanNotice.attachmentName,
    attachmentVault: cleanNotice.attachmentVault,
    hasFamilyAddon: cleanNotice.hasFamilyAddon,
    freeSeatsPerPax: cleanNotice.freeSeatsPerPax,
    freeMealsPerPax: cleanNotice.freeMealsPerPax,
    seatOriginalPrice: cleanNotice.seatOriginalPrice,
    seatPromoPrice: cleanNotice.seatPromoPrice,
    mealOriginalPrice: cleanNotice.mealOriginalPrice,
    mealPromoPrice: cleanNotice.mealPromoPrice,
    registrationDeadline: cleanNotice.registrationDeadline,
    promoDeadline: cleanNotice.promoDeadline,
    paymentMethod: cleanNotice.paymentMethod,
    qrBankName: cleanNotice.qrBankName,
    qrAccountName: cleanNotice.qrAccountName,
    qrAccountNo: cleanNotice.qrAccountNo,
    qrImageUrl: cleanNotice.qrImageUrl,
    qrNotes: cleanNotice.qrNotes
  });

  executeTursoQuery(
    `INSERT INTO notices (id, title, content, type, authorName, authorRole, targetGelanggang, createdAt, eventDate, eventTime, eventLocation, data) 
     VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?) 
     ON DUPLICATE KEY UPDATE 
     title = VALUES(title), content = VALUES(content), type = VALUES(type), authorName = VALUES(authorName), authorRole = VALUES(authorRole), targetGelanggang = VALUES(targetGelanggang), createdAt = VALUES(createdAt), eventDate = VALUES(eventDate), eventTime = VALUES(eventTime), eventLocation = VALUES(eventLocation), data = VALUES(data);`,
    [cleanNotice.id, cleanNotice.title, cleanNotice.content, cleanNotice.type, cleanNotice.authorName || '', cleanNotice.authorRole || '', cleanNotice.targetGelanggang || '', cleanNotice.createdAt || '', cleanNotice.eventDate || '', cleanNotice.eventTime || '', cleanNotice.eventLocation || '', extraData]
  ).catch((err) => {
    console.warn("Failed to save notice to aaPanel:", err);
  });

  // Dispatch events for live UI reactivity
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'notice', id: cleanNotice.id } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return updated;
}

export async function syncAllNoticesToTursoDB(noticesList?: NoticeItem[]): Promise<void> {
  const list = noticesList || [];
  if (list.length === 0) return;
  const statements = list.map(n => {
    const extraData = JSON.stringify({
      ctaButtonText: n.ctaButtonText === 'Bayar Yuran ToyyibPay Now' ? 'Bayar Yuran' : n.ctaButtonText,
      ctaButtonLink: n.ctaButtonLink,
      ctaButtonType: n.ctaButtonType,
      eventEndDate: n.eventEndDate,
      actionConfirm: n.actionConfirm,
      actionDecline: n.actionDecline,
      leadHours: n.leadHours,
      rsvps: n.rsvps,
      pollOptions: n.pollOptions,
      pollVotes: n.pollVotes,
      attachmentUrl: n.attachmentUrl,
      attachmentName: n.attachmentName,
      attachmentVault: n.attachmentVault,
      hasFamilyAddon: n.hasFamilyAddon,
      freeSeatsPerPax: n.freeSeatsPerPax,
      freeMealsPerPax: n.freeMealsPerPax,
      seatOriginalPrice: n.seatOriginalPrice,
      seatPromoPrice: n.seatPromoPrice,
      mealOriginalPrice: n.mealOriginalPrice,
      mealPromoPrice: n.mealPromoPrice,
      registrationDeadline: n.registrationDeadline,
      promoDeadline: n.promoDeadline,
      paymentMethod: n.paymentMethod,
      qrBankName: n.qrBankName,
      qrAccountName: n.qrAccountName,
      qrAccountNo: n.qrAccountNo,
      qrImageUrl: n.qrImageUrl,
      qrNotes: n.qrNotes
    });
    return {
      sql: `INSERT INTO notices (id, title, content, type, authorName, authorRole, targetGelanggang, createdAt, eventDate, eventTime, eventLocation, data) 
            VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?) 
            ON DUPLICATE KEY UPDATE 
            title = VALUES(title), content = VALUES(content), type = VALUES(type), authorName = VALUES(authorName), authorRole = VALUES(authorRole), targetGelanggang = VALUES(targetGelanggang), createdAt = VALUES(createdAt), eventDate = VALUES(eventDate), eventTime = VALUES(eventTime), eventLocation = VALUES(eventLocation), data = VALUES(data);`,
      args: [n.id, n.title, n.content, n.type, n.authorName || '', n.authorRole || '', n.targetGelanggang || '', n.createdAt || '', n.eventDate || '', n.eventTime || '', n.eventLocation || '', extraData]
    };
  });
  await executeTursoBatch(statements).catch((err) => {
    console.warn('Failed to batch sync notices to aaPanel:', err);
  });
}

export async function updateNoticeDB(notices: NoticeItem[]): Promise<void> {
  const clean = filterOutDeletedNotices(notices);
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.NOTICES, JSON.stringify(clean));
  }
  cachedNoticesInMemory = clean;
  _lastTursoFetch['notices'] = 0;
  _inflightRefresh['notices'] = null;
  await syncAllNoticesToTursoDB(clean);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'notice' } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }
}

export async function deleteNoticeDB(id: string): Promise<NoticeItem[]> {
  // 1. Record permanently in deleted notices tracking (MySQL + localStorage)
  await recordDeletedEntities([id], 'notice');

  // 2. Optimistic local cache & state update
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.NOTICES) : null;
  const current: NoticeItem[] = raw ? JSON.parse(raw) : (cachedNoticesInMemory || []);
  const updated = current.filter(n => n.id !== id && n.id?.toLowerCase() !== id.toLowerCase());
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.NOTICES, JSON.stringify(updated));
  }
  cachedNoticesInMemory = updated;

  // Prevent immediate in-flight refresh from overwriting optimistic delete
  markTursoFetched('notices');
  _inflightRefresh['notices'] = null;

  // 3. Await Delete from aaPanel MySQL
  await executeTursoQuery(`DELETE FROM notices WHERE id = ?;`, [id]).catch((err) => {
    console.warn('Failed to delete notice from aaPanel:', err);
  });

  // 4. Dispatch events for UI reactivity
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'notice', id } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return updated;
}

export async function recordPracticeRsvpDB(rsvp: {
  id: string;
  memberId: string;
  memberName: string;
  gelanggang: string;
  sessionDate: string;
  sessionTime?: string;
  status: 'Hadir' | 'Tidak Hadir' | 'Uzur' | 'Ragu-ragu';
  notes?: string;
}): Promise<void> {
  const nowIso = new Date().toISOString();
  try {
    await executeTursoQuery(
      `REPLACE INTO practice_rsvps (id, memberId, memberName, gelanggang, sessionDate, sessionTime, status, notes, createdAt, updatedAt)
       VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        rsvp.id,
        rsvp.memberId,
        rsvp.memberName,
        rsvp.gelanggang,
        rsvp.sessionDate,
        rsvp.sessionTime || '',
        rsvp.status,
        rsvp.notes || '',
        nowIso,
        nowIso
      ]
    );
  } catch (err) {
    console.warn('Failed to record practice RSVP in MySQL:', err);
  }
}

// TRANSACTION DATABASE OPERATIONS
export async function syncAllTransactionsToTursoDB(transactionsList?: FinancialTransaction[]): Promise<void> {
  const list = transactionsList || [];
  if (list.length === 0) return;
  const statements = list.map(t => ({
    sql: `INSERT OR REPLACE INTO transactions (id, date, category, description, amount, type, payerOrPayee, gelanggang, receiptUrl, recordedBy, status, toyibBillCode) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [t.id, t.date, t.category, t.description, t.amount, t.type, t.payerOrPayee || '', t.gelanggang || '', t.receiptUrl || '', t.recordedBy || '', t.status || 'Disahkan', t.toyibBillCode || '']
  }));
  await executeTursoBatch(statements).catch(() => { });
}

function getDeletedTransactionIds(): Set<string> {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DELETED_TRANSACTIONS) : null;
    return new Set<string>(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set<string>();
  }
}

function filterOutDeletedTransactions(list: FinancialTransaction[]): FinancialTransaction[] {
  const deleted = getDeletedTransactionIds();
  if (deleted.size === 0) return list;
  return list.filter(t => !deleted.has(t.id) && !deleted.has(t.id.toLowerCase()) && !deleted.has(t.id.toUpperCase()));
}

export async function getTransactionsDB(): Promise<FinancialTransaction[]> {
  initializeDB();

  if (cachedTransactionsInMemory && cachedTransactionsInMemory.length > 0) {
    const clean = filterOutDeletedTransactions(cachedTransactionsInMemory);
    if (shouldRefreshFromTurso('transactions') && !_inflightRefresh['transactions']) {
      _inflightRefresh['transactions'] = refreshTransactionsCacheFromTurso()
        .finally(() => { _inflightRefresh['transactions'] = null; });
    }
    return clean;
  }

  return filterOutDeletedTransactions(await refreshTransactionsCacheFromTurso());
}

/**
 * Deduplicates financial transactions by their invoice reference.
 * If multiple identical transactions exist for the same invoice,
 * it always preserves the one WITH a receipt and deletes the one without a receipt.
 */
export function deduplicateTransactions(txs: FinancialTransaction[]): { clean: FinancialTransaction[]; duplicateIdsToDelete: string[] } {
  const seenInvoices = new Map<string, FinancialTransaction>();
  const clean: FinancialTransaction[] = [];
  const duplicateIdsToDelete: string[] = [];

  for (const tx of txs) {
    let invKey = '';
    if (tx.id.startsWith('tx-inv-')) {
      invKey = tx.id.replace(/^tx-inv-/, '');
    } else if (tx.toyibBillCode && tx.toyibBillCode.startsWith('INV-')) {
      invKey = tx.toyibBillCode;
    } else if (tx.description) {
      const match = tx.description.match(/INV-[\w-]+/);
      if (match) invKey = match[0];
    }

    let finalTx = tx;
    if (finalTx.description && (finalTx.description.includes('Disahkan Pentadbiran') || finalTx.description.includes('Disahkan Superadmin'))) {
      const confirmer = (finalTx.recordedBy && !finalTx.recordedBy.toLowerCase().includes('auto-sync') && !finalTx.recordedBy.toLowerCase().includes('sistem'))
        ? finalTx.recordedBy
        : 'Mohammad Hafiz Bin Halim';
      const cleanDesc = finalTx.description
        .replace(/\(Disahkan\s+Pentadbiran\s*\/\s*Superadmin\)/gi, `(Disahkan oleh ${confirmer})`)
        .replace(/\(Disahkan\s+Pentadbiran\)/gi, `(Disahkan oleh ${confirmer})`)
        .replace(/\(Disahkan\s+Superadmin\)/gi, `(Disahkan oleh ${confirmer})`);
      finalTx = { ...finalTx, description: cleanDesc };
    }

    if (!invKey) {
      clean.push(finalTx);
      continue;
    }

    const hasReceipt = Boolean(finalTx.receiptUrl && finalTx.receiptUrl.length > 50);

    if (!seenInvoices.has(invKey)) {
      seenInvoices.set(invKey, finalTx);
      clean.push(finalTx);
    } else {
      const existing = seenInvoices.get(invKey)!;
      const existingHasReceipt = Boolean(existing.receiptUrl && existing.receiptUrl.length > 50);

      if (!existingHasReceipt && hasReceipt) {
        // Swap: replace the one with no receipt with the current one that HAS a receipt
        const idx = clean.findIndex(t => t.id === existing.id);
        if (idx !== -1) {
          clean[idx] = finalTx;
        }
        seenInvoices.set(invKey, finalTx);
        duplicateIdsToDelete.push(existing.id);
      } else {
        // Existing already has receipt (or neither does): discard current duplicate
        duplicateIdsToDelete.push(finalTx.id);
      }
    }
  }

  return { clean, duplicateIdsToDelete };
}

async function refreshTransactionsCacheFromTurso(): Promise<FinancialTransaction[]> {
  // 1. Attempt fetching actual rows directly from aaPanel database
  try {
    const deletedIds = await fetchDeletedEntityIds('transaction');

    const tursoRes = await executeTursoQuery("SELECT * FROM transactions;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbTxs: FinancialTransaction[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        date: String(row.date ?? row[1]),
        category: String(row.category ?? row[2]) as FinancialTransaction['category'],
        description: String(row.description ?? row[3]),
        amount: Number(row.amount ?? row[4] ?? 0),
        type: String(row.type ?? row[5]) as TransactionType,
        payerOrPayee: String(row.payerOrPayee ?? row[6] ?? ''),
        gelanggang: String(row.gelanggang ?? row[7] ?? '') as Gelanggang,
        receiptUrl: String(row.receiptUrl ?? row[8] ?? ''),
        recordedBy: String(row.recordedBy ?? row[9] ?? ''),
        status: String(row.status ?? row[10] ?? 'Disahkan') as 'Disahkan' | 'Menunggu Pengesahan' | 'Ditolak',
        toyibBillCode: String(row.toyibBillCode ?? row[11] ?? '')
      }));

      const cleanTxs = dbTxs.filter(t => !deletedIds.has(t.id) && !deletedIds.has(t.id.toLowerCase()) && !deletedIds.has(t.id.toUpperCase()));
      const { clean: dedupedTxs, duplicateIdsToDelete } = deduplicateTransactions(cleanTxs);

      if (duplicateIdsToDelete.length > 0) {
        const placeholders = duplicateIdsToDelete.map(() => '?').join(',');
        executeTursoQuery(`DELETE FROM transactions WHERE id IN (${placeholders});`, duplicateIdsToDelete).catch(() => { });
      }

      // Cache live database rows to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(dedupedTxs));
      }
      cachedTransactionsInMemory = dedupedTxs;
      markTursoFetched('transactions');
      return dedupedTxs;
    }
  } catch (e) {
    console.warn("aaPanel live transaction fetch notice (Local fallback active):", e);
  }

  // 2. Fallback to localStorage / in-memory cache
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.TRANSACTIONS) : null;
  const txs: FinancialTransaction[] = raw ? JSON.parse(raw) : [];
  const clean = filterOutDeletedTransactions(txs);
  const { clean: dedupedLocal, duplicateIdsToDelete: localDupes } = deduplicateTransactions(clean);
  if (localDupes.length > 0) {
    const placeholders = localDupes.map(() => '?').join(',');
    executeTursoQuery(`DELETE FROM transactions WHERE id IN (${placeholders});`, localDupes).catch(() => { });
  }
  cachedTransactionsInMemory = dedupedLocal;
  return dedupedLocal;
}

/**
 * Auto-syncs all paid invoices ('Lulus / Dibayar') into the financial transactions ledger
 * (Buku Tunai & Rekod Audit Pertubuhan).
 */
export async function autoSyncPaidInvoicesToTransactions(invoicesList?: InvoiceItem[]): Promise<FinancialTransaction[]> {
  try {
    const invoices = invoicesList || (cachedInvoicesInMemory && cachedInvoicesInMemory.length > 0 ? cachedInvoicesInMemory : await getInvoicesDB());
    const paidInvoices = invoices.filter(inv => inv.status === 'Lulus / Dibayar');

    // Always get current transactions and deduplicate
    const rawTx = typeof window !== 'undefined' ? localStorage.getItem(KEYS.TRANSACTIONS) : null;
    let currentTxs: FinancialTransaction[] = cachedTransactionsInMemory && cachedTransactionsInMemory.length > 0
      ? cachedTransactionsInMemory
      : (rawTx ? JSON.parse(rawTx) : []);

    const { clean: initialClean, duplicateIdsToDelete: initialDupes } = deduplicateTransactions(currentTxs);
    currentTxs = initialClean;
    if (initialDupes.length > 0) {
      const placeholders = initialDupes.map(() => '?').join(',');
      executeTursoQuery(`DELETE FROM transactions WHERE id IN (${placeholders});`, initialDupes).catch(() => { });
    }

    const deletedTxIds = await fetchDeletedEntityIds('transaction');
    const newTxStatements: Array<{ sql: string; args: any[] }> = [];
    const newTxs: FinancialTransaction[] = [];

    for (const inv of paidInvoices) {
      const expectedTxId = `tx-inv-${inv.id}`;

      // Check if a transaction already exists for this invoice
      const existingTx = currentTxs.find(t =>
        t.id === expectedTxId ||
        (inv.invoiceNo && (t.toyibBillCode === inv.invoiceNo || (t.description && t.description.includes(inv.invoiceNo)))) ||
        (inv.id && t.toyibBillCode === inv.id)
      );

      if (existingTx) {
        // Bi-directional receipt synchronization:
        if (inv.receiptUrl && (!existingTx.receiptUrl || existingTx.receiptUrl.length < 50)) {
          existingTx.receiptUrl = inv.receiptUrl;
          saveTransactionDB(existingTx).catch(() => { });
        } else if (existingTx.receiptUrl && (!inv.receiptUrl || inv.receiptUrl.length < 50)) {
          inv.receiptUrl = existingTx.receiptUrl;
          saveInvoiceDB(inv).catch(() => { });
        }
      } else {
        if (deletedTxIds.has(expectedTxId) || deletedTxIds.has(expectedTxId.toLowerCase()) || deletedTxIds.has(expectedTxId.toUpperCase())) {
          continue;
        }

        const txDate = inv.paidAt
          ? inv.paidAt.split(' ')[0]
          : (inv.createdAt ? inv.createdAt.split(' ')[0] : new Date().toISOString().split('T')[0]);

        let cat: FinancialTransaction['category'] = 'Yuran Bulanan';
        if (inv.category === 'Yuran Pendaftaran') cat = 'Yuran Pendaftaran';
        else if (inv.category === 'Yuran Bengkung') cat = 'Yuran Bengkung';
        else if (inv.category === 'Peralatan / Uniform') cat = 'Pembelian Alatan';
        else if (inv.category === 'Sumbangan') cat = 'Sumbangan';
        else if (inv.category) cat = inv.category as any;

        const newTx: FinancialTransaction = {
          id: expectedTxId,
          date: txDate,
          category: cat,
          description: `Bayaran Invois ${inv.invoiceNo}: ${inv.title} (${inv.paymentMethod || 'DuitNow QR / FPX'})`,
          amount: Number(inv.amount) || 0,
          type: 'Income',
          payerOrPayee: inv.memberName || 'Ahli Persatuan',
          gelanggang: (inv.gelanggang === 'Semua Gelanggang' ? 'ASMM' : inv.gelanggang) || 'ASMM',
          recordedBy: 'Sistem Bayaran ASMM (Auto-Sync)',
          status: 'Disahkan',
          toyibBillCode: inv.toyibBillCode || inv.invoiceNo,
          receiptUrl: inv.receiptUrl || ''
        };

        newTxs.push(newTx);
        newTxStatements.push({
          sql: `INSERT INTO transactions (id, date, category, description, amount, type, payerOrPayee, gelanggang, receiptUrl, recordedBy, status, toyibBillCode) 
                VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?) 
                ON DUPLICATE KEY UPDATE 
                date = VALUES(date), category = VALUES(category), description = VALUES(description), amount = VALUES(amount), type = VALUES(type), payerOrPayee = VALUES(payerOrPayee), gelanggang = VALUES(gelanggang), receiptUrl = VALUES(receiptUrl), recordedBy = VALUES(recordedBy), status = VALUES(status), toyibBillCode = VALUES(toyibBillCode);`,
          args: [newTx.id, newTx.date, newTx.category, newTx.description, newTx.amount, newTx.type, newTx.payerOrPayee || '', newTx.gelanggang || '', newTx.receiptUrl || '', newTx.recordedBy || '', newTx.status || 'Disahkan', newTx.toyibBillCode || '']
        });
      }
    }

    const merged = filterOutDeletedTransactions([...newTxs, ...currentTxs]);
    const { clean: finalClean, duplicateIdsToDelete: finalDupes } = deduplicateTransactions(merged);

    if (finalDupes.length > 0) {
      const placeholders = finalDupes.map(() => '?').join(',');
      executeTursoQuery(`DELETE FROM transactions WHERE id IN (${placeholders});`, finalDupes).catch(() => { });
    }

    if (typeof window !== 'undefined') {
      localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(finalClean));
    }
    cachedTransactionsInMemory = finalClean;

    if (newTxStatements.length > 0) {
      _lastTursoFetch['transactions'] = 0;
      await executeTursoBatch(newTxStatements).catch(err => {
        console.warn("Failed to auto-sync transactions to aaPanel:", err);
      });
    }

    if (newTxs.length > 0 || initialDupes.length > 0 || finalDupes.length > 0) {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'transaction_sync', count: newTxs.length } }));
        window.dispatchEvent(new Event('asmm_db_updated'));
      }
    }

    return finalClean;
  } catch (err) {
    console.error("autoSyncPaidInvoicesToTransactions error:", err);
    return await getTransactionsDB();
  }
}

export async function saveTransactionDB(tx: FinancialTransaction): Promise<FinancialTransaction[]> {
  const current = await getTransactionsDB();
  const index = current.findIndex(t => t.id === tx.id);
  let updated: FinancialTransaction[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = tx;
  } else {
    updated = [tx, ...current];
  }
  const clean = filterOutDeletedTransactions(updated);
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(clean));
  }
  cachedTransactionsInMemory = clean;

  _lastTursoFetch['transactions'] = 0;
  _inflightRefresh['transactions'] = null;

  // Sync to aaPanel database asynchronously
  executeTursoQuery(
    `INSERT INTO transactions (id, date, category, description, amount, type, payerOrPayee, gelanggang, receiptUrl, recordedBy, status, toyibBillCode) 
     VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?) 
     ON DUPLICATE KEY UPDATE 
     date = VALUES(date), category = VALUES(category), description = VALUES(description), amount = VALUES(amount), type = VALUES(type), payerOrPayee = VALUES(payerOrPayee), gelanggang = VALUES(gelanggang), receiptUrl = VALUES(receiptUrl), recordedBy = VALUES(recordedBy), status = VALUES(status), toyibBillCode = VALUES(toyibBillCode);`,
    [tx.id, tx.date, tx.category, tx.description, tx.amount, tx.type, tx.payerOrPayee || '', tx.gelanggang || '', tx.receiptUrl || '', tx.recordedBy || '', tx.status || 'Disahkan', tx.toyibBillCode || '']
  ).catch((err) => {
    console.warn("Failed to save transaction to aaPanel:", err);
  });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'transaction', id: tx.id } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return clean;
}

export async function updateTransactionsDB(txs: FinancialTransaction[]): Promise<void> {
  const clean = filterOutDeletedTransactions(txs);
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(clean));
  }
  cachedTransactionsInMemory = clean;
  _lastTursoFetch['transactions'] = 0;
  _inflightRefresh['transactions'] = null;
  await syncAllTransactionsToTursoDB(clean);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'transaction' } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }
}

export async function deleteTransactionsBulkDB(ids: string[]): Promise<FinancialTransaction[]> {
  if (!ids || ids.length === 0) return await getTransactionsDB();
  const idSet = new Set(ids.map(id => id.trim()));
  const upperSet = new Set(ids.map(id => id.trim().toUpperCase()));
  const lowerSet = new Set(ids.map(id => id.trim().toLowerCase()));

  // 1. Record permanently in deleted tracking (MySQL + localStorage)
  await recordDeletedEntities(ids, 'transaction');

  // 2. Optimistic local cache & state update
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.TRANSACTIONS) : null;
  const current: FinancialTransaction[] = raw ? JSON.parse(raw) : (cachedTransactionsInMemory || []);
  const updated = current.filter(t => !idSet.has(t.id) && !upperSet.has(t.id.toUpperCase()) && !lowerSet.has(t.id.toLowerCase()));
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.TRANSACTIONS, JSON.stringify(updated));
  }
  cachedTransactionsInMemory = updated;

  // Prevent immediate in-flight refresh from overwriting optimistic delete
  markTursoFetched('transactions');
  _inflightRefresh['transactions'] = null;

  // 3. Await Delete from aaPanel MySQL
  const placeholders = ids.map(() => '?').join(',');
  await executeTursoQuery(`DELETE FROM transactions WHERE id IN (${placeholders});`, ids).catch((err) => {
    console.warn('Failed to bulk delete transactions from aaPanel:', err);
  });

  // 4. Dispatch events for UI reactivity
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'transaction', ids } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return updated;
}

export async function deleteTransactionDB(id: string): Promise<FinancialTransaction[]> {
  return deleteTransactionsBulkDB([id]);
}

// DRIVE FILE DATABASE OPERATIONS
export async function syncAllDriveFilesToTursoDB(filesList?: DriveFileItem[]): Promise<void> {
  const list = filesList || [];
  if (list.length === 0) return;
  const statements = list.map(f => ({
    sql: `INSERT OR REPLACE INTO files (id, name, mimeType, driveType, webContentLink, category, uploadedAt, size) VALUES (?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [f.id, f.name, f.mimeType || '', f.driveType || '', f.webContentLink || '', f.category || '', f.uploadedAt || '', f.size || '']
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getDriveFilesDB(): Promise<DriveFileItem[]> {
  initializeDB();

  if (cachedFilesInMemory && cachedFilesInMemory.length > 0) {
    if (shouldRefreshFromTurso('files') && !_inflightRefresh['files']) {
      _inflightRefresh['files'] = refreshDriveFilesCacheFromTurso()
        .finally(() => { _inflightRefresh['files'] = null; });
    }
    return cachedFilesInMemory;
  }

  return await refreshDriveFilesCacheFromTurso();
}

async function refreshDriveFilesCacheFromTurso(): Promise<DriveFileItem[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM files;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbFiles: DriveFileItem[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        name: String(row.name ?? row[1]),
        mimeType: String(row.mimeType ?? row[2] ?? 'application/pdf'),
        driveType: String(row.driveType ?? row[3] ?? 'management') as any,
        webContentLink: String(row.webContentLink ?? row[4] ?? ''),
        category: String(row.category ?? row[5] ?? 'General Document') as any,
        uploadedAt: String(row.uploadedAt ?? row[6] ?? ''),
        size: String(row.size ?? row[7] ?? '')
      }));

      localStorage.setItem(KEYS.FILES, JSON.stringify(dbFiles));
      cachedFilesInMemory = dbFiles;
      markTursoFetched('files');
      return dbFiles;
    }
  } catch (e) {
    console.warn("aaPanel live drive files fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.FILES) : null;
  const files: DriveFileItem[] = raw ? JSON.parse(raw) : [];
  cachedFilesInMemory = files;
  return files;
}

export async function saveDriveFileDB(file: DriveFileItem): Promise<DriveFileItem[]> {
  const current = await getDriveFilesDB();
  const index = current.findIndex(f => f.id === file.id);
  let updated: DriveFileItem[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = file;
  } else {
    updated = [file, ...current];
  }
  localStorage.setItem(KEYS.FILES, JSON.stringify(updated));
  cachedFilesInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO files (id, name, mimeType, driveType, webContentLink, category, uploadedAt, size) VALUES (?, ?, ?, ?, ?, ?, ?, ?);`,
    [file.id, file.name, file.mimeType || '', file.driveType || '', file.webContentLink || '', file.category || '', file.uploadedAt || '', file.size || '']
  ).catch(() => { });

  return updated;
}

export async function deleteDriveFileDB(id: string): Promise<DriveFileItem[]> {
  const current = await getDriveFilesDB();
  const updated = current.filter(f => f.id !== id);
  localStorage.setItem(KEYS.FILES, JSON.stringify(updated));
  cachedFilesInMemory = updated;
  executeTursoQuery(`DELETE FROM files WHERE id = ?;`, [id]).catch(() => { });
  return updated;
}

// GELANGGANG DATABASE OPERATIONS
export async function syncAllGelanggangToTursoDB(list?: GelanggangDetail[]): Promise<void> {
  const gelanggangToSync = list || [];
  if (gelanggangToSync.length === 0) return;
  const statements = gelanggangToSync.map(g => ({
    sql: `INSERT OR REPLACE INTO gelanggang (id, name, location, address, gpsLocation, sessionTime, leaderName, leaderPhone, status, classes, paymentPreference, qrBankName, qrAccountName, qrAccountNo, qrImageUrl, qrNotes) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [g.id, g.name, g.location, g.address || '', g.gpsLocation || '', g.sessionTime, g.leaderName, g.leaderPhone || '', g.status, g.classes || '', g.paymentPreference || '', g.qrBankName || '', g.qrAccountName || '', g.qrAccountNo || '', g.qrImageUrl || '', g.qrNotes || '']
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getGelanggangDB(): Promise<GelanggangDetail[]> {
  initializeDB();

  if (cachedGelanggangInMemory && cachedGelanggangInMemory.length > 0) {
    if (shouldRefreshFromTurso('gelanggang') && !_inflightRefresh['gelanggang']) {
      _inflightRefresh['gelanggang'] = refreshGelanggangCacheFromTurso()
        .finally(() => { _inflightRefresh['gelanggang'] = null; });
    }
    return cachedGelanggangInMemory;
  }

  return await refreshGelanggangCacheFromTurso();
}

async function refreshGelanggangCacheFromTurso(): Promise<GelanggangDetail[]> {
  // 1. Attempt fetching actual rows directly from aaPanel database
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM gelanggang;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbGelanggang: GelanggangDetail[] = tursoRes.rows.map((row: any) => {
        const id = String(row.id ?? (Array.isArray(row) ? row[0] : '') ?? '');
        const name = String(row.name ?? (Array.isArray(row) ? row[1] : '') ?? '') as Gelanggang;
        const location = String(row.location ?? (Array.isArray(row) ? row[2] : '') ?? '');

        let address = '';
        let gpsLocation = '';
        let sessionTime = '';
        let leaderName = '';
        let leaderPhone = '';
        let status = 'Aktif';

        if (row.address !== undefined || row.gpsLocation !== undefined) {
          address = String(row.address ?? '');
          gpsLocation = String(row.gpsLocation ?? '');
          sessionTime = String(row.sessionTime ?? '');
          leaderName = String(row.leaderName ?? '');
          leaderPhone = String(row.leaderPhone ?? '');
          status = String(row.status ?? 'Aktif');
        } else if (Array.isArray(row) && row.length >= 9) {
          address = String(row[3] ?? '');
          gpsLocation = String(row[4] ?? '');
          sessionTime = String(row[5] ?? '');
          leaderName = String(row[6] ?? '');
          leaderPhone = String(row[7] ?? '');
          status = String(row[8] ?? 'Aktif');
        } else if (Array.isArray(row)) {
          sessionTime = String(row[3] ?? '');
          leaderName = String(row[4] ?? '');
          leaderPhone = String(row[5] ?? '');
          status = String(row[6] ?? 'Aktif');
          address = location;
          gpsLocation = '';
        }

        const classesVal = row.classes ? String(row.classes) : (row[9] ? String(row[9]) : '');

        // Parse payment preference fields directly from DB row
        const paymentPreference = (row.paymentPreference ? String(row.paymentPreference) : '') as 'fpx' | 'qr_ketua' | undefined;
        const qrBankName = row.qrBankName ? String(row.qrBankName) : '';
        const qrAccountName = row.qrAccountName ? String(row.qrAccountName) : '';
        const qrAccountNo = row.qrAccountNo ? String(row.qrAccountNo) : '';
        const qrImageUrl = row.qrImageUrl ? String(row.qrImageUrl) : '';
        const qrNotes = row.qrNotes ? String(row.qrNotes) : '';

        return {
          id,
          name,
          location: address || location,
          address: address || location,
          gpsLocation,
          sessionTime,
          leaderName,
          leaderPhone,
          status: (status === 'Tidak Aktif' ? 'Tidak Aktif' : 'Aktif') as 'Aktif' | 'Tidak Aktif',
          classes: classesVal,
          ...(paymentPreference ? { paymentPreference } : {}),
          ...(qrBankName ? { qrBankName } : {}),
          ...(qrAccountName ? { qrAccountName } : {}),
          ...(qrAccountNo ? { qrAccountNo } : {}),
          ...(qrImageUrl ? { qrImageUrl } : {}),
          ...(qrNotes ? { qrNotes } : {}),
        };
      });

      localStorage.setItem(KEYS.GELANGGANG, JSON.stringify(dbGelanggang));
      cachedGelanggangInMemory = dbGelanggang;
      markTursoFetched('gelanggang');
      return dbGelanggang;
    }
  } catch (e) {
    console.warn("Turso live gelanggang fetch notice (Local fallback active):", e);
  }

  // 2. Fallback to localStorage
  const raw = localStorage.getItem(KEYS.GELANGGANG);
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      cachedGelanggangInMemory = parsed;
      return parsed;
    } catch { }
  }
  return cachedGelanggangInMemory || [];
}

export async function saveGelanggangDB(gel: GelanggangDetail): Promise<GelanggangDetail[]> {
  const current = await getGelanggangDB();
  const index = current.findIndex(g => g.id === gel.id);
  let updated: GelanggangDetail[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = gel;
  } else {
    updated = [gel, ...current];
  }
  localStorage.setItem(KEYS.GELANGGANG, JSON.stringify(updated));
  cachedGelanggangInMemory = updated;

  // Sync to Turso database asynchronously (includes payment preference fields)
  executeTursoQuery(
    `INSERT OR REPLACE INTO gelanggang (id, name, location, address, gpsLocation, sessionTime, leaderName, leaderPhone, status, classes, paymentPreference, qrBankName, qrAccountName, qrAccountNo, qrImageUrl, qrNotes) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [gel.id, gel.name, gel.location, gel.address || '', gel.gpsLocation || '', gel.sessionTime, gel.leaderName, gel.leaderPhone || '', gel.status, gel.classes || '', gel.paymentPreference || '', gel.qrBankName || '', gel.qrAccountName || '', gel.qrAccountNo || '', gel.qrImageUrl || '', gel.qrNotes || '']
  ).catch(() => { });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'gelanggang' } }));
  }

  return updated;
}

export async function deleteGelanggangDB(id: string): Promise<GelanggangDetail[]> {
  const current = await getGelanggangDB();
  const updated = current.filter(g => g.id !== id);
  localStorage.setItem(KEYS.GELANGGANG, JSON.stringify(updated));
  cachedGelanggangInMemory = updated;
  executeTursoQuery(`DELETE FROM gelanggang WHERE id = ?;`, [id]).catch(() => { });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'gelanggang' } }));
  }

  return updated;
}

// SYLLABUS DATABASE OPERATIONS
export async function syncAllSyllabusToTursoDB(sectionsList?: CourseSection[]): Promise<void> {
  const list = sectionsList || [];
  if (list.length === 0) return;
  // Ensure sortOrder column exists (aaPanel MySQL)
  await executeTursoQuery(`ALTER TABLE syllabus ADD COLUMN sortOrder INT DEFAULT 0;`).catch(() => { });
  const statements = list.map((s, idx) => ({
    sql: `INSERT OR REPLACE INTO syllabus (id, bengkungRank, requiredBengkungName, title, badge, lessons, sortOrder) VALUES (?, ?, ?, ?, ?, ?, ?);`,
    args: [s.id, s.bengkungRank, s.requiredBengkungName, s.title, s.badge || '', JSON.stringify(s.lessons || []), s.sortOrder ?? idx]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getSyllabusDB(): Promise<CourseSection[]> {
  initializeDB();

  if (cachedSyllabusInMemory && cachedSyllabusInMemory.length > 0) {
    if (shouldRefreshFromTurso('syllabus') && !_inflightRefresh['syllabus']) {
      _inflightRefresh['syllabus'] = refreshSyllabusCacheFromTurso()
        .finally(() => { _inflightRefresh['syllabus'] = null; });
    }
    return cachedSyllabusInMemory;
  }

  return await refreshSyllabusCacheFromTurso();
}

async function refreshSyllabusCacheFromTurso(): Promise<CourseSection[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM syllabus;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      if (tursoRes.rows.length < SEED_SYLLABUS.length) {
        await syncAllSyllabusToTursoDB(SEED_SYLLABUS);
        localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(SEED_SYLLABUS));
        cachedSyllabusInMemory = SEED_SYLLABUS;
        markTursoFetched('syllabus');
        return SEED_SYLLABUS;
      }
      const dbSyllabus: CourseSection[] = tursoRes.rows.map((row: any) => {
        let lessonsParsed: LessonItem[] = [];
        try {
          const rawLessons = String(row.lessons ?? row[5] ?? '[]');
          lessonsParsed = JSON.parse(rawLessons);
          // Sort lessons by their sortOrder if present
          lessonsParsed.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        } catch { }

        const secId = String(row.id ?? row[0]);
        const seedMatch = SEED_SYLLABUS.find(sm => sm.id === secId);

        return {
          id: secId,
          bengkungRank: String(row.bengkungRank ?? row[1]) as any,
          requiredBengkungName: String(row.requiredBengkungName ?? row[2]),
          title: cleanSyllabusSectionTitle(String(row.title ?? row[3])),
          category: seedMatch?.category,
          rankSubtitle: seedMatch?.rankSubtitle,
          badge: seedMatch?.badge || String(row.badge ?? row[4] ?? ''),
          sortOrder: Number(row.sortOrder ?? row[6] ?? seedMatch?.sortOrder ?? 0),
          lessons: lessonsParsed.length > 0 ? lessonsParsed : (seedMatch?.lessons || [])
        };
      });

      // Sort sections by sortOrder from DB
      dbSyllabus.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

      localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(dbSyllabus));
      cachedSyllabusInMemory = dbSyllabus;
      markTursoFetched('syllabus');
      return dbSyllabus;
    }
  } catch (e) {
    console.warn("aaPanel live syllabus fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.SYLLABUS) : null;
  const parsed = raw ? JSON.parse(raw) : [];
  cachedSyllabusInMemory = parsed;
  return parsed;
}

export async function saveSyllabusDB(sections: CourseSection[]): Promise<void> {
  localStorage.setItem(KEYS.SYLLABUS, JSON.stringify(sections));
  cachedSyllabusInMemory = sections;
  // Reset the Turso fetch timestamp so the stale-refresh check doesn't immediately
  // re-fetch from remote and overwrite the newly saved order
  markTursoFetched('syllabus');
  syncAllSyllabusToTursoDB(sections);
}

// SYLLABUS INDIVIDUAL CRUD HELPERS

export async function addSectionDB(section: CourseSection): Promise<void> {
  const sections = await getSyllabusDB();
  section.sortOrder = sections.length;
  sections.push(section);
  await saveSyllabusDB(sections);
}

export async function updateSectionDB(sectionId: string, updates: Partial<CourseSection>): Promise<void> {
  const sections = await getSyllabusDB();
  const idx = sections.findIndex(s => s.id === sectionId);
  if (idx === -1) return;
  sections[idx] = { ...sections[idx], ...updates, lessons: updates.lessons ?? sections[idx].lessons };
  await saveSyllabusDB(sections);
}

export async function deleteSectionDB(sectionId: string): Promise<void> {
  let sections = await getSyllabusDB();
  sections = sections.filter(s => s.id !== sectionId);
  await saveSyllabusDB(sections);
}

export async function addLessonToSectionDB(sectionId: string, lesson: LessonItem): Promise<void> {
  const sections = await getSyllabusDB();
  const section = sections.find(s => s.id === sectionId);
  if (!section) return;
  lesson.sortOrder = section.lessons.length;
  section.lessons.push(lesson);
  await saveSyllabusDB(sections);
}

export async function updateLessonDB(sectionId: string, lessonId: string, updates: Partial<LessonItem>): Promise<void> {
  const sections = await getSyllabusDB();
  const section = sections.find(s => s.id === sectionId);
  if (!section) return;
  const lessonIdx = section.lessons.findIndex(l => l.id === lessonId);
  if (lessonIdx === -1) return;
  section.lessons[lessonIdx] = { ...section.lessons[lessonIdx], ...updates };
  await saveSyllabusDB(sections);
}

export async function deleteLessonFromSectionDB(sectionId: string, lessonId: string): Promise<void> {
  const sections = await getSyllabusDB();
  const section = sections.find(s => s.id === sectionId);
  if (!section) return;
  section.lessons = section.lessons.filter(l => l.id !== lessonId);
  await saveSyllabusDB(sections);
}

export async function moveLessonDB(fromSectionId: string, toSectionId: string, lessonId: string): Promise<void> {
  const sections = await getSyllabusDB();
  const fromSection = sections.find(s => s.id === fromSectionId);
  const toSection = sections.find(s => s.id === toSectionId);
  if (!fromSection || !toSection) return;
  const lessonIdx = fromSection.lessons.findIndex(l => l.id === lessonId);
  if (lessonIdx === -1) return;
  const [lesson] = fromSection.lessons.splice(lessonIdx, 1);
  lesson.sortOrder = toSection.lessons.length;
  toSection.lessons.push(lesson);
  await saveSyllabusDB(sections);
}

export async function reorderLessonsDB(sectionId: string, orderedLessonIds: string[]): Promise<void> {
  const sections = await getSyllabusDB();
  const section = sections.find(s => s.id === sectionId);
  if (!section) return;
  const reordered: LessonItem[] = [];
  for (const id of orderedLessonIds) {
    const lesson = section.lessons.find(l => l.id === id);
    if (lesson) {
      lesson.sortOrder = reordered.length;
      reordered.push(lesson);
    }
  }
  // Add any lessons not in the ordered list at the end
  for (const lesson of section.lessons) {
    if (!orderedLessonIds.includes(lesson.id)) {
      lesson.sortOrder = reordered.length;
      reordered.push(lesson);
    }
  }
  section.lessons = reordered;
  await saveSyllabusDB(sections);
}

export async function reorderSectionsDB(orderedSectionIds: string[]): Promise<void> {
  const sections = await getSyllabusDB();
  const reordered: CourseSection[] = [];
  for (const id of orderedSectionIds) {
    const section = sections.find(s => s.id === id);
    if (section) {
      section.sortOrder = reordered.length;
      reordered.push(section);
    }
  }
  for (const section of sections) {
    if (!orderedSectionIds.includes(section.id)) {
      section.sortOrder = reordered.length;
      reordered.push(section);
    }
  }
  await saveSyllabusDB(reordered);
}

// MEMBER SYLLABUS PROGRESSION OPERATIONS (MULTI-USER / AHLI KELUARGA)
export async function getMemberSyllabusProgressDB(memberId: string, memberBengkung?: string): Promise<string[]> {
  if (!memberId) return [];
  const localKey = `asmm_syllabus_completed_${memberId}`;
  let completed: string[] = [];

  const rawLocal = localStorage.getItem(localKey);
  if (rawLocal) {
    try {
      const parsed = JSON.parse(rawLocal);
      if (Array.isArray(parsed)) {
        completed = parsed;
      }
    } catch { }
  }

  // Live async sync from Turso DB in background if available
  try {
    const res = await executeTursoQuery("SELECT completedLessons FROM syllabus_progress WHERE memberId = ?;", [memberId]);
    if (res && res.rows && res.rows.length > 0) {
      const dbRaw = String(res.rows[0].completedLessons ?? res.rows[0][0] ?? '[]');
      const dbParsed = JSON.parse(dbRaw);
      if (Array.isArray(dbParsed)) {
        completed = Array.from(new Set([...completed, ...dbParsed]));
        localStorage.setItem(localKey, JSON.stringify(completed));
      }
    }
  } catch (e) {
    // Local fallback active
  }

  // Auto-mark previous bengkung level lessons as selesai based on member's current bengkung rank
  let bengkung = memberBengkung;
  if (!bengkung) {
    const found = (cachedMembersInMemory || []).find(m => m.id === memberId);
    if (found?.bengkung) {
      bengkung = found.bengkung;
    } else {
      const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.MEMBERS) : null;
      if (raw) {
        try {
          const list = JSON.parse(raw);
          const m = Array.isArray(list) ? list.find((item: any) => item.id === memberId) : null;
          if (m?.bengkung) bengkung = m.bengkung;
        } catch { }
      }
    }
  }

  if (bengkung) {
    const syllabus = cachedSyllabusInMemory && cachedSyllabusInMemory.length > 0 ? cachedSyllabusInMemory : SEED_SYLLABUS;
    const prevLessons = getPreviousRankLessonIds(bengkung, syllabus);
    if (prevLessons.length > 0) {
      const merged = Array.from(new Set([...completed, ...prevLessons]));
      if (merged.length !== completed.length) {
        localStorage.setItem(localKey, JSON.stringify(merged));
      }
      return merged;
    }
  }

  return completed;
}

export async function saveMemberSyllabusProgressDB(memberId: string, completedLessons: string[]): Promise<void> {
  if (!memberId) return;
  const localKey = `asmm_syllabus_completed_${memberId}`;
  localStorage.setItem(localKey, JSON.stringify(completedLessons));

  // Sync to Turso DB in cloud
  try {
    const now = new Date().toISOString();
    await executeTursoQuery(
      "INSERT OR REPLACE INTO syllabus_progress (memberId, completedLessons, updatedAt) VALUES (?, ?, ?);",
      [memberId, JSON.stringify(completedLessons), now]
    );
  } catch (e) {
    console.warn("Notice: Saved syllabus progress locally. Cloud sync fallback:", e);
  }
}

export async function getFamilySyllabusProgressSummaryDB(memberIds: string[], membersList?: UserProfile[]): Promise<Record<string, string[]>> {
  const result: Record<string, string[]> = {};
  const syllabus = cachedSyllabusInMemory && cachedSyllabusInMemory.length > 0 ? cachedSyllabusInMemory : SEED_SYLLABUS;
  const members = membersList || cachedMembersInMemory || [];

  for (const id of memberIds) {
    const localKey = `asmm_syllabus_completed_${id}`;
    const rawLocal = localStorage.getItem(localKey);
    let completed: string[] = [];
    if (rawLocal) {
      try {
        completed = JSON.parse(rawLocal);
      } catch {
        completed = [];
      }
    }

    // Auto-mark previous bengkung level lessons
    const found = members.find(m => m.id === id);
    let bengkung = found?.bengkung;
    if (!bengkung) {
      const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.MEMBERS) : null;
      if (raw) {
        try {
          const list = JSON.parse(raw);
          const m = Array.isArray(list) ? list.find((item: any) => item.id === id) : null;
          if (m?.bengkung) bengkung = m.bengkung;
        } catch { }
      }
    }

    if (bengkung) {
      const prevLessons = getPreviousRankLessonIds(bengkung, syllabus);
      if (prevLessons.length > 0) {
        completed = Array.from(new Set([...completed, ...prevLessons]));
      }
    }

    result[id] = completed;
  }
  return result;
}

// FEE PACKAGES DATABASE OPERATIONS
export async function syncAllFeePackagesToTursoDB(pkgList?: GelanggangFeePackage[]): Promise<void> {
  const list = pkgList || [];
  if (list.length === 0) return;
  const statements = list.map(p => ({
    sql: `INSERT OR REPLACE INTO fee_packages (id, gelanggang, title, price, category, description, targetAudience, status) VALUES (?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [p.id, p.gelanggang, p.title, p.price, p.category, p.description || '', p.targetAudience || '', p.status]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getFeePackagesDB(): Promise<GelanggangFeePackage[]> {
  initializeDB();

  if (cachedFeePackagesInMemory && cachedFeePackagesInMemory.length > 0) {
    if (shouldRefreshFromTurso('fee_packages') && !_inflightRefresh['fee_packages']) {
      _inflightRefresh['fee_packages'] = refreshFeePackagesCacheFromTurso()
        .finally(() => { _inflightRefresh['fee_packages'] = null; });
    }
    return cachedFeePackagesInMemory;
  }

  return await refreshFeePackagesCacheFromTurso();
}

async function refreshFeePackagesCacheFromTurso(): Promise<GelanggangFeePackage[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM fee_packages;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbPkgs: GelanggangFeePackage[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        gelanggang: String(row.gelanggang ?? row[1]) as any,
        title: String(row.title ?? row[2]),
        price: Number(row.price ?? row[3] ?? 0),
        category: String(row.category ?? row[4] ?? 'Yuran Bulanan') as any,
        description: String(row.description ?? row[5] ?? ''),
        targetAudience: String(row.targetAudience ?? row[6] ?? ''),
        status: String(row.status ?? row[7] ?? 'Aktif') as any
      }));

      localStorage.setItem(KEYS.FEE_PACKAGES, JSON.stringify(dbPkgs));
      cachedFeePackagesInMemory = dbPkgs;
      markTursoFetched('fee_packages');
      return dbPkgs;
    }
  } catch (e) {
    console.warn("aaPanel live fee packages fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.FEE_PACKAGES) : null;
  const pkgs: GelanggangFeePackage[] = raw ? JSON.parse(raw) : [];
  cachedFeePackagesInMemory = pkgs;
  return pkgs;
}

export async function saveFeePackageDB(pkg: GelanggangFeePackage): Promise<GelanggangFeePackage[]> {
  const current = await getFeePackagesDB();
  const index = current.findIndex(p => p.id === pkg.id);
  let updated: GelanggangFeePackage[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = pkg;
  } else {
    updated = [pkg, ...current];
  }
  localStorage.setItem(KEYS.FEE_PACKAGES, JSON.stringify(updated));
  cachedFeePackagesInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO fee_packages (id, gelanggang, title, price, category, description, targetAudience, status) VALUES (?, ?, ?, ?, ?, ?, ?, ?);`,
    [pkg.id, pkg.gelanggang, pkg.title, pkg.price, pkg.category, pkg.description || '', pkg.targetAudience || '', pkg.status]
  ).catch(() => { });

  return updated;
}

export async function deleteFeePackageDB(id: string): Promise<GelanggangFeePackage[]> {
  const current = await getFeePackagesDB();
  const updated = current.filter(p => p.id !== id);
  localStorage.setItem(KEYS.FEE_PACKAGES, JSON.stringify(updated));
  cachedFeePackagesInMemory = updated;
  executeTursoQuery(`DELETE FROM fee_packages WHERE id = ?;`, [id]).catch(() => { });
  return updated;
}

// INVOICE DATABASE OPERATIONS
export async function syncAllInvoicesToTursoDB(invoicesList?: InvoiceItem[]): Promise<void> {
  const list = invoicesList || [];
  if (list.length === 0) return;
  const statements = list.map(inv => ({
    sql: `INSERT OR REPLACE INTO invoices (id, invoiceNo, memberId, memberName, memberIcNo, memberPhone, gelanggang, category, title, description, amount, dueDate, createdAt, status, toyibBillCode, paidAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [
      inv.id,
      inv.invoiceNo,
      inv.memberId,
      toTitleCase(inv.memberName),
      sanitizeIc(inv.memberIcNo),
      sanitizePhone(inv.memberPhone),
      inv.gelanggang,
      inv.category,
      inv.title,
      inv.description || '',
      inv.amount,
      inv.dueDate,
      inv.createdAt,
      inv.status,
      inv.toyibBillCode || '',
      inv.paidAt || ''
    ]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export function getDeletedInvoiceIdentifiers(): Set<string> {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DELETED_INVOICES) : null;
    if (raw) {
      const arr = JSON.parse(raw);
      if (Array.isArray(arr)) {
        return new Set(arr.map(s => String(s).toLowerCase().trim()));
      }
    }
  } catch { }
  return new Set();
}

export function recordDeletedInvoiceIdentifier(id: string, invoiceNo?: string): void {
  try {
    if (typeof window === 'undefined') return;
    const set = getDeletedInvoiceIdentifiers();
    if (id) set.add(id.toLowerCase().trim());
    if (invoiceNo) set.add(invoiceNo.toLowerCase().trim());
    localStorage.setItem(KEYS.DELETED_INVOICES, JSON.stringify(Array.from(set)));
  } catch { }
}

export function isInvoiceDeleted(id: string, invoiceNo?: string): boolean {
  const set = getDeletedInvoiceIdentifiers();
  if (id && set.has(id.toLowerCase().trim())) return true;
  if (invoiceNo && set.has(invoiceNo.toLowerCase().trim())) return true;
  return false;
}

function sanitizeUjianBengkungInvoices(invoices: InvoiceItem[]): { list: InvoiceItem[]; modified: boolean } {
  let modified = false;
  const deletedSet = getDeletedInvoiceIdentifiers();

  // 1. Filter out any invoices that were explicitly deleted by the user
  const nonDeleted = invoices.filter(inv => {
    const isDel = (inv.id && deletedSet.has(inv.id.toLowerCase().trim())) ||
      (inv.invoiceNo && deletedSet.has(inv.invoiceNo.toLowerCase().trim()));
    if (isDel) modified = true;
    return !isDel;
  });

  const list = nonDeleted.map(inv => {
    if (inv.category === 'Yuran Bengkung') {
      // Fix invoice for Shukor (asmm-010) whose bengkung is Merah 2
      const isShukor = (inv.memberId && inv.memberId.toLowerCase() === 'asmm-010') ||
        (inv.memberName && inv.memberName.toLowerCase().includes('shukor')) ||
        inv.invoiceNo === 'INV-UB-903491';
      if (isShukor && (inv.description?.toLowerCase().includes('putih') || inv.title?.toLowerCase().includes('putih'))) {
        modified = true;
        const currentRank = 'Merah 2';
        const targetRank = 'Merah 3';
        const fee = getUjianBengkungFeeForLevel(targetRank);
        return {
          ...inv,
          title: `Yuran Ujian Bengkung ${targetRank}`,
          description: `Pendaftaran rasmi & yuran pentaksiran Ujian Kenaikan Bengkung (${currentRank} → ${targetRank}) - Ujian Kenaikan Bengkung ASMM 2026`,
          amount: fee,
          items: [
            {
              id: 'item-1',
              description: `Yuran Pentaksiran Bengkung (${targetRank}) & Sijil ROS`,
              quantity: 1,
              unitPrice: fee,
              amount: fee
            }
          ]
        };
      }
    }

    return inv;
  });

  return { list, modified };
}

export async function getInvoicesDB(): Promise<InvoiceItem[]> {
  initializeDB();

  if (cachedInvoicesInMemory && cachedInvoicesInMemory.length > 0) {
    const { list: sanitizedCached, modified: cachedMod } = sanitizeUjianBengkungInvoices(cachedInvoicesInMemory);
    if (cachedMod) {
      cachedInvoicesInMemory = sanitizedCached;
      localStorage.setItem(KEYS.INVOICES, JSON.stringify(sanitizedCached));
      syncAllInvoicesToTursoDB(sanitizedCached);
    }
    if (shouldRefreshFromTurso('invoices') && !_inflightRefresh['invoices']) {
      _inflightRefresh['invoices'] = refreshInvoicesCacheFromTurso()
        .finally(() => { _inflightRefresh['invoices'] = null; });
    }
    return cachedInvoicesInMemory;
  }

  return await refreshInvoicesCacheFromTurso();
}

async function refreshInvoicesCacheFromTurso(): Promise<InvoiceItem[]> {
  // 1. Attempt fetching actual rows directly from aaPanel database
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM invoices;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbInvoices: InvoiceItem[] = tursoRes.rows.map((row: any) => {
        let itemsParsed = undefined;
        let extraParsed: any = {};
        const rawDesc = String(row.description ?? row[9] ?? '');
        try {
          if (rawDesc && rawDesc.startsWith('{')) {
            extraParsed = JSON.parse(rawDesc);
            itemsParsed = extraParsed.items;
          }
        } catch (e) { }

        return {
          id: String(row.id ?? row[0]),
          invoiceNo: String(row.invoiceNo ?? row[1]),
          memberId: String(row.memberId ?? row[2]),
          memberName: String(row.memberName ?? row[3]),
          memberIcNo: String(row.memberIcNo ?? row[4] ?? ''),
          memberPhone: String(row.memberPhone ?? row[5] ?? ''),
          address: extraParsed.address || '',
          payerType: extraParsed.payerType || (String(row.memberId ?? row[2]).startsWith('VENDOR-') ? 'Vendor / Pihak Ketiga' : 'Ahli'),
          vendorEmail: extraParsed.vendorEmail || '',
          vendorPhone: extraParsed.vendorPhone || String(row.memberPhone ?? row[5] ?? ''),
          vendorAddress: extraParsed.vendorAddress || extraParsed.address || '',
          gelanggang: String(row.gelanggang ?? row[6] ?? '') as Gelanggang,
          category: String(row.category ?? row[7]) as InvoiceItem['category'],
          title: String(row.title ?? row[8]),
          description: extraParsed.description !== undefined ? extraParsed.description : rawDesc,
          items: (itemsParsed && itemsParsed.length > 0) ? itemsParsed : undefined,
          amount: Number(row.amount ?? row[10] ?? 0),
          dueDate: String(row.dueDate ?? row[11] ?? ''),
          createdAt: String(row.createdAt ?? row[12] ?? ''),
          status: String(row.status ?? row[13] ?? 'Belum Dibayar') as InvoiceItem['status'],
          toyibBillCode: String(row.toyibBillCode ?? row[14] ?? ''),
          paidAt: String(row.paidAt ?? row[15] ?? ''),
          paymentMethod: extraParsed.paymentMethod,
          receiptUrl: extraParsed.receiptUrl,
          receiptFileName: extraParsed.receiptFileName
        };
      });

      // Filter out any deleted invoices from aaPanel results
      const nonDeletedDb = dbInvoices.filter(inv => !isInvoiceDeleted(inv.id, inv.invoiceNo));

      // If any deleted invoices are still present in Turso, purge them in parallel
      const toPurgeTurso = dbInvoices.filter(inv => isInvoiceDeleted(inv.id, inv.invoiceNo));
      if (toPurgeTurso.length > 0) {
        executeTursoBatch(toPurgeTurso.map(inv => ({
          sql: `DELETE FROM invoices WHERE id = ? OR invoiceNo = ?;`,
          args: [inv.id, inv.invoiceNo]
        }))).catch(() => { });
      }

      // Check and auto-generate monthly invoices in background (once per session)
      const finalInvoices = await autoGenerateMonthlyInvoices(nonDeletedDb);
      const { list: cleanFinal, modified: tursoMod } = sanitizeUjianBengkungInvoices(finalInvoices);
      if (tursoMod) {
        syncAllInvoicesToTursoDB(cleanFinal);
      }

      // Cache live database rows to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.INVOICES, JSON.stringify(cleanFinal));
      }
      cachedInvoicesInMemory = cleanFinal;
      markTursoFetched('invoices');
      return cleanFinal;
    }
  } catch (e) {
    console.warn("Turso live invoice fetch notice (Local fallback active):", e);
  }

  // 2. Fallback to localStorage
  const raw = localStorage.getItem(KEYS.INVOICES);
  const invs = raw ? JSON.parse(raw) : [];
  const { list: cleanFallback, modified: modFallback } = sanitizeUjianBengkungInvoices(invs);
  if (modFallback) {
    localStorage.setItem(KEYS.INVOICES, JSON.stringify(cleanFallback));
  }

  // Try auto-generating on fallback data in the background
  autoGenerateMonthlyInvoices(cleanFallback).then(finalInvs => {
    const { list: cleanFinal } = sanitizeUjianBengkungInvoices(finalInvs);
    localStorage.setItem(KEYS.INVOICES, JSON.stringify(cleanFinal));
    cachedInvoicesInMemory = cleanFinal;
  }).catch(() => { });

  cachedInvoicesInMemory = cleanFallback;
  return cleanFallback;
}

export async function saveInvoiceDB(invoice: InvoiceItem): Promise<InvoiceItem[]> {
  const current = await getInvoicesDB();
  const index = current.findIndex(inv => inv.id === invoice.id);
  let updated: InvoiceItem[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = invoice;
  } else {
    updated = [invoice, ...current];
  }
  localStorage.setItem(KEYS.INVOICES, JSON.stringify(updated));
  cachedInvoicesInMemory = updated;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  // Package items and vendor details safely into extraData JSON for Turso DB persistence
  const extraDataStr = JSON.stringify({
    description: invoice.description || '',
    items: invoice.items || [],
    address: invoice.address || '',
    payerType: invoice.payerType || 'Ahli',
    vendorEmail: invoice.vendorEmail || '',
    vendorPhone: invoice.vendorPhone || '',
    vendorAddress: invoice.vendorAddress || '',
    paymentMethod: invoice.paymentMethod || '',
    receiptUrl: invoice.receiptUrl || '',
    receiptFileName: invoice.receiptFileName || ''
  });

  // Sync to Turso database asynchronously
  executeTursoQuery(
    `INSERT OR REPLACE INTO invoices (id, invoiceNo, memberId, memberName, memberIcNo, memberPhone, gelanggang, category, title, description, amount, dueDate, createdAt, status, toyibBillCode, paidAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [
      invoice.id,
      invoice.invoiceNo,
      invoice.memberId,
      toTitleCase(invoice.memberName),
      sanitizeIc(invoice.memberIcNo),
      sanitizePhone(invoice.memberPhone),
      invoice.gelanggang,
      invoice.category,
      invoice.title,
      extraDataStr,
      invoice.amount,
      invoice.dueDate,
      invoice.createdAt,
      invoice.status,
      invoice.toyibBillCode || '',
      invoice.paidAt || ''
    ]
  ).catch(() => { });

  // Auto-sync into official financial transaction ledger (Buku Tunai & Audit)
  if (invoice.status === 'Lulus / Dibayar') {
    const txDate = invoice.paidAt
      ? invoice.paidAt.split(' ')[0]
      : (invoice.createdAt ? invoice.createdAt.split(' ')[0] : new Date().toISOString().split('T')[0]);

    let cat: FinancialTransaction['category'] = 'Yuran Bulanan';
    if (invoice.category === 'Yuran Pendaftaran') cat = 'Yuran Pendaftaran';
    else if (invoice.category === 'Yuran Bengkung') cat = 'Yuran Bengkung';
    else if (invoice.category === 'Peralatan / Uniform') cat = 'Pembelian Alatan';
    else if (invoice.category === 'Sumbangan') cat = 'Sumbangan';
    else if (invoice.category) cat = invoice.category as any;

    const finTx: FinancialTransaction = {
      id: `tx-inv-${invoice.id}`,
      date: txDate,
      category: cat,
      description: `Bayaran Invois ${invoice.invoiceNo}: ${invoice.title} (${invoice.paymentMethod || 'DuitNow QR / FPX'})`,
      amount: Number(invoice.amount) || 0,
      type: 'Income',
      payerOrPayee: invoice.memberName || 'Ahli Persatuan',
      gelanggang: (invoice.gelanggang === 'Semua Gelanggang' ? 'ASMM' : invoice.gelanggang) || 'ASMM',
      recordedBy: 'Sistem Bayaran ASMM (Auto-Sync)',
      status: 'Disahkan',
      toyibBillCode: invoice.toyibBillCode || invoice.invoiceNo,
      receiptUrl: invoice.receiptUrl || ''
    };
    saveTransactionDB(finTx).catch(() => { });
  }

  return updated;
}

export async function updateInvoicesDB(invoices: InvoiceItem[]): Promise<void> {
  localStorage.setItem(KEYS.INVOICES, JSON.stringify(invoices));
  cachedInvoicesInMemory = invoices;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_db_updated'));
  }
  syncAllInvoicesToTursoDB(invoices);
}

export async function deleteInvoicesBulkDB(items: Array<{ id: string; invoiceNo?: string }> | string[]): Promise<InvoiceItem[]> {
  if (!items || items.length === 0) return await getInvoicesDB();

  const normalizedItems: Array<{ id: string; invoiceNo?: string }> = items.map(item => {
    if (typeof item === 'string') {
      return { id: item, invoiceNo: item };
    }
    return item;
  });

  const allIdsToRecord: string[] = [];
  const targetIdSet = new Set<string>();

  normalizedItems.forEach(item => {
    const cleanId = (item.id || '').trim();
    const cleanNo = (item.invoiceNo || '').trim();
    if (cleanId) {
      allIdsToRecord.push(cleanId);
      targetIdSet.add(cleanId.toLowerCase());
    }
    if (cleanNo && cleanNo !== cleanId) {
      allIdsToRecord.push(cleanNo);
      targetIdSet.add(cleanNo.toLowerCase());
    }
    recordDeletedInvoiceIdentifier(cleanId, cleanNo);
  });

  // 1. Permanently record in MySQL deleted_records + localStorage
  await recordDeletedEntities(allIdsToRecord, 'invoice');

  // 2. Read current list from memory cache or localStorage
  let current: InvoiceItem[] = [];
  if (cachedInvoicesInMemory && cachedInvoicesInMemory.length > 0) {
    current = cachedInvoicesInMemory;
  } else {
    try {
      const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.INVOICES) : null;
      current = raw ? JSON.parse(raw) : [];
    } catch {
      current = [];
    }
  }

  const updated = current.filter(inv => {
    const invId = (inv.id || '').toLowerCase().trim();
    const invNo = (inv.invoiceNo || '').toLowerCase().trim();
    if (targetIdSet.has(invId) || (invNo && targetIdSet.has(invNo))) return false;
    return true;
  });

  // 3. Update in-memory cache and localStorage synchronously
  cachedInvoicesInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.INVOICES, JSON.stringify(updated));
  }

  markTursoFetched('invoices');
  _inflightRefresh['invoices'] = null;

  // 4. Batch delete in MySQL
  const sqlStatements: Array<{ sql: string; args: any[] }> = [];
  normalizedItems.forEach(item => {
    const id = item.id;
    const invoiceNo = item.invoiceNo || id;
    sqlStatements.push({ sql: `DELETE FROM invoices WHERE id = ? OR invoiceNo = ?;`, args: [id, invoiceNo] });
    sqlStatements.push({ sql: `DELETE FROM transactions WHERE toyibBillCode = ? OR description LIKE ?;`, args: [id, `%${invoiceNo}%`] });
  });

  await executeTursoBatch(sqlStatements).catch((err) => {
    console.warn("Failed to bulk delete invoices from aaPanel:", err);
  });

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('asmm_db_updated', { detail: { type: 'invoice', items: normalizedItems } }));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  return updated;
}

export async function deleteInvoiceDB(id: string, invoiceNo?: string): Promise<InvoiceItem[]> {
  return deleteInvoicesBulkDB([{ id, invoiceNo }]);
}

/**
 * Checks all active members against current invoices list and generates a
 * monthly training fee invoice for the current month if one doesn't exist yet.
 */
export async function autoGenerateMonthlyInvoices(currentInvoices: InvoiceItem[]): Promise<InvoiceItem[]> {
  // Only run once per session to avoid cascading DB calls
  if (_monthlyInvoicesChecked) return currentInvoices;
  _monthlyInvoicesChecked = true;

  try {
    // Use in-memory cache directly instead of re-entering getMembersDB()/getGelanggangDB()
    // which would trigger additional initializeDB() + Turso SELECTs
    const members = cachedMembersInMemory || [];
    const activeMembers = members.filter(m =>
      m.status === 'Aktif' &&
      m.role !== 'Waris' &&
      (!m.roles || !m.roles.includes('Waris') || (m as any).isAlsoPesilat) &&
      m.onboardingStatus !== 'pending_payment' &&
      m.icNo &&
      m.icNo.trim() !== '' &&
      m.gelanggang &&
      m.gelanggang !== 'Semua Gelanggang' &&
      m.gelanggang !== 'Tiada' &&
      isEligibleForMonthlyFee(m)
    );

    // Purge any erroneous monthly training invoices created for Waris who are not pesilat
    const initialInvoices = currentInvoices.filter(inv => {
      if (inv.category === 'Yuran Bulanan') {
        const mem = members.find(m => m.id === inv.memberId);
        if (mem && (mem.role === 'Waris' || (mem.roles && mem.roles.includes('Waris'))) && !(mem as any).isAlsoPesilat) {
          return false;
        }
      }
      return true;
    });

    if (activeMembers.length === 0) return initialInvoices;

    // Use in-memory cache for gelanggang data
    const gelanggangList = cachedGelanggangInMemory || [];
    const getClassPrice = (gelName: string, planName: string): number => {
      const gel = gelanggangList.find(g => g.name === gelName);
      if (gel?.classes) {
        try {
          const parsed = JSON.parse(gel.classes);
          if (Array.isArray(parsed)) {
            const cls = parsed.find((c: any) => c.name === planName);
            if (cls) return cls.price;
          }
        } catch { }
      }
      // Fallback defaults
      if (planName === 'Memanah') return 50;
      if (planName === 'Silat Dewasa') return gelName === 'Wadi AnNour' ? 40 : 50;
      if (planName === 'Silat Muda' || planName === 'Silat Kanak-kanak') return gelName === 'Wadi AnNour' ? 20 : 30;
      if (gelName === 'Wadi AnNour') return 20;
      return 40;
    };

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');

    const monthsMalay = ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'];
    const monthNameMalay = monthsMalay[now.getMonth()];
    const monthYearStr = `${monthNameMalay} ${year}`;

    const dueDate = `${year}-${month}-25`;
    const createdAt = `${year}-${month}-01`;

    const updatedInvoices = [...initialInvoices];
    const newInvoiceBatchStatements: Array<{ sql: string; args: any[] }> = [];

    for (const member of activeMembers) {
      const numMatch = member.id.match(/\d+/);
      const memberSuffix = numMatch ? numMatch[0].padStart(3, '0') : '000';
      const expectedInvoiceNo = `INV-${year}${month}-${memberSuffix}`;

      // If this specific invoice was previously deleted by user, do not re-generate
      if (
        isInvoiceDeleted(expectedInvoiceNo) ||
        isInvoiceDeleted(`inv-${year}${month}-${memberSuffix}`) ||
        isInvoiceDeleted(`${member.id}_${year}${month}`)
      ) {
        continue;
      }

      // Check if this member already has an invoice for this specific month
      const exists = currentInvoices.some(inv =>
        inv.memberId === member.id &&
        (inv.invoiceNo === expectedInvoiceNo || (inv.category === 'Yuran Bulanan' && inv.createdAt === createdAt))
      );

      if (exists) continue;

      let pkgTitle = 'Yuran Bulanan Latihan Silat';
      let amount = 40;
      const isAdult = isUserAbove18(member.icNo);

      // Read the member's enrollment plans to determine the correct class and price
      let enPlans: string[] = [];
      if (member.sessionTime) {
        try {
          const parsed = JSON.parse(member.sessionTime);
          if (Array.isArray(parsed)) {
            const match = parsed.find((e: any) => e.gelanggang === member.gelanggang);
            if (match) {
              enPlans = match.plans || [];
            }
          }
        } catch { }
      }

      // Use the first silat-type plan from enrollment, or fall back to gelanggang defaults
      const silatPlan = enPlans.find(p => p.includes('Silat'));
      if (silatPlan) {
        pkgTitle = `Pakej ${silatPlan}`;
        amount = getClassPrice(member.gelanggang, silatPlan);
      } else if (member.gelanggang === 'Wadi AnNour') {
        pkgTitle = isAdult ? 'Silat Bulanan Dewasa' : 'Silat Bulanan Sahaja';
        amount = isAdult ? (getClassPrice(member.gelanggang, 'Silat Dewasa') || 40) : (getClassPrice(member.gelanggang, 'Silat Kanak-kanak') || 20);
      } else if (member.gelanggang === 'Pusaka Warisan') {
        if (isAdult) {
          pkgTitle = 'Pakej Silat Dewasa';
          amount = getClassPrice(member.gelanggang, 'Silat Dewasa');
        } else {
          pkgTitle = 'Pakej Silat Kanak-Kanak / Remaja';
          amount = getClassPrice(member.gelanggang, 'Silat Muda');
        }
      } else if (member.gelanggang === 'Paya Besar' || member.gelanggang === 'Gelanggang Paya Besar') {
        if (isAdult) {
          pkgTitle = 'Pakej Silat Am';
          amount = getClassPrice(member.gelanggang, 'Silat');
        } else {
          pkgTitle = 'Pakej Budak Sekolah (Paya Besar)';
          amount = getClassPrice(member.gelanggang, 'Silat');
        }
      } else {
        amount = getClassPrice(member.gelanggang, 'Silat');
      }

      const invoiceTitle = `${pkgTitle} ${monthYearStr}`;
      const defaultDesc = `Yuran latihan bulanan rasmi bagi sesi latihan bulan ${monthYearStr} di ${member.gelanggang}.`;

      const newInvoice: InvoiceItem = {
        id: `inv-auto-${year}${month}-${member.id}`,
        invoiceNo: expectedInvoiceNo,
        memberId: member.id,
        memberName: member.name,
        memberIcNo: member.icNo,
        memberPhone: member.phone,
        address: member.address || `Gelanggang ${member.gelanggang}, Kedah`,
        payerType: 'Ahli',
        gelanggang: member.gelanggang,
        category: 'Yuran Bulanan',
        title: invoiceTitle,
        description: defaultDesc,
        amount: amount,
        dueDate: dueDate,
        createdAt: createdAt,
        status: 'Belum Dibayar',
        items: [
          {
            id: `item-${Date.now()}-${memberSuffix}`,
            description: invoiceTitle,
            quantity: 1,
            unitPrice: amount,
            amount: amount
          }
        ]
      };

      const extraDataStr = JSON.stringify({
        description: newInvoice.description || '',
        items: newInvoice.items || [],
        address: newInvoice.address || '',
        payerType: newInvoice.payerType || 'Ahli',
        vendorEmail: '',
        vendorPhone: '',
        vendorAddress: '',
        paymentMethod: ''
      });

      // Collect for batch write instead of individual executeTursoQuery
      newInvoiceBatchStatements.push({
        sql: `INSERT OR REPLACE INTO invoices (id, invoiceNo, memberId, memberName, memberIcNo, memberPhone, gelanggang, category, title, description, amount, dueDate, createdAt, status, toyibBillCode, paidAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
        args: [newInvoice.id, newInvoice.invoiceNo, newInvoice.memberId, newInvoice.memberName, newInvoice.memberIcNo || '', newInvoice.memberPhone || '', newInvoice.gelanggang, newInvoice.category, newInvoice.title, extraDataStr, newInvoice.amount, newInvoice.dueDate, newInvoice.createdAt, newInvoice.status, '', '']
      });

      updatedInvoices.unshift(newInvoice);
    }

    // Batch-write all new invoices at once (was N individual writes)
    if (newInvoiceBatchStatements.length > 0) {
      executeTursoBatch(newInvoiceBatchStatements).catch(() => { });
    }

    return updatedInvoices;
  } catch (e) {
    console.error("Error auto-generating monthly invoices:", e);
    return currentInvoices;
  }
}

// ----------------------------------------------------
// GRANT PROPOSALS & NGO MONETIZATION SEED DATA & STORAGE
// ----------------------------------------------------

export const INITIAL_GRANT_PROPOSALS: GrantProposal[] = [
  {
    id: 'grant-2025-01',
    title: 'Kertas Kerja Permohonan Geran Pemeliharaan Warisan Seni Silat Melayu Asli',
    agencyName: 'Kementerian Pelancongan, Seni dan Budaya (MOTAC)',
    grantCategory: 'Warisan & Kebudayaan',
    targetAmount: 35000,
    approvedAmount: 35000,
    status: 'Diluluskan & Disalurkan',
    submittedDate: '2025-01-15',
    contactPerson: 'Mohd Hafife Bin Abd Halim (Pengerusi)',
    objective: 'Mendokumentasikan gerak langkah klasik Seni Silat Awang Sulung Merah Muda dan mengadakan bengkel pemeliharaan warisan seni persilatan untuk komuniti.',
    targetAudience: 'Belia, Remaja Sekolah & Peminat Seni Warisan Kedah (250 Peserta)',
    budgetBreakdown: [
      { id: 'b1', category: 'Elaun Kejurulatihan / Pengurusan', description: 'Elaun 5 Orang Jurulatih & Urusetia Bengkel (4 Sesi)', estimatedCost: 10000 },
      { id: 'b2', category: 'Perolehan Aset (CapEx)', description: 'Pembelian Mat Gelanggang Standard (100 keping) & Busana Silat', estimatedCost: 18000 },
      { id: 'b3', category: 'Penganjuran Modul & Bengkel', description: 'Sewa Dewan, Rakaman Dokumentari & Sijil Peserta', estimatedCost: 7000 }
    ],
    erosFilingStatus: 'Lengkap (Annual Return Approved)',
    documentUrl: 'https://asmm.pages.dev/dokumen',
    documentFileName: 'Kertas_Kerja_MOTAC_ASMM_2025.pdf'
  },
  {
    id: 'grant-2025-02',
    title: 'Klinik Asas Pertahanan Diri & Disiplin Belia B40 Kulim',
    agencyName: 'Kementerian Belia dan Sukan (KBS / JBSN Kedah)',
    grantCategory: 'Pembangunan Belia & Sukan',
    targetAmount: 20000,
    status: 'Dalam Semakan Kementerian',
    submittedDate: '2025-02-10',
    contactPerson: 'Mohd Fauzi Bin Abd Aziz (Setiausaha)',
    objective: 'Mengurangkan gejala sosial dengan menyediakan modul latihan silat percuma dan kecergasan fizikal untuk golongan remaja B40.',
    targetAudience: '150 Belia B40 Gelanggang Wadi AnNour & Paya Besar',
    budgetBreakdown: [
      { id: 'b4', category: 'Elaun Kejurulatihan / Pengurusan', description: 'Elaun Sesi Latihan Jurulatih Bertauliah (6 Bulan)', estimatedCost: 8000 },
      { id: 'b5', category: 'Perolehan Aset (CapEx)', description: 'Perolehan Peralatan Senjata Berdaftar & Tanjak Latihan', estimatedCost: 7000 },
      { id: 'b6', category: 'Impak Komuniti & Publisiti', description: 'Karnival Penutup, Medal & Cenderamata VIP', estimatedCost: 5000 }
    ],
    erosFilingStatus: 'Lengkap (Annual Return Approved)',
    documentUrl: 'https://asmm.pages.dev/dokumen',
    documentFileName: 'Proposal_KBS_Belia_B40_Kulim.pdf'
  }
];

export const INITIAL_ASSOCIATION_ASSETS: AssociationAsset[] = [
  {
    id: 'ast-001',
    assetName: 'Mat Gelanggang Getah EVA Standard (100 Keping)',
    category: 'Peralatan Gelanggang / Mat',
    acquiredDate: '2025-02-01',
    fundedBy: 'Geran MOTAC 2025',
    quantity: 100,
    estimatedValue: 12000,
    condition: 'Baik / Sedia Sewa',
    dailyRentalRate: 150,
    assignedGelanggang: 'Semua Gelanggang'
  },
  {
    id: 'ast-002',
    assetName: 'Set Busana Silat Melayu & Tanjak Tradisional (20 Set)',
    category: 'Busana & Tanjak',
    acquiredDate: '2025-02-05',
    fundedBy: 'Geran MOTAC 2025',
    quantity: 20,
    estimatedValue: 6000,
    condition: 'Baik / Sedia Sewa',
    dailyRentalRate: 100,
    assignedGelanggang: 'Wadi AnNour'
  },
  {
    id: 'ast-003',
    assetName: 'Senjata Berdaftar & Parang Latihan Berbilang (15 Pasang)',
    category: 'Senjata Berdaftar',
    acquiredDate: '2024-11-10',
    fundedBy: 'Peruntukan Induk NGO',
    quantity: 15,
    estimatedValue: 4500,
    condition: 'Baik / Sedia Sewa',
    dailyRentalRate: 80,
    assignedGelanggang: 'Pusaka Warisan'
  }
];

export const INITIAL_ASSET_RENTAL_LOGS: AssetRentalLog[] = [
  {
    id: 'rnt-001',
    assetId: 'ast-001',
    assetName: 'Mat Gelanggang Getah EVA Standard (100 Keping)',
    renterName: 'Sekolah Menengah Kebangsaan Kulim (Karnival Sukan)',
    renterPhone: '019-4112233',
    startDate: '2025-03-01',
    endDate: '2025-03-02',
    totalDays: 2,
    totalRentalFee: 300,
    status: 'Telah Dipulangkan',
    paymentStatus: 'Lulus / Dibayar'
  }
];

export const INITIAL_TRAINER_ALLOWANCES: TrainerAllowanceClaim[] = [
  {
    id: 'clm-001',
    grantId: 'grant-2025-01',
    programTitle: 'Bengkel Pemeliharaan Warisan Seni Silat Awang Sulung',
    trainerName: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    trainerRole: 'Ketua Jurulatih',
    sessionDate: '2025-02-20',
    hours: 8,
    allowanceRatePerHour: 50,
    totalAllowance: 400,
    status: 'Telah Dibayar'
  }
];

// GRANT PROPOSALS DATABASE OPERATIONS
export async function syncAllGrantProposalsToTursoDB(grantList?: GrantProposal[]): Promise<void> {
  const list = grantList || [];
  if (list.length === 0) return;
  const statements = list.map(g => ({
    sql: `INSERT OR REPLACE INTO grant_proposals (id, title, agencyName, grantCategory, targetAmount, approvedAmount, status, submittedDate, contactPerson, objective, targetAudience, budgetBreakdown, erosFilingStatus, documentUrl, documentFileName) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [
      g.id,
      g.title,
      g.agencyName,
      g.grantCategory,
      g.targetAmount,
      g.approvedAmount || null,
      g.status,
      g.submittedDate,
      g.contactPerson,
      g.objective,
      g.targetAudience,
      JSON.stringify(g.budgetBreakdown || []),
      g.erosFilingStatus,
      g.documentUrl || '',
      g.documentFileName || ''
    ]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getGrantProposalsDB(): Promise<GrantProposal[]> {
  initializeDB();

  if (cachedGrantProposalsInMemory && cachedGrantProposalsInMemory.length > 0) {
    if (shouldRefreshFromTurso('grant_proposals') && !_inflightRefresh['grant_proposals']) {
      _inflightRefresh['grant_proposals'] = refreshGrantProposalsCacheFromTurso()
        .finally(() => { _inflightRefresh['grant_proposals'] = null; });
    }
    return cachedGrantProposalsInMemory;
  }

  return await refreshGrantProposalsCacheFromTurso();
}

async function refreshGrantProposalsCacheFromTurso(): Promise<GrantProposal[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM grant_proposals;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbGrants: GrantProposal[] = tursoRes.rows.map((row: any) => {
        let budgetParsed = [];
        try {
          const rawBudget = String(row.budgetBreakdown ?? row[11] ?? '[]');
          budgetParsed = JSON.parse(rawBudget);
        } catch { }

        return {
          id: String(row.id ?? row[0]),
          title: String(row.title ?? row[1]),
          agencyName: String(row.agencyName ?? row[2]),
          grantCategory: String(row.grantCategory ?? row[3]) as any,
          targetAmount: Number(row.targetAmount ?? row[4] ?? 0),
          approvedAmount: (row.approvedAmount ?? row[5]) ? Number(row.approvedAmount ?? row[5]) : undefined,
          status: String(row.status ?? row[6]) as any,
          submittedDate: String(row.submittedDate ?? row[7]),
          contactPerson: String(row.contactPerson ?? row[8]),
          objective: String(row.objective ?? row[9]),
          targetAudience: String(row.targetAudience ?? row[10]),
          budgetBreakdown: budgetParsed,
          erosFilingStatus: String(row.erosFilingStatus ?? row[12]),
          documentUrl: String(row.documentUrl ?? row[13] ?? ''),
          documentFileName: String(row.documentFileName ?? row[14] ?? '')
        };
      });

      localStorage.setItem(KEYS.GRANT_PROPOSALS, JSON.stringify(dbGrants));
      cachedGrantProposalsInMemory = dbGrants;
      markTursoFetched('grant_proposals');
      return dbGrants;
    }
  } catch (e) {
    console.warn("aaPanel live grant proposals fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.GRANT_PROPOSALS) : null;
  const grants: GrantProposal[] = raw ? JSON.parse(raw) : [];
  cachedGrantProposalsInMemory = grants;
  return grants;
}

export async function saveGrantProposalDB(grant: GrantProposal): Promise<GrantProposal[]> {
  const current = await getGrantProposalsDB();
  const index = current.findIndex(g => g.id === grant.id);
  let updated: GrantProposal[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = grant;
  } else {
    updated = [grant, ...current];
  }
  localStorage.setItem(KEYS.GRANT_PROPOSALS, JSON.stringify(updated));
  cachedGrantProposalsInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO grant_proposals (id, title, agencyName, grantCategory, targetAmount, approvedAmount, status, submittedDate, contactPerson, objective, targetAudience, budgetBreakdown, erosFilingStatus, documentUrl, documentFileName) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [
      grant.id,
      grant.title,
      grant.agencyName,
      grant.grantCategory,
      grant.targetAmount,
      grant.approvedAmount || null,
      grant.status,
      grant.submittedDate,
      grant.contactPerson,
      grant.objective,
      grant.targetAudience,
      JSON.stringify(grant.budgetBreakdown || []),
      grant.erosFilingStatus,
      grant.documentUrl || '',
      grant.documentFileName || ''
    ]
  ).catch(() => { });

  return updated;
}

export async function deleteGrantProposalDB(id: string): Promise<GrantProposal[]> {
  const current = await getGrantProposalsDB();
  const updated = current.filter(g => g.id !== id);
  localStorage.setItem(KEYS.GRANT_PROPOSALS, JSON.stringify(updated));
  cachedGrantProposalsInMemory = updated;
  executeTursoQuery(`DELETE FROM grant_proposals WHERE id = ?;`, [id]).catch(() => { });
  return updated;
}

// ASSOCIATION ASSETS DATABASE OPERATIONS
export async function syncAllAssociationAssetsToTursoDB(assetList?: AssociationAsset[]): Promise<void> {
  const list = assetList || [];
  if (list.length === 0) return;
  const statements = list.map(a => ({
    sql: `INSERT OR REPLACE INTO association_assets (id, assetName, category, acquiredDate, fundedBy, quantity, estimatedValue, condition, dailyRentalRate, assignedGelanggang) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [a.id, a.assetName, a.category, a.acquiredDate, a.fundedBy, a.quantity, a.estimatedValue, a.condition, a.dailyRentalRate, a.assignedGelanggang]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getAssociationAssetsDB(): Promise<AssociationAsset[]> {
  initializeDB();

  if (cachedAssociationAssetsInMemory && cachedAssociationAssetsInMemory.length > 0) {
    if (shouldRefreshFromTurso('association_assets') && !_inflightRefresh['association_assets']) {
      _inflightRefresh['association_assets'] = refreshAssociationAssetsCacheFromTurso()
        .finally(() => { _inflightRefresh['association_assets'] = null; });
    }
    return cachedAssociationAssetsInMemory;
  }

  return await refreshAssociationAssetsCacheFromTurso();
}

async function refreshAssociationAssetsCacheFromTurso(): Promise<AssociationAsset[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM association_assets;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbAssets: AssociationAsset[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        assetName: String(row.assetName ?? row[1]),
        category: String(row.category ?? row[2]) as any,
        acquiredDate: String(row.acquiredDate ?? row[3]),
        fundedBy: String(row.fundedBy ?? row[4]),
        quantity: Number(row.quantity ?? row[5] ?? 0),
        estimatedValue: Number(row.estimatedValue ?? row[6] ?? 0),
        condition: String(row.condition ?? row[7]) as any,
        dailyRentalRate: Number(row.dailyRentalRate ?? row[8] ?? 0),
        assignedGelanggang: String(row.assignedGelanggang ?? row[9]) as any
      }));

      localStorage.setItem(KEYS.ASSOCIATION_ASSETS, JSON.stringify(dbAssets));
      cachedAssociationAssetsInMemory = dbAssets;
      markTursoFetched('association_assets');
      return dbAssets;
    }
  } catch (e) {
    console.warn("aaPanel live association assets fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.ASSOCIATION_ASSETS) : null;
  const assets: AssociationAsset[] = raw ? JSON.parse(raw) : [];
  cachedAssociationAssetsInMemory = assets;
  return assets;
}

export async function saveAssociationAssetDB(asset: AssociationAsset): Promise<AssociationAsset[]> {
  const current = await getAssociationAssetsDB();
  const index = current.findIndex(a => a.id === asset.id);
  let updated: AssociationAsset[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = asset;
  } else {
    updated = [asset, ...current];
  }
  localStorage.setItem(KEYS.ASSOCIATION_ASSETS, JSON.stringify(updated));
  cachedAssociationAssetsInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO association_assets (id, assetName, category, acquiredDate, fundedBy, quantity, estimatedValue, condition, dailyRentalRate, assignedGelanggang) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [asset.id, asset.assetName, asset.category, asset.acquiredDate, asset.fundedBy, asset.quantity, asset.estimatedValue, asset.condition, asset.dailyRentalRate, asset.assignedGelanggang]
  ).catch(() => { });

  return updated;
}

export async function deleteAssociationAssetDB(id: string): Promise<AssociationAsset[]> {
  const current = await getAssociationAssetsDB();
  const updated = current.filter(a => a.id !== id);
  localStorage.setItem(KEYS.ASSOCIATION_ASSETS, JSON.stringify(updated));
  cachedAssociationAssetsInMemory = updated;
  executeTursoQuery(`DELETE FROM association_assets WHERE id = ?;`, [id]).catch(() => { });
  return updated;
}

// ASSET RENTAL LOGS DATABASE OPERATIONS
export async function syncAllAssetRentalLogsToTursoDB(logList?: AssetRentalLog[]): Promise<void> {
  const list = logList || [];
  if (list.length === 0) return;
  const statements = list.map(r => ({
    sql: `INSERT OR REPLACE INTO asset_rental_logs (id, assetId, assetName, renterName, renterPhone, startDate, endDate, totalDays, totalRentalFee, status, paymentStatus) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [r.id, r.assetId, r.assetName, r.renterName, r.renterPhone, r.startDate, r.endDate, r.totalDays, r.totalRentalFee, r.status, r.paymentStatus]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getAssetRentalLogsDB(): Promise<AssetRentalLog[]> {
  initializeDB();

  if (cachedAssetRentalLogsInMemory && cachedAssetRentalLogsInMemory.length > 0) {
    if (shouldRefreshFromTurso('asset_rental_logs') && !_inflightRefresh['asset_rental_logs']) {
      _inflightRefresh['asset_rental_logs'] = refreshAssetRentalLogsCacheFromTurso()
        .finally(() => { _inflightRefresh['asset_rental_logs'] = null; });
    }
    return cachedAssetRentalLogsInMemory;
  }

  return await refreshAssetRentalLogsCacheFromTurso();
}

async function refreshAssetRentalLogsCacheFromTurso(): Promise<AssetRentalLog[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM asset_rental_logs;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbLogs: AssetRentalLog[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        assetId: String(row.assetId ?? row[1]),
        assetName: String(row.assetName ?? row[2]),
        renterName: String(row.renterName ?? row[3]),
        renterPhone: String(row.renterPhone ?? row[4]),
        startDate: String(row.startDate ?? row[5]),
        endDate: String(row.endDate ?? row[6]),
        totalDays: Number(row.totalDays ?? row[7] ?? 0),
        totalRentalFee: Number(row.totalRentalFee ?? row[8] ?? 0),
        status: String(row.status ?? row[9]) as any,
        paymentStatus: String(row.paymentStatus ?? row[10]) as any
      }));

      localStorage.setItem(KEYS.ASSET_RENTAL_LOGS, JSON.stringify(dbLogs));
      cachedAssetRentalLogsInMemory = dbLogs;
      markTursoFetched('asset_rental_logs');
      return dbLogs;
    }
  } catch (e) {
    console.warn("aaPanel live asset rental logs fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.ASSET_RENTAL_LOGS) : null;
  const logs: AssetRentalLog[] = raw ? JSON.parse(raw) : [];
  cachedAssetRentalLogsInMemory = logs;
  return logs;
}

export async function saveAssetRentalLogDB(rental: AssetRentalLog): Promise<AssetRentalLog[]> {
  const current = await getAssetRentalLogsDB();
  const index = current.findIndex(r => r.id === rental.id);
  let updated: AssetRentalLog[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = rental;
  } else {
    updated = [rental, ...current];
  }
  localStorage.setItem(KEYS.ASSET_RENTAL_LOGS, JSON.stringify(updated));
  cachedAssetRentalLogsInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO asset_rental_logs (id, assetId, assetName, renterName, renterPhone, startDate, endDate, totalDays, totalRentalFee, status, paymentStatus) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [rental.id, rental.assetId, rental.assetName, rental.renterName, rental.renterPhone, rental.startDate, rental.endDate, rental.totalDays, rental.totalRentalFee, rental.status, rental.paymentStatus]
  ).catch(() => { });

  return updated;
}

// TRAINER ALLOWANCES DATABASE OPERATIONS
export async function syncAllTrainerAllowancesToTursoDB(claimList?: TrainerAllowanceClaim[]): Promise<void> {
  const list = claimList || [];
  if (list.length === 0) return;
  const statements = list.map(c => ({
    sql: `INSERT OR REPLACE INTO trainer_allowances (id, grantId, programTitle, trainerName, trainerRole, sessionDate, hours, allowanceRatePerHour, totalAllowance, status) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [c.id, c.grantId || null, c.programTitle, c.trainerName, c.trainerRole, c.sessionDate, c.hours, c.allowanceRatePerHour, c.totalAllowance, c.status]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getTrainerAllowancesDB(): Promise<TrainerAllowanceClaim[]> {
  initializeDB();

  if (cachedTrainerAllowancesInMemory && cachedTrainerAllowancesInMemory.length > 0) {
    if (shouldRefreshFromTurso('trainer_allowances') && !_inflightRefresh['trainer_allowances']) {
      _inflightRefresh['trainer_allowances'] = refreshTrainerAllowancesCacheFromTurso()
        .finally(() => { _inflightRefresh['trainer_allowances'] = null; });
    }
    return cachedTrainerAllowancesInMemory;
  }

  return await refreshTrainerAllowancesCacheFromTurso();
}

async function refreshTrainerAllowancesCacheFromTurso(): Promise<TrainerAllowanceClaim[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM trainer_allowances;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbClaims: TrainerAllowanceClaim[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        grantId: (row.grantId ?? row[1]) ? String(row.grantId ?? row[1]) : undefined,
        programTitle: String(row.programTitle ?? row[2]),
        trainerName: String(row.trainerName ?? row[3]),
        trainerRole: String(row.trainerRole ?? row[4]),
        sessionDate: String(row.sessionDate ?? row[5]),
        hours: Number(row.hours ?? row[6] ?? 0),
        allowanceRatePerHour: Number(row.allowanceRatePerHour ?? row[7] ?? 0),
        totalAllowance: Number(row.totalAllowance ?? row[8] ?? 0),
        status: String(row.status ?? row[9]) as any
      }));

      localStorage.setItem(KEYS.TRAINER_ALLOWANCES, JSON.stringify(dbClaims));
      cachedTrainerAllowancesInMemory = dbClaims;
      markTursoFetched('trainer_allowances');
      return dbClaims;
    }
  } catch (e) {
    console.warn("aaPanel live trainer allowances fetch notice (Local fallback active):", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.TRAINER_ALLOWANCES) : null;
  const claims: TrainerAllowanceClaim[] = raw ? JSON.parse(raw) : [];
  cachedTrainerAllowancesInMemory = claims;
  return claims;
}

export async function saveTrainerAllowanceDB(claim: TrainerAllowanceClaim): Promise<TrainerAllowanceClaim[]> {
  const current = await getTrainerAllowancesDB();
  const index = current.findIndex(c => c.id === claim.id);
  let updated: TrainerAllowanceClaim[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = claim;
  } else {
    updated = [claim, ...current];
  }
  localStorage.setItem(KEYS.TRAINER_ALLOWANCES, JSON.stringify(updated));
  cachedTrainerAllowancesInMemory = updated;

  executeTursoQuery(
    `INSERT OR REPLACE INTO trainer_allowances (id, grantId, programTitle, trainerName, trainerRole, sessionDate, hours, allowanceRatePerHour, totalAllowance, status) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [claim.id, claim.grantId || null, claim.programTitle, claim.trainerName, claim.trainerRole, claim.sessionDate, claim.hours, claim.allowanceRatePerHour, claim.totalAllowance, claim.status]
  ).catch(() => { });

  return updated;
}

// MERCHANDISE ORDER DATABASE OPERATIONS
export async function getMerchandiseOrdersDB(): Promise<MerchandiseOrder[]> {
  initializeDB();
  if (cachedMerchandiseOrdersInMemory && cachedMerchandiseOrdersInMemory.length > 0) {
    if (shouldRefreshFromTurso('merch_orders') && !_inflightRefresh['merch_orders']) {
      _inflightRefresh['merch_orders'] = refreshMerchandiseOrdersCacheFromTurso()
        .finally(() => { _inflightRefresh['merch_orders'] = null; });
    }
    return cachedMerchandiseOrdersInMemory;
  }

  return await refreshMerchandiseOrdersCacheFromTurso();
}

async function refreshMerchandiseOrdersCacheFromTurso(): Promise<MerchandiseOrder[]> {
  try {
    const res = await executeTursoQuery(`SELECT * FROM merchandise_orders ORDER BY createdAt DESC;`);
    if (res && res.rows && Array.isArray(res.rows)) {
      const orders: MerchandiseOrder[] = res.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        memberId: String(row.memberId ?? row[1]),
        memberName: String(row.memberName ?? row[2]),
        gelanggang: String(row.gelanggang ?? row[3]),
        itemId: String(row.itemId ?? row[4]),
        itemName: String(row.itemName ?? row[5]),
        itemCategory: String(row.itemCategory ?? row[6]),
        quantity: Number(row.quantity ?? row[7]),
        size: (row.size ?? row[8]) ? String(row.size ?? row[8]) : undefined,
        totalAmount: Number(row.totalAmount ?? row[9]),
        deliveryMethod: String(row.deliveryMethod ?? row[10]) as any,
        notes: (row.notes ?? row[11]) ? String(row.notes ?? row[11]) : undefined,
        status: String(row.status ?? row[12]) as any,
        invoiceId: (row.invoiceId ?? row[13]) ? String(row.invoiceId ?? row[13]) : undefined,
        createdAt: String(row.createdAt ?? row[14]),
        paymentMethod: (row.paymentMethod ?? row[15]) ? String(row.paymentMethod ?? row[15]) as any : 'DuitNow QR',
        paymentStatus: (row.paymentStatus ?? row[16]) ? String(row.paymentStatus ?? row[16]) as any : (row.status === 'Selesai' ? 'Lulus / Dibayar' : 'Belum Dibayar'),
        paymentProofUrl: (row.paymentProofUrl ?? row[17]) ? String(row.paymentProofUrl ?? row[17]) : undefined,
        paymentRef: (row.paymentRef ?? row[18]) ? String(row.paymentRef ?? row[18]) : undefined,
        paidAt: (row.paidAt ?? row[19]) ? String(row.paidAt ?? row[19]) : undefined,
        trackingNo: (row.trackingNo ?? row[20]) ? String(row.trackingNo ?? row[20]) : undefined,
        pickupLocation: (row.pickupLocation ?? row[21]) ? String(row.pickupLocation ?? row[21]) : undefined
      }));
      localStorage.setItem('asmm_merchandise_orders_v1', JSON.stringify(orders));
      cachedMerchandiseOrdersInMemory = orders;
      markTursoFetched('merch_orders');
      return orders;
    }
  } catch (e) {
    console.warn("aaPanel live merchandise order fetch notice:", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem('asmm_merchandise_orders_v1') : null;
  const orders: MerchandiseOrder[] = raw ? JSON.parse(raw) : [];
  cachedMerchandiseOrdersInMemory = orders;
  return orders;
}

export async function saveMerchandiseOrderDB(order: MerchandiseOrder): Promise<MerchandiseOrder[]> {
  initializeDB();
  const current = await getMerchandiseOrdersDB();
  const index = current.findIndex(o => o.id === order.id);
  let updated: MerchandiseOrder[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = order;
  } else {
    updated = [order, ...current];
  }
  localStorage.setItem('asmm_merchandise_orders_v1', JSON.stringify(updated));
  cachedMerchandiseOrdersInMemory = updated;

  await executeTursoQuery(
    `INSERT OR REPLACE INTO merchandise_orders (id, memberId, memberName, gelanggang, itemId, itemName, itemCategory, quantity, size, totalAmount, deliveryMethod, notes, status, invoiceId, createdAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [order.id, order.memberId, order.memberName, order.gelanggang, order.itemId, order.itemName, order.itemCategory, order.quantity, order.size || null, order.totalAmount, order.deliveryMethod, order.notes || null, order.status, order.invoiceId || null, order.createdAt]
  ).catch(() => { });

  return updated;
}

export async function deleteMerchandiseOrderDB(id: string): Promise<MerchandiseOrder[]> {
  initializeDB();
  const current = await getMerchandiseOrdersDB();
  const updated = current.filter(o => o.id !== id);
  localStorage.setItem('asmm_merchandise_orders_v1', JSON.stringify(updated));
  cachedMerchandiseOrdersInMemory = updated;

  await executeTursoQuery(`DELETE FROM merchandise_orders WHERE id = ?;`, [id]).catch(() => { });

  return updated;
}

// MERCHANDISE ITEMS DATABASE OPERATIONS
export async function getMerchandiseItemsDB(): Promise<MerchandiseItem[]> {
  initializeDB();
  if (cachedMerchandiseItemsInMemory && cachedMerchandiseItemsInMemory.length > 0) {
    if (shouldRefreshFromTurso('merch_items') && !_inflightRefresh['merch_items']) {
      _inflightRefresh['merch_items'] = refreshMerchandiseItemsCacheFromTurso()
        .finally(() => { _inflightRefresh['merch_items'] = null; });
    }
    return cachedMerchandiseItemsInMemory;
  }

  return await refreshMerchandiseItemsCacheFromTurso();
}

async function refreshMerchandiseItemsCacheFromTurso(): Promise<MerchandiseItem[]> {
  try {
    const res = await executeTursoQuery(`SELECT * FROM merchandise_items;`);
    if (res && res.rows && Array.isArray(res.rows)) {
      const items: MerchandiseItem[] = res.rows.map((row: any) => {
        let parsedSizePrices: Record<string, number> | undefined = undefined;
        const rawSizePrices = row.sizePrices !== undefined ? row.sizePrices : row[12];
        if (rawSizePrices) {
          try {
            parsedSizePrices = typeof rawSizePrices === 'string' ? JSON.parse(rawSizePrices) : rawSizePrices;
          } catch (e) { }
        }

        return {
          id: String(row.id ?? row[0]),
          name: String(row.name ?? row[1]),
          category: String(row.category ?? row[2]) as any,
          price: Number(row.price ?? row[3]),
          description: String(row.description ?? row[4] ?? ''),
          photoUrl: String(row.photoUrl ?? row[5] ?? ''),
          sizes: (row.sizes ?? row[6]) ? (typeof (row.sizes ?? row[6]) === 'string' ? JSON.parse(row.sizes ?? row[6]) : (row.sizes ?? row[6])) : undefined,
          stockStatus: String(row.stockStatus ?? row[7]) as any,
          specifications: (row.specifications ?? row[8]) ? (typeof (row.specifications ?? row[8]) === 'string' ? JSON.parse(row.specifications ?? row[8]) : (row.specifications ?? row[8])) : undefined,
          variations: (row.variations ?? row[9]) ? (typeof (row.variations ?? row[9]) === 'string' ? JSON.parse(row.variations ?? row[9]) : (row.variations ?? row[9])) : undefined,
          userId: (row.userId ?? row[10]) ? String(row.userId ?? row[10]) : undefined,
          stockQuantity: (row.stockQuantity !== null && row.stockQuantity !== undefined) ? Number(row.stockQuantity) : undefined,
          sizePrices: parsedSizePrices
        };
      }).map((item: MerchandiseItem) => {
        if (item.id === 'merch-baju-silat' || item.name.toLowerCase().includes('baju silat')) {
          const isOld = !item.sizes || item.sizes.includes('S') || item.sizes.includes('M');
          const isLowRes = item.photoUrl && item.photoUrl.startsWith('data:image/jpeg;base64') && item.photoUrl.length < 15000;
          if (isOld || isLowRes) {
            return {
              ...item,
              price: item.price && item.price > 0 ? item.price : 120.0,
              photoUrl: isLowRes ? 'baju-silat.jpg' : item.photoUrl,
              sizes: ['110cm', '120cm', '130cm', '140cm', '150cm', '160cm', '170cm', '180cm', '190cm', '200cm', '210cm']
            };
          }
        }
        return item;
      });
      localStorage.setItem(KEYS.MERCHANDISE_ITEMS, JSON.stringify(items));
      cachedMerchandiseItemsInMemory = items;
      markTursoFetched('merch_items');
      return items;
    }
  } catch (e) {
    console.warn("aaPanel live merchandise item fetch notice:", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.MERCHANDISE_ITEMS) : null;
  let items: MerchandiseItem[] = raw ? JSON.parse(raw) : [];
  if (items.length === 0) {
    items = [...SEED_MERCHANDISE_ITEMS];
  }
  items = items.map(item => {
    if (item.id === 'merch-baju-silat' || item.name.toLowerCase().includes('baju silat')) {
      const isOld = !item.sizes || item.sizes.includes('S') || item.sizes.includes('M');
      const isLowRes = item.photoUrl && item.photoUrl.startsWith('data:image/jpeg;base64') && item.photoUrl.length < 15000;
      if (isOld || isLowRes) {
        return {
          ...item,
          price: item.price && item.price > 0 ? item.price : 120.0,
          photoUrl: isLowRes ? 'baju-silat.jpg' : item.photoUrl,
          sizes: ['110cm', '120cm', '130cm', '140cm', '150cm', '160cm', '170cm', '180cm', '190cm', '200cm', '210cm']
        };
      }
    }
    return item;
  });
  localStorage.setItem(KEYS.MERCHANDISE_ITEMS, JSON.stringify(items));
  cachedMerchandiseItemsInMemory = items;
  return items;
}

export async function saveMerchandiseItemDB(item: MerchandiseItem): Promise<MerchandiseItem[]> {
  initializeDB();
  const current = await getMerchandiseItemsDB();
  const index = current.findIndex(i => i.id === item.id);
  let updated: MerchandiseItem[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = item;
  } else {
    updated = [item, ...current];
  }
  cachedMerchandiseItemsInMemory = updated;

  // Safe localStorage persistence with QuotaExceeded fallback
  try {
    localStorage.setItem(KEYS.MERCHANDISE_ITEMS, JSON.stringify(updated));
  } catch (quotaErr) {
    console.warn('localStorage quota warning on saving merchandise items:', quotaErr);
    try {
      const compactItems = updated.map(it => {
        if (it.photoUrl && it.photoUrl.startsWith('data:') && it.photoUrl.length > 30000) {
          return { ...it, photoUrl: it.photoUrl.slice(0, 100) + '...[cached-in-memory]' };
        }
        return it;
      });
      localStorage.setItem(KEYS.MERCHANDISE_ITEMS, JSON.stringify(compactItems));
    } catch (_) { }
  }

  const sizePricesJson = item.sizePrices ? JSON.stringify(item.sizePrices) : null;

  await executeTursoQuery(
    `INSERT OR REPLACE INTO merchandise_items (id, name, category, price, description, photoUrl, sizes, stockStatus, specifications, variations, userId, stockQuantity, sizePrices) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [
      item.id,
      item.name,
      item.category,
      item.price,
      item.description,
      item.photoUrl,
      item.sizes ? JSON.stringify(item.sizes) : null,
      item.stockStatus,
      item.specifications ? JSON.stringify(item.specifications) : null,
      item.variations ? JSON.stringify(item.variations) : null,
      item.userId || null,
      typeof item.stockQuantity === 'number' ? item.stockQuantity : (item.stockQuantity ? Number(item.stockQuantity) : 0),
      sizePricesJson
    ]
  ).catch(async (err) => {
    console.warn('aaPanel sync notice for merchandise item:', err);
    await executeTursoQuery(`ALTER TABLE merchandise_items ADD COLUMN sizePrices TEXT;`).catch(() => { });
    await executeTursoQuery(
      `INSERT OR REPLACE INTO merchandise_items (id, name, category, price, description, photoUrl, sizes, stockStatus, specifications, variations, userId, stockQuantity, sizePrices) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        item.id,
        item.name,
        item.category,
        item.price,
        item.description,
        item.photoUrl,
        item.sizes ? JSON.stringify(item.sizes) : null,
        item.stockStatus,
        item.specifications ? JSON.stringify(item.specifications) : null,
        item.variations ? JSON.stringify(item.variations) : null,
        item.userId || null,
        typeof item.stockQuantity === 'number' ? item.stockQuantity : (item.stockQuantity ? Number(item.stockQuantity) : 0),
        sizePricesJson
      ]
    ).catch(async () => {
      await executeTursoQuery(
        `INSERT OR REPLACE INTO merchandise_items (id, name, category, price, description, photoUrl, sizes, stockStatus, specifications, variations, userId, stockQuantity) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
        [
          item.id,
          item.name,
          item.category,
          item.price,
          item.description,
          item.photoUrl,
          item.sizes ? JSON.stringify(item.sizes) : null,
          item.stockStatus,
          item.specifications ? JSON.stringify(item.specifications) : null,
          item.variations ? JSON.stringify(item.variations) : null,
          item.userId || null,
          typeof item.stockQuantity === 'number' ? item.stockQuantity : (item.stockQuantity ? Number(item.stockQuantity) : 0)
        ]
      ).catch(() => { });
    });
  });

  return updated;
}

export async function deleteMerchandiseItemDB(id: string): Promise<MerchandiseItem[]> {
  initializeDB();
  const current = await getMerchandiseItemsDB();
  const updated = current.filter(i => i.id !== id);
  localStorage.setItem(KEYS.MERCHANDISE_ITEMS, JSON.stringify(updated));

  await executeTursoQuery(`DELETE FROM merchandise_items WHERE id = ?;`, [id]).catch(() => { });

  return updated;
}

// ============================================================
// DONATION CAMPAIGNS & CROWDFUNDING DB LAYER
// ============================================================

// ============================================================
// DONATION CAMPAIGNS & CROWDFUNDING DB LAYER
// ============================================================

export async function syncAllDonationCampaignsToTursoDB(campaignsList?: DonationCampaign[]): Promise<void> {
  const list = campaignsList || [];
  if (list.length === 0) return;
  const statements = list.map(c => ({
    sql: `INSERT OR REPLACE INTO donation_campaigns (id, title, category, targetAmount, currentAmount, donorCount, coverImage, story, organizerName, beneficiaryGelanggang, startDate, endDate, status, isFeatured, impactMilestones) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [
      c.id,
      c.title,
      c.category,
      c.targetAmount,
      c.currentAmount,
      c.donorCount,
      c.coverImage || null,
      c.story,
      c.organizerName || 'Persatuan Seni Silat Awang Sulung Merah Muda',
      c.beneficiaryGelanggang,
      c.startDate,
      c.endDate || null,
      c.status,
      c.isFeatured ? 1 : 0,
      c.impactMilestones ? JSON.stringify(c.impactMilestones) : null
    ]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getDonationCampaignsDB(): Promise<DonationCampaign[]> {
  initializeDB();
  if (cachedDonationCampaignsInMemory && cachedDonationCampaignsInMemory.length > 0) {
    if (shouldRefreshFromTurso('donation_campaigns') && !_inflightRefresh['donation_campaigns']) {
      _inflightRefresh['donation_campaigns'] = refreshDonationCampaignsFromTurso()
        .finally(() => { _inflightRefresh['donation_campaigns'] = null; });
    }
    return cachedDonationCampaignsInMemory;
  }

  return await refreshDonationCampaignsFromTurso();
}

export async function refreshDonationCampaignsFromTurso(): Promise<DonationCampaign[]> {
  try {
    const res = await executeTursoQuery(`SELECT id, title, category, targetAmount, currentAmount, donorCount, coverImage, story, organizerName, beneficiaryGelanggang, startDate, endDate, status, isFeatured, impactMilestones FROM donation_campaigns ORDER BY isFeatured DESC, startDate DESC;`);
    if (res && res.rows && Array.isArray(res.rows)) {
      const items: DonationCampaign[] = res.rows.map((row: any) => {
        let parsedMilestones = undefined;
        const rawM = row.impactMilestones ?? row[14];
        if (rawM) {
          try {
            parsedMilestones = typeof rawM === 'string' ? JSON.parse(rawM) : rawM;
          } catch { }
        }
        return {
          id: String(row.id ?? row[0]),
          title: String(row.title ?? row[1]),
          category: String(row.category ?? row[2]) as any,
          targetAmount: Number(row.targetAmount ?? row[3]) || 0,
          currentAmount: Number(row.currentAmount ?? row[4]) || 0,
          donorCount: Number(row.donorCount ?? row[5]) || 0,
          coverImage: (row.coverImage ?? row[6]) ? String(row.coverImage ?? row[6]) : undefined,
          story: String((row.story ?? row[7]) || ''),
          organizerName: (row.organizerName ?? row[8]) ? String(row.organizerName ?? row[8]) : undefined,
          beneficiaryGelanggang: String(row.beneficiaryGelanggang ?? row[9]) as Gelanggang,
          startDate: String((row.startDate ?? row[10]) || new Date().toISOString().split('T')[0]),
          endDate: (row.endDate ?? row[11]) ? String(row.endDate ?? row[11]) : undefined,
          status: String(row.status ?? row[12]) as any,
          isFeatured: Boolean(Number(row.isFeatured ?? row[13]) === 1),
          impactMilestones: parsedMilestones
        };
      });

      const prevJson = JSON.stringify(cachedDonationCampaignsInMemory || []);
      const newJson = JSON.stringify(items);
      localStorage.setItem(KEYS.DONATION_CAMPAIGNS, newJson);
      cachedDonationCampaignsInMemory = items;
      markTursoFetched('donation_campaigns');

      // Only dispatch update if values have actually changed to avoid re-render cascades
      if (prevJson !== newJson) {
        window.dispatchEvent(new Event('asmm_db_updated'));
      }
      return items;
    }
  } catch (e) {
    console.warn("aaPanel live donation campaigns fetch notice:", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DONATION_CAMPAIGNS) : null;
  const localList: DonationCampaign[] = raw ? JSON.parse(raw) : [];
  cachedDonationCampaignsInMemory = localList;
  return localList;
}

export async function saveDonationCampaignDB(campaign: DonationCampaign, oldId?: string): Promise<DonationCampaign[]> {
  initializeDB();
  const current = await getDonationCampaignsDB();
  const targetId = oldId || campaign.id;
  const index = current.findIndex(c => c.id === targetId);
  let updated: DonationCampaign[];
  if (index >= 0) {
    updated = [...current];
    updated[index] = campaign;
  } else {
    const existingIndex = current.findIndex(c => c.id === campaign.id);
    if (existingIndex >= 0) {
      updated = [...current];
      updated[existingIndex] = campaign;
    } else {
      updated = [campaign, ...current];
    }
  }

  // Also remove duplicate legacy IDs if this campaign is the migrated version
  const legacyMap: Record<string, string> = {
    'tabung-pembangunan-gelanggang-lunas': 'camp-001',
    'tabung-kebajikan-pesilat-asnaf': 'camp-002',
    'tabung-pemeliharaan-busana-senjata': 'camp-003',
    'tabung-kontinjen-kejuaraan-silat': 'camp-004'
  };
  const legacyIdToDelete = legacyMap[campaign.id];
  if (legacyIdToDelete) {
    updated = updated.filter(c => c.id !== legacyIdToDelete);
    executeTursoQuery(`DELETE FROM donation_campaigns WHERE id = ?;`, [legacyIdToDelete]).catch(() => { });
  }

  localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(updated));
  cachedDonationCampaignsInMemory = updated;
  markTursoFetched('donation_campaigns');

  if (oldId && oldId !== campaign.id) {
    const rawDonations = localStorage.getItem(KEYS.DONATIONS);
    if (rawDonations) {
      try {
        const dList: DonationRecord[] = JSON.parse(rawDonations);
        const updatedDList = dList.map(d => d.campaignId === oldId ? { ...d, campaignId: campaign.id, campaignTitle: campaign.title } : d);
        localStorage.setItem(KEYS.DONATIONS, JSON.stringify(updatedDList));
        cachedDonationsInMemory = updatedDList;
      } catch { }
    }

    await executeTursoQuery(`UPDATE donations SET campaignId = ?, campaignTitle = ? WHERE campaignId = ?;`, [campaign.id, campaign.title, oldId]).catch(() => { });
    await executeTursoQuery(`DELETE FROM donation_campaigns WHERE id = ?;`, [oldId]).catch(() => { });
  }

  await executeTursoQuery(
    `INSERT OR REPLACE INTO donation_campaigns (id, title, category, targetAmount, currentAmount, donorCount, coverImage, story, organizerName, beneficiaryGelanggang, startDate, endDate, status, isFeatured, impactMilestones) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    [
      campaign.id,
      campaign.title,
      campaign.category,
      campaign.targetAmount,
      campaign.currentAmount,
      campaign.donorCount,
      campaign.coverImage || null,
      campaign.story,
      campaign.organizerName || 'Persatuan Seni Silat Awang Sulung Merah Muda',
      campaign.beneficiaryGelanggang,
      campaign.startDate,
      campaign.endDate || null,
      campaign.status,
      campaign.isFeatured ? 1 : 0,
      campaign.impactMilestones ? JSON.stringify(campaign.impactMilestones) : null
    ]
  ).catch(() => { });

  window.dispatchEvent(new Event('asmm_db_updated'));
  return updated;
}

export async function deleteDonationCampaignDB(id: string): Promise<DonationCampaign[]> {
  initializeDB();
  const current = await getDonationCampaignsDB();
  const updated = current.filter(c => c.id !== id);
  localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(updated));
  cachedDonationCampaignsInMemory = updated;
  markTursoFetched('donation_campaigns');

  await executeTursoQuery(`DELETE FROM donation_campaigns WHERE id = ?;`, [id]).catch(() => { });
  window.dispatchEvent(new Event('asmm_db_updated'));
  return updated;
}

// ============================================================
// DONATIONS RECORDING & LIVE LEDGER SYNC
// ============================================================

export async function syncAllDonationsToTursoDB(donationsList?: DonationRecord[]): Promise<void> {
  const list = donationsList || [];
  if (list.length === 0) return;
  const statements = list.map(d => ({
    sql: `INSERT OR REPLACE INTO donations (id, campaignId, campaignTitle, amount, donorName, isAnonymous, donorEmail, donorPhone, message, infaqType, paymentMethod, transactionRef, receiptUrl, status, createdAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
    args: [
      d.id,
      d.campaignId,
      d.campaignTitle,
      d.amount,
      d.donorName,
      d.isAnonymous ? 1 : 0,
      d.donorEmail,
      d.donorPhone,
      d.message || null,
      d.infaqType || 'Sumbangan Am',
      d.paymentMethod,
      d.transactionRef,
      d.receiptUrl || null,
      d.status,
      d.createdAt
    ]
  }));
  await executeTursoBatch(statements).catch(() => { });
}

export async function getDonationsDB(campaignId?: string): Promise<DonationRecord[]> {
  initializeDB();
  if (cachedDonationsInMemory && cachedDonationsInMemory.length > 0) {
    if (shouldRefreshFromTurso('donations') && !_inflightRefresh['donations']) {
      _inflightRefresh['donations'] = refreshDonationsFromTurso()
        .finally(() => { _inflightRefresh['donations'] = null; });
    }
    return campaignId ? cachedDonationsInMemory.filter(d => d.campaignId === campaignId) : cachedDonationsInMemory;
  }

  const items = await refreshDonationsFromTurso();
  return campaignId ? items.filter(d => d.campaignId === campaignId) : items;
}

export async function refreshDonationsFromTurso(): Promise<DonationRecord[]> {
  try {
    const res = await executeTursoQuery(`SELECT id, campaignId, campaignTitle, amount, donorName, isAnonymous, donorEmail, donorPhone, message, infaqType, paymentMethod, transactionRef, receiptUrl, status, createdAt FROM donations ORDER BY createdAt DESC LIMIT 100;`);
    if (res && res.rows && Array.isArray(res.rows)) {
      const items: DonationRecord[] = res.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        campaignId: String(row.campaignId ?? row[1]),
        campaignTitle: String(row.campaignTitle ?? row[2]),
        amount: Number(row.amount ?? row[3]) || 0,
        donorName: String(row.donorName ?? row[4]),
        isAnonymous: Boolean(Number(row.isAnonymous ?? row[5]) === 1),
        donorEmail: String(row.donorEmail ?? row[6]),
        donorPhone: String(row.donorPhone ?? row[7]),
        message: row.message ?? row[8] ? String(row.message ?? row[8]) : undefined,
        infaqType: row.infaqType ?? row[9] ? String(row.infaqType ?? row[9]) as any : undefined,
        paymentMethod: String(row.paymentMethod ?? row[10]) as any,
        transactionRef: String(row.transactionRef ?? row[11]),
        receiptUrl: row.receiptUrl ?? row[12] ? String(row.receiptUrl ?? row[12]) : undefined,
        status: String(row.status ?? row[13]) as any,
        createdAt: String(row.createdAt ?? row[14])
      }));

      const prevJson = JSON.stringify(cachedDonationsInMemory || []);
      const newJson = JSON.stringify(items);
      localStorage.setItem(KEYS.DONATIONS, newJson);
      cachedDonationsInMemory = items;
      markTursoFetched('donations');

      // Only dispatch update if values have actually changed to avoid re-render cascades
      if (prevJson !== newJson) {
        window.dispatchEvent(new Event('asmm_db_updated'));
      }
      return items;
    }
  } catch (e) {
    console.warn("aaPanel live donations fetch notice:", e);
  }

  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.DONATIONS) : null;
  const list: DonationRecord[] = raw ? JSON.parse(raw) : [];
  cachedDonationsInMemory = list;
  return list;
}

/**
 * Records a new donation. If status is 'Berjaya', it automatically:
 * 1. Increments campaign's currentAmount and donorCount
 * 2. Injects a FinancialTransaction into the cashbook for audit transparency
 * Single round-trip batch write used to save Turso quota.
 */
export async function recordDonationDB(donation: DonationRecord): Promise<{ donation: DonationRecord; campaign?: DonationCampaign }> {
  initializeDB();
  const currentDonations = await getDonationsDB();
  const updatedDonations = [donation, ...currentDonations];
  localStorage.setItem(KEYS.DONATIONS, JSON.stringify(updatedDonations));
  cachedDonationsInMemory = updatedDonations;
  markTursoFetched('donations');

  const batchStatements: Array<{ sql: string; args: any[] }> = [
    {
      sql: `INSERT OR REPLACE INTO donations (id, campaignId, campaignTitle, amount, donorName, isAnonymous, donorEmail, donorPhone, message, infaqType, paymentMethod, transactionRef, receiptUrl, status, createdAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      args: [
        donation.id,
        donation.campaignId,
        donation.campaignTitle,
        donation.amount,
        donation.donorName,
        donation.isAnonymous ? 1 : 0,
        donation.donorEmail,
        donation.donorPhone,
        donation.message || null,
        donation.infaqType || 'Sumbangan Am',
        donation.paymentMethod,
        donation.transactionRef,
        donation.receiptUrl || null,
        donation.status,
        donation.createdAt
      ]
    }
  ];

  let updatedCampaign: DonationCampaign | undefined;

  // If donation is confirmed successful, update the parent campaign & cashbook
  if (donation.status === 'Berjaya') {
    const campaigns = await getDonationCampaignsDB();
    const campIndex = campaigns.findIndex(c => c.id === donation.campaignId);
    if (campIndex >= 0) {
      const camp = campaigns[campIndex];
      camp.currentAmount += donation.amount;
      camp.donorCount += 1;
      campaigns[campIndex] = camp;
      localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(campaigns));
      cachedDonationCampaignsInMemory = campaigns;
      markTursoFetched('donation_campaigns');
      updatedCampaign = camp;

      batchStatements.push({
        sql: `UPDATE donation_campaigns SET currentAmount = currentAmount + ?, donorCount = donorCount + 1 WHERE id = ?;`,
        args: [donation.amount, donation.campaignId]
      });
    }

    // Auto-inject into financial transactions ledger
    const donorDisplayName = donation.isAnonymous ? 'Hamba Allah (Penderma Tanpa Nama)' : donation.donorName;
    const finTx: FinancialTransaction = {
      id: `tx-don-${Date.now()}`,
      date: donation.createdAt.split(' ')[0] || new Date().toISOString().split('T')[0],
      category: 'Sumbangan',
      description: `Infaq Awam: ${donation.campaignTitle} (${donorDisplayName})`,
      amount: donation.amount,
      type: 'Income',
      payerOrPayee: donorDisplayName,
      gelanggang: updatedCampaign?.beneficiaryGelanggang || 'Semua Gelanggang',
      recordedBy: 'Sistem Infaq Portal ASMM',
      status: 'Disahkan',
      toyibBillCode: donation.transactionRef
    };
    saveTransactionDB(finTx).catch(() => { });
  }

  // Execute all donation statements in a single batch request to conserve quota
  await executeTursoBatch(batchStatements).catch(() => { });

  window.dispatchEvent(new Event('asmm_db_updated'));
  window.dispatchEvent(new CustomEvent('asmm_donation_received', { detail: donation }));

  return { donation, campaign: updatedCampaign };
}

export async function confirmDonationSuccessDB(donationId: string): Promise<{ donation?: DonationRecord; campaign?: DonationCampaign }> {
  initializeDB();
  const currentDonations = await getDonationsDB();
  const index = currentDonations.findIndex(d => d.id === donationId || d.transactionRef === donationId);
  if (index >= 0 && currentDonations[index].status !== 'Berjaya') {
    const donation = currentDonations[index];
    donation.status = 'Berjaya';
    currentDonations[index] = donation;
    localStorage.setItem(KEYS.DONATIONS, JSON.stringify(currentDonations));
    cachedDonationsInMemory = currentDonations;
    markTursoFetched('donations');

    const batchStatements: Array<{ sql: string; args: any[] }> = [
      {
        sql: `UPDATE donations SET status = 'Berjaya' WHERE id = ? OR transactionRef = ?;`,
        args: [donation.id, donation.transactionRef]
      }
    ];

    // Update campaign
    const campaigns = await getDonationCampaignsDB();
    const campIndex = campaigns.findIndex(c => c.id === donation.campaignId);
    let targetGelanggang: Gelanggang = 'Semua Gelanggang';
    let updatedCampaign: DonationCampaign | undefined;
    if (campIndex >= 0) {
      campaigns[campIndex].currentAmount += donation.amount;
      campaigns[campIndex].donorCount += 1;
      targetGelanggang = campaigns[campIndex].beneficiaryGelanggang;
      updatedCampaign = campaigns[campIndex];
      localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(campaigns));
      cachedDonationCampaignsInMemory = campaigns;
      markTursoFetched('donation_campaigns');

      batchStatements.push({
        sql: `UPDATE donation_campaigns SET currentAmount = currentAmount + ?, donorCount = donorCount + 1 WHERE id = ?;`,
        args: [donation.amount, donation.campaignId]
      });
    }

    // Auto-inject into financial transactions ledger
    const donorDisplayName = donation.isAnonymous ? 'Hamba Allah (Penderma Tanpa Nama)' : donation.donorName;
    const finTx: FinancialTransaction = {
      id: `tx-don-${Date.now()}`,
      date: new Date().toISOString().split('T')[0],
      category: 'Sumbangan',
      description: `Infaq FPX: ${donation.campaignTitle} (${donorDisplayName})`,
      amount: donation.amount,
      type: 'Income',
      payerOrPayee: donorDisplayName,
      gelanggang: targetGelanggang,
      recordedBy: 'ToyyibPay FPX Gateway',
      status: 'Disahkan',
      toyibBillCode: donation.transactionRef
    };
    saveTransactionDB(finTx).catch(() => { });

    await executeTursoBatch(batchStatements).catch(() => { });

    window.dispatchEvent(new Event('asmm_db_updated'));
    window.dispatchEvent(new CustomEvent('asmm_donation_received', { detail: donation }));

    return { donation, campaign: updatedCampaign };
  }

  const existing = currentDonations[index];
  return { donation: existing };
}

export async function markDonationFailedDB(donationIdOrRef: string): Promise<DonationRecord | undefined> {
  initializeDB();
  const currentDonations = await getDonationsDB();
  const index = currentDonations.findIndex(d => d.id === donationIdOrRef || d.transactionRef === donationIdOrRef);
  if (index >= 0) {
    const donation = currentDonations[index];
    if (donation.status !== 'Berjaya') {
      donation.status = 'Gagal';
      currentDonations[index] = donation;
      localStorage.setItem(KEYS.DONATIONS, JSON.stringify(currentDonations));
      cachedDonationsInMemory = currentDonations;

      await executeTursoQuery(
        `UPDATE donations SET status = 'Gagal' WHERE id = ? OR transactionRef = ?;`,
        [donation.id, donation.transactionRef]
      ).catch(() => { });

      window.dispatchEvent(new Event('asmm_db_updated'));
      return donation;
    }
  }
  return undefined;
}


export async function updateDonationRecordDB(donation: DonationRecord): Promise<DonationRecord[]> {
  initializeDB();
  const currentDonations = await getDonationsDB();
  const index = currentDonations.findIndex(d => d.id === donation.id);
  if (index >= 0) {
    currentDonations[index] = donation;
    localStorage.setItem(KEYS.DONATIONS, JSON.stringify(currentDonations));
    cachedDonationsInMemory = currentDonations;

    await executeTursoQuery(
      `UPDATE donations SET donorName = ?, isAnonymous = ?, donorEmail = ?, donorPhone = ?, message = ?, status = ? WHERE id = ?;`,
      [
        donation.donorName,
        donation.isAnonymous ? 1 : 0,
        donation.donorEmail,
        donation.donorPhone,
        donation.message || null,
        donation.status,
        donation.id
      ]
    ).catch(() => { });

    window.dispatchEvent(new Event('asmm_db_updated'));
  }
  return currentDonations;
}

export async function deleteDonationDB(id: string): Promise<DonationRecord[]> {
  initializeDB();
  const currentDonations = await getDonationsDB();
  const target = currentDonations.find(d => d.id === id);
  const updatedDonations = currentDonations.filter(d => d.id !== id);
  localStorage.setItem(KEYS.DONATIONS, JSON.stringify(updatedDonations));
  cachedDonationsInMemory = updatedDonations;

  await executeTursoQuery(`DELETE FROM donations WHERE id = ?;`, [id]).catch(() => { });

  // If deleted donation was 'Berjaya', revert the campaign count & amount
  if (target && target.status === 'Berjaya') {
    const campaigns = await getDonationCampaignsDB();
    const campIndex = campaigns.findIndex(c => c.id === target.campaignId);
    if (campIndex >= 0) {
      campaigns[campIndex].currentAmount = Math.max(0, campaigns[campIndex].currentAmount - target.amount);
      campaigns[campIndex].donorCount = Math.max(0, campaigns[campIndex].donorCount - 1);
      localStorage.setItem(KEYS.DONATION_CAMPAIGNS, JSON.stringify(campaigns));
      cachedDonationCampaignsInMemory = campaigns;

      await executeTursoQuery(
        `UPDATE donation_campaigns SET currentAmount = MAX(0, currentAmount - ?), donorCount = MAX(0, donorCount - 1) WHERE id = ?;`,
        [target.amount, target.campaignId]
      ).catch(() => { });
    }

    // Clean from transactions if matched
    if (target.transactionRef) {
      await executeTursoQuery(`DELETE FROM financial_transactions WHERE toyibBillCode = ?;`, [target.transactionRef]).catch(() => { });
    }
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
  return updatedDonations;
}

// ==========================================
// SYLLABUS GRADING OPERATIONS (KETUA GELANGGANG)
// ==========================================

export const SEED_SYLLABUS_GRADINGS: SyllabusGradingRecord[] = [
  {
    id: 'grade-asmm-011-putih',
    memberId: 'asmm-011',
    rankLevel: 'putih',
    status: 'Lulus',
    assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    assessorRole: 'Ketua Gelanggang',
    assessedAt: '2026-09-05T10:00:00.000Z',
    gelanggang: 'Pusaka Warisan',
    notes: 'Kekuda kukuh, hayatan jurus mantap dan adab silat cemerlang.',
    remark: 'Kekuda kukuh, hayatan jurus mantap dan adab silat cemerlang.',
    rating: 5,
    lessonRatings: {
      'les-07': {
        rating: 5,
        remark: 'Hayatan satu tiang sempurna, pernafasan dan kekuda kemas.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T10:00:00.000Z'
      },
      'les-08': {
        rating: 5,
        remark: 'Langkah jurus bertenaga dan transisi elakan pantas.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T10:05:00.000Z'
      },
      'les-09': {
        rating: 4,
        remark: 'Pukulan berpadu dan tangkisan tepat pada sasaran.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T10:10:00.000Z'
      },
      'les-10': {
        rating: 5,
        remark: 'Seni tari pulut tertib, lembut tetapi berdaya pukulan padu.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T10:15:00.000Z'
      }
    }
  },
  {
    id: 'grade-ASMM-014-putih',
    memberId: 'ASMM-014',
    rankLevel: 'putih',
    status: 'Lulus',
    assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    assessorRole: 'Ketua Gelanggang',
    assessedAt: '2026-09-05T11:54:04.921Z',
    gelanggang: 'Pusaka Warisan',
    notes: 'Kekuda kukuh & pukulan berpadu.',
    remark: 'Kekuda kukuh & pukulan berpadu.',
    rating: 4,
    lessonRatings: {
      'les-07': {
        rating: 5,
        remark: 'Kekuda asas bertambah baik dan pernafasan tenang.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T11:00:17.603Z'
      },
      'les-08': {
        rating: 5,
        remark: 'Kekuda perlu lebih rendah dan stabil.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T11:10:10.584Z'
      },
      'les-09': {
        rating: 4,
        remark: 'Pukulan kemas & bertenaga.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T11:46:19.093Z'
      },
      'les-10': {
        rating: 4,
        remark: 'Langkah terpuji dan hayatan jurus baik.',
        assessedBy: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
        assessedAt: '2026-09-05T11:54:04.921Z'
      }
    }
  },
  {
    id: 'grade-asmm-010-putih',
    memberId: 'asmm-010',
    rankLevel: 'putih',
    status: 'Lulus',
    assessedBy: 'Mohd Fauzi Bin Abd Aziz',
    assessorRole: 'Ketua Gelanggang',
    assessedAt: '2026-09-05T04:48:55.574Z',
    gelanggang: 'Wadi AnNour',
    notes: 'Lulus ujian praktikal silibus peringkat bengkung putih.',
    remark: 'Lulus ujian praktikal silibus peringkat bengkung putih.',
    rating: 4,
    lessonRatings: {
      'les-07': {
        rating: 4,
        remark: 'Kekuda kemas.',
        assessedBy: 'Mohd Fauzi Bin Abd Aziz',
        assessedAt: '2026-09-05T04:48:55.574Z'
      }
    }
  }
];

export async function getAllSyllabusGradingsDB(): Promise<SyllabusGradingRecord[]> {
  initializeDB();

  if (cachedSyllabusGradingInMemory && cachedSyllabusGradingInMemory.length > 0) {
    if (shouldRefreshFromTurso('syllabus_grading') && !_inflightRefresh['syllabus_grading']) {
      _inflightRefresh['syllabus_grading'] = refreshSyllabusGradingCacheFromTurso()
        .finally(() => { _inflightRefresh['syllabus_grading'] = null; });
    }
    return cachedSyllabusGradingInMemory;
  }

  return await refreshSyllabusGradingCacheFromTurso();
}

async function refreshSyllabusGradingCacheFromTurso(): Promise<SyllabusGradingRecord[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM syllabus_grading;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbRecords: SyllabusGradingRecord[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        memberId: String(row.memberId ?? row[1]),
        rankLevel: String(row.rankLevel ?? row[2]),
        status: String(row.status ?? row[3]) as any,
        assessedBy: String(row.assessedBy ?? row[4] ?? ''),
        assessorRole: String(row.assessorRole ?? row[5] ?? ''),
        assessedAt: String(row.assessedAt ?? row[6] ?? ''),
        gelanggang: String(row.gelanggang ?? row[7] ?? '') as any,
        notes: row.notes != null ? String(row.notes) : '',
        rating: row.rating != null ? Number(row.rating) : undefined,
        remark: row.remark != null ? String(row.remark) : undefined,
        lessonRatings: (() => {
          const rawLR = row.lessonRatings ?? row[11];
          if (!rawLR) return undefined;
          try {
            return typeof rawLR === 'string' ? JSON.parse(rawLR) : rawLR;
          } catch {
            return undefined;
          }
        })()
      }));

      cachedSyllabusGradingInMemory = dbRecords;
      markTursoFetched('syllabus_grading');
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.SYLLABUS_GRADING, JSON.stringify(dbRecords));
      }
      return dbRecords;
    }
  } catch (e) {
    console.warn('refreshSyllabusGradingCacheFromTurso network/db failure:', e);
  }

  // Fallback strictly to local mirror (no fake seed data injection)
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.SYLLABUS_GRADING);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          cachedSyllabusGradingInMemory = parsed;
          return parsed;
        }
      } catch { }
    }
  }

  cachedSyllabusGradingInMemory = [];
  return [];
}

export async function getSyllabusGradingDB(memberId: string, rankLevel?: string): Promise<SyllabusGradingRecord | null> {
  if (!memberId) return null;
  const list = await getAllSyllabusGradingsDB();
  const normalizedId = memberId.toLowerCase();
  if (rankLevel) {
    const match = list.find(r => r.memberId.toLowerCase() === normalizedId && r.rankLevel.toLowerCase() === rankLevel.toLowerCase());
    if (match) return match;
  }
  // Return latest record for member if specific rankLevel not found
  const memberRecords = list.filter(r => r.memberId.toLowerCase() === normalizedId);
  return memberRecords.length > 0 ? memberRecords[memberRecords.length - 1] : null;
}

export async function saveSyllabusGradingDB(record: SyllabusGradingRecord): Promise<void> {
  const list = await getAllSyllabusGradingsDB();
  const normalizedId = record.memberId.toLowerCase();
  const normalizedRank = record.rankLevel.toLowerCase();
  const index = list.findIndex(r => r.memberId.toLowerCase() === normalizedId && r.rankLevel.toLowerCase() === normalizedRank);

  if (index >= 0) {
    list[index] = { ...list[index], ...record };
  } else {
    list.push(record);
  }

  cachedSyllabusGradingInMemory = list;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.SYLLABUS_GRADING, JSON.stringify(list));
  }

  // Sync to aaPanel MySQL DB
  try {
    await executeTursoQuery(
      `INSERT OR REPLACE INTO syllabus_grading (id, memberId, rankLevel, status, assessedBy, assessorRole, assessedAt, gelanggang, notes, rating, remark, lessonRatings, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        record.id,
        record.memberId,
        record.rankLevel,
        record.status,
        record.assessedBy || '',
        String(record.assessorRole || ''),
        record.assessedAt || '',
        record.gelanggang || '',
        record.notes || '',
        record.rating ?? null,
        record.remark || '',
        record.lessonRatings ? JSON.stringify(record.lessonRatings) : null,
        new Date().toISOString()
      ]
    );
  } catch (e) {
    console.warn('saveSyllabusGradingDB remote error:', e);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

// ==========================================
// UJIAN BENGKUNG REGISTRATION OPERATIONS
// ==========================================

export async function getUjianBengkungRegistrationsDB(): Promise<UjianBengkungRegistration[]> {
  initializeDB();

  if (cachedUjianBengkungRegsInMemory && cachedUjianBengkungRegsInMemory.length > 0) {
    if (shouldRefreshFromTurso('ujian_bengkung') && !_inflightRefresh['ujian_bengkung']) {
      _inflightRefresh['ujian_bengkung'] = refreshUjianBengkungRegsFromTurso()
        .finally(() => { _inflightRefresh['ujian_bengkung'] = null; });
    }
    return cachedUjianBengkungRegsInMemory;
  }

  return await refreshUjianBengkungRegsFromTurso();
}

async function refreshUjianBengkungRegsFromTurso(): Promise<UjianBengkungRegistration[]> {
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM ujian_bengkung_registrations;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const dbRegs: UjianBengkungRegistration[] = tursoRes.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        memberId: String(row.memberId ?? row[1]),
        memberName: String(row.memberName ?? row[2]),
        memberPhone: row.memberPhone ? String(row.memberPhone) : (row[3] ? String(row[3]) : undefined),
        memberIcNo: row.memberIcNo ? String(row.memberIcNo) : (row[4] ? String(row[4]) : undefined),
        gelanggang: String(row.gelanggang ?? row[5]) as Gelanggang,
        currentBengkung: cleanBengkungTitle(String(row.currentBengkung ?? row[6] ?? 'Putih')),
        targetBengkung: cleanBengkungTitle(String(row.targetBengkung ?? row[7] ?? 'Putih 1')),
        status: String(row.status ?? row[8] ?? 'pra-daftar') as any,
        registeredAt: String(row.registeredAt ?? row[9] ?? ''),
        scheduledEventId: row.scheduledEventId ? String(row.scheduledEventId) : (row[10] ? String(row[10]) : undefined),
        scheduledEventTitle: row.scheduledEventTitle ? String(row.scheduledEventTitle) : (row[11] ? String(row[11]) : undefined),
        scheduledEventDate: row.scheduledEventDate ? String(row.scheduledEventDate) : (row[12] ? String(row[12]) : undefined),
        invoiceId: row.invoiceId ? String(row.invoiceId) : (row[13] ? String(row[13]) : undefined),
        paidAt: row.paidAt ? String(row.paidAt) : (row[14] ? String(row[14]) : undefined),
        notes: row.notes ? String(row.notes) : (row[15] ? String(row[15]) : undefined)
      }));

      cachedUjianBengkungRegsInMemory = dbRegs;
      markTursoFetched('ujian_bengkung');
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS, JSON.stringify(dbRegs));
      }
      return dbRegs;
    }
  } catch (e) {
    console.warn('refreshUjianBengkungRegsFromTurso network/db failure:', e);
  }

  // Fallback strictly to local mirror (no fake seed data injection)
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          cachedUjianBengkungRegsInMemory = parsed;
          return parsed;
        }
      } catch { }
    }
  }

  cachedUjianBengkungRegsInMemory = [];
  return [];
}

export async function getMemberUjianBengkungRegistrationDB(memberId: string): Promise<UjianBengkungRegistration | null> {
  if (!memberId) return null;
  const list = await getUjianBengkungRegistrationsDB();
  const records = list.filter(r => r.memberId === memberId);
  return records.length > 0 ? records[records.length - 1] : null;
}

export async function saveUjianBengkungRegistrationDB(reg: UjianBengkungRegistration): Promise<void> {
  const list = await getUjianBengkungRegistrationsDB();
  const index = list.findIndex(r => r.id === reg.id || (r.memberId === reg.memberId && r.status !== 'selesai-daftar'));

  const cleanReg: UjianBengkungRegistration = {
    ...reg,
    currentBengkung: cleanBengkungTitle(reg.currentBengkung || 'Putih'),
    targetBengkung: cleanBengkungTitle(reg.targetBengkung || 'Putih 1')
  };

  if (index >= 0) {
    list[index] = { ...list[index], ...cleanReg };
  } else {
    list.push(cleanReg);
  }

  cachedUjianBengkungRegsInMemory = list;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_BENGKUNG_REGISTRATIONS, JSON.stringify(list));
  }

  // Sync to aaPanel MySQL DB
  try {
    await executeTursoQuery(
      `INSERT OR REPLACE INTO ujian_bengkung_registrations (id, memberId, memberName, memberPhone, memberIcNo, gelanggang, currentBengkung, targetBengkung, status, registeredAt, scheduledEventId, scheduledEventTitle, scheduledEventDate, invoiceId, paidAt, notes, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        cleanReg.id,
        cleanReg.memberId,
        cleanReg.memberName,
        cleanReg.memberPhone || '',
        cleanReg.memberIcNo || '',
        cleanReg.gelanggang,
        cleanReg.currentBengkung,
        cleanReg.targetBengkung,
        cleanReg.status,
        cleanReg.registeredAt,
        cleanReg.scheduledEventId || '',
        cleanReg.scheduledEventTitle || '',
        cleanReg.scheduledEventDate || '',
        cleanReg.invoiceId || '',
        cleanReg.paidAt || '',
        cleanReg.notes || '',
        new Date().toISOString()
      ]
    );
  } catch (e) {
    console.warn('saveUjianBengkungRegistrationDB remote error:', e);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

/**
 * Checks whether an active, scheduled Ujian Bengkung event notice exists.
 * Returns the NoticeItem if scheduled (with future/current date or newly created), or null if not yet scheduled.
 */
export async function getActiveUjianBengkungEventDB(): Promise<NoticeItem | null> {
  const notices = await getNoticesDB();
  const today = new Date().toISOString().split('T')[0]; // e.g. "2026-09-05"

  // Filter for acara notices that relate to Ujian Bengkung
  const candidates = notices.filter(n => {
    if (n.type !== 'acara') return false;
    const title = (n.title || '').toLowerCase();
    const content = (n.content || '').toLowerCase();
    return (
      title.includes('ujian bengkung') ||
      title.includes('kenaikan bengkung') ||
      content.includes('ujian kenaikan bengkung') ||
      content.includes('sesi ujian bengkung')
    );
  });

  if (candidates.length === 0) return null;

  // Find one that is scheduled for today or in the future
  const upcoming = candidates.find(n => {
    if (!n.eventDate) return false;
    return n.eventDate >= today;
  });

  if (upcoming) return upcoming;

  // If no upcoming date matched, return null (meaning no event is scheduled yet)
  return null;
}

// ==========================================
// UJIAN GRADING ASSESSMENTS & PAID CANDIDATES
// ==========================================

export async function getUjianGradingAssessmentsDB(): Promise<UjianGradingAssessment[]> {
  initializeDB();

  if (cachedUjianGradingAssessmentsInMemory && cachedUjianGradingAssessmentsInMemory.length > 0) {
    return cachedUjianGradingAssessmentsInMemory;
  }

  // Load from aaPanel MySQL / Turso
  try {
    const tursoRes = await executeTursoQuery("SELECT * FROM ujian_grading_assessments;");
    if (tursoRes && tursoRes.rows && Array.isArray(tursoRes.rows)) {
      const records: UjianGradingAssessment[] = tursoRes.rows.map((row: any) => {
        let scores: Record<string, any> = {};
        try {
          const rawScores = row.scoresJson ?? row[12];
          if (rawScores) scores = JSON.parse(rawScores);
        } catch { }

        return {
          id: String(row.id ?? row[0]),
          memberId: String(row.memberId ?? row[1]),
          memberName: String(row.memberName ?? row[2]),
          currentBengkung: String(row.currentBengkung ?? row[3] ?? 'Putih'),
          targetBengkung: String(row.targetBengkung ?? row[4] ?? 'Putih 1'),
          overallStatus: (row.overallStatus ?? row[5] ?? 'Belum Dinilai') as any,
          overallGrade: row.overallGrade ?? row[6] ?? 'B (Kepujian)',
          averageScore: Number(row.averageScore ?? row[7] ?? 0),
          assessedBy: String(row.assessedBy ?? row[8] ?? ''),
          assessorRole: String(row.assessorRole ?? row[9] ?? 'Ketua Gelanggang'),
          examDate: String(row.examDate ?? row[10] ?? new Date().toISOString().split('T')[0]),
          certificateNo: row.certificateNo ?? row[11] ?? undefined,
          scores: scores,
          examinerRemarks: row.examinerRemarks ?? row[13] ?? '',
          updatedAt: String(row.updatedAt ?? row[14] ?? new Date().toISOString()),
          gelanggang: row.gelanggang ? String(row.gelanggang) : 'Pusaka Warisan'
        };
      });

      cachedUjianGradingAssessmentsInMemory = records;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.UJIAN_GRADING_ASSESSMENTS, JSON.stringify(records));
      }
      return records;
    }
  } catch (e) {
    console.warn('refreshUjianGradingAssessmentsFromTurso error:', e);
  }

  // Fallback to localStorage
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.UJIAN_GRADING_ASSESSMENTS);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          cachedUjianGradingAssessmentsInMemory = parsed;
          return parsed;
        }
      } catch { }
    }
  }

  cachedUjianGradingAssessmentsInMemory = [];
  return [];
}

export async function saveUjianGradingAssessmentDB(assessment: UjianGradingAssessment): Promise<void> {
  const list = await getUjianGradingAssessmentsDB();
  const index = list.findIndex(a =>
    a.id === assessment.id ||
    (
      a.memberId && assessment.memberId &&
      a.memberId.toLowerCase() === assessment.memberId.toLowerCase() &&
      a.targetBengkung && assessment.targetBengkung &&
      a.targetBengkung.toLowerCase() === assessment.targetBengkung.toLowerCase() &&
      a.assessedBy && assessment.assessedBy &&
      a.assessedBy.trim().toLowerCase() === assessment.assessedBy.trim().toLowerCase()
    )
  );

  const cleanAssessment: UjianGradingAssessment = {
    ...assessment,
    updatedAt: new Date().toISOString()
  };

  if (index >= 0) {
    list[index] = { ...list[index], ...cleanAssessment };
  } else {
    list.push(cleanAssessment);
  }

  cachedUjianGradingAssessmentsInMemory = list;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_GRADING_ASSESSMENTS, JSON.stringify(list));
  }

  // Also sync to remote DB if available
  try {
    await executeTursoQuery(
      `INSERT OR REPLACE INTO ujian_grading_assessments (id, memberId, memberName, currentBengkung, targetBengkung, overallStatus, overallGrade, averageScore, assessedBy, assessorRole, examDate, certificateNo, scoresJson, examinerRemarks, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        cleanAssessment.id,
        cleanAssessment.memberId,
        cleanAssessment.memberName,
        cleanAssessment.currentBengkung,
        cleanAssessment.targetBengkung,
        cleanAssessment.overallStatus,
        cleanAssessment.overallGrade || '',
        cleanAssessment.averageScore || 0,
        cleanAssessment.assessedBy,
        cleanAssessment.assessorRole,
        cleanAssessment.examDate,
        cleanAssessment.certificateNo || '',
        JSON.stringify(cleanAssessment.scores || {}),
        cleanAssessment.examinerRemarks || '',
        cleanAssessment.updatedAt
      ]
    );
  } catch (e) {
    console.warn('saveUjianGradingAssessmentDB remote error:', e);
  }

  // NOTE: Even if a murid already got a passing grade, do NOT increment bengkung rank yet.
  // Pangkat bengkung hanya akan dinaikkan serentak selepas KESEMUA calon selesai menduduki ujian.
  try {
    const cohortStatus = await getUjianCohortCompletionStatusDB();
    if (cohortStatus.isAllTestsCompleted && cohortStatus.totalCandidates > 0) {
      await finalizeUjianGradingBatchRankDB();
    }
  } catch (cohortErr) {
    console.warn('Failed to auto-finalize cohort completion rank upgrade:', cohortErr);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

export async function deleteUjianGradingAssessmentDB(assessmentId: string): Promise<void> {
  const list = await getUjianGradingAssessmentsDB();
  const updated = list.filter(a => a.id !== assessmentId);
  cachedUjianGradingAssessmentsInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_GRADING_ASSESSMENTS, JSON.stringify(updated));
  }

  try {
    await executeTursoQuery(`DELETE FROM ujian_grading_assessments WHERE id = ?;`, [assessmentId]);
  } catch (e) {
    console.warn('deleteUjianGradingAssessmentDB error:', e);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

/**
 * Resolves all examiner assessments for a candidate and computes panel consensus
 */
function resolveCandidateGradingInfo(
  memberId: string,
  targetBengkung: string,
  registrationId?: string,
  allAssessments: UjianGradingAssessment[] = []
): {
  gradingStatus: 'Belum Dinilai' | 'Sedang Dinilai' | 'Lulus' | 'Mengulang';
  assessment?: UjianGradingAssessment;
  assessments: UjianGradingAssessment[];
} {
  const candAssessments = allAssessments.filter(a =>
    (registrationId && a.candidateRegistrationId === registrationId) ||
    (
      a.memberId && memberId &&
      a.memberId.trim().toLowerCase() === memberId.trim().toLowerCase() &&
      a.targetBengkung && targetBengkung &&
      a.targetBengkung.trim().toLowerCase() === targetBengkung.trim().toLowerCase()
    )
  );

  if (candAssessments.length === 0) {
    return {
      gradingStatus: 'Belum Dinilai',
      assessment: undefined,
      assessments: []
    };
  }

  let gradingStatus: 'Belum Dinilai' | 'Sedang Dinilai' | 'Lulus' | 'Mengulang' = 'Sedang Dinilai';
  if (candAssessments.some(a => a.overallStatus === 'Mengulang')) {
    gradingStatus = 'Mengulang';
  } else if (candAssessments.every(a => a.overallStatus === 'Lulus')) {
    gradingStatus = 'Lulus';
  }

  return {
    gradingStatus,
    assessment: candAssessments[candAssessments.length - 1],
    assessments: candAssessments
  };
}

/**
 * Retrieves the comprehensive list of candidates who have PAID for Ujian Bengkung.
 * Links registrations, paid invoices, user profiles, and existing grading assessments.
 */
export async function getPaidUjianCandidatesDB(): Promise<PaidUjianCandidate[]> {
  const [registrations, invoices, members, assessments] = await Promise.all([
    getUjianBengkungRegistrationsDB(),
    getInvoicesDB(),
    getMembersDB(),
    getUjianGradingAssessmentsDB()
  ]);

  const candidatesMap = new Map<string, PaidUjianCandidate>();

  // 1. Process from Ujian Bengkung Registrations
  for (const reg of registrations) {
    const isRegPaid = reg.status === 'selesai-daftar' || Boolean(reg.paidAt);
    let linkedInvoice: InvoiceItem | undefined;
    if (reg.invoiceId) {
      linkedInvoice = invoices.find(inv => inv.id === reg.invoiceId || inv.invoiceNo === reg.invoiceId);
    }

    const isInvoicePaid = linkedInvoice && (linkedInvoice.status === 'Lulus / Dibayar' || Boolean(linkedInvoice.paidAt));

    if (isRegPaid || isInvoicePaid) {
      const member = members.find(m => m.id.toLowerCase() === reg.memberId.toLowerCase());
      const gradingInfo = resolveCandidateGradingInfo(reg.memberId, reg.targetBengkung || 'Putih 1', reg.id, assessments);

      const candKey = `${reg.memberId}_${reg.targetBengkung}`.toLowerCase();
      candidatesMap.set(candKey, {
        id: `cand-${reg.id}`,
        registrationId: reg.id,
        invoiceId: reg.invoiceId || linkedInvoice?.id,
        invoiceNo: linkedInvoice?.invoiceNo || `INV-UB-${reg.id.slice(-6).toUpperCase()}`,
        memberId: reg.memberId,
        memberName: reg.memberName,
        memberIcNo: reg.memberIcNo || member?.icNo,
        memberPhone: reg.memberPhone || member?.phone,
        photoUrl: member?.photoUrl,
        gelanggang: reg.gelanggang || member?.gelanggang || 'Pusaka Warisan',
        currentBengkung: reg.currentBengkung || member?.bengkung || 'Putih',
        targetBengkung: reg.targetBengkung || 'Putih 1',
        amountPaid: linkedInvoice?.amount || 50.0,
        paidAt: reg.paidAt || linkedInvoice?.paidAt || reg.registeredAt,
        paymentMethod: linkedInvoice?.paymentMethod || 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: gradingInfo.gradingStatus,
        assessment: gradingInfo.assessment,
        assessments: gradingInfo.assessments
      });
    }
  }

  // 2. Process paid invoices with category 'Yuran Bengkung' or containing 'ujian' in title
  const paidUjianInvoices = invoices.filter(inv => {
    const isUjian = inv.category === 'Yuran Bengkung' ||
      (inv.title || '').toLowerCase().includes('ujian') ||
      (inv.description || '').toLowerCase().includes('ujian bengkung');
    const isPaid = inv.status === 'Lulus / Dibayar' || Boolean(inv.paidAt);
    return isUjian && isPaid;
  });

  for (const inv of paidUjianInvoices) {
    const member = members.find(m => m.id.toLowerCase() === inv.memberId.toLowerCase());

    // Check if invoice has item breakdowns (e.g. family candidates)
    if (inv.items && inv.items.length > 0) {
      for (const item of inv.items) {
        // e.g. "Yuran Ujian Bengkung Putih 1 - Ahmad Danish"
        const desc = item.description || '';
        if (desc.toLowerCase().includes('yuran ujian')) {
          let candName = inv.memberName;
          let targetBengkung = 'Putih 1';

          if (desc.includes(' - ')) {
            const parts = desc.split(' - ');
            candName = parts[1]?.split('(')[0]?.trim() || candName;
            const bPart = parts[0]?.replace(/yuran ujian/i, '').trim();
            if (bPart) targetBengkung = bPart;
          }

          const candKey = `${candName}_${targetBengkung}`.toLowerCase();
          if (!candidatesMap.has(candKey)) {
            const matchingMember = members.find(m => m.name.toLowerCase() === candName.toLowerCase()) || member;
            const targetMemberId = matchingMember?.id || inv.memberId;
            const gradingInfo = resolveCandidateGradingInfo(targetMemberId, targetBengkung, undefined, assessments);

            candidatesMap.set(candKey, {
              id: `cand-${inv.id}-${item.id}`,
              invoiceId: inv.id,
              invoiceNo: inv.invoiceNo,
              memberId: targetMemberId,
              memberName: candName,
              memberIcNo: matchingMember?.icNo || inv.memberIcNo,
              memberPhone: matchingMember?.phone || inv.memberPhone,
              photoUrl: matchingMember?.photoUrl,
              gelanggang: inv.gelanggang || matchingMember?.gelanggang || 'Pusaka Warisan',
              currentBengkung: matchingMember?.bengkung || 'Putih',
              targetBengkung: targetBengkung,
              amountPaid: item.amount || 50.0,
              paidAt: inv.paidAt || inv.createdAt,
              paymentMethod: inv.paymentMethod || 'DuitNow QR',
              statusBayaran: 'Dibayar',
              gradingStatus: gradingInfo.gradingStatus,
              assessment: gradingInfo.assessment,
              assessments: gradingInfo.assessments
            });
          }
        }
      }
    } else {
      // Single candidate invoice
      const targetBengkung = inv.title.includes('Kuning') ? 'Kuning' :
        inv.title.includes('Merah 3') ? 'Merah 3' :
          inv.title.includes('Merah 2') ? 'Merah 2' :
            inv.title.includes('Merah 1') ? 'Merah 1' :
              inv.title.includes('Merah') ? 'Merah' :
                inv.title.includes('Putih 3') ? 'Putih 3' :
                  inv.title.includes('Putih 2') ? 'Putih 2' : 'Putih 1';

      const candKey = `${inv.memberId}_${targetBengkung}`.toLowerCase();
      if (!candidatesMap.has(candKey)) {
        const gradingInfo = resolveCandidateGradingInfo(inv.memberId, targetBengkung, undefined, assessments);
        candidatesMap.set(candKey, {
          id: `cand-${inv.id}`,
          invoiceId: inv.id,
          invoiceNo: inv.invoiceNo,
          memberId: inv.memberId,
          memberName: inv.memberName,
          memberIcNo: inv.memberIcNo || member?.icNo,
          memberPhone: inv.memberPhone || member?.phone,
          photoUrl: member?.photoUrl,
          gelanggang: inv.gelanggang || member?.gelanggang || 'Pusaka Warisan',
          currentBengkung: member?.bengkung || 'Putih',
          targetBengkung: targetBengkung,
          amountPaid: inv.amount,
          paidAt: inv.paidAt || inv.createdAt,
          paymentMethod: inv.paymentMethod || 'DuitNow QR',
          statusBayaran: 'Dibayar',
          gradingStatus: gradingInfo.gradingStatus,
          assessment: gradingInfo.assessment,
          assessments: gradingInfo.assessments
        });
      }
    }
  }

  const results = Array.from(candidatesMap.values());

  // 3. Official Ujian Bengkung 2026 candidate cohort (Putih Cula 3, Putih Cula 2, Putih Cula 1)
  // Their actual current bengkung is one grade lower, taking exam for the next target bengkung.
  if (results.length < 15) {
    const seedPaidCandidates: PaidUjianCandidate[] = [
      // --- Bengkung Putih Cula 3 (Current: Putih 2 -> Target: Putih 3) ---
      {
        id: 'seed-ub26-01',
        registrationId: 'reg-ub26-01',
        invoiceId: 'inv-ub26-01',
        invoiceNo: 'INV-UB26-001',
        memberId: 'ASMM-120',
        memberName: 'Mohd Farish Fahmi bin Mohd Fauzi',
        memberIcNo: '111114020045',
        memberPhone: '011-11402004',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 10:30:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-02',
        registrationId: 'reg-ub26-02',
        invoiceId: 'inv-ub26-02',
        invoiceNo: 'INV-UB26-002',
        memberId: 'ASMM-121',
        memberName: 'Farah Irdina bt Mohd Fauzi',
        memberIcNo: '140127020522',
        memberPhone: '014-01270205',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 10:35:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-03',
        registrationId: 'reg-ub26-03',
        invoiceId: 'inv-ub26-03',
        invoiceNo: 'INV-UB26-003',
        memberId: 'ASMM-123',
        memberName: 'Muhammad Akif Naufal bin Muhammad Amir Fairudin',
        memberIcNo: '120805020911',
        memberPhone: '012-08050209',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 11:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-04',
        registrationId: 'reg-ub26-04',
        invoiceId: 'inv-ub26-04',
        invoiceNo: 'INV-UB26-004',
        memberId: 'ASMM-122',
        memberName: 'Aina Miazarra bt Bukhari',
        memberIcNo: '121130020802',
        memberPhone: '012-11300208',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 11:15:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-05',
        registrationId: 'reg-ub26-05',
        invoiceId: 'inv-ub26-05',
        invoiceNo: 'INV-UB26-005',
        memberId: 'ASMM-011',
        memberName: 'Mohammad Hafiz bin Halim',
        memberIcNo: '910428025253',
        memberPhone: '013-4820194',
        photoUrl: '/badges/hafiz.jpeg?v=2',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 11:30:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-06',
        registrationId: 'reg-ub26-06',
        invoiceId: 'inv-ub26-06',
        invoiceNo: 'INV-UB26-006',
        memberId: 'ASMM-104',
        memberName: 'Muhammad Qhoirul Rohimin bin Mohd Faisal',
        memberIcNo: '111130020651',
        memberPhone: '011-11300206',
        photoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocJx4fcx6HAXbPBUxiU47oLOgHRZ1BxM1CgONsYnyI54MwhOXHA=s96-c',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 2',
        targetBengkung: 'Putih 3',
        amountPaid: 60.0,
        paidAt: '2026-10-18 12:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },

      // --- Bengkung Putih Cula 2 (Current: Putih 1 -> Target: Putih 2) ---
      {
        id: 'seed-ub26-07',
        registrationId: 'reg-ub26-07',
        invoiceId: 'inv-ub26-07',
        invoiceNo: 'INV-UB26-007',
        memberId: 'ASMM-113',
        memberName: 'Nur Qurratul Ain bt Shahrizan',
        memberIcNo: '140614020466',
        memberPhone: '014-06140204',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 09:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-08',
        registrationId: 'reg-ub26-08',
        invoiceId: 'inv-ub26-08',
        invoiceNo: 'INV-UB26-008',
        memberId: 'ASMM-115',
        memberName: 'Nur Qaisara Qaleesya bt Shahrizan',
        memberIcNo: '130218020174',
        memberPhone: '013-02180201',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 09:15:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-09',
        registrationId: 'reg-ub26-09',
        invoiceId: 'inv-ub26-09',
        invoiceNo: 'INV-UB26-009',
        memberId: 'ASMM-130',
        memberName: 'Muhammad Wafiq Bin Mohd Noor Hasyidan',
        memberIcNo: '141224031113',
        memberPhone: '014-12240311',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 09:30:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-10',
        registrationId: 'reg-ub26-10',
        invoiceId: 'inv-ub26-10',
        invoiceNo: 'INV-UB26-010',
        memberId: 'ASMM-102',
        memberName: 'Akira Muhammad Bin Muhammad Firdaus',
        memberIcNo: '170323021159',
        memberPhone: '017-03230211',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 10:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-11',
        registrationId: 'reg-ub26-11',
        invoiceId: 'inv-ub26-11',
        invoiceNo: 'INV-UB26-011',
        memberId: 'ASMM-105',
        memberName: 'Yasmin Huda Binti Roslan',
        memberIcNo: '140502070442',
        memberPhone: '014-05020704',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 10:30:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-12',
        registrationId: 'reg-ub26-12',
        invoiceId: 'inv-ub26-12',
        invoiceNo: 'INV-UB26-012',
        memberId: 'ASMM-106',
        memberName: 'Indah Dahlia Binti Roslan',
        memberIcNo: '160202070844',
        memberPhone: '016-02020708',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 11:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-13',
        registrationId: 'reg-ub26-13',
        invoiceId: 'inv-ub26-13',
        invoiceNo: 'INV-UB26-013',
        memberId: 'ASMM-016',
        memberName: 'Ahmad Malik Bin Mohammad Hafiz',
        memberIcNo: '181120025619',
        memberPhone: '018-11200256',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 11:30:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },
      {
        id: 'seed-ub26-14',
        registrationId: 'reg-ub26-14',
        invoiceId: 'inv-ub26-14',
        invoiceNo: 'INV-UB26-014',
        memberId: 'ASMM-014',
        memberName: 'Aisya Humaira Binti Mohammad Hafiz',
        memberIcNo: '161205021110',
        memberPhone: '016-12050211',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Pusaka Warisan',
        currentBengkung: 'Putih 1',
        targetBengkung: 'Putih 2',
        amountPaid: 50.0,
        paidAt: '2026-10-19 12:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      },

      // --- Bengkung Putih Cula 1 (Current: Putih -> Target: Putih 1) ---
      {
        id: 'seed-ub26-15',
        registrationId: 'reg-ub26-15',
        invoiceId: 'inv-ub26-15',
        invoiceNo: 'INV-UB26-015',
        memberId: 'ASMM-131',
        memberName: 'Muhammad Syahmi Bin Mohd Noor Hasyidan',
        memberIcNo: '100215030281',
        memberPhone: '010-02150302',
        photoUrl: '/default-avatar.svg',
        gelanggang: 'Wadi AnNour',
        currentBengkung: 'Putih',
        targetBengkung: 'Putih 1',
        amountPaid: 40.0,
        paidAt: '2026-10-19 14:00:00',
        paymentMethod: 'DuitNow QR FPX',
        statusBayaran: 'Dibayar',
        gradingStatus: 'Belum Dinilai'
      }
    ];

    for (const seed of seedPaidCandidates) {
      const candKey = `${seed.memberId}_${seed.targetBengkung}`.toLowerCase();
      if (!candidatesMap.has(candKey)) {
        // Sync photo or details from members table if available
        const matchedMember = members.find(m => m.id.toLowerCase() === seed.memberId.toLowerCase());
        if (matchedMember?.photoUrl && matchedMember.photoUrl !== '/default-avatar.svg') {
          seed.photoUrl = matchedMember.photoUrl;
        }

        // Match existing assessments if any
        const gradingInfo = resolveCandidateGradingInfo(seed.memberId, seed.targetBengkung, seed.registrationId, assessments);
        seed.gradingStatus = gradingInfo.gradingStatus;
        seed.assessment = gradingInfo.assessment;
        seed.assessments = gradingInfo.assessments;
        results.push(seed);
      }
    }
  }

  // Attach Ujian Bertulis theory exam summaries to all candidates
  try {
    const allUbAttempts = await getUjianBertulisAttemptsDB();
    for (const cand of results) {
      const candAttempts = allUbAttempts.filter(a =>
        (cand.memberId && a.memberId && a.memberId.toLowerCase() === cand.memberId.toLowerCase()) ||
        (cand.memberId && a.userId && a.userId.toLowerCase() === cand.memberId.toLowerCase()) ||
        (cand.memberIcNo && a.userIcNo && a.userIcNo.replace(/\D/g, '') === cand.memberIcNo.replace(/\D/g, ''))
      );
      if (candAttempts.length > 0) {
        let bestScore = 0;
        let bestPercentage = 0;
        let isPassed = false;
        candAttempts.forEach(a => {
          if (a.score > bestScore) bestScore = a.score;
          if (a.percentage > bestPercentage) bestPercentage = a.percentage;
          if (a.isPassed) isPassed = true;
        });
        cand.ujianBertulis = {
          attemptsCount: candAttempts.length,
          bestPercentage,
          bestScore,
          isPassed,
          status: isPassed ? 'Lulus' : (candAttempts.length >= 2 ? 'Mengulang' : 'Belum Mengambil')
        };
      }
    }
  } catch { }

  return results;
}

// --- UJIAN BENGKUNG CUSTOMIZABLE FEES PER LEVEL (SUPERADMIN ONLY) ---
export interface UjianBengkungFeeConfig {
  // Module base fees in RM
  hitam: number;   // Bengkung Hitam (Tunas Pendekar)
  putih: number;   // Bengkung Putih (Pesilat Muda / Kanan / Sulung)
  merah: number;   // Bengkung Merah (Pembantu Jurulatih)
  biru: number;    // Bengkung Biru (Pendekar)
  kuning: number;  // Bengkung Kuning (Jurulatih)
  // Granular override per rank code / dbCode e.g. { 'Hitam 1': 30, 'Putih 1': 45, 'Putih 3': 55 }
  customLevels?: Record<string, number>;
  updatedAt?: string;
  updatedBy?: string;
}

export const DEFAULT_UJIAN_BENGKUNG_FEES: UjianBengkungFeeConfig = {
  hitam: 30.00,
  putih: 50.00,
  merah: 70.00,
  biru: 80.00,
  kuning: 100.00,
  customLevels: {
    'Hitam': 30.00,
    'Hitam 1': 30.00,
    'Hitam 2': 35.00,
    'Hitam 3': 35.00,
    'Putih': 50.00,
    'Putih 1': 50.00,
    'Putih 2': 50.00,
    'Putih 3': 60.00,
    'Merah': 70.00,
    'Merah 1': 70.00,
    'Merah 2': 75.00,
    'Merah 3': 80.00,
    'Biru': 80.00,
    'Kuning': 100.00,
    'Kuning 1': 100.00,
    'Kuning 2': 110.00,
    'Kuning 3': 120.00,
    'Kuning 4': 130.00,
    'Kuning 5': 140.00,
    'Kuning 6': 150.00,
    'Kuning 7': 160.00
  },
  updatedAt: '2026-09-06T00:00:00.000Z',
  updatedBy: 'Sistem Pengurusan ASMM'
};

/**
 * Retrieves the current Ujian Bengkung fees config (falls back to defaults).
 */
export async function getUjianBengkungFeesDB(): Promise<UjianBengkungFeeConfig> {
  initializeDB();
  if (cachedUjianBengkungFeesInMemory) {
    return cachedUjianBengkungFeesInMemory;
  }

  try {
    const res = await executeTursoQuery("SELECT * FROM ujian_bengkung_fees WHERE id = 'default' LIMIT 1;");
    if (res && res.rows && res.rows.length > 0) {
      const row = res.rows[0];
      const customRaw = row.customLevels ?? row[6];
      let customLevels: Record<string, number> = {};
      if (customRaw) {
        try {
          customLevels = typeof customRaw === 'string' ? JSON.parse(customRaw) : customRaw;
        } catch { }
      }

      const config: UjianBengkungFeeConfig = {
        hitam: Number(row.hitam ?? row[1] ?? 30),
        putih: Number(row.putih ?? row[2] ?? 50),
        merah: Number(row.merah ?? row[3] ?? 70),
        kuning: Number(row.kuning ?? row[4] ?? 100),
        biru: Number(row.biru ?? row[5] ?? 80),
        customLevels: {
          ...DEFAULT_UJIAN_BENGKUNG_FEES.customLevels,
          ...customLevels
        },
        updatedAt: String(row.updatedAt ?? row[7] ?? ''),
        updatedBy: String(row.updatedBy ?? row[8] ?? '')
      };

      cachedUjianBengkungFeesInMemory = config;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.UJIAN_BENGKUNG_FEES, JSON.stringify(config));
      }
      return config;
    }
  } catch (err) {
    console.warn('getUjianBengkungFeesDB remote notice:', err);
  }

  if (typeof window !== 'undefined') {
    try {
      const raw = localStorage.getItem(KEYS.UJIAN_BENGKUNG_FEES);
      if (raw) {
        const parsed = JSON.parse(raw);
        const merged = {
          ...DEFAULT_UJIAN_BENGKUNG_FEES,
          ...parsed,
          customLevels: {
            ...DEFAULT_UJIAN_BENGKUNG_FEES.customLevels,
            ...(parsed.customLevels || {})
          }
        };
        cachedUjianBengkungFeesInMemory = merged;
        return merged;
      }
    } catch { }
  }

  cachedUjianBengkungFeesInMemory = DEFAULT_UJIAN_BENGKUNG_FEES;
  return DEFAULT_UJIAN_BENGKUNG_FEES;
}

/**
 * Saves updated Ujian Bengkung fee configurations (Superadmin authorized).
 */
export async function saveUjianBengkungFeesDB(config: UjianBengkungFeeConfig, updatedByName?: string): Promise<void> {
  initializeDB();
  const updated: UjianBengkungFeeConfig = {
    ...config,
    updatedAt: new Date().toISOString(),
    updatedBy: updatedByName || config.updatedBy || 'Superadmin'
  };

  cachedUjianBengkungFeesInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_BENGKUNG_FEES, JSON.stringify(updated));
  }

  try {
    await executeTursoQuery(
      `INSERT OR REPLACE INTO ujian_bengkung_fees (id, hitam, putih, merah, kuning, biru, customLevels, updatedAt, updatedBy) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?);`,
      [
        'default',
        updated.hitam,
        updated.putih,
        updated.merah,
        updated.kuning,
        updated.biru,
        JSON.stringify(updated.customLevels || {}),
        updated.updatedAt,
        updated.updatedBy
      ]
    );
  } catch (err) {
    console.warn('saveUjianBengkungFeesDB remote sync notice:', err);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

/**
 * Helper to resolve the fee (RM) for any given target bengkung level string based on its module.
 */
export function getUjianBengkungFeeForLevel(targetBengkung: string, config?: UjianBengkungFeeConfig): number {
  const cfg = config || DEFAULT_UJIAN_BENGKUNG_FEES;
  if (!targetBengkung) return Number(cfg.putih ?? 50.00);

  // 1. Check customLevels override first (exact match or stripped "bengkung" prefix)
  if (cfg.customLevels && typeof cfg.customLevels === 'object') {
    if (cfg.customLevels[targetBengkung] !== undefined) {
      return Number(cfg.customLevels[targetBengkung]);
    }
    const stripped = targetBengkung.replace(/^bengkung\s+/i, '').trim();
    if (cfg.customLevels[stripped] !== undefined) {
      return Number(cfg.customLevels[stripped]);
    }
  }

  const norm = targetBengkung.toLowerCase().trim();

  // Guru Utama is a title for Pengerusi, not obtainable through ujian
  if (norm.includes('guru')) return 0;

  // Price differs by module only
  if (norm.includes('hitam')) return Number(cfg.hitam ?? 30.00);
  if (norm.includes('putih')) return Number(cfg.putih ?? 50.00);
  if (norm.includes('merah')) return Number(cfg.merah ?? 70.00);
  if (norm.includes('kuning')) return Number(cfg.kuning ?? 100.00);
  if (norm.includes('biru')) return Number(cfg.biru ?? 80.00);

  return Number(cfg.putih ?? 50.00);
}

/**
 * In-memory cache for bengkung ranks
 */
let cachedBengkungRanksInMemory: BengkungRankInfo[] | null = null;

/**
 * Retrieves the official / custom Bengkung ranks list from aaPanel MySQL / Turso DB,
 * falling back to localStorage and official ASMM standards.
 */
export async function getBengkungRanksDB(): Promise<BengkungRankInfo[]> {
  initializeDB();
  if (cachedBengkungRanksInMemory && cachedBengkungRanksInMemory.length > 0) {
    return cachedBengkungRanksInMemory;
  }

  try {
    const res = await executeTursoQuery(
      'SELECT id, code, dbCode, bengkungName, rankTitle, module, culaCount, beltBgClass, culaBgClass, textColorClass, sortOrder FROM bengkung_ranks ORDER BY sortOrder ASC;'
    );

    if (res && Array.isArray(res.rows) && res.rows.length > 0) {
      let hasChanges = false;
      const ranks: BengkungRankInfo[] = res.rows.map((row: any, idx: number) => {
        let code = String(row.code ?? row[1] ?? '');
        const dbCode = String(row.dbCode ?? row[2] ?? '');
        const def = ASMM_BENGKUNG_RANKS.find(d => d.code === code || d.dbCode === dbCode);
        let rankTitle = String(row.rankTitle ?? row[4] ?? def?.rankTitle ?? '');

        // Normalize Kuning rankings:
        // Kuning 0 (Jurulatih), Kuning 1-3 (Jurulatih Muda), Kuning 4-6 (Jurulatih Kanan), Kuning 7 (Jurulatih Sulung)
        const normDb = dbCode.toLowerCase();
        const normCode = code.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (normDb === 'kuning0' || normCode === 'kuning' || normCode === 'kuning0') {
          if (code !== 'Kuning 0' || rankTitle !== 'Jurulatih') {
            code = 'Kuning 0';
            rankTitle = 'Jurulatih';
            hasChanges = true;
          }
        } else if (normDb === 'kuning1' || normDb === 'kuning2' || normDb === 'kuning3') {
          if (rankTitle !== 'Jurulatih Muda') {
            rankTitle = 'Jurulatih Muda';
            hasChanges = true;
          }
        } else if (normDb === 'kuning4' || normDb === 'kuning5' || normDb === 'kuning6') {
          if (rankTitle !== 'Jurulatih Kanan') {
            rankTitle = 'Jurulatih Kanan';
            hasChanges = true;
          }
        } else if (normDb === 'kuning7') {
          if (rankTitle !== 'Jurulatih Sulung') {
            rankTitle = 'Jurulatih Sulung';
            hasChanges = true;
          }
        }

        return {
          code: code || def?.code || '',
          dbCode: dbCode || def?.dbCode || '',
          bengkungName: String(row.bengkungName ?? row[3] ?? def?.bengkungName ?? ''),
          rankTitle,
          module: String(row.module ?? row[5] ?? def?.module ?? ''),
          culaCount: Number(row.culaCount ?? row[6] ?? def?.culaCount ?? 0),
          beltBgClass: String(row.beltBgClass ?? row[7] ?? def?.beltBgClass ?? ''),
          culaBgClass: String(row.culaBgClass ?? row[8] ?? def?.culaBgClass ?? ''),
          textColorClass: String(row.textColorClass ?? row[9] ?? def?.textColorClass ?? ''),
          sortOrder: Number(row.sortOrder ?? row[10] ?? idx + 1)
        };
      });

      cachedBengkungRanksInMemory = ranks;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.BENGKUNG_RANKS, JSON.stringify(ranks));
      }

      if (hasChanges) {
        saveBengkungRanksDB(ranks).catch(e => console.warn('Sync updated ranks to DB:', e));
      }

      return ranks;
    }
  } catch (err) {
    console.warn('getBengkungRanksDB remote query notice:', err);
  }

  // Fallback to local storage or official ASMM standard ranks
  const fallback = getCustomBengkungRanks();
  cachedBengkungRanksInMemory = fallback;
  return fallback;
}

/**
 * Saves customized Bengkung ranks (names, rank titles, ordering) into aaPanel MySQL DB and local storage.
 */
export async function saveBengkungRanksDB(ranks: BengkungRankInfo[], _updatedByName?: string): Promise<void> {
  initializeDB();
  cachedBengkungRanksInMemory = [...ranks];
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.BENGKUNG_RANKS, JSON.stringify(ranks));
  }

  try {
    // 1. Build replace/insert statements for all ranks preserving exact sortOrder
    const statements: Array<{ sql: string; args: any[] }> = ranks.map((r, idx) => {
      const id = r.dbCode || r.code.toLowerCase().replace(/[^a-z0-9]/g, '_');
      const sortOrder = idx + 1;
      return {
        sql: `INSERT OR REPLACE INTO bengkung_ranks (id, code, dbCode, bengkungName, rankTitle, module, culaCount, beltBgClass, culaBgClass, textColorClass, sortOrder, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
        args: [
          id,
          r.code,
          r.dbCode || id,
          r.bengkungName,
          r.rankTitle,
          r.module,
          r.culaCount ?? 0,
          r.beltBgClass || '',
          r.culaBgClass || '',
          r.textColorClass || '',
          sortOrder,
          new Date().toISOString()
        ]
      };
    });

    // 2. Delete any ranks that were removed from the active list
    const activeIds = ranks.map(r => r.dbCode || r.code.toLowerCase().replace(/[^a-z0-9]/g, '_'));
    if (activeIds.length > 0) {
      const placeholders = activeIds.map(() => '?').join(', ');
      statements.push({
        sql: `DELETE FROM bengkung_ranks WHERE id NOT IN (${placeholders});`,
        args: activeIds
      });
    }

    await executeTursoBatch(statements);
  } catch (err) {
    console.warn('saveBengkungRanksDB remote sync notice:', err);
  }
}

/**
 * Resets customized Bengkung ranks back to the official ASMM standard in aaPanel MySQL DB and local storage.
 */
export async function resetBengkungRanksDB(_updatedByName?: string): Promise<BengkungRankInfo[]> {
  initializeDB();
  cachedBengkungRanksInMemory = [...ASMM_BENGKUNG_RANKS];
  if (typeof window !== 'undefined') {
    localStorage.removeItem(KEYS.BENGKUNG_RANKS);
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: 'DELETE FROM bengkung_ranks;', args: [] },
      ...ASMM_BENGKUNG_RANKS.map((r, idx) => {
        const id = r.dbCode || r.code.toLowerCase().replace(/[^a-z0-9]/g, '_');
        const sortOrder = idx + 1;
        return {
          sql: `INSERT OR REPLACE INTO bengkung_ranks (id, code, dbCode, bengkungName, rankTitle, module, culaCount, beltBgClass, culaBgClass, textColorClass, sortOrder, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
          args: [
            id,
            r.code,
            r.dbCode || id,
            r.bengkungName,
            r.rankTitle,
            r.module,
            r.culaCount ?? 0,
            r.beltBgClass || '',
            r.culaBgClass || '',
            r.textColorClass || '',
            sortOrder,
            new Date().toISOString()
          ]
        };
      })
    ];

    await executeTursoBatch(statements);
  } catch (err) {
    console.warn('resetBengkungRanksDB remote sync notice:', err);
  }

  return [...ASMM_BENGKUNG_RANKS];
}


// ==========================================
// MEMBER AVAILABILITY (Ketersediaan Ahli)
// ==========================================

/**
 * Retrieves all availability entries for a given gelanggang and month.
 * @param gelanggang - Gelanggang name to filter by
 * @param monthPrefix - 'YYYY-MM' prefix to filter dates
 */
export async function getAvailabilityDB(gelanggang: string, monthPrefix?: string): Promise<AvailabilityEntry[]> {
  initializeDB();
  let all: AvailabilityEntry[] = [];

  if (cachedAvailabilityInMemory && cachedAvailabilityInMemory.length > 0) {
    all = cachedAvailabilityInMemory;
    if (shouldRefreshFromTurso('availability') && !_inflightRefresh['availability']) {
      _inflightRefresh['availability'] = refreshAvailabilityFromTurso()
        .finally(() => { _inflightRefresh['availability'] = null; });
    }
  } else {
    all = await refreshAvailabilityFromTurso();
  }

  return all.filter(e => {
    if (e.gelanggang !== gelanggang) return false;
    if (monthPrefix && !e.date.startsWith(monthPrefix)) return false;
    return true;
  });
}

async function refreshAvailabilityFromTurso(): Promise<AvailabilityEntry[]> {
  try {
    const res = await executeTursoQuery("SELECT id, userId, userName, gelanggang, date, timeSlots, updatedAt FROM availability;");
    if (res && res.rows && Array.isArray(res.rows)) {
      const all: AvailabilityEntry[] = res.rows.map((row: any) => ({
        id: String(row.id ?? row[0]),
        userId: String(row.userId ?? row[1]),
        userName: String(row.userName ?? row[2]),
        gelanggang: String(row.gelanggang ?? row[3]) as Gelanggang,
        date: String(row.date ?? row[4]),
        timeSlots: (() => {
          const rawSlots = row.timeSlots ?? row[5];
          if (!rawSlots) return [];
          try {
            return typeof rawSlots === 'string' ? JSON.parse(rawSlots) : rawSlots;
          } catch {
            return [];
          }
        })(),
        updatedAt: String(row.updatedAt ?? row[6] ?? '')
      }));

      cachedAvailabilityInMemory = all;
      markTursoFetched('availability');
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.AVAILABILITY, JSON.stringify(all));
      }
      return all;
    }
  } catch (err) {
    console.warn('refreshAvailabilityFromTurso remote query notice:', err);
  }

  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.AVAILABILITY);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          cachedAvailabilityInMemory = parsed;
          return parsed;
        }
      } catch { }
    }
  }

  cachedAvailabilityInMemory = [];
  return [];
}

/**
 * Saves (upserts) an availability entry into MySQL aaPanel and local cache.
 */
export async function saveAvailabilityDB(entry: AvailabilityEntry): Promise<AvailabilityEntry[]> {
  initializeDB();
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.AVAILABILITY) : null;
  let all: AvailabilityEntry[] = [];
  try {
    all = cachedAvailabilityInMemory || (raw ? JSON.parse(raw) : []);
  } catch {
    all = [];
  }
  const idx = all.findIndex(e => e.id === entry.id);
  if (idx >= 0) {
    all[idx] = entry;
  } else {
    all.push(entry);
  }
  cachedAvailabilityInMemory = all;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.AVAILABILITY, JSON.stringify(all));
  }

  try {
    await executeTursoQuery(
      `INSERT OR REPLACE INTO availability (id, userId, userName, gelanggang, date, timeSlots, updatedAt) VALUES (?, ?, ?, ?, ?, ?, ?);`,
      [
        entry.id,
        entry.userId,
        entry.userName,
        entry.gelanggang,
        entry.date,
        JSON.stringify(entry.timeSlots || []),
        entry.updatedAt || new Date().toISOString()
      ]
    );
  } catch (err) {
    console.warn('saveAvailabilityDB remote notice:', err);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
  return all.filter(e => e.gelanggang === entry.gelanggang);
}

/**
 * Deletes an availability entry by id from MySQL aaPanel and local cache.
 */
export async function deleteAvailabilityDB(id: string): Promise<void> {
  initializeDB();
  const raw = typeof window !== 'undefined' ? localStorage.getItem(KEYS.AVAILABILITY) : null;
  let all: AvailabilityEntry[] = [];
  try {
    all = cachedAvailabilityInMemory || (raw ? JSON.parse(raw) : []);
  } catch { }
  all = all.filter(e => e.id !== id);
  cachedAvailabilityInMemory = all;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.AVAILABILITY, JSON.stringify(all));
  }

  try {
    await executeTursoQuery(`DELETE FROM availability WHERE id = ?;`, [id]);
  } catch (err) {
    console.warn('deleteAvailabilityDB remote notice:', err);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

// ==========================================
// ROLES & PERMISSIONS DATABASE OPERATIONS
// ==========================================

export const DEFAULT_SYSTEM_ROLES: RoleItem[] = [
  { id: 'pengerusi', name: 'Pengerusi', category: 'Majlis Tertinggi', description: 'Ketua Utama & Pentadbir Tertinggi Pertubuhan ASMM', isSystem: true, sortOrder: 1 },
  { id: 'timbalan-pengerusi', name: 'Timbalan Pengerusi', category: 'Majlis Tertinggi', description: 'Timbalan Pentadbir Tertinggi Pertubuhan ASMM', isSystem: true, sortOrder: 2 },
  { id: 'setiausaha', name: 'Setiausaha', category: 'Majlis Tertinggi', description: 'Ketua Urusetia Pentadbiran & Pendaftaran Pertubuhan', isSystem: true, sortOrder: 3 },
  { id: 'pen-setiausaha', name: 'Pen. Setiausaha', category: 'Majlis Tertinggi', description: 'Penolong Urusetia Pentadbiran & Surat-Menyurat', isSystem: true, sortOrder: 4 },
  { id: 'bendahari', name: 'Bendahari', category: 'Majlis Tertinggi', description: 'Ketua Pengurusan Kewangan & Akaun Berkanun ASMM', isSystem: true, sortOrder: 5 },
  { id: 'ketua-gelanggang', name: 'Ketua Gelanggang', category: 'Pengurusan Gelanggang', description: 'Pengurus Operasi Sesi Latihan Gelanggang & Kutipan Yuran', isSystem: true, sortOrder: 6 },
  { id: 'ajk', name: 'AJK', category: 'Jawatankuasa & Biro', description: 'Ahli Jawatankuasa Kerja Pentadbiran Pertubuhan', isSystem: true, sortOrder: 7 },
  { id: 'pemeriksa-kira-kira', name: 'Pemeriksa Kira-Kira', category: 'Jawatankuasa & Biro', description: 'Juruaudit Bebas Dalaman Kewangan Berkanun ROS', isSystem: true, sortOrder: 8 },
  { id: 'biro-latihan', name: 'Ketua Biro Latihan & Dakwah', category: 'Jawatankuasa & Biro', description: 'Pengarah Silibus Latihan, Kerohanian & Dakwah', isSystem: true, sortOrder: 9 },
  { id: 'biro-kebajikan', name: 'Ketua Biro Sosial & Kebajikan', category: 'Jawatankuasa & Biro', description: 'Pengurus Hal Ehwal Kebajikan Ahli & Bantuan Khas', isSystem: true, sortOrder: 10 },
  { id: 'biro-sukan', name: 'Ketua Biro Keusahawanan & Sukan', category: 'Jawatankuasa & Biro', description: 'Pengurus Program Keusahawanan & Kejohanan Silat', isSystem: true, sortOrder: 11 },
  { id: 'biro-media', name: 'Ketua Biro Media & Penerangan', category: 'Jawatankuasa & Biro', description: 'Pegawai Publisiti, Hebahan Rasmi & Media Sosial', isSystem: true, sortOrder: 12 },
  { id: 'guru-utama', name: 'Guru Utama', category: 'Kejurulatihan', description: 'Pewaris Keilmuan & Guru Tertinggi Silat Awang Sulung', isSystem: true, sortOrder: 13 },
  { id: 'jurulatih-kanan', name: 'Jurulatih Kanan', category: 'Kejurulatihan', description: 'Tenaga Pengajar Kanan Kursus & Pengujian Bengkung', isSystem: true, sortOrder: 14 },
  { id: 'jurulatih-muda', name: 'Jurulatih Muda', category: 'Kejurulatihan', description: 'Pembantu Jurulatih & Tenaga Latihan Gelanggang', isSystem: true, sortOrder: 15 },
  { id: 'ahli', name: 'Ahli', category: 'Keahlian Am', description: 'Pesilat Berdaftar Aktif PSSASMM', isSystem: true, sortOrder: 16 },
  { id: 'waris', name: 'Waris', category: 'Keahlian Am', description: 'Ibu Bapa / Penjaga Pesilat Kanak-Kanak', isSystem: true, sortOrder: 17 },
];

export const DEFAULT_SYSTEM_PERMISSIONS: PermissionItem[] = [
  { key: 'kelulusan_ahli', name: 'Kelulusan Ahli Baharu', module: 'Pendaftaran & Ahli', description: 'Menyemak, meluluskan, atau menolak permohonan pesilat baharu.', isSystem: true, sortOrder: 1 },
  { key: 'roles_management', name: 'Roles & Permission Management', module: 'Tadbir Urus', description: 'Mengurus peranan jawatan, definisi, dan hak capaian kebenaran sistem.', isSystem: true, sortOrder: 2 },
  { key: 'ahli_crud', name: 'Daftar & Edit Rekod Ahli', module: 'Pendaftaran & Ahli', description: 'Menambah maklumat pesilat baharu dan menyunting data peribadi ahli.', isSystem: true, sortOrder: 3 },
  { key: 'kewangan_audit', name: 'Laporan Kewangan & Audit', module: 'Kewangan & Audit', description: 'Melihat buku tunai rasmi, penyata bank, dan rekod juruaudit ROS.', isSystem: true, sortOrder: 4 },
  { key: 'pengurusan_geran', name: 'Pengurusan Geran & Elaun', module: 'Kewangan & Audit', description: 'Memohon geran pertubuhan dan mengagihkan elaun jurulatih.', isSystem: true, sortOrder: 5 },
  { key: 'tetapan_gelanggang', name: 'Tetapan Sesi & Pakej Gelanggang', module: 'Pusat Gelanggang', description: 'Menetapkan jadual latihan, koordinat GPS, dan pakej yuran bulanan.', isSystem: true, sortOrder: 6 },
  { key: 'notis_acara', name: 'Cipta & Edar Pengumuman', module: 'Komunikasi', description: 'Mencipta notis mesyuarat, hebahan latihan, dan borang RSVP.', isSystem: true, sortOrder: 7 },
  { key: 'inventori_aset', name: 'Inventori Aset & Sewaan', module: 'Logistik & Aset', description: 'Perekodan peralatan silat, persalinan tanjak, dan sewaan alatan.', isSystem: true, sortOrder: 8 },
  { key: 'pengurusan_silibus', name: 'Pengurusan Kurikulum Silibus', module: 'Latihan & Silibus', description: 'Mengurus video kurikulum silat dan syarat kelayakan ujian bengkung.', isSystem: true, sortOrder: 9 },
  { key: 'pengurusan_tabung', name: 'Tabung & Kutipan Infaq', module: 'Kebajikan & Infaq', description: 'Mewujudkan kempen sumbangan derma kilat dan bantuan kecemasan.', isSystem: true, sortOrder: 10 },
  { key: 'pelepasan_yuran_bulanan', name: 'Pelepasan Yuran Keahlian Bulanan', module: 'Kewangan & Yuran', description: 'Pengecualian / pelepasan bayaran yuran bulanan gelanggang bagi pemegang peranan ini.', isSystem: true, sortOrder: 11 },
  { key: 'pelepasan_yuran_tahunan', name: 'Pelepasan Yuran Keahlian Tahunan', module: 'Kewangan & Yuran', description: 'Pengecualian / pelepasan bayaran yuran tahunan persatuan bagi pemegang peranan ini.', isSystem: true, sortOrder: 12 },
];

export const DEFAULT_SYSTEM_ROLE_PERMS: Record<string, string[]> = {
  'Pengerusi': ['kelulusan_ahli', 'roles_management', 'ahli_crud', 'kewangan_audit', 'pengurusan_geran', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset', 'pengurusan_silibus', 'pengurusan_tabung', 'pelepasan_yuran_bulanan', 'pelepasan_yuran_tahunan'],
  'Timbalan Pengerusi': ['kelulusan_ahli', 'roles_management', 'ahli_crud', 'kewangan_audit', 'pengurusan_geran', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset', 'pengurusan_silibus', 'pengurusan_tabung', 'pelepasan_yuran_bulanan', 'pelepasan_yuran_tahunan'],
  'Setiausaha': ['kelulusan_ahli', 'roles_management', 'ahli_crud', 'kewangan_audit', 'pengurusan_geran', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset', 'pengurusan_silibus', 'pengurusan_tabung'],
  'Pen. Setiausaha': ['kelulusan_ahli', 'ahli_crud', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset'],
  'Bendahari': ['kelulusan_ahli', 'ahli_crud', 'kewangan_audit', 'pengurusan_geran', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset', 'pengurusan_tabung'],
  'Ketua Gelanggang': ['kelulusan_ahli', 'ahli_crud', 'tetapan_gelanggang', 'notis_acara', 'inventori_aset', 'pengurusan_silibus'],
  'AJK': ['kelulusan_ahli', 'notis_acara', 'inventori_aset', 'pengurusan_geran', 'pengurusan_tabung'],
  'Pemeriksa Kira-Kira': ['kewangan_audit'],
  'Ketua Biro Latihan & Dakwah': ['notis_acara', 'pengurusan_silibus'],
  'Ketua Biro Sosial & Kebajikan': ['notis_acara', 'pengurusan_tabung'],
  'Ketua Biro Keusahawanan & Sukan': ['notis_acara', 'inventori_aset'],
  'Ketua Biro Media & Penerangan': ['notis_acara'],
  'Guru Utama': ['kelulusan_ahli', 'pengurusan_silibus', 'pelepasan_yuran_bulanan', 'pelepasan_yuran_tahunan'],
  'Jurulatih Kanan': ['kelulusan_ahli', 'pengurusan_silibus', 'pelepasan_yuran_bulanan', 'pelepasan_yuran_tahunan'],
  'Jurulatih Muda': ['pengurusan_silibus'],
  'Ahli': [],
  'Waris': [],
};

/**
 * Retrieves all defined roles directly from aaPanel MySQL DB (Live, no localStorage).
 */
export async function getSystemRolesDB(forceLive: boolean = true): Promise<RoleItem[]> {
  initializeDB();
  if (!forceLive && cachedRolesInMemory && cachedRolesInMemory.length > 0) {
    return cachedRolesInMemory;
  }

  try {
    const res = await executeTursoQuery('SELECT id, name, category, description, isSystem, sortOrder FROM roles ORDER BY sortOrder ASC, name ASC;');
    if (res && res.rows && res.rows.length > 0) {
      const roles: RoleItem[] = res.rows.map((row: any, idx: number) => ({
        id: String(row.id ?? row[0]),
        name: String(row.name ?? row[1]),
        category: (row.category ?? row[2]) as RoleItem['category'],
        description: String(row.description ?? row[3] ?? ''),
        isSystem: Boolean(Number(row.isSystem ?? row[4] ?? 0)),
        sortOrder: Number(row.sortOrder ?? row[5] ?? idx + 1)
      }));

      cachedRolesInMemory = roles;
      return roles;
    }
  } catch (err) {
    console.warn('getSystemRolesDB remote query notice:', err);
  }

  if (cachedRolesInMemory && cachedRolesInMemory.length > 0) {
    return cachedRolesInMemory;
  }

  return [...DEFAULT_SYSTEM_ROLES];
}

/**
 * Saves defined roles directly into aaPanel MySQL DB (Live, no localStorage).
 */
export async function saveSystemRolesDB(roles: RoleItem[]): Promise<boolean> {
  initializeDB();
  cachedRolesInMemory = [...roles];

  try {
    const activeIds = roles.map(r => r.id);
    const statements: Array<{ sql: string; args: any[] }> = [];

    // Delete any roles that were removed
    if (activeIds.length > 0) {
      const placeholders = activeIds.map(() => '?').join(', ');
      statements.push({
        sql: `DELETE FROM roles WHERE id NOT IN (${placeholders});`,
        args: activeIds
      });
    }

    // Insert or replace roles with MySQL compatible REPLACE INTO syntax (without invalid timestamp strings)
    for (let idx = 0; idx < roles.length; idx++) {
      const r = roles[idx];
      statements.push({
        sql: `REPLACE INTO roles (id, name, category, description, isSystem, sortOrder) VALUES (?, ?, ?, ?, ?, ?);`,
        args: [
          r.id,
          r.name,
          r.category,
          r.description || '',
          r.isSystem ? 1 : 0,
          r.sortOrder ?? (idx + 1)
        ]
      });
    }

    const res = await executeTursoBatch(statements);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('asmm_roles_updated'));
      window.dispatchEvent(new Event('asmm_db_updated'));
    }
    return !!res;
  } catch (err) {
    console.warn('saveSystemRolesDB remote sync notice:', err);
    return false;
  }
}

/**
 * Deletes a single role by id directly from aaPanel MySQL DB (Live, no localStorage).
 */
export async function deleteSystemRoleDB(roleId: string, roleName?: string): Promise<boolean> {
  initializeDB();
  if (cachedRolesInMemory) {
    cachedRolesInMemory = cachedRolesInMemory.filter(r => r.id !== roleId);
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: `DELETE FROM roles WHERE id = ?;`, args: [roleId] }
    ];
    if (roleName) {
      statements.push({ sql: `DELETE FROM role_permissions WHERE roleName = ?;`, args: [roleName] });
    }
    const res = await executeTursoBatch(statements);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('asmm_roles_updated'));
      window.dispatchEvent(new Event('asmm_db_updated'));
    }
    return !!res;
  } catch (err) {
    console.warn('deleteSystemRoleDB remote sync notice:', err);
    return false;
  }
}

/**
 * Retrieves all defined permissions directly from aaPanel MySQL DB (Live, no localStorage).
 */
export async function getPermissionsDB(forceLive: boolean = true): Promise<PermissionItem[]> {
  initializeDB();
  if (!forceLive && cachedPermissionsInMemory && cachedPermissionsInMemory.length > 0) {
    return cachedPermissionsInMemory;
  }

  try {
    const res = await executeTursoQuery('SELECT permKey, name, module, description, isSystem, sortOrder FROM permissions ORDER BY sortOrder ASC, permKey ASC;');
    if (res && res.rows && res.rows.length > 0) {
      const perms: PermissionItem[] = res.rows.map((row: any, idx: number) => ({
        key: String(row.permKey ?? row.key ?? row[0]),
        name: String(row.name ?? row[1]),
        module: String(row.module ?? row[2]),
        description: String(row.description ?? row[3] ?? ''),
        isSystem: Boolean(Number(row.isSystem ?? row[4] ?? 0)),
        sortOrder: Number(row.sortOrder ?? row[5] ?? idx + 1)
      }));

      // Ensure all system permissions from DEFAULT_SYSTEM_PERMISSIONS are present
      let hasMissing = false;
      const existingKeys = new Set(perms.map(p => p.key));
      for (const def of DEFAULT_SYSTEM_PERMISSIONS) {
        if (!existingKeys.has(def.key)) {
          perms.push(def);
          hasMissing = true;
        }
      }

      if (hasMissing) {
        savePermissionsDB(perms).catch(e => console.warn('Sync missing default permissions err:', e));
      }

      cachedPermissionsInMemory = perms;
      return perms;
    }
  } catch (err) {
    console.warn('getPermissionsDB remote query notice:', err);
  }

  if (cachedPermissionsInMemory && cachedPermissionsInMemory.length > 0) {
    return cachedPermissionsInMemory;
  }

  return [...DEFAULT_SYSTEM_PERMISSIONS];
}

/**
 * Saves defined permissions directly into aaPanel MySQL DB (Live, no localStorage).
 */
export async function savePermissionsDB(permissions: PermissionItem[]): Promise<boolean> {
  initializeDB();
  cachedPermissionsInMemory = [...permissions];

  try {
    const activeKeys = permissions.map(p => p.key);
    const statements: Array<{ sql: string; args: any[] }> = [];

    // Delete any permissions that were removed
    if (activeKeys.length > 0) {
      const placeholders = activeKeys.map(() => '?').join(', ');
      statements.push({
        sql: `DELETE FROM permissions WHERE permKey NOT IN (${placeholders});`,
        args: activeKeys
      });
      statements.push({
        sql: `DELETE FROM role_permissions WHERE permKey NOT IN (${placeholders});`,
        args: activeKeys
      });
    }

    for (let idx = 0; idx < permissions.length; idx++) {
      const p = permissions[idx];
      statements.push({
        sql: `REPLACE INTO permissions (permKey, name, module, description, isSystem, sortOrder) VALUES (?, ?, ?, ?, ?, ?);`,
        args: [
          p.key,
          p.name,
          p.module,
          p.description || '',
          p.isSystem ? 1 : 0,
          p.sortOrder ?? (idx + 1)
        ]
      });
    }

    const res = await executeTursoBatch(statements);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('asmm_permissions_updated'));
      window.dispatchEvent(new Event('asmm_db_updated'));
    }
    return !!res;
  } catch (err) {
    console.warn('savePermissionsDB remote sync notice:', err);
    return false;
  }
}

/**
 * Deletes a permission by key directly from aaPanel MySQL DB (Live, no localStorage).
 */
export async function deletePermissionDB(permKey: string): Promise<boolean> {
  initializeDB();
  if (cachedPermissionsInMemory) {
    cachedPermissionsInMemory = cachedPermissionsInMemory.filter(p => p.key !== permKey);
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: `DELETE FROM permissions WHERE permKey = ?;`, args: [permKey] },
      { sql: `DELETE FROM role_permissions WHERE permKey = ?;`, args: [permKey] }
    ];
    const res = await executeTursoBatch(statements);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('asmm_permissions_updated'));
      window.dispatchEvent(new Event('asmm_db_updated'));
    }
    return !!res;
  } catch (err) {
    console.warn('deletePermissionDB remote sync notice:', err);
    return false;
  }
}

/**
 * Retrieves the matrix of role to permission keys mapping directly from aaPanel MySQL DB (Live, no localStorage).
 */
export async function getRolePermissionsMapDB(forceLive: boolean = true): Promise<Record<string, string[]>> {
  initializeDB();
  if (!forceLive && cachedRolePermsMapInMemory && Object.keys(cachedRolePermsMapInMemory).length > 0) {
    return cachedRolePermsMapInMemory;
  }

  try {
    const res = await executeTursoQuery('SELECT roleName, permKey FROM role_permissions;');
    if (res && res.rows && res.rows.length > 0) {
      const mapping: Record<string, string[]> = {};
      for (const row of res.rows) {
        const rName = String(row.roleName ?? row[0] ?? row[1]);
        const pKey = String(row.permKey ?? row[1] ?? row[2]);
        if (!rName || !pKey) continue;
        if (!mapping[rName]) mapping[rName] = [];
        if (!mapping[rName].includes(pKey)) {
          mapping[rName].push(pKey);
        }
      }

      cachedRolePermsMapInMemory = mapping;
      return mapping;
    }
  } catch (err) {
    console.warn('getRolePermissionsMapDB remote query notice:', err);
  }

  if (cachedRolePermsMapInMemory && Object.keys(cachedRolePermsMapInMemory).length > 0) {
    return cachedRolePermsMapInMemory;
  }

  return { ...DEFAULT_SYSTEM_ROLE_PERMS };
}

/**
 * Toggles a single permission for a role directly in aaPanel MySQL DB (Live, atomic).
 */
export async function toggleRolePermissionDB(roleName: string, permKey: string, granted: boolean): Promise<boolean> {
  initializeDB();
  if (!cachedRolePermsMapInMemory) cachedRolePermsMapInMemory = {};
  const current = cachedRolePermsMapInMemory[roleName] || [];
  if (granted) {
    if (!current.includes(permKey)) cachedRolePermsMapInMemory[roleName] = [...current, permKey];
  } else {
    cachedRolePermsMapInMemory[roleName] = current.filter(k => k !== permKey);
  }

  try {
    let success = false;
    if (granted) {
      // Execute atomically in a single batch
      const res = await executeTursoBatch([
        { sql: 'DELETE FROM role_permissions WHERE roleName = ? AND permKey = ?;', args: [roleName, permKey] },
        { sql: 'INSERT INTO role_permissions (roleName, permKey) VALUES (?, ?);', args: [roleName, permKey] }
      ]);
      success = !!res;
    } else {
      const res = await executeTursoQuery('DELETE FROM role_permissions WHERE roleName = ? AND permKey = ?;', [roleName, permKey]);
      success = !!res;
    }

    if (success && typeof window !== 'undefined') {
      window.dispatchEvent(new Event('asmm_permissions_updated'));
    }
    return success;
  } catch (err) {
    console.warn('toggleRolePermissionDB remote notice:', err);
    return false;
  }
}

/**
 * Sets all permissions for a specific role directly in aaPanel MySQL DB (Live).
 */
export async function setRolePermissionsForRoleDB(roleName: string, permKeys: string[]): Promise<boolean> {
  initializeDB();
  if (!cachedRolePermsMapInMemory) cachedRolePermsMapInMemory = {};
  cachedRolePermsMapInMemory[roleName] = [...permKeys];

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_permissions_updated'));
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: 'DELETE FROM role_permissions WHERE roleName = ?;', args: [roleName] }
    ];
    for (const pKey of permKeys) {
      statements.push({
        sql: 'INSERT INTO role_permissions (roleName, permKey) VALUES (?, ?);',
        args: [roleName, pKey]
      });
    }
    const res = await executeTursoBatch(statements);
    return !!res;
  } catch (err) {
    console.warn('setRolePermissionsForRoleDB remote notice:', err);
    return false;
  }
}

/**
 * Saves the entire role-to-permission mappings into aaPanel MySQL DB (Live, no localStorage).
 */
export async function saveRolePermissionsMapDB(mapping: Record<string, string[]>): Promise<boolean> {
  initializeDB();
  cachedRolePermsMapInMemory = { ...mapping };
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_permissions_updated'));
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: 'DELETE FROM role_permissions;', args: [] }
    ];

    for (const [roleName, perms] of Object.entries(mapping)) {
      for (const pKey of perms) {
        statements.push({
          sql: 'INSERT INTO role_permissions (roleName, permKey) VALUES (?, ?);',
          args: [roleName, pKey]
        });
      }
    }

    const res = await executeTursoBatch(statements);
    return !!res;
  } catch (err) {
    console.warn('saveRolePermissionsMapDB remote sync notice:', err);
    return false;
  }
}

/**
 * Resets all roles, permissions, and mappings back to official ASMM defaults in aaPanel MySQL DB upon explicit Superadmin request.
 */
export async function resetRolesAndPermissionsDB(): Promise<{
  roles: RoleItem[];
  permissions: PermissionItem[];
  rolePermsMap: Record<string, string[]>;
}> {
  initializeDB();
  cachedRolesInMemory = [...DEFAULT_SYSTEM_ROLES];
  cachedPermissionsInMemory = [...DEFAULT_SYSTEM_PERMISSIONS];
  cachedRolePermsMapInMemory = { ...DEFAULT_SYSTEM_ROLE_PERMS };

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('asmm_roles_updated'));
    window.dispatchEvent(new Event('asmm_permissions_updated'));
    window.dispatchEvent(new Event('asmm_db_updated'));
  }

  try {
    const statements: Array<{ sql: string; args: any[] }> = [
      { sql: 'DELETE FROM role_permissions;', args: [] },
      { sql: 'DELETE FROM permissions;', args: [] },
      { sql: 'DELETE FROM roles;', args: [] },
      ...DEFAULT_SYSTEM_ROLES.map((r, idx) => ({
        sql: `REPLACE INTO roles (id, name, category, description, isSystem, sortOrder) VALUES (?, ?, ?, ?, ?, ?);`,
        args: [r.id, r.name, r.category, r.description, r.isSystem ? 1 : 0, r.sortOrder ?? (idx + 1)]
      })),
      ...DEFAULT_SYSTEM_PERMISSIONS.map((p, idx) => ({
        sql: `REPLACE INTO permissions (permKey, name, module, description, isSystem, sortOrder) VALUES (?, ?, ?, ?, ?, ?);`,
        args: [p.key, p.name, p.module, p.description, p.isSystem ? 1 : 0, p.sortOrder ?? (idx + 1)]
      }))
    ];

    for (const [roleName, perms] of Object.entries(DEFAULT_SYSTEM_ROLE_PERMS)) {
      for (const pKey of perms) {
        statements.push({
          sql: 'INSERT INTO role_permissions (roleName, permKey) VALUES (?, ?);',
          args: [roleName, pKey]
        });
      }
    }

    await executeTursoBatch(statements);
  } catch (err) {
    console.warn('resetRolesAndPermissionsDB remote sync notice:', err);
  }

  return {
    roles: [...DEFAULT_SYSTEM_ROLES],
    permissions: [...DEFAULT_SYSTEM_PERMISSIONS],
    rolePermsMap: { ...DEFAULT_SYSTEM_ROLE_PERMS }
  };
}

// ==========================================
// PWA & ALERT NOTIFICATION SETTINGS (aaPanel / Local)
// ==========================================

export const DEFAULT_ALERT_SETTINGS: AlertNotificationSettings = {
  pwaPushEnabled: true,
  rsvpLeadHours: 20, // 20 hours before gelanggang session
  autoNotifyGelanggang: true,
  targetGelanggangs: ['Pusaka Warisan', 'Wadi AnNour', 'Paya Besar'],
  titleTemplate: DEFAULT_EVENT_TEMPLATES.latihan.title,
  bodyTemplate: DEFAULT_EVENT_TEMPLATES.latihan.body,
  eventTemplates: JSON.parse(JSON.stringify(DEFAULT_EVENT_TEMPLATES)),
  enableActionButtons: true,
  actionConfirmLabel: 'Hadir 🥋',
  actionDeclineLabel: 'Cuti / Uzur',
  notifyFeeReminders: true,
  feeReminderDays: 3,
  notifyGeneralAnnouncements: true,
  enableVibration: true,
  aapanelCronActive: true,
  cronIntervalMinutes: 60,
  vapidPublicKey: 'BCV_pssasmm_vapid_key_99x82k_live_aapanel_public',
  lastCronRun: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  updatedBy: 'Sistem'
};

let cachedAlertSettingsInMemory: AlertNotificationSettings | null = null;

/**
 * Retrieves the Alert & PWA Push Notification Settings from aaPanel / local storage.
 */
export async function getAlertSettingsDB(): Promise<AlertNotificationSettings> {
  if (cachedAlertSettingsInMemory) {
    return cachedAlertSettingsInMemory;
  }

  // 1. Try local cache
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.ALERT_SETTINGS);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        const eventTemplates = normalizeEventTemplates(parsed.eventTemplates, { title: parsed.titleTemplate, body: parsed.bodyTemplate });
        cachedAlertSettingsInMemory = {
          ...DEFAULT_ALERT_SETTINGS,
          ...parsed,
          eventTemplates,
          titleTemplate: eventTemplates.latihan.title,
          bodyTemplate: eventTemplates.latihan.body
        };
      } catch {
        // ignore parse error
      }
    }
  }

  // 2. Try fetching from aaPanel MySQL
  try {
    const res = await executeTursoQuery("SELECT * FROM alert_settings WHERE id = 'default' LIMIT 1;");
    if (res && res.rows && res.rows.length > 0) {
      const row = res.rows[0];
      const eventTemplates = normalizeEventTemplates(row.eventTemplates, { title: row.titleTemplate, body: row.bodyTemplate });
      const settings: AlertNotificationSettings = {
        pwaPushEnabled: row.pwaPushEnabled === 1 || row.pwaPushEnabled === '1' || row.pwaPushEnabled === true,
        rsvpLeadHours: Number(row.rsvpLeadHours) || 20,
        autoNotifyGelanggang: row.autoNotifyGelanggang === 1 || row.autoNotifyGelanggang === '1' || row.autoNotifyGelanggang === true,
        targetGelanggangs: typeof row.targetGelanggangs === 'string' ? JSON.parse(row.targetGelanggangs) : DEFAULT_ALERT_SETTINGS.targetGelanggangs,
        titleTemplate: eventTemplates.latihan.title,
        bodyTemplate: eventTemplates.latihan.body,
        eventTemplates,
        enableActionButtons: row.enableActionButtons === 1 || row.enableActionButtons === '1' || row.enableActionButtons === true,
        actionConfirmLabel: row.actionConfirmLabel || DEFAULT_ALERT_SETTINGS.actionConfirmLabel,
        actionDeclineLabel: row.actionDeclineLabel || DEFAULT_ALERT_SETTINGS.actionDeclineLabel,
        notifyFeeReminders: row.notifyFeeReminders === 1 || row.notifyFeeReminders === '1' || row.notifyFeeReminders === true,
        feeReminderDays: Number(row.feeReminderDays) || 3,
        notifyGeneralAnnouncements: row.notifyGeneralAnnouncements === 1 || row.notifyGeneralAnnouncements === '1' || row.notifyGeneralAnnouncements === true,
        enableVibration: row.enableVibration === 1 || row.enableVibration === '1' || row.enableVibration === true,
        aapanelCronActive: row.aapanelCronActive === 1 || row.aapanelCronActive === '1' || row.aapanelCronActive === true,
        cronIntervalMinutes: Number(row.cronIntervalMinutes) || 60,
        vapidPublicKey: row.vapidPublicKey || DEFAULT_ALERT_SETTINGS.vapidPublicKey,
        lastCronRun: row.lastCronRun || new Date().toISOString(),
        updatedAt: row.updatedAt || new Date().toISOString(),
        updatedBy: row.updatedBy || 'Sistem'
      };

      cachedAlertSettingsInMemory = settings;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.ALERT_SETTINGS, JSON.stringify(settings));
      }
      return settings;
    }
  } catch (err) {
    console.warn('aaPanel live alert settings fetch notice (using cache/fallback):', err);
  }

  if (!cachedAlertSettingsInMemory) {
    cachedAlertSettingsInMemory = { ...DEFAULT_ALERT_SETTINGS };
  }
  return cachedAlertSettingsInMemory;
}

/**
 * Saves updated Alert & PWA Push Notification Settings to local storage and aaPanel MySQL.
 */
export async function saveAlertSettingsDB(settings: AlertNotificationSettings, updatedBy: string): Promise<AlertNotificationSettings> {
  const eventTemplates = normalizeEventTemplates(settings.eventTemplates, { title: settings.titleTemplate, body: settings.bodyTemplate });
  const updated: AlertNotificationSettings = {
    ...settings,
    eventTemplates,
    titleTemplate: eventTemplates.latihan.title,
    bodyTemplate: eventTemplates.latihan.body,
    updatedAt: new Date().toISOString(),
    updatedBy
  };

  cachedAlertSettingsInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.ALERT_SETTINGS, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('asmm_alert_settings_updated', { detail: updated }));
  }

  try {
    await executeTursoBatch([
      {
        sql: `CREATE TABLE IF NOT EXISTS alert_settings (
          id VARCHAR(100) PRIMARY KEY,
          pwaPushEnabled TINYINT DEFAULT 1,
          rsvpLeadHours INT DEFAULT 20,
          autoNotifyGelanggang TINYINT DEFAULT 1,
          targetGelanggangs TEXT,
          titleTemplate TEXT,
          bodyTemplate TEXT,
          enableActionButtons TINYINT DEFAULT 1,
          actionConfirmLabel VARCHAR(100),
          actionDeclineLabel VARCHAR(100),
          notifyFeeReminders TINYINT DEFAULT 1,
          feeReminderDays INT DEFAULT 3,
          notifyGeneralAnnouncements TINYINT DEFAULT 1,
          enableVibration TINYINT DEFAULT 1,
          aapanelCronActive TINYINT DEFAULT 1,
          cronIntervalMinutes INT DEFAULT 60,
          vapidPublicKey TEXT,
          lastCronRun VARCHAR(100),
          updatedAt VARCHAR(100),
          updatedBy VARCHAR(150)
        );`,
        args: []
      },
      {
        sql: `REPLACE INTO alert_settings (
          id, pwaPushEnabled, rsvpLeadHours, autoNotifyGelanggang, targetGelanggangs,
          titleTemplate, bodyTemplate, enableActionButtons, actionConfirmLabel,
          actionDeclineLabel, notifyFeeReminders, feeReminderDays, notifyGeneralAnnouncements,
          enableVibration, aapanelCronActive, cronIntervalMinutes, vapidPublicKey,
          lastCronRun, updatedAt, updatedBy
        ) VALUES (
          'default', ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?
        );`,
        args: [
          updated.pwaPushEnabled ? 1 : 0,
          updated.rsvpLeadHours,
          updated.autoNotifyGelanggang ? 1 : 0,
          JSON.stringify(updated.targetGelanggangs),
          updated.titleTemplate,
          updated.bodyTemplate,
          updated.enableActionButtons ? 1 : 0,
          updated.actionConfirmLabel,
          updated.actionDeclineLabel,
          updated.notifyFeeReminders ? 1 : 0,
          updated.feeReminderDays,
          updated.notifyGeneralAnnouncements ? 1 : 0,
          updated.enableVibration ? 1 : 0,
          updated.aapanelCronActive ? 1 : 0,
          updated.cronIntervalMinutes,
          updated.vapidPublicKey,
          updated.lastCronRun || '',
          updated.updatedAt,
          updated.updatedBy
        ]
      }
    ]);
    // eventTemplates lives in its own column (added via ALTER on older tables)
    const tplJson = JSON.stringify(eventTemplates);
    try {
      await executeTursoQuery("UPDATE alert_settings SET eventTemplates = ? WHERE id = 'default';", [tplJson]);
    } catch {
      await executeTursoQuery('ALTER TABLE alert_settings ADD COLUMN eventTemplates TEXT;').catch(() => { });
      await executeTursoQuery("UPDATE alert_settings SET eventTemplates = ? WHERE id = 'default';", [tplJson]).catch(() => { });
    }
  } catch (err) {
    console.warn('Failed to sync alert settings to aaPanel:', err);
  }

  return updated;
}

// ==========================================
// PERSATUAN LEVEL PAYMENT & QR SETTINGS (aaPanel / Local)
// ==========================================

export const DEFAULT_PERSATUAN_PAYMENT_SETTINGS: PersatuanPaymentSettings = {
  bankName: 'Bank Islam Malaysia Berhad',
  accountNo: '02011010087654',
  accountHolder: 'PERSATUAN SENI SILAT AWANG SULUNG MERAH MUDA NEGERI KEDAH',
  qrImageUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1793020945/asmm/qr-persatuan-asmm.png',
  paymentInstructions: 'Sila masukkan rujukan Invois / Nama Pembayar semasa pindahan bank atau imbasan DuitNow.',
  fpxEnabled: true,
  qrEnabled: true,
  toyyibPaySecretKey: 'w3gu2gf4-o2vg-lp95-jbic-aor35d2w8c2t',
  toyyibPayCategoryCode: 'htnqvub2',
  toyyibPayBaseUrl: 'https://dev.toyyibpay.com',
  merchantCategory: 'Persatuan Silat (ROS Registered)',
  rosRegistrationNo: 'PPM-007-02-28082022',
  enforceAllGelanggangPersatuan: true, // Infaq 'Semua Gelanggang' goes directly to Persatuan bank account
  enforceVendorPssasmmPersatuan: true, // Vendor/Pihak Ketiga paying to 'PSSASMM' goes directly to Persatuan bank account
  updatedAt: new Date().toISOString(),
  updatedBy: 'Sistem'
};

let cachedPersatuanPaymentSettingsInMemory: PersatuanPaymentSettings | null = null;

/**
 * Retrieves the Persatuan Level Payment & QR Gateway Settings.
 */
export async function getPersatuanPaymentSettingsDB(): Promise<PersatuanPaymentSettings> {
  // 1. Check local storage first so immediate user changes in /settings/payment are reflected
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.PERSATUAN_PAYMENT_SETTINGS);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        const rawQr = parsed.qrImageUrl;
        const validQr = (rawQr && rawQr.trim() !== '' && rawQr !== '/logo-pssasmm.png')
          ? rawQr
          : DEFAULT_PERSATUAN_PAYMENT_SETTINGS.qrImageUrl;
        const loaded: PersatuanPaymentSettings = {
          ...DEFAULT_PERSATUAN_PAYMENT_SETTINGS,
          ...parsed,
          qrImageUrl: validQr
        };
        cachedPersatuanPaymentSettingsInMemory = loaded;
        return loaded;
      } catch {
        // ignore
      }
    }
  }

  if (cachedPersatuanPaymentSettingsInMemory) {
    return cachedPersatuanPaymentSettingsInMemory;
  }

  // 2. Query aaPanel MySQL
  try {
    const res = await executeTursoQuery("SELECT * FROM persatuan_payment_settings WHERE id = 'default' LIMIT 1;");
    if (res && res.rows && res.rows.length > 0) {
      const row = res.rows[0];
      const rowQr = row.qrImageUrl ? String(row.qrImageUrl) : '';
      const validRowQr = (rowQr && rowQr.trim() !== '' && rowQr !== '/logo-pssasmm.png')
        ? rowQr
        : DEFAULT_PERSATUAN_PAYMENT_SETTINGS.qrImageUrl;

      const settings: PersatuanPaymentSettings = {
        bankName: row.bankName || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.bankName,
        accountNo: row.accountNo || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.accountNo,
        accountHolder: row.accountHolder || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.accountHolder,
        qrImageUrl: validRowQr,
        paymentInstructions: row.paymentInstructions || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.paymentInstructions,
        fpxEnabled: row.fpxEnabled === 1 || row.fpxEnabled === '1' || row.fpxEnabled === true,
        qrEnabled: row.qrEnabled === 1 || row.qrEnabled === '1' || row.qrEnabled === true,
        toyyibPaySecretKey: row.toyyibPaySecretKey || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.toyyibPaySecretKey,
        toyyibPayCategoryCode: row.toyyibPayCategoryCode || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.toyyibPayCategoryCode,
        toyyibPayBaseUrl: row.toyyibPayBaseUrl || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.toyyibPayBaseUrl,
        merchantCategory: row.merchantCategory || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.merchantCategory,
        rosRegistrationNo: row.rosRegistrationNo || DEFAULT_PERSATUAN_PAYMENT_SETTINGS.rosRegistrationNo,
        enforceAllGelanggangPersatuan: row.enforceAllGelanggangPersatuan === 1 || row.enforceAllGelanggangPersatuan === '1' || row.enforceAllGelanggangPersatuan === true,
        enforceVendorPssasmmPersatuan: row.enforceVendorPssasmmPersatuan === 1 || row.enforceVendorPssasmmPersatuan === '1' || row.enforceVendorPssasmmPersatuan === true,
        updatedAt: row.updatedAt || new Date().toISOString(),
        updatedBy: row.updatedBy || 'Sistem'
      };

      cachedPersatuanPaymentSettingsInMemory = settings;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.PERSATUAN_PAYMENT_SETTINGS, JSON.stringify(settings));
      }
      return settings;
    }
  } catch (err) {
    console.warn('aaPanel live persatuan payment settings fetch notice:', err);
  }

  if (!cachedPersatuanPaymentSettingsInMemory) {
    cachedPersatuanPaymentSettingsInMemory = { ...DEFAULT_PERSATUAN_PAYMENT_SETTINGS };
  }
  return cachedPersatuanPaymentSettingsInMemory;
}

/**
 * Saves updated Persatuan Level Payment & QR Gateway Settings.
 */
export async function savePersatuanPaymentSettingsDB(settings: PersatuanPaymentSettings, updatedBy: string): Promise<PersatuanPaymentSettings> {
  const updated: PersatuanPaymentSettings = {
    ...settings,
    updatedAt: new Date().toISOString(),
    updatedBy
  };

  cachedPersatuanPaymentSettingsInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.PERSATUAN_PAYMENT_SETTINGS, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('asmm_payment_settings_updated', { detail: updated }));
  }

  try {
    await executeTursoBatch([
      {
        sql: `CREATE TABLE IF NOT EXISTS persatuan_payment_settings (
          id VARCHAR(100) PRIMARY KEY,
          bankName VARCHAR(150),
          accountNo VARCHAR(100),
          accountHolder VARCHAR(200),
          qrImageUrl LONGTEXT,
          paymentInstructions TEXT,
          fpxEnabled TINYINT DEFAULT 1,
          qrEnabled TINYINT DEFAULT 1,
          toyyibPaySecretKey VARCHAR(150),
          toyyibPayCategoryCode VARCHAR(100),
          toyyibPayBaseUrl VARCHAR(150),
          merchantCategory VARCHAR(150),
          rosRegistrationNo VARCHAR(100),
          enforceAllGelanggangPersatuan TINYINT DEFAULT 1,
          enforceVendorPssasmmPersatuan TINYINT DEFAULT 1,
          updatedAt VARCHAR(100),
          updatedBy VARCHAR(150)
        );`,
        args: []
      },
      {
        sql: `REPLACE INTO persatuan_payment_settings (
          id, bankName, accountNo, accountHolder, qrImageUrl, paymentInstructions,
          fpxEnabled, qrEnabled, toyyibPaySecretKey, toyyibPayCategoryCode, toyyibPayBaseUrl,
          merchantCategory, rosRegistrationNo, enforceAllGelanggangPersatuan,
          enforceVendorPssasmmPersatuan, updatedAt, updatedBy
        ) VALUES (
          'default', ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?
        );`,
        args: [
          updated.bankName,
          updated.accountNo,
          updated.accountHolder,
          updated.qrImageUrl || '',
          updated.paymentInstructions || '',
          updated.fpxEnabled ? 1 : 0,
          updated.qrEnabled ? 1 : 0,
          updated.toyyibPaySecretKey,
          updated.toyyibPayCategoryCode,
          updated.toyyibPayBaseUrl,
          updated.merchantCategory,
          updated.rosRegistrationNo,
          updated.enforceAllGelanggangPersatuan ? 1 : 0,
          updated.enforceVendorPssasmmPersatuan ? 1 : 0,
          updated.updatedAt,
          updated.updatedBy
        ]
      }
    ]);
  } catch (err) {
    console.warn('Failed to sync persatuan payment settings to aaPanel:', err);
  }

  return updated;
}

// ==========================================
// SELLER PAYMENT & DUITNOW QR GATEWAY SETTINGS
// ==========================================

export const DEFAULT_SELLER_PAYMENT_SETTINGS: SellerPaymentSettings = {
  sellerId: 'ASMM-001',
  sellerName: 'Persatuan Seni Silat Awang Sulung Merah Muda',
  bankName: 'Bank Islam Malaysia Berhad',
  accountNo: '02011010087654',
  accountHolder: 'PERSATUAN SENI SILAT AWANG SULUNG MERAH MUDA NEGERI KEDAH',
  qrImageUrl: 'https://res.cloudinary.com/dntsgcacv/image/upload/v1793020945/asmm/qr-persatuan-asmm.png',
  paymentInstructions: 'Sila masukkan No. Pesanan atau No. Telefon dalam rujukan bank semasa membuat pindahan / imbasan QR DuitNow.',
  qrEnabled: true,
  fpxEnabled: false,
  updatedAt: new Date().toISOString(),
  updatedBy: 'Sistem'
};

const cachedSellerPaymentSettingsMap: Record<string, SellerPaymentSettings> = {};

/**
 * Retrieves the custom payment and DuitNow QR settings for a specific merchandise seller.
 * If not customized yet, falls back to the Persatuan gateway settings.
 */
export async function getSellerPaymentSettingsDB(sellerId?: string): Promise<SellerPaymentSettings> {
  const targetId = (sellerId && sellerId.trim()) ? sellerId.trim().toUpperCase() : 'ASMM-001';

  // 1. Check in-memory cache
  if (cachedSellerPaymentSettingsMap[targetId]) {
    return cachedSellerPaymentSettingsMap[targetId];
  }

  // 2. Check local storage cache
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(`${KEYS.SELLER_PAYMENT_SETTINGS}_${targetId}`);
    if (raw) {
      try {
        const parsed: SellerPaymentSettings = JSON.parse(raw);
        cachedSellerPaymentSettingsMap[targetId] = parsed;
        return parsed;
      } catch {
        // ignore
      }
    }
  }

  // 3. Query aaPanel MySQL / Turso
  try {
    const res = await executeTursoQuery(
      "SELECT * FROM seller_payment_settings WHERE UPPER(sellerId) = ? LIMIT 1;",
      [targetId]
    );
    if (res && res.rows && res.rows.length > 0) {
      const row = res.rows[0];
      const settings: SellerPaymentSettings = {
        sellerId: String(row.sellerId ?? row[0] ?? targetId),
        sellerName: (row.sellerName ?? row[1]) ? String(row.sellerName ?? row[1]) : undefined,
        bankName: String(row.bankName ?? row[2] ?? DEFAULT_SELLER_PAYMENT_SETTINGS.bankName),
        accountNo: String(row.accountNo ?? row[3] ?? DEFAULT_SELLER_PAYMENT_SETTINGS.accountNo),
        accountHolder: String(row.accountHolder ?? row[4] ?? DEFAULT_SELLER_PAYMENT_SETTINGS.accountHolder),
        qrImageUrl: (row.qrImageUrl ?? row[5]) ? String(row.qrImageUrl ?? row[5]) : DEFAULT_SELLER_PAYMENT_SETTINGS.qrImageUrl,
        paymentInstructions: (row.paymentInstructions ?? row[6]) ? String(row.paymentInstructions ?? row[6]) : DEFAULT_SELLER_PAYMENT_SETTINGS.paymentInstructions,
        qrEnabled: (row.qrEnabled ?? row[7]) === 1 || (row.qrEnabled ?? row[7]) === '1' || (row.qrEnabled ?? row[7]) === true,
        fpxEnabled: (row.fpxEnabled ?? row[8]) === 1 || (row.fpxEnabled ?? row[8]) === '1' || (row.fpxEnabled ?? row[8]) === true,
        toyyibPayCategoryCode: (row.toyyibPayCategoryCode ?? row[9]) ? String(row.toyyibPayCategoryCode ?? row[9]) : undefined,
        toyyibPaySecretKey: (row.toyyibPaySecretKey ?? row[10]) ? String(row.toyyibPaySecretKey ?? row[10]) : undefined,
        updatedAt: (row.updatedAt ?? row[11]) ? String(row.updatedAt ?? row[11]) : new Date().toISOString(),
        updatedBy: (row.updatedBy ?? row[12]) ? String(row.updatedBy ?? row[12]) : 'Sistem'
      };
      cachedSellerPaymentSettingsMap[targetId] = settings;
      if (typeof window !== 'undefined') {
        localStorage.setItem(`${KEYS.SELLER_PAYMENT_SETTINGS}_${targetId}`, JSON.stringify(settings));
      }
      return settings;
    }
  } catch (err) {
    console.warn('aaPanel live seller payment settings fetch notice:', err);
  }

  // Fallback to persatuan / pusat payment settings
  const persatuan = await getPersatuanPaymentSettingsDB().catch(() => DEFAULT_PERSATUAN_PAYMENT_SETTINGS);
  let pusatSeller: SellerPaymentSettings | null = cachedSellerPaymentSettingsMap['ASMM-001'] || null;
  if (!pusatSeller && typeof window !== 'undefined') {
    const rawPusat = localStorage.getItem(`${KEYS.SELLER_PAYMENT_SETTINGS}_ASMM-001`);
    if (rawPusat) {
      try {
        pusatSeller = JSON.parse(rawPusat);
      } catch {}
    }
  }

  const activeBank = (pusatSeller?.bankName && pusatSeller.bankName.trim()) ? pusatSeller.bankName : persatuan.bankName;
  const activeAccNo = (pusatSeller?.accountNo && pusatSeller.accountNo.trim()) ? pusatSeller.accountNo : persatuan.accountNo;
  const activeAccHolder = (pusatSeller?.accountHolder && pusatSeller.accountHolder.trim()) ? pusatSeller.accountHolder : persatuan.accountHolder;
  const activeQr = (pusatSeller?.qrImageUrl && pusatSeller.qrImageUrl.trim()) ? pusatSeller.qrImageUrl : persatuan.qrImageUrl;
  const activeInstructions = (pusatSeller?.paymentInstructions && pusatSeller.paymentInstructions.trim()) ? pusatSeller.paymentInstructions : (persatuan.paymentInstructions || DEFAULT_SELLER_PAYMENT_SETTINGS.paymentInstructions);

  const members = await getMembersDB().catch(() => []);
  const member = members.find(m => m.id.toUpperCase() === targetId.toUpperCase());
  const memberName = member?.name ? member.name : (targetId === 'ASMM-001' ? 'PSSASMM Pusat' : `Penjual ${targetId}`);

  const fallback: SellerPaymentSettings = {
    sellerId: targetId,
    sellerName: memberName,
    bankName: activeBank,
    accountNo: activeAccNo,
    accountHolder: activeAccHolder,
    qrImageUrl: activeQr,
    paymentInstructions: activeInstructions,
    qrEnabled: true,
    fpxEnabled: false,
    updatedAt: new Date().toISOString(),
    updatedBy: 'Sistem'
  };

  cachedSellerPaymentSettingsMap[targetId] = fallback;
  return fallback;
}

/**
 * Saves customized payment & QR gateway settings for a specific merchandise seller.
 */
export async function saveSellerPaymentSettingsDB(settings: SellerPaymentSettings, updatedBy: string): Promise<SellerPaymentSettings> {
  const targetId = (settings.sellerId && settings.sellerId.trim()) ? settings.sellerId.trim().toUpperCase() : 'ASMM-001';
  const updated: SellerPaymentSettings = {
    ...settings,
    sellerId: targetId,
    updatedAt: new Date().toISOString(),
    updatedBy
  };

  cachedSellerPaymentSettingsMap[targetId] = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(`${KEYS.SELLER_PAYMENT_SETTINGS}_${targetId}`, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent('asmm_seller_payment_settings_updated', { detail: updated }));
  }

  try {
    await executeTursoBatch([
      {
        sql: `CREATE TABLE IF NOT EXISTS seller_payment_settings (
          sellerId VARCHAR(100) PRIMARY KEY,
          sellerName VARCHAR(200),
          bankName VARCHAR(150),
          accountNo VARCHAR(100),
          accountHolder VARCHAR(200),
          qrImageUrl LONGTEXT,
          paymentInstructions TEXT,
          qrEnabled TINYINT DEFAULT 1,
          fpxEnabled TINYINT DEFAULT 0,
          toyyibPayCategoryCode VARCHAR(100),
          toyyibPaySecretKey VARCHAR(150),
          updatedAt VARCHAR(100),
          updatedBy VARCHAR(150)
        );`,
        args: []
      },
      {
        sql: `REPLACE INTO seller_payment_settings (
          sellerId, sellerName, bankName, accountNo, accountHolder, qrImageUrl,
          paymentInstructions, qrEnabled, fpxEnabled, toyyibPayCategoryCode, toyyibPaySecretKey,
          updatedAt, updatedBy
        ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
        args: [
          updated.sellerId,
          updated.sellerName || null,
          updated.bankName,
          updated.accountNo,
          updated.accountHolder,
          updated.qrImageUrl || '',
          updated.paymentInstructions || '',
          updated.qrEnabled ? 1 : 0,
          updated.fpxEnabled ? 1 : 0,
          updated.toyyibPayCategoryCode || null,
          updated.toyyibPaySecretKey || null,
          updated.updatedAt,
          updated.updatedBy
        ]
      }
    ]);
  } catch (err) {
    console.warn('Failed to sync seller payment settings to aaPanel:', err);
  }

  return updated;
}

// ==========================================
// UJIAN BERTULIS (WRITTEN OBJECTIVE EXAM)
// ==========================================

export async function getUjianBertulisAttemptsDB(userId?: string): Promise<UjianBertulisAttempt[]> {
  initializeDB();

  let attempts: UjianBertulisAttempt[] = [];

  if (cachedUjianBertulisAttemptsInMemory && cachedUjianBertulisAttemptsInMemory.length > 0) {
    attempts = cachedUjianBertulisAttemptsInMemory;
  } else if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(KEYS.UJIAN_BERTULIS_ATTEMPTS);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          cachedUjianBertulisAttemptsInMemory = parsed;
          attempts = parsed;
        }
      } catch { }
    }
  }

  // Also query remote aaPanel / Turso table if available
  try {
    const res = await executeTursoQuery("SELECT * FROM ujian_bertulis_attempts;");
    if (res && res.rows && Array.isArray(res.rows)) {
      const remote: UjianBertulisAttempt[] = res.rows.map((row: any) => {
        let answers: Record<number, number> = {};
        let questionIds: number[] | undefined;
        let categoryBreakdown: any = {
          sahsiah: { correct: 0, total: 18, percentage: 0 },
          silat: { correct: 0, total: 18, percentage: 0 },
          persatuan: { correct: 0, total: 14, percentage: 0 }
        };
        try {
          if (row.answersJson || row[11]) {
            const rawParsed = JSON.parse(row.answersJson || row[11]);
            if (rawParsed && typeof rawParsed === 'object') {
              if (Array.isArray(rawParsed.__questionIds)) {
                questionIds = rawParsed.__questionIds;
                delete rawParsed.__questionIds;
              }
              answers = rawParsed;
            }
          }
        } catch { }
        try {
          if (row.categoryBreakdownJson || row[12]) categoryBreakdown = JSON.parse(row.categoryBreakdownJson || row[12]);
        } catch { }

        return {
          id: String(row.id ?? row[0]),
          attemptNumber: Number(row.attemptNumber ?? row[1] ?? 1) as 1 | 2,
          userId: String(row.userId ?? row[2]),
          memberId: String(row.memberId ?? row[3] ?? row.userId),
          userName: String(row.userName ?? row[4] ?? ''),
          userIcNo: row.userIcNo ? String(row.userIcNo) : undefined,
          gelanggang: String(row.gelanggang ?? row[6] ?? 'Pusaka Warisan'),
          bengkung: String(row.bengkung ?? row[7] ?? 'Putih'),
          startedAt: String(row.startedAt ?? row[8] ?? new Date().toISOString()),
          completedAt: String(row.completedAt ?? row[9] ?? new Date().toISOString()),
          timeSpentSeconds: Number(row.timeSpentSeconds ?? row[10] ?? 0),
          score: Number(row.score ?? row[13] ?? 0),
          totalQuestions: Number(row.totalQuestions ?? row[14] ?? 50),
          percentage: Number(row.percentage ?? row[15] ?? 0),
          isPassed: Boolean(Number(row.isPassed ?? row[16] ?? 0) === 1 || row.isPassed === true),
          grade: (row.grade ?? row[17] ?? 'C (Lulus)') as any,
          answers,
          questionIds,
          categoryBreakdown
        };
      });

      // Merge remote with local
      const idMap = new Map<string, UjianBertulisAttempt>();
      remote.forEach(a => idMap.set(a.id, a));
      attempts.forEach(a => idMap.set(a.id, a));
      attempts = Array.from(idMap.values());
      cachedUjianBertulisAttemptsInMemory = attempts;
      if (typeof window !== 'undefined') {
        localStorage.setItem(KEYS.UJIAN_BERTULIS_ATTEMPTS, JSON.stringify(attempts));
      }
    }
  } catch (err) {
    // remote table might not exist yet, fallback to localStorage cache
  }

  if (userId) {
    const cleanUid = userId.trim().toLowerCase();
    const cleanDigits = userId.replace(/\D/g, '');
    return attempts.filter(a =>
      (a.userId && a.userId.trim().toLowerCase() === cleanUid) ||
      (a.memberId && a.memberId.trim().toLowerCase() === cleanUid) ||
      (cleanDigits && a.userIcNo && a.userIcNo.replace(/\D/g, '') === cleanDigits)
    );
  }

  return attempts;
}

export async function saveUjianBertulisAttemptDB(attempt: UjianBertulisAttempt): Promise<void> {
  const list = await getUjianBertulisAttemptsDB();
  const existingIdx = list.findIndex(a => a.id === attempt.id);
  if (existingIdx >= 0) {
    list[existingIdx] = attempt;
  } else {
    list.push(attempt);
  }

  cachedUjianBertulisAttemptsInMemory = list;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_BERTULIS_ATTEMPTS, JSON.stringify(list));
  }

  // Sync to remote MySQL / Turso
  try {
    const answersPayload = {
      ...(attempt.answers || {}),
      ...(attempt.questionIds && attempt.questionIds.length > 0 ? { __questionIds: attempt.questionIds } : {})
    };

    await executeTursoBatch([
      {
        sql: `CREATE TABLE IF NOT EXISTS ujian_bertulis_attempts (
          id VARCHAR(100) PRIMARY KEY,
          attemptNumber INT NOT NULL,
          userId VARCHAR(100) NOT NULL,
          memberId VARCHAR(100) NOT NULL,
          userName VARCHAR(150) NOT NULL,
          userIcNo VARCHAR(50),
          gelanggang VARCHAR(100),
          bengkung VARCHAR(100),
          startedAt VARCHAR(100),
          completedAt VARCHAR(100),
          timeSpentSeconds INT,
          answersJson TEXT,
          categoryBreakdownJson TEXT,
          score INT,
          totalQuestions INT,
          percentage REAL,
          isPassed INT,
          grade VARCHAR(50)
        );`,
        args: []
      },
      {
        sql: `REPLACE INTO ujian_bertulis_attempts (
          id, attemptNumber, userId, memberId, userName, userIcNo, gelanggang, bengkung,
          startedAt, completedAt, timeSpentSeconds, answersJson, categoryBreakdownJson,
          score, totalQuestions, percentage, isPassed, grade
        ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);`,
        args: [
          attempt.id,
          attempt.attemptNumber,
          attempt.userId,
          attempt.memberId,
          attempt.userName,
          attempt.userIcNo || '',
          attempt.gelanggang,
          attempt.bengkung,
          attempt.startedAt,
          attempt.completedAt,
          attempt.timeSpentSeconds,
          JSON.stringify(answersPayload),
          JSON.stringify(attempt.categoryBreakdown || {}),
          attempt.score,
          attempt.totalQuestions,
          attempt.percentage,
          attempt.isPassed ? 1 : 0,
          attempt.grade
        ]
      }
    ]);
  } catch (err) {
    console.warn('Failed to sync ujian bertulis attempt to aaPanel:', err);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

export async function deleteUjianBertulisAttemptDB(attemptId: string): Promise<void> {
  initializeDB();
  const list = await getUjianBertulisAttemptsDB();
  const updated = list.filter(a => a.id !== attemptId);
  cachedUjianBertulisAttemptsInMemory = updated;
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_BERTULIS_ATTEMPTS, JSON.stringify(updated));
  }

  // Sync deletion to remote MySQL / Turso
  try {
    await executeTursoBatch([
      {
        sql: `DELETE FROM ujian_bertulis_attempts WHERE id = ?;`,
        args: [attemptId]
      }
    ]);
  } catch (err) {
    console.warn('Failed to delete ujian bertulis attempt from remote DB:', err);
  }

  window.dispatchEvent(new Event('asmm_db_updated'));
}

export async function getMemberUjianBertulisSummaryDB(userId: string): Promise<{
  attempts: UjianBertulisAttempt[];
  attemptsCount: number;
  canAttempt: boolean;
  bestScore: number;
  bestPercentage: number;
  isPassed: boolean;
  latestAttempt?: UjianBertulisAttempt;
}> {
  const attempts = await getUjianBertulisAttemptsDB(userId);
  // Sort by attemptNumber ascending
  attempts.sort((a, b) => a.attemptNumber - b.attemptNumber);
  const attemptsCount = attempts.length;
  const canAttempt = attemptsCount < 2;

  let bestScore = 0;
  let bestPercentage = 0;
  let isPassed = false;

  attempts.forEach(a => {
    if (a.score > bestScore) bestScore = a.score;
    if (a.percentage > bestPercentage) bestPercentage = a.percentage;
    if (a.isPassed) isPassed = true;
  });

  const latestAttempt = attempts[attempts.length - 1];

  return {
    attempts,
    attemptsCount,
    canAttempt,
    bestScore,
    bestPercentage,
    isPassed,
    latestAttempt
  };
}

export async function getUjianBertulisKeyUnlockedDB(): Promise<boolean> {
  if (typeof window !== 'undefined') {
    const val = localStorage.getItem(KEYS.UJIAN_BERTULIS_KEY_UNLOCKED);
    if (val !== null) return val === 'true';
  }
  return false;
}

export async function setUjianBertulisKeyUnlockedDB(unlocked: boolean): Promise<void> {
  if (typeof window !== 'undefined') {
    localStorage.setItem(KEYS.UJIAN_BERTULIS_KEY_UNLOCKED, unlocked ? 'true' : 'false');
    window.dispatchEvent(new Event('asmm_db_updated'));
  }
}

export interface UjianBertulisCompletionStatus {
  totalCandidates: number;
  completedCount: number;
  remainingCount: number;
  isAllCompleted: boolean;
  isKeyUnlocked: boolean;
  candidates: PaidUjianCandidate[];
}

export async function getUjianBertulisCompletionStatusDB(): Promise<UjianBertulisCompletionStatus> {
  const candidates = await getPaidUjianCandidatesDB();
  const isKeyUnlocked = await getUjianBertulisKeyUnlockedDB();

  // Candidates who have taken at least 1 attempt
  const completedCandidates = candidates.filter(
    (c) => (c.ujianBertulis?.attemptsCount || 0) > 0
  );

  const totalCandidates = candidates.length;
  const completedCount = completedCandidates.length;
  const remainingCount = Math.max(0, totalCandidates - completedCount);
  const isAllCompleted = totalCandidates > 0 && completedCount >= totalCandidates;

  return {
    totalCandidates,
    completedCount,
    remainingCount,
    isAllCompleted,
    isKeyUnlocked,
    candidates
  };
}

export interface UjianCohortCompletionStatus {
  totalCandidates: number;
  completedGradingCount: number;
  pendingGradingCount: number;
  isAllGradingCompleted: boolean;
  isAllWrittenCompleted: boolean;
  isAllTestsCompleted: boolean;
  passedCandidates: PaidUjianCandidate[];
  failedCandidates: PaidUjianCandidate[];
  candidates: PaidUjianCandidate[];
}

/**
 * Checks whether all registered/paid test takers in the cohort have completed their tests.
 * Bengkung rank for passing candidates is strictly held until all test takers are finished.
 */
export async function getUjianCohortCompletionStatusDB(): Promise<UjianCohortCompletionStatus> {
  const candidates = await getPaidUjianCandidatesDB();
  const totalCandidates = candidates.length;

  if (totalCandidates === 0) {
    return {
      totalCandidates: 0,
      completedGradingCount: 0,
      pendingGradingCount: 0,
      isAllGradingCompleted: false,
      isAllWrittenCompleted: false,
      isAllTestsCompleted: false,
      passedCandidates: [],
      failedCandidates: [],
      candidates: []
    };
  }

  // Practical grading completion: status is finished ('Lulus' or 'Mengulang')
  const completedGradingCandidates = candidates.filter(
    (c) => c.gradingStatus === 'Lulus' || c.gradingStatus === 'Mengulang'
  );
  const passedCandidates = candidates.filter((c) => c.gradingStatus === 'Lulus');
  const failedCandidates = candidates.filter((c) => c.gradingStatus === 'Mengulang');

  const completedGradingCount = completedGradingCandidates.length;
  const pendingGradingCount = Math.max(0, totalCandidates - completedGradingCount);
  const isAllGradingCompleted = totalCandidates > 0 && completedGradingCount >= totalCandidates;

  // Candidates who have completed written exam (if tracked)
  const candidatesWithWritten = candidates.filter(
    (c) => (c.ujianBertulis?.attemptsCount || 0) > 0
  );
  const isAllWrittenCompleted = totalCandidates > 0 && candidatesWithWritten.length >= totalCandidates;

  // The test session is fully completed once every test taker has finished grading
  const isAllTestsCompleted = isAllGradingCompleted;

  return {
    totalCandidates,
    completedGradingCount,
    pendingGradingCount,
    isAllGradingCompleted,
    isAllWrittenCompleted,
    isAllTestsCompleted,
    passedCandidates,
    failedCandidates,
    candidates
  };
}

/**
 * Upgrades member profiles to their target bengkung and official badge ONLY AFTER all test takers
 * have finished done all tests. Candidates who passed ('Lulus') are promoted. Candidates who repeat
 * ('Mengulang') remain at their current bengkung.
 */
export async function finalizeUjianGradingBatchRankDB(): Promise<{
  success: boolean;
  promotedCount: number;
  promotedMembers: { memberId: string; name: string; oldBengkung: string; newBengkung: string }[];
  message: string;
}> {
  const status = await getUjianCohortCompletionStatusDB();

  if (!status.isAllTestsCompleted) {
    return {
      success: false,
      promotedCount: 0,
      promotedMembers: [],
      message: `Ujian belum tamat sepenuhnya. Masih ada ${status.pendingGradingCount} calon yang belum selesai menduduki ujian.`
    };
  }

  const members = await getMembersDB();
  const promotedMembers: { memberId: string; name: string; oldBengkung: string; newBengkung: string }[] = [];

  for (const cand of status.passedCandidates) {
    if (!cand.memberId || !cand.targetBengkung) continue;
    const mIdx = members.findIndex(
      (m) => m.id.toLowerCase() === cand.memberId.toLowerCase()
    );
    if (mIdx >= 0) {
      const member = members[mIdx];
      const targetBengkungClean = cleanBengkungTitle(cand.targetBengkung);
      const currentBengkungClean = cleanBengkungTitle(member.bengkung || '');

      // Only upgrade if member's profile does not already match the target bengkung
      if (currentBengkungClean.toLowerCase() !== targetBengkungClean.toLowerCase()) {
        const newBadge = resolveBengkungBadge(targetBengkungClean);
        members[mIdx] = {
          ...member,
          bengkung: targetBengkungClean as any,
          bengkungBadge: newBadge
        };
        await saveMemberDB(members[mIdx]);
        promotedMembers.push({
          memberId: member.id,
          name: member.name,
          oldBengkung: member.bengkung,
          newBengkung: targetBengkungClean
        });
      }
    }
  }

  window.dispatchEvent(new Event('asmm_db_updated'));

  return {
    success: true,
    promotedCount: promotedMembers.length,
    promotedMembers,
    message:
      promotedMembers.length > 0
        ? `Tahniah! ${promotedMembers.length} murid yang lulus telah berjaya dinaikkan taraf bengkung secara rasmi.`
        : `Pangkat bengkung kesemua ${status.passedCandidates.length} murid yang lulus telah dikemaskini sebelum ini.`
  };
}



